import * as React from "react"
import styled from "styled-components"

const Svg = styled.svg`

width: 100%;
height: fit-content;
`

function SvgComponent(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={577}
      viewBox="0 0 577 382"
      {...props}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#6C5BC0"
          d="M208.181 414.691h-18a2.1 2.1 0 01-.518-1.504c2.065-4.859.293-10.189 1.839-15.115 1.284-2.061 2.915-2.061 4.753-.803.576.629.793 1.416.999 2.232.417 1.656-.412 4.01 1.995 4.631 2.295.59 4.156-.707 5.88-2.086 1.188-.951 1.727-2.443 2.873-3.438 2.362-.465 3.233 1.158 4.043 2.875.163.52.246 1.051.271 1.594-.977 4.011.265 8.819-4.135 11.614z"
        />
        <path
          fill="#6B5BC1"
          d="M310.182 414.691h-18c-1.896-3.469-4.537-6.631-4.502-10.902a3.003 3.003 0 011.529-1.553c1.273-.361 2.217.201 3.137 1.027 4.57 4.105 5.291 4.164 10.789 1.07 3.012-.086 5.348 1.652 7.872 2.906 2.175 2.755 1.068 5.148-.825 7.452z"
        />
        <path
          fill="#5447BB"
          d="M289.182 414.691h-11c-1.357-1.211-2.155-2.645-1.816-4.533 1.547-6.631 4.754-8.236 9.903-4.963 1.911 2.875 3.667 5.803 2.913 9.496z"
        />
        <path
          fill="#6555BE"
          d="M208.181 414.691c2.397-3.65 2.085-7.979 3.002-12 1.611-1.641 3.407-3.088 4.08-5.498.444-1.59 1.498-2.656 3.333-1.393 1.94 5.336-1.408 10.176-1.411 15.33-.316 1.383-1.079 2.518-2.004 3.561h-7z"
        />
        <path
          fill="#6954BC"
          d="M310.182 414.691c-.602-2.334 2.488-4.668-.002-7.002-4.213-3.283-4.352-7.865-4.02-12.592.125-.488.357-.936.674-1.328 4.051 1.309 6.691 3.695 6.377 7.971 0-.463.102-1.275.59-1.998.615-.59 1.334-.678 2.125-.457.484.27.824.662 1.027 1.176.242 2.926.506 5.85.008 8.775-1.166 2.188-1.943 4.725-4.779 5.455h-2z"
        />
        <path
          fill="#5547B9"
          d="M270.181 414.691l-.77-6.01c.723-1.502-.136-3.1.281-4.625.266-.42.639-.654 1.141-.68 2.161.711 3.878 2.014 5.2 3.857.49 2.477 1.33 4.947.148 7.457l-6 .001z"
        />
        <path
          fill="#6858C0"
          d="M289.182 414.691c-1.678-2.846-1.432-6.539-3.977-9.002-.658-2.029-2.428-3.674-2.107-6.049.109-.846.406-1.602 1.039-2.199 4.143.273 4.416 3.053 4.045 6.25.709 3.893 4.285 6.744 4 11h-3z"
        />
        <path
          fill="#6453B9"
          d="M184.181 414.691h-1c-1.089-5.609-.372-11.168.467-16.727 1.04-1.369 2.468-1.443 3.993-1.201 2.328.732 1.853 2.441 1.447 4.133-2.494 4.29-2.139 9.598-4.907 13.795z"
        />
        <path
          fill="#6656C0"
          d="M184.181 414.691c.279-4.969 1.198-9.754 4-14 2.888 3.99.435 8.805 2 13v1h-6z"
        />
        <path
          fill="#5344BE"
          d="M215.181 414.691c.042-1.096-.174-2.279.995-3 1.828-1.324.548-3.354 1.131-4.941.451-1.232-.159-3.318 1.98-3.338 1.573-.014 1.86 1.566 2.271 2.783.207.613.41 1.23.513 1.879.159 2.434-.293 4.689-1.89 6.617h-5z"
        />
        <path
          fill="#6151B0"
          d="M184.187 397.695c-.029 5.684-1.64 11.273-1.005 16.996h-1c-.679-6.908.063-13.809.12-20.713.119-.529.425-.725.951-.535.789.594 1.224 1.416 1.502 2.338.122.729-.011 1.385-.568 1.914z"
        />
        <path
          fill="#6455CC"
          d="M220.181 414.691l.984-7.016c-.678-4.184.585-8.053 1.908-11.92.24-.482.576-.885 1.001-1.215.95-.16 1.469.369 1.841 1.143.361 1.037.317 2.084.093 3.137-1.1 4.205-2.044 8.447-2.633 12.764-.177 1.428-.974 2.418-2.195 3.107h-.999z"
        />
        <path
          fill="#6157BF"
          d="M312.182 414.691c2.479-.752.957-4.701 3.998-5.002.52-.57 1.145-.637 1.836-.391.861.574.465 1.691 1.039 2.391.041 1 .084 2.002.127 3.002h-7z"
        />
        <path
          fill="#6657CE"
          d="M276.181 414.691c.473-2.777-.915-5.314-1.041-8.014-2.234-1.422-2.414-3.488-1.82-5.799.34-.787.837-1.379 1.785-1.385.684.482 1.047 1.18 1.306 1.947.703 2.695 1.227 5.416.798 8.227l.973 5.023-2.001.001z"
        />
        <path
          fill="#5548BE"
          d="M221.181 414.691l1.021-3.02c1.028-2.236 2.244-3.789 4.586-1.262-.195 1.428.242 2.945-.606 4.281l-5.001.001z"
        />
        <path
          fill="#4C448F"
          d="M226.181 414.691l.04-4.986c1.936-.051 1.439 1.053 1.009 2.127l-.049 2.859h-1z"
        />
        <path
        className="desaparecera"
          fill="#E0F2FE"
          d="M78.169 181.695l.016-3.995c.661-8.518 3.321-16.627 5.06-24.926.43-2.051 1.781-3.488 2.926-5.084.011-.33.016-.661.014-.991.948-1.558.27-3.76 1.991-5.01l8.009-16.993c3.281-7.921 7.134-15.461 13.981-21.009 8.546-11.444 18.623-21.271 29.894-30.104 10.525-8.247 22.051-14.537 33.968-20.312 1.639-.795 3.208-1.775 5.144-1.593.948-.747 2.237-.973 3.016-1.978l1.99-.027c2.534 3.847-1.453 5.451-2.994 8.313 1.979.676 2.95-.412 4.156-1.502 3.637-3.284 6.304-2.512 7.658 1.681 3.217-3.553 4.176-8.234 4.656-13.086 3.833-3.856 9.061-2.114 13.538-3.383 11.087-.463 22.101-2.772 33.218-1.915 8.658.668 17.481.651 25.776 3.89.869.869 2.137.79 3.135 1.304 1.458.751 1.992 2.329.457 3.028-3.053 1.393-4.865 5.227-8.938 4.545 2.33.499 4.556 1.128 7.047.576 2.162-.479 3.029.799 2.111 2.958-1.838 2.363-4.426 3.575-7.109 4.641-2.61.541-5.103 1.33-6.979 3.392-1.135 1.055-2.221 2.158-3.31 3.262-1.688 1.555-3.527 2.898-5.576 3.95a5.125 5.125 0 01-2.076.228c-2.969-.606-6.16-.14-8.756-2.521-.994-.911-2.842-.574-4.028.669-.337.323-.624.69-.907 1.06.492-.2.505-.81.935-1.091 4.404-1.229 4.788-.949 6.606 4.784.071 1.489-.999 2.646-1.173 4.065-.582 3.15.764 5.97 1.53 8.888.269 1.191.543 2.38.896 3.552.307 1.242.411 2.501.368 3.776-.054 1.013-.242 1.987-.857 2.827-1.384.965-2.492-.104-3.697-.503-4.754-1.581-6.478-.304-6.419 4.723.016 1.338.167 2.646.63 3.91.497 1.839 1.168 3.635 1.331 5.549.04 2.799 1.8 4.653 3.58 6.502 2.298 2.718 2.799 5.879 2.307 9.287-.138.986-.432 1.938-.663 2.905-.05.491-.115.98-.168 1.472-.232 1.738-.363 3.528-2.148 4.526-1.839.293-1.356-1.674-2.239-2.308-.49-.604-.894-1.248-.891-2.119-.764 1.377.758 1.592 1.126 2.374.325 1.435 1.301 2.575 1.76 3.949.223 1.598-.152 2.981-1.438 4.034-.91.487-1.764.436-2.604-.224-.365-.287-.259-.938-.849-1.013.058.631.249 1.227.489 1.815.064.475.031.937-.103 1.396-.672 1.371-1.826 2.186-3.176 2.774-2.155.909-4.474 3.286-6.404-1.066 1.218 2.985.823 4.859-2.259 5.303-2.565.369-4.748 1.879-7.638 1.609-3.405-.316-4.053 3.274-5.521 5.54-.848 1.023-1.902 1.562-3.255 1.402-1.862-.498-2.583-2.124-3.507-3.55-.266-1.947-.776-3.62-3.567-2.706.626.822 1.734 1.364 2.331 2.321 1.332 2.491-.185 4.487-1.143 6.585-1.872 2.26-5.079 2.207-7.144 4.137-4.203 1.12-8.571 1.965-10.694 6.508a2.584 2.584 0 01-1.254.57c-2.503-.476-4.543-2.275-2.943-4.367 2.756-3.602-.36-4.919-1.739-7.028-.318-.634-.491-1.308-.576-2.006-.088-.674-.105-1.353-.111-2.028.149-1.678-.512-2.921-2.013-3.724-3.415-3.144-4.413-7.506-5.921-11.624-.146-7.479-1.024-14.975.586-22.403 1.465-1.75 3.375-1.777 5.382-1.382 1.701-.496 2.207 4.767 4.607.949.653-.852 1.278-1.71 1.27-2.856.102-1.392.133-2.787.46-4.151.535-1.629.569-3.355.954-5.012.885-3.551.753-7.123.232-10.697-.336-.6-.732-1.156-1.229-1.633a5.162 5.162 0 00-1.93-.886c-8.544.938-17.166.139-25.665 1.407-2.184 2.815-.73 6.078-1.13 9.105-.313 2.374.675 5.054-1.69 6.918-2.61-.747-1.522-2.944-1.645-4.546-.189-2.473-.053-4.971-.05-6.572.981 4.061-1.708 9.315 1.282 14.086 1.314.729 1.887 2.207 3.12 3.013 1.712.747 3.534.442 5.302.566 2.606.185 4.315 1.286 4.582 4.067.156 1.377.139 2.759.135 4.14-.171 2.411.043 4.838-.23 7.241a5.985 5.985 0 01-.394 1.439c-1.427 2.404-2.688 4.82-.278 7.38.367.298.679.641.957 1.02.354.635.536 1.319.616 2.037.079.715.06 1.429-.038 2.142-.973 3.429-2.647 4.012-5.155 1.269-1.436-1.569-2.561-3.518-4.855-4.046-1.461-.248-2.874-.103-4.219.546-1.168.561-1.857 1.595-2.571 2.608-1.533 1.889-3.965 3.021-4.65 5.609-4.783 4.038-3.676 8.283-.428 12.604.507 1.092.857 2.228.994 3.423.664 2.873-1.041 6.135 1.456 8.7 1.849 1.538 4.326 2.426 5.182 4.991.335 1.533.029 2.911-1 4.109-.966 1.22-3.271 1.541-2.582 3.871.602 1.657 1.709 3.149 1.609 5.024-.049.46-.171.899-.352 1.324-2.445 2.303-2.938 4.879-1.082 7.789.375.962.663 1.943.848 2.96 2.012 6.789.404 13.857 1.647 20.699.708 2.585.107 5.32.912 7.894.463 1.673.388 3.449.972 5.1a42.485 42.485 0 004.77 11.507c.704 1.129 1.38 2.276 2.141 3.369 1.393 2.183 2.871 4.291 5.022 5.818 2.973 2.241 5.304.563 7.604-1.247 3.839-4.236 9.511-6.395 12.752-11.3 1.078-1.083 2.229-2.104 2.971-3.479.54-.972 1.034-1.971 1.711-2.859 2.586-3.453 5.183-6.897 6.945-10.875.799-2.152 2.284-3.934 3.221-6.014.526-1.051 1.017-2.118 1.531-3.177 1.243-1.648 1.502-4.648 4.787-3.519a3.7 3.7 0 01.747 1.351c.4 1.784.366 3.61.543 5.417 1.054 3.01.42 6.267 1.387 9.289.199.781.318 1.573.381 2.375.405 5.875 1.398 11.663 2.577 17.423.454 1.805.426 3.704 1.109 5.465.628 4.99 4.035 9.82.905 15.042-2.44 2.303-4.508 5.092-7.932 6.135-1.758.547-3.523 1.003-5.384.998-15.159-.046-30.318.28-45.471-.16-3.455-1-6.957-1.153-10.495-.487a5.85 5.85 0 01-2.306-.004c-4.216-2.807-4.483-4.754-.909-7.7 1.256-1.035 2.233-2.381 3.657-3.207.752-.258 1.575-.377 2.16-1.016.165-.18.341-.283.336-.345-.075-.813-.517.024-.761-.142-.608.339.096.006-.513.1-2.015.313-3.294 4.144-5.372 2.021-1.87-1.91-2.899-5.216-1.777-7.913 1.669-4.014 1.466-8.101 1.658-12.213.057-2.988 2.969-5.579 1.208-8.817-.882-1.577-1.523-3.423-3.104-4.385-3.795-2.31-5.268-6.119-6.953-9.887-2.204-4.929-3.598-10.262-7.1-14.558-.59-.718-1.044-1.521-1.464-2.345-.637-1.417-1.441-2.775-1.642-4.359.36-1.435.568-2.885.334-4.373.154-2.033 1.438-3.748 1.588-5.778.499-2.785-.15-5.245-2.063-7.353a6.559 6.559 0 01-.532-1.23c-.101-2.718-2.66-3.876-3.789-5.939-.355-1.05-.843-1.894-2.195-1.423-1.673.462-4.125.369-2.226 3.257.641.837 1.244 1.697 1.741 2.628.665 1.34 1.295 2.697 2.029 4.01.227.403.411.819.582 1.249.356.923.563 1.861.386 2.855-1.295 4.119-4.06 5.849-8.333 5.127-2.758-.749-3.609-3.205-4.801-5.357-.922-1.438-.998-3.434-2.823-4.239-.583.266-.864.76-1.072 1.313-.32 1.019-.322 2.063-.298 3.112-.269 2.589.867 5.059.628 7.64-2.184 1.77-3.724 4.146-.128 5.384 5.556 1.912 10.425 4.594 14.467 8.821 1.822 1.347 2.62 3.339 3.382 5.356a3.704 3.704 0 01-.148 2.079c-.971 1.512-1.354 3.249-1.979 5.041 1.832-.085 3.552-.528 5.231.153.488.203.908.487 1.291.848 1.555 1.719 2.491 3.788 3.287 5.905.738 1.964.813 3.843-1.528 4.919-11.868.946-23.747.327-35.62.333-1.198.001-2.24-.503-3.136-1.298l-4.007-19.99c-1.583-2.049-.782-4.478-1.055-6.731-.554-4.574-.793-9.175-1.399-13.754-.875-6.649 1.312-13.038 2.451-19.507zM308.186 55.688c12.4 5.681 24.125 12.407 34 21.99 1.172 2.851 2.879 5.006 6.031 6.048 2.049.677 3.887 2.281 4.406 4.496.813 3.462 3.105 4.418 6.221 4.433 2.578.832 4.262 2.606 5.313 5.044 1.152 3.845 4.635 6.28 6.037 9.974 1.24 2.065 1.566 4.735 3.982 6.022 3.629 4.115 6.501 8.662 8.015 13.988-7.908 1.103-15.855.262-23.781.47-5.139.135-10.283-.004-15.426.05 11.939-.001 23.879-.024 35.818.049 1.228.008 3.144-.912 3.458 1.492-1.756 1.696-3.994 1.323-6.095 1.333-11.045.053-22.09.023-33.129.029-2.541-.115-5.117.206-7.623-.428-.447-.183-.975-.383-1.193-.811-.447-.873.178-1.313.863-1.665-1.113.154-2.406-.004-2.701 1.571-.525.721-1.266 1.157-2.01 1.595-1.596.86-2.885 2.015-3.584 3.739-.537 2.797-.168 5.609-.219 8.416.002 4.69.002 9.374.021 14.057-.027 3.801-.016 7.602-.016 11.397-.164 3.94.293 7.918-.377 11.83-.984 5.738-2.5 6.414-7.535 3.579-.717-.403-1.375-.907-2.104-1.278-1.801-.592-3.518-1.364-5.041-2.517a5.08 5.08 0 01-.963-.958c-.637-.925-1.025-1.971-1.432-3.008-.598-1.984-2.412-1.63-3.846-1.992-4.333-.142-7.104-3.487-10.678-5.192-3.906-1.469-7.451-3.576-10.77-6.083-.42-.772.297-1.398.277-2.122-.391.23-.713.559-1.107.804-2.903.016-4.567-2.009-6.366-3.821-.764-.973-1.276-2.024-1.012-3.312.492-1.364 1.326-2.506 2.332-3.536a4.998 4.998 0 011.254-.629c1.345-.295 2.686-.78 4.075-.211 2.02 1.787 4.57 2.632 6.898 3.833 1.402-2.854.482-5.806.467-8.706 1.25-7.158 4.004-14.011 4.35-21.356a7.422 7.422 0 01.402-2.081c.18-.439.428-.838.727-1.205 1.434-1.571 3.734-3.109.146-4.836a3.238 3.238 0 01-.82-1.023c-.42-1.211-.916-2.388-1.752-3.395a5.513 5.513 0 01-.473-1.232c-.299-1.481-.225-3.062-1.189-4.359-.453-1.137-.58-2.388-1.189-3.478-.227-1.059.092-2.055.33-3.063.092-.407.219-.804.354-1.197.344-.99.5-2.02.617-3.057.141-1.07.475-2.095.68-3.149.178-1.071.293-2.155.666-3.186.502-1.175 1.275-2.22 1.648-3.459.127-.404.289-.796.465-1.181.557-1.122 1.107-2.247 1.344-3.494.301-1.639.918-3.214.918-4.905.027-1.547-.748-2.732-1.727-3.829-.848-1.064-1.303-2.314-1.736-3.577-.566-2.156-.916-4.381-2.076-6.342-1.176-3.83-5.162-1.714-7.322-3.458a1.829 1.829 0 01.023-1.381 28.299 28.299 0 019.627-6.331c4.857.514 8.661 4.113 13.527 4.604z"
        />
        <path
          fill="#3B8FF6"
          d="M116.198 383.836c-.951-.506-2.301.021-2.997-1.15 1.798-2.619 4.604-2.365 7.217-2.393 9.804-.098 19.609-.016 29.414-.055 1.635-.006 3.309.291 4.921-.354.373-1.08-.615-1.148-1.071-1.156-11.131-.193-21.836-4.125-33.053-3.707-2.582.098-5.722-.053-5.013-4.26 1.951-4.313 5.321-4.666 9.557-3.957 9.452 1.584 18.892 3.699 28.535 3.373 5.922-.199 11.353 2.473 17.259 2.176 5.201-.262 10.662 3.002 15.548-1.262 1.673 3.729-.222 7.156-.9 10.695a6.263 6.263 0 01-.768 1.609c-.219.213-.439.418-.665.627a4.16 4.16 0 01-1.837.166c-20.913-.027-41.822-.016-62.731-.002-1.155.002-2.325.236-3.416-.35z"
        />
        <path
          fill="#3992F9"
          d="M116.184 370.689c-.216 2.498 1.168 3.029 3.362 3.033 5.218.008 10.422.199 15.624.873 2.473.32 4.793.777 7.19 1.498 2.876.865 5.826 1.715 9.142.844 3.246-.852 6.14.383 7.058 4.752-12.557 0-24.8.037-37.042-.029-2.838-.016-5.608.16-8.316 1.025-1.83-.182-1.542-2.5-3.043-3.014a4.794 4.794 0 01-.804-1.277c-.325-1.484-.298-2.949.259-4.379 1.397-.975 4.026-.309 3.941-3.342-.033-1.182 1.283-1.793 2.633-1.197.312.407.326.809-.004 1.213z"
        />
        <path
          fill="#E755EC"
          d="M68.278 287.688a2.773 2.773 0 01-.257-.888 2.812 2.812 0 01-.237-1.413c.811-6.17 2.441-7.23 7.987-5.212.639.188 1.271.407 1.892.646.408.124.816.257 1.229.358 3.045-.423 6.084-.871 9.173-.72a57.884 57.884 0 012.125-.035 23.01 23.01 0 011.485-.024c1.027-.024 2.049-.048 3.075-.044 2.165.047 4.354-.241 6.461.512 1.153.56 1.651 1.446 1.359 2.728-1.319 4.337-4.305 5.712-8.713 5.596-6.141-.163-12.301-.327-18.449.28-2.512.247-4.909-.558-7.13-1.784z"
        />
        <path
        className="desaparecera"
          fill="#E2F2FC"
          d="M294.182 51.691c-2.65 2.525-5.57 4.647-8.998 6.006-3.002-2.052-7.171-3.393-5.247-8.335-4.945-.288-2.299 4.841-4.574 6.591-.702.362-1.401.397-2.095-.019.115-1.028.366-3.225-1.175-1.886-3.211 2.789-5.442-.784-8.169-.496-1.447.152-1.971-1.227-1.505-2.456.598-1.578 1.44-.479 2.233.007 1.537.942 2.783.418 3.909-.84 1.398-1.56 3.015-2.845 5.416-3.004-1.042-2.055-3.43-1.695-3.791-3.588 7.808-.401 14.708 3.172 22.005 5.016.602.761 1.816.245 2.357 1.134.265.699.208 1.336-.366 1.87z"
        />
        <path
        className="desaparecera"
          fill="#E3F0FC"
          d="M196.291 46.693l1.888-1.005c-1.125 3.489 2.784 8.466-3.171 10.589-.647.23.177 1.116.344 1.707.556 1.968-.965 2.905-2.314 2.917-1.108.01-2.577-1.141-2.094-2.719.352-1.149 1.358-2.184-.708-2.403-1.286-.137-3.267-.52-3.602.836-1.23 4.98-4.777 2.473-7.648 3.009.578-4.216 6.164-5.357 5.193-9.949l4.003-1.985 2.134-.009c2.233 1.133 4.452 2.177 5.975-.988z"
        />
        <path
          fill="#E14FE8"
          d="M68.278 287.688c8.711.001 17.422-.008 26.133.009 2.905.005 6.257.734 5.929-4.012l1.836.002c.684.468 1.119 1.132 1.491 1.852 1.579 4.274.584 5.912-4.112 6.382-4.614.462-9.3-.369-13.894.694-4.357.119-8.712.094-13.068.024-.922-.032-1.716-.374-2.4-.984-.629-1.327-2.485-2.061-1.915-3.967z"
        />
        <path
          fill="#FA88F8"
          d="M67.168 249.473a1.157 1.157 0 01-.002-.626c-.528-1.031.16-1.421.93-1.769 5.244 2.075 10.919-.005 16.215 1.658.509.224.939.55 1.303.969.965 1.861.92 3.642-.429 5.313-4.047 1.092-8.209 1.559-12.375 1.763-1.994.098-3.879-.643-3.961-3.044-.827 1.303 2.181 4.617-2.053 4.71a9.55 9.55 0 01-.112-1.601c-.327-2.495-1.188-5.017.484-7.373z"
        />
        <path
          fill="#7B9AD1"
          d="M408.178 129.532l10.081.316c2.633 1.056 5.557-.457 8.156.923.098.637-.119 1.13-.652 1.49-3.734 1.589-7.676.424-11.494.896-2.715.067-5.424.073-8.112-.407-5.34-1.331-10.771-.394-16.156-.647-5.258-.023-10.516-.013-15.771.004-5.277-.029-10.557-.014-15.834-.003-5.209-.363-10.49.724-15.648-.762-.654-.377-.773-.882-.357-1.513l39.757-.213c.338-.426.693-.42 1.063-.04l24.967-.044z"
        />
        <path
          fill="#577CD6"
          d="M108.037 355.699l.284-8.068c.63-7.051.54-14.097.016-21.154-.23-3.097-.569-6.24.341-9.315.918-1.17 1.533-.403 2.157.333 1.224 2.61.651 5.389.749 8.104.011 2.653-.056 5.309.004 7.963.094 2.04.105 4.081.004 6.12.048 3.166.029 6.333-.026 9.498.013 1.126.09 2.254.033 3.381-.125 1.658.029 3.325-.082 4.985-.042 1.107-.15 2.209-.4 3.291-1.311 3.393.261 7.182-1.436 10.523-.396.525-.869.605-1.418.244l.022.021c-1.221-1.287-1.149-2.6-.083-3.934-.056-3.998-.111-7.994-.165-11.992z"
        />
        <path
        className="desaparecera"
          fill="#E1F3FA"
          d="M352.196 85.687l6.994 7.999c-4.063.482-7.396.247-7.768-5.205-.17-2.503-3.055-4.223-4.955-4.306-5.033-.219-4.311-3.403-4.281-6.497 1.732-.124 2.605 1.451 3.99 2.016.965 1.701 2.289 3.043 4.008 3.989 1.106.231 1.775.9 2.012 2.004z"
        />
        <path
          fill="#EFFAFA"
          d="M418.225 49.672c.813.037 1.545.224 1.961 1.019.064 10.436-2.713 20.692-1.947 31.184.107 1.489.428 3.502-1.973 3.919l-.209-.238a4.43 4.43 0 01-.998-2.114 9.345 9.345 0 01-.156-1.592c-.021-1.898-.027-3.796.42-5.661 1.15-5.221-.063-10.557.766-15.79.916-2.555.729-5.233.848-7.879a5.386 5.386 0 01.346-1.56c.259-.469.575-.897.942-1.288z"
        />
        <path
          fill="#D578D8"
          d="M70.205 243.93c.288-.17.596-.286.924-.348 16.651-1.163 33.315-1.164 49.988-.576.647.291.985.791 1.015 1.499a3.335 3.335 0 01-1.51 1.169c-16.526.558-33.054.951-49.578-.195-.643-.319-.922-.836-.839-1.549z"
        />
        <path
          fill="#C6BFD9"
          d="M122.142 243.655l-51.013-.072c3.539-1.91 7.378-.355 11.03-.957 12.805-.963 25.628-.151 38.439-.419a2.314 2.314 0 011.722.535l-.178.913z"
        />
        <path
          fill="#E4F2F9"
          d="M344.292 323.83c-3.447 4.007-8.41 6.153-12.098 9.864-1.395.551-2.27 2.145-4.01 2.003a63.606 63.606 0 00-.404-.651c2.58-5.866 7.133-9.629 12.941-11.985 1.252-.509 2.604-.519 3.571.769z"
        />
        <path
          fill="#E1F0F5"
          d="M383.209 129.576l-1.063.041c-1.521-1.548-3.464-.887-5.222-.896-11.141-.059-22.281-.029-33.432-1.037h38.699c.772.398.967 1.106 1.018 1.892z"
        />
        <path
        className="desaparecera"
          fill="#553AD3"
          d="M365.946 354.719c3.293-2.469 6.59-4.933 11.109-4.012.402.498.809.996 1.213 1.494.88 2.781-.225 4.371-2.977 4.978-3.945-.83-4.721 6.256-9.342 3.736-.857-2.063-1.165-4.13-.003-6.196z"
        />
        <path
          fill="#F6EDFA"
          d="M122.039 242.603l-39.879.023c.012-.315.021-.63.025-.945l39.813.042.393.422-.352.458z"
        />
        <path
          fill="#98BFDE"
          d="M510.12 169.57c-.277.106-.557.201-.842.284-1.305-1.017-1.348-2.49-1.441-3.945-.125-2.77.301-5.583-.645-8.292-.5-2.456-.316-4.946-.385-7.424-.023-1.864.045-3.729.107-5.593.018-.53.104-1.051.236-1.563.145-.508.396-.963.74-1.363.469-.297.955-.32 1.451-.073.229.455.336.942.318 1.454.203 2.176-.41 4.401.373 6.549l.258 6.091c-.055 4.624-.114 9.25-.17 13.875z"
        />
        <path
        className="desaparecera2"

          fill="#6395EC"
          d="M49.464 226.683c-3.375 1.906-6.771 1.938-10.19.119a19.077 19.077 0 01-.157-1.014c-.469-1.23-.965-2.458-.414-3.797.555-.88 1.396-1.149 2.376-1.107 2.033 1.005 4.077 1.79 6.157.061.94-.213 1.811-.079 2.603.494.867 1.1.915 2.35.696 3.653a3.621 3.621 0 01-1.071 1.591z"
        />
        <path
        className="desaparecera"
          fill="#E6F1F9"
          d="M294.182 51.691l-.002-1.993c2.113-1.438 3.896-.331 5.344 1.015 1.66 1.545 4.047 1.484 5.659 2.977l3.004 1.999c-5.542 1.724-9.24-3.007-14.005-3.998z"
        />
        <path
        className="desaparecera2"

          fill="#8E7BFB"
          d="M48.154 214.215c.541.755 1.081 1.512 1.621 2.269.363.642.472 1.324.329 2.05a2.647 2.647 0 01-1.463 1.479c-3.211.725-6.399 1.08-9.452-.621-.726-1.04-.657-2.02.228-2.935 1.006-.611-.446-2.315 1.179-2.651 2.591-1.203 5.147-1.744 7.558.409z"
        />
        <path
          fill="#D874D9"
          d="M67.078 285.888c-1.501-5.029-.707-10.173-.77-15.274.986-1.938-.217-4.168.813-6.104.569-.17 1.059-.041 1.475.382.959 1.477.94 3.14.942 4.802-.025 1.937.097 3.876-.069 5.812a11.72 11.72 0 01-.377 2.479c-1.402 2.446-.12 5.582-2.014 7.903z"
        />
        <path
          fill="#E7F2F9"
          d="M328.184 335.697c-2.682 3.083-6.092 4.953-9.996 6-.133-.203-.268-.406-.402-.608 2.33-5.643 5.492-7.286 10.393-5.404l.005.012z"
        />
        <path
          fill="#E6F3FA"
          d="M374.176 113.695c-4.713.232-3.941-3.164-3.982-6.022 2.363 1.321 3.601 3.388 3.982 6.022z"
        />
        <path
          fill="#D871DB"
          d="M67.168 249.473l-.026 8.235c-.365.443-.706.405-1.027-.051-.056-2.78-2.705-5.894 1.053-8.184z"
        />
        <path
          fill="#CB68CB"
          d="M66.115 257.658c.343.017.685.033 1.027.051.036.313.069.628.1.943 1.622 2.007 1.481 4.006-.029 5.999-.374 1.977.726 4.178-.906 5.964l-.192-12.957z"
        />
        <path
    className="desaparecera2"
          fill="#7686DC"
          d="M39.416 216.458l-.053 2.615c.698.867.694 1.717-.057 2.55l-.188 4.165c-3.02-3.21-3.818-6.349.298-9.33z"
        />
        <path
          fill="#CA8FC8"
          d="M70.205 243.93c.016.28.038.56.064.84.253.409.293.832.089 1.273-.494.824-1.509.987-2.116 1.67l-1.077 1.133c-1.756-3.349.777-4.05 3.04-4.916z"
        />
        <path
          fill="#B461B5"
          d="M67.078 285.888c.682-2.651-.75-5.567 1.011-8.084 1.579 2.58.467 5.219.171 7.84l-.237 1.157-.945-.913z"
        />
        <path
        className="desaparecera2"
          fill="#7A8BD1"
          d="M49.481 219.059l.146-1.429c2.434.335 3.794 1.325 2.426 3.978-.153.361-.18.732-.082 1.111-.956.799.036 3.229-2.362 2.82l-.104-3.919c-.75-.848-.752-1.702-.024-2.561z"
        />
        <path
          fill="#6754A4"
          d="M183.362 386.016c.277-.438.555-.873.833-1.309 3.38 1.189.847 3.012.495 4.604a1.826 1.826 0 01-1.315.619c-.539-.275-.656-.676-.353-1.199l.34-2.715z"
        />
        <path
          fill="#E2F1F9"
          d="M316.182 343.695l-1.996.006c-.129-.244-.258-.489-.389-.733.74-2.888 2.457-2.43 4.377-1.278l.014.008-2.006 1.997z"
        />
        <path
          fill="#EDF7F7"
          d="M182.188 49.702c-.112 2.021-1.558 2.009-3.016 1.978.577-1.313 1.57-1.991 3.016-1.978z"
        />
        <path
        className="desaparecera"
          fill="#E0F0FC"
          d="M257.124 362.678l-15.816.014c-1.811-3.275.479-6.117.954-9.157.874-2.574 1.35-5.474 4.792-5.997 1.925-.243 3.837-.256 5.712.355.772.318 1.384.837 1.863 1.515.788 1.385.911 2.996 1.514 4.447.451 2.924 3.065 5.618.981 8.823z"
        />
        <path
          fill="#40278D"
          d="M257.124 362.678l-1.967-8.926c-.529-1.238.239-2.022 1.208-2.108 2.381-.211 2.592 2.015 3.754 4.255-1.412-3.375-.412-5.704.616-8.03a1.524 1.524 0 011.25-.462c1.362.915 1.382 2.35 1.46 3.765.097 1.757.951-.073 1.352.282 1.671.767 2.113 2.292 2.439 3.892 1.222 4.336-1.863 5.316-4.909 6.326-.811 1.092-.354 2.406-.635 3.592-.548 1.02-1.095 2.041-2.553 1.432l-2.015-4.018z"
        />
        <path
          fill="#4A3299"
          d="M239.289 367.973c-.462 5.811-3.296 10.998-4.363 16.648-3.358-2.518-2.21-6.686-3.636-9.918 1.127-3.635 1.235-7.828 5.342-9.855 2.094.015 3.56.564 2.657 3.125z"
        />
        <path
          fill="#503EAC"
          d="M269.054 405.986l-3.728-15.279a4.318 4.318 0 011.137-.836c1.389-.398 2.793-.693 4.255-.623.487.148.875.436 1.184.836 1.287 3.191 2.721 6.359 1.811 9.945-.856 1.521-2.596 2.205-3.521 3.668l-.029.01c-.747.576-.206 1.779-1.109 2.279z"
        />
        <path
          fill="#5345B4"
          d="M227.23 411.832l-1.01-2.127c-1.398.535-3.065.523-4.019 1.967.425-4.461.997-8.887 2.961-12.996 1.812-1.773 3.38-2.08 4.019.908.446 2.084.339 4.232.116 6.357v.723c-.688 1.723-1.377 3.445-2.067 5.168z"
        />
        <path
          fill="#462E90"
          d="M239.289 367.973c-.088-2.051-1.458-2.357-3.108-2.285-1.337-1.5-.183-2.949.083-4.42.136-.43.314-.84.51-1.244 1.494-2.5 2.254-5.416 4.286-7.619a2.66 2.66 0 011.381-.214c.708.301 1.282.667.764 1.564l-1.897 8.936-2.019 5.282z"
        />
        <path
          fill="#4B349C"
          d="M266.192 390.674c-.289.012-.577.023-.866.033-1.5-4.186-2.536-8.488-3.189-12.885-.447-4.369-.168-4.609 3.852-3.305 1.689 1.34 2.086 3.17 1.975 5.193-1.093 2.186-2.025 4.322-.953 6.898.56 1.349.356 2.892-.819 4.066z"
        />
        <path
          fill="#4B36A1"
          d="M232.186 374.699c2.147 2.967 1.529 6.697 2.74 9.922l-.421 1.17c-.929.404-1.576 1.301-2.621 1.508-1.823.139-2.908-.791-3.511-2.422-.625-3.168 1.165-5.869 1.707-8.816.161-.488.414-.926.744-1.318.441-.372.896-.386 1.362-.044z"
        />
        <path
          fill="#4A3296"
          d="M265.196 374.664c-3.049-.912-3.036 1.141-3.06 3.158-1.54-3.563-2.748-7.217-2.998-11.127.988-.369 1.661-1.061 2.063-2.027 1.446-.498 1.732.771 2.356 1.535.212.371.383.762.53 1.162.455 1.664 1.325 3.172 1.812 4.828.154.934.078 1.805-.703 2.471z"
        />
        <path
          fill="#4D3C95"
          d="M232.179 386.695c.539-.912 1.408-.971 2.327-.904-.953 2.152-1.269 4.438-1.381 6.762l-1.077 2.1c-3.603-2.714-1.047-5.325.131-7.958z"
        />
        <path
          fill="#493F90"
          d="M269.054 405.986c.169-.857.219-1.773 1.108-2.279-.172 1.67.569 3.479-.751 4.975l-.357-2.696z"
        />
        <path
          fill="#52B1F0"
          d="M304.127 348.739c1.68 4.83 3.317 9.677 5.063 14.484.75 2.064 1.289 4.119 1.045 6.328.48.684.463 1.41.186 2.156a1.92 1.92 0 01-1.383.463c-1.094-.26-1.557-1.08-1.836-2.063-.236-1.568-.486-3.135-1.568-4.412-.313-.627-.49-1.293-.588-1.982-.104-3.088-1.952-5.578-2.895-8.375-.447-1.053-.83-2.127-1.016-3.259-.162-1.079-.328-2.157-.885-3.128-.912-1.553-1.232-3.302-1.693-5.007-.221-.881-.309-1.764-.029-2.648.184-.418.488-.721.893-.925.447-.033.848.096 1.197.378.85.967 1.277 2.187 1.938 3.27.225.356.414.731.596 1.109.434.96.912 1.907 1.02 2.979-.016.21-.031.421-.045.632z"
        />
        <path
          fill="#E4F2F9"
          d="M314.186 343.701c-2.729 2.925-6.383 4.004-10.059 5.038l-.023.031c-.521-1.084-.666-2.181-.109-3.303 3.161-1.931 6.221-4.453 10.186-1.78l.005.014z"
        />
        <path
          fill="#5AB1F0"
          d="M315.948 388.629c.777 5.025 2.549 9.91 2.162 15.104-2.758-.373-.504-3.059-1.879-4.07l.008-.027c-1.18-1.012-1.693-2.373-2.021-3.834-.305-1.65-.289-3.352-.783-4.977-.188-.988-.191-1.959.309-2.873 1.12-1.036 1.702-.306 2.204.677z"
        />
        <path
          fill="#50BAED"
          d="M311.346 371.676c1.254 3.252 2.451 6.52 2.785 10.025-.543 1.021.266 2.58-1.271 3.209-3.197-2.1-1.578-6.049-3.354-8.699a6.913 6.913 0 01-.313-1.5c-.078-1.072.156-2.047.904-2.857.047-.768.092-1.535.137-2.303 1.028.365.903 1.332 1.112 2.125z"
        />
        <path
          fill="#5F5CBC"
          d="M316.231 399.662c.625 1.357 1.252 2.713 1.879 4.07l.186 2.668c.428 1.125.672 2.242-.174 3.303l-1.941-.014c.017-3.343.032-6.685.05-10.027z"
        />
        <path
          fill="#6CB3E4"
          d="M313.206 384.588c.006-1.061-.186-2.184.926-2.887.664 1.699 1.326 3.4 1.988 5.102l-.17 1.826-1.73-.949c-1.008-.256-1.48-.961-1.617-1.941.038-.468.249-.848.603-1.151z"
        />
        <path
          fill="#6671BB"
          d="M318.122 409.703l.172-3.303c1.029 1.652.916 3.467.762 5.289-.313-.662-.624-1.324-.934-1.986z"
        />
        <path
          fill="#705DBE"
          d="M208.181 398.691c-.967 4.557-4.759 7.629-9.114 6.938-5.437-.861-1.871-5.295-2.886-7.938-1.079-1.455-1.208-2.91-.01-4.369 4.03-1.689 8.057-1.709 12.083.031 1.289 1.795 1.471 3.579-.073 5.338z"
        />
        <path
          fill="#6953BA"
          d="M218.194 395.697c-1.096.139-2.083.633-1.927 1.83.519 3.98-2.144 4.676-5.084 5.164l-.002-1.002c-.302-3.633-.427-7.213 1.691-10.486 1.097-1.695 1.06-3.369-.465-4.982-.773-.818-2.415-1.756-.64-3.215 3.24-1.023 6.486-.934 9.74-.105.512.252.874.648 1.09 1.176-.179 4.035-1.011 7.904-2.973 11.482-.439.423-.916.468-1.43.138z"
        />
        <path
          fill="#7059BC"
          d="M211.172 383.773c3.489 1.725 5.365 4.496 2.855 7.883-2.338 3.154-.85 7.018-2.846 10.033a6.264 6.264 0 00-3-2.998l-.001-5c-.1-.131-.237-.246-.293-.395-1.247-3.27 1.128-7.008-1.304-10.133 1.664-.78 3.229-.849 4.589.61z"
        />
        <path
          fill="#6A58BB"
          d="M190.181 413.691c-2.395-.326-1.971-2.18-1.988-3.746-.034-3.084-.011-6.17-.012-9.254-.33-1 1.158-2.002-.002-3.002-.961-1.094-1.141-2.305-.556-3.633 3.561-2.178 3.306 1.344 4.356 2.92.07.238.137.477.204.715-.001 3.77-.126 7.547.047 11.309.093 2.02-.637 3.445-2.049 4.691z"
        />
        <path
          fill="#7059BC"
          d="M196.184 393.691l-.002 4c-1.333-.037-2.666-.971-3.999 0l-.001-.002c-2.696-5.977 1.634-9.967 4.093-14.492 2.057-1.07 4.152-1.025 6.27-.227.423.27.875.654.77 1.146-.366 1.709-2.973.938-2.965 1.732.019 1.936-.815 3.488-1.351 5.182-.439 1.388-1.755 1.902-2.815 2.661z"
        />
        <path
          fill="#6F5CBF"
          d="M303.182 404.691c-2.893 4.266-8.623 4.373-11.043.107-.721-1.27-1.512-2.045-2.957-2.107-.373-2.996-2.414-5.766-1.221-8.977 4.711 2.166 9.852 2.766 14.82 4.025 1.535 2.24 2.313 4.519.401 6.952z"
        />
        <path
          fill="#6D59BD"
          d="M303.182 404.691c.316-2.426-.426-4.701-1-7-1.975-3.178-1.443-7.033-2.811-10.375a2.994 2.994 0 01.463-1.449c5.67.26 5.743 5.182 7.348 8.824-.221 4.615.805 8.941 2.998 12.998-2.623-.32-4.644-2.046-6.998-2.998z"
        />
        <path
          fill="#6D57BB"
          d="M288.182 393.691c.031 3.033 2.354 5.813 1 9l-1 1c-1.492-1.895-1.277-4.928-4-6.002-1.793-3.154-1.865-6.686-2.24-10.156.537-1.846 1.588-3.271 3.371-4.092 1.283.137 1.666 1.115 2.014 2.135.136 2.717 2.831 5.174.855 8.115z"
        />
        <path
          fill="#5241B3"
          d="M277.208 409.668l-1.966-8.02c1.251-3.363 3.313-6.109 6.23-8.211 2.924 1.213 1.354 4.367 2.705 6.26.342 1.998.686 3.994 1.027 5.992-4.034-1.726-6.305-.597-7.996 3.979zM218.194 395.697c.328-.004.656-.006.984-.008 1.658-.123 3.31-2.832 4.976-.016l-2.989 12.002-1.824-3.539-1.203.117c0 2.492.271 5.023-.08 7.465-.323 2.246-1.271 2.082-1.883-.027-.495-5.478 2.245-10.548 2.019-15.994z"
        />
        <path
          fill="#6753B7"
          d="M313.168 385.691l1.051 1.988c.012.959.021 1.918.033 2.879.801 1.629.242 3.373.426 5.057.184 1.402.686 2.844-.49 4.084-.244 2.436.531 4.963-1.148 7.574.082-5.516-2.127-9.912-5.857-13.584-2.563-5.412-3.696-11.473-7.493-16.338-.725-.928-.545-2.188.039-3.273 3.629-2.215 4.102 2.324 6.393 2.98 1.721 1.82 2.67 4.211 4.424 6.01.529 1.215 1.529 1.965 2.622 2.623z"
        />
        <path
          fill="#6D55B8"
          d="M300.182 373.689c.059 4.74 4.288 7.598 5.395 12.086.646 2.617 1.627 5.141 1.605 7.914v1.002c-2.756-2.672-3.442-6.951-7-9-1.902-2.971-5.365-5.152-4.75-9.398.434-1.158 1.328-1.938 2.238-2.705.607-.412 1.264-.533 1.975-.33l.537.431z"
        />
        <path
          fill="#5F5CBC"
          d="M314.188 399.699l.043-4.059c.303-.414.611-.4.93-.018.678 1.252 1.346 2.506 1.078 4.012l-2.051.065z"
        />
        <path
          fill="#5040B6"
          d="M270.192 403.697c.213-1.793-.879-4.889 3.009-3.014.331-.461.654-.479.968.02-.021 2.047-.139 4.111.972 5.975-2.309.101-3.116-2.291-4.949-2.981z"
        />
        <path
          fill="#6853BB"
          d="M284.178 399.697l-2.992-6.014c-3.017-1.77-2.345-4.975-2.992-7.67.077-1.08.343-2.059 1.436-2.57 2.765.094 2.666 2.582 3.552 4.248.799 3.287 1.27 6.605 1 9.998 0 .668-.002 1.338-.004 2.008z"
        />
        <path
          fill="#6650B3"
          d="M188.185 393.691l-.007 3.998-3.992.006-.01-2.02c-.519-.537-.48-1.184-.359-1.842.668-1.104 1.195-2.23.553-3.541a31.892 31.892 0 01-.19-.598c-.677-1.666 1.772-3.32.015-4.988a9 9 0 01-.283-.936l.375-.211c.659-.477 1.34-.453 2.035-.092 1.003 1.918 2.792 3.063 4.384 4.41 1.254 2.852-.487 4.396-2.521 5.814z"
        />
        <path
          fill="#5A4A8F"
          d="M184.219 393.68l-.043 1.996c-.894-.488-.917-1.41-1.117-2.246l.299-3.738c.274.004.547.006.821.004l.042.004c1.025 1.327 1.027 2.654-.002 3.98z"
        />
        <path
          fill="#4F3CAC"
          d="M232.179 386.695c.914 2.668-1.831 5.275-.132 7.957l-3.168 11.938c-1.326-1.895-.789-4.076-.623-6.057.269-3.199-1.769-1.762-3.093-1.857l.036-2.973c.49-3.975-.185-8.369 3.977-11.02.561 1.329 1.558 2.005 3.003 2.012z"
        />
        <path
          fill="#4D3AAB"
          d="M224.155 395.674c-1.469-.814-2.661-.367-3.781.74-1.232 1.219-1.02-.109-1.195-.725.649-3.768 1.23-7.553 2.976-11.023 2.692.133 3.936 1.813 4.501 4.215-.438 2.102-.572 4.334-2.44 5.842-.012.316-.033.634-.061.951z"
        />
        <path
          fill="#614CBF"
          d="M224.216 394.723l1.918-6.068c-1.222-4.99 1.568-8.861 3.612-12.945.461-.357.942-.383 1.441-.082l-2.012 9.057-3.977 11.02c-.326-.328-.654-.656-.982-.982z"
        />
        <path
          fill="#4F3BAE"
          d="M279.172 385.711c.671 2.656 1.343 5.314 2.013 7.973-.844 3.504-3.787 5.443-5.944 7.967-.032-.646-.065-1.289-.099-1.934-2.733-2.559-2.135-6.34-3.452-9.416-.07-.965-1.035-1.635-.893-2.67.402-1.283 1.652-2.998 2.473-2.154 2.096 2.156 3.152-.75 4.711-.445.462.114.855.347 1.191.679z"
        />
        <path
          fill="#6350C2"
          d="M272.166 389.695l2.978 10.021-.975.986a31.32 31.32 0 00-.969-.02c.204-3.826-1.896-7.227-2.038-10.988.336-.401.67-.401 1.004.001z"
        />
        <path
          fill="#926ECF"
          d="M230.537 145.829l2.59-2.236c1.84.563 2.056 2.399 2.935 3.72.586 1.007 1.027 2.069 1.212 3.226.274 2.475 1.063 4.763 2.5 6.815 1.032 2.051 2.156 4.058 2.949 6.227.093.478.078.952-.019 1.428-.771 1.648-2.186 1.729-3.715 1.531a3.646 3.646 0 01-1.273-.613c-2.671-2.309-3.723-5.714-5.713-8.484-.346-.896-.524-1.853-.674-2.146.395.353.123 1.649.934 2.526 1.738 2.967 3.169 6.132 5.674 8.592 2.375 1.852 3.778 4.527 5.715 6.751.977 1.123 1.743 2.485.375 3.938-6.782.627-12.191-3.297-18.139-5.455-.877-.582-1.729-1.195-2.348-2.069-2.142-3.499-1.489-7.499-1.918-11.308-.227-.637-1.184.108-.56-.127.188-.072.301.012.347.247.659 3.4.428 6.726-.842 9.965-2.104 1.539-4.101.275-5.986-.425-2.896-1.075-5.854-1.958-8.747-3.036-1.626-.894-3.383-1.685-3.336-3.981.227-1.733 1.671-1.759 2.912-2.07l2.77-1.264c4.08-3.548 9.348-4.693 14.103-6.848 2.963-1.346 5.988-2.443 8.254-4.904z"
        />
        <path
        className="desaparecera"
          fill="#E0F1FC"
          d="M176.209 161.69c2.06 1.965 6.971 2.824 2.123 7.197-1.956 1.765.618 2.965 2.082 3.904 1.337 2.024.07 3.9-.315 5.829-.786 2.035-.918 4.327-2.336 6.122-2.274 1.57-4.49 3.193-5.108 6.153a4.639 4.639 0 01-1.647 1.539c-1.725.626-3.44 1.606-5.231.172-.951-1.39-.884-2.985-.928-4.559-.134-2.414.457-4.886-.561-7.233a6.217 6.217 0 01-.849-1.987c-.242-1.491.294-2.808.92-4.104.937-1.792 2.08-3.462 3.165-5.167 1.051-1.367 2.233-2.637 3.123-4.129a8.046 8.046 0 012.882-2.436c.905-.403 1.731-.981 2.68-1.301z"
        />
        <path
          fill="#8F7EE8"
          d="M182.249 251.14c-3.159 5.206-9.037 7.332-13.074 11.544-2.936 1.305-5.859 2.724-9.142 1.068-2.319-1.419-3.751-3.574-4.93-5.94-.414-2.487 1.612-3.305 3.077-4.508 2.411.172 4.904.65 6.431-2.06.213-.379.851-.66 1.303-.629 5.527.379 9.173-3.785 13.764-5.653 1.934-.158 2.941-1.051 2.995-3.145.072-2.822 1.092-5.505 1.572-8.275.203-1.171.548-3.025 2.49-1.271 1.556 4.351 1.301 8.62-.511 12.827.405 1.238-.856 1.702-1.203 2.591-1.354.805-2.467 1.803-2.772 3.451z"
        />
        <path
          fill="#AB9AED"
          d="M146.106 229.83c-1.92-7.267-.372-14.828-1.876-22.13 2.278-1.219 3.384 1.794 5.516 1.476-.977-.21-2.155-.148-1.681-1.647 1.075-1.009 2.471-1.117 3.814-1.37 2.723.637 4.894-1.037 7.292-1.764.746.221 1.521.779 2.277.251 3.432-2.396 3.618.159 3.954 2.542.065 1.471-.013 2.926-.348 4.361-.612 1.549-.522 3.485-2.362 4.366-3.968 2.063-8.333 3.152-12.391 4.985-1.752.792-2.524 2.478-2.778 4.394-.209 1.583.094 3.351-1.417 4.536z"
        />
        <path
          fill="#BB5D75"
          d="M238.131 135.674c1.071-1.474 1.228-3.195 1.339-4.93.345-.017.769-.017.912.22 4.567 7.524 9.198 15.016 12.584 23.186-.324 2.316-2.165 2.547-3.937 2.878-1.752.023-2.993 1.621-4.771 1.579-1.009-.009-1.889-.348-2.629-1.037-1.662-1.663-2.389-3.974-3.948-5.716-.703-1.487-.97-3.168-2.009-4.51-.59-1.403-.689-2.854-.442-4.342.178-.471.413-.911.7-1.324l1.37-3.787c.384-.699.072-1.658.831-2.217z"
        />
        <path
          fill="#8671C8"
          d="M118.214 189.607c.031.276.046.553.045.83 1.781 2.443 2.618 5.215 2.841 8.198.286 2.374-1.748 3.945-2.11 6.095-1.139 1.521-2.837 2.227-4.446 3.066-2.489 1.174-4.957 2.397-7.544 3.361-3.149-.194-6.301-.389-8.119-3.595-.304-1.23.125-2.351.526-3.478.191-.434.456-.823.766-1.182 1.328-1.496 3.213-1.721 4.996-2.183 4.218.797 6.641-1.239 7.948-5.036 1.183-1.2-.281-1.411-.745-1.995l-.272-.972c.782-1.871 2.833-2.543 3.909-4.142 1.119-.477 1.609.392 2.205 1.033z"
        />
        <path
          fill="#9887EB"
          d="M153.221 254.671c-2.521-3.615-4.673-7.387-5.079-11.904-.452-.773-.542-2.16.275-1.977 4.712 1.061 7.732-3.116 11.894-3.565 3.499.047 7.159 1.1 10.022-2.158 1.223-1.392 2.85-1.676 4.378-.181.782 1.423.734 2.886.234 4.373-1.138 1.608-1.485 3.546-2.186 5.337-.917.957-1.837 2.003-2.957.214-.161-.257.099-.606-.167-.849-2.458 4.094-7.051 3.624-10.764 5.05-.535.854-3.866-2.167-2.305 1.865.912 2.345-.216 4.296-3.345 3.795z"
        />
        <path
          fill="#614EBD"
          d="M198.205 224.762l-1.146 2.895c-2.09.2-3.515-.956-4.366-2.603-2.997-5.8-8.508-9.788-11.24-15.768-.71-2.79.471-4.383 3.169-5.021 1.041-.189 1.954.145 2.813.689 2.422 1.745 4.849 3.489 7.711 4.493 3.305 4.647 6.146 9.39 3.059 15.315z"
        />
        <path
          fill="#93336A"
          d="M252.181 153.703c-4.774-7.356-8.668-15.199-12.711-22.958l-.089-1.042c3.394-1.069 3.323 2.545 5.054 3.725.928 2.564 2.432 4.659 4.909 5.957a398.612 398.612 0 014.657 5.076c.389.518.835 1.067.895 1.695.454 4.81 3.027 4.524 6.287 2.661 2.221-.6 4.354-.148 6.468.521.466.126.918.294 1.364.478 1.092.487 2.263.819 3.236 1.561.306.396.496.838.565 1.334a3.526 3.526 0 01-.342 1.43c-1.091 1.451-2.314 2.602-4.344 1.859-.545-.451-.909-1.044-1.249-1.644-2.835-.301-6.048-1.233-5.494 3.625.274 2.406-1.398 2.654-3.176 2.746-1.545-.098-2.732-.84-3.668-2.033-1.367-1.389-1.617-3.307-2.362-4.991z"
        />
        <path
          fill="#F469BE"
          d="M150.208 93.824c8.385-.664 16.832.267 25.199-1.016 1.241-.19 2.663-.362 3.752.709.491.596.537 1.317.578 2.041a4.011 4.011 0 01-1.406 2.398c-1.857.552-3.916-.375-5.698.771-.84.251-1.684.489-2.481.863-4.405 4.331-9.047 3.331-13.766.628-3.868 1.778-5.647-.184-6.577-3.667-.077-.94-.364-1.911.399-2.727z"
        />
        <path
          fill="#A594EC"
          d="M146.106 229.83c-.345-8.908.868-10.059 9.653-12.26 1.972-.494 4.129-.73 5.535-2.779.573-.836.724.426.894.908 1.813 2.643.108 5.258-.046 7.888-1.307 3.076-.14 7.15-3.723 9.315-1.019-.563-1.242-1.555-1.401-2.581.017-2.919-1.091-4.576-3.499-1.833-1.457 1.66-4.624 1.614-4.594 4.637-.593 1.569-.259 3.495-1.809 4.688-1.586-2.503-.748-5.313-1.01-7.983z"
        />
        <path
          fill="#C2A8EE"
          d="M181.144 172.611c.938-4.791 4.198-6.834 11.042-6.919 1.663-1.27 3.504-1.307 5.427-.799 1.232.494 2.084 1.514 3.13 2.266 1.446 2.1 5.873.153 5.838 4.271-2.287 2.164-5.195 3.567-7.445 5.714-2.805 2.676-4.973 1.479-5.499-1.298-.933-4.924-3.644-3.863-6.686-2.858-1.277.423-2.591.557-3.929.568-.749-.072-1.413-.311-1.878-.945z"
        />
        <path
          fill="#6452C1"
          d="M182.184 209.69c3.7-.162 3.645 3.825 4.737 5.525 1.988 3.095 5.91 4.822 6.462 8.87.285 2.093 2.751 2.065 3.675 3.571l-3.065 5.967c-5.411-2.131-7.49-7.443-10.949-11.443-1.524-2.211-1.907-4.826-2.611-7.331-.217-.963-.242-1.925.021-2.885.322-.95.801-1.784 1.73-2.274z"
        />
        <path
          fill="#AC9CDF"
          d="M121.289 214.554c4.194 2.389 4.195 7.187 6.192 10.833 2.7 4.931 3.232 11.198 9.308 14.043 1.202.563 1.637 2.765 2.425 4.211.562.775.046 1.111-.57 1.411-1.284.101-2.571.269-3.847-.086-2.065-1.412-4.229-1.966-6.603-.761a4.887 4.887 0 01-1.361.021c-1.485-.434-3.283-.305-3.979-2.175.105-2.709 2.745-3.102 4.181-4.582.581-.619.882-1.265.147-2.011-1.847-2.527-1.094-5.859-2.694-8.448a62.52 62.52 0 01-1.094-2.499 30.638 30.638 0 00-2.223-5.1c-.626-1.634-1.51-3.28.118-4.857z"
        />
        <path
          fill="#5B47B2"
          d="M198.205 224.762c1.237-5.693-1.504-10.348-3.936-15.084-1.725-1.833-2.807-3.762-.92-6.136 1.042-.417 1.95.001 2.853.452 2.818 2.413 5.901 4.518 8.579 7.111 1.63 2.146 4.522 3.39 4.723 6.563-.945 2.064-3.289 1.965-4.831 3.119-.858.42-1.778-.031-2.65.198-3.027-.515-1.952 3.118-3.818 3.777z"
        />
        <path
          fill="#F89D9C"
          d="M161.43 147.703l-.027-2.019c.579-.759 2.146-1.684-.324-1.93a2.7 2.7 0 01-.805-.096c-1.643-2.639-1.504-5.301-.105-7.979.104-.263.136-.534.093-.813.304-.605.554-1.243 1.042-1.741.763-.554 1.582-.933 2.561-.788.806.226 1.333.822 1.869 1.409.584-.729.16-1.557.208-2.334.05-.818-.062-1.643-.078-2.471.088-2.825-.386-5.684.531-8.455a2.03 2.03 0 011.149-1.06l.756.279-.087 23.963c.515.596.446 1.322.458 2.032-.235 1.91-.372 3.861-2.131 5.141-2.679.544-3.745-1.54-5.11-3.138z"
        />
        <path
          fill="#907DD0"
          d="M121.289 214.554c-.503 1.852.811 3.375.925 5.115-3.326.094-4.988 3.505-8.085 4.055l-3.13-4.974c-2.052-1.436-3.096-3.411-3.176-5.905 1.832-2.033 3.993-3.553 6.685-4.247 1.15-.094 2.284-.072 3.313.55 1.42.797.673 2.994 2.343 3.635l1.125 1.771z"
        />
        <path
          fill="#917CDE"
          d="M207.03 256.917c-1.837-5.934-2.606-12.033-2.806-18.219 4.891.917 7.125 4.618 9.069 8.636.256 2.641.604 5.289-.469 7.847.55 1.281-3.696-.999-1.33 1.869 1.044 1.266 1.166 3.217-.223 4.517-1.412 1.322-2.317.12-3.056-1.056-1.106-.959.32-2.76-1.185-3.594z"
        />
        <path
          fill="#796AD2"
          d="M212.183 246.703c-2.239-3.081-4.933-5.708-7.959-8.005l-.121-1.709c-.702-1.554-.319-3.189-.369-4.791.277-.883.97-1.076 1.777-1.073 3.134 3.254 8.437 2.907 11.245 6.734.759 1.831.929 3.75.858 5.71-.567 2.125-1.553 3.809-4.088 3.836a2.945 2.945 0 01-1.343-.702z"
        />
        <path
          fill="#6759C8"
          d="M184.133 221.709c1.672 2.284 4.88 3.653 4.324 7.283-.035.23.482.772.515.755 4.67-2.567 2.568 3.618 5.021 3.876-2.014 4.213-4.084 8.389-7.767 11.474-.678-4.453 1.16-9.099-1.022-13.438-1.792-3.162-2.964-6.391-1.071-9.95z"
        />
        <path
          fill="#E3EFFC"
          d="M138.1 252.517c-.159 4.373.905 8.785-1.729 12.993-1.497 2.392 1.449 4.789 1.343 7.782 2.191-1.521 3.388-4.631 6.6-3.555.225 1.77-1.054 2.361-2.321 2.961-1.143 1.348-2.024 3.274-3.479 3.934-4.413 1.999-2.183 3.947-.333 6.058-3.961 1.788-4.077-1.163-4.156-3.604-.099-3.064.757-6.188-.829-9.119-.569-5.12-.709-10.236.05-15.351a3.178 3.178 0 011.683-1.788c1.022-.428 2.063-.72 3.171-.311z"
        />
        <path
          fill="#0E3E90"
          d="M242.216 87.689c-1.455-3.175-2.784-6.374-1.997-9.996 3.061-1.509 6.141-2.94 9.701-2.463 1.135.744 1.418 1.937 1.057 3.06-.745 2.316-1.866 4.399 1.478 5.876 1.111.491.75 2.386-.102 3.594-3.393 2.185-6.759.21-10.137-.071z"
        />
        <path
          fill="#C4AAEB"
          d="M198.182 165.693l-5.995-.001c1.156-3.362 4.866-2.332 6.976-4.055.929-1.438 2.053-2.229 3.749-1.135.157 2.024 1.907 2.431 3.273 3.226 2.891 1.364 4.512 4.405 7.547 5.641 1.035.421 1.057 1.56.346 2.533-2.681 1.52-5.319 1.761-7.896-.212-.194-2.104-1.761-2.008-3.244-1.997-1.429.011-2.615-.262-2.756-2.001-.14-1.193-1.473-1.194-2-1.999z"
        />
        <path
          fill="#9D8CEB"
          d="M147.117 237.813c.375-1.703-.637-3.694 1.064-5.122 1.128 1.104 1.058 2.279.31 3.388 2.669-2.79 5.786-5.18 9.685-6.389l.01 3.007c1.079.862.702 2.298 1.332 3.336.323.512.612 1.038.662 1.657-3.972 1.292-6.454 6.88-11.836 4.105l-.201.971c-1.34-1.444-.908-3.256-1.026-4.953z"
        />
        <path
          fill="#8E7ADB"
          d="M208.182 259.696c.882.279 1.175 1.998 2.231 1.37 1.419-.844.497-2.229.271-3.45-.174-.943-1.643-2.221.395-2.815.248-.072.707.579 1.068.896 2.658 3.963 1.321 9.252 4.36 13.083.693 1.247 1.543 2.413 2.033 3.771.066.478-.042.921-.289 1.332-2.693.566-4.781 2.386-7.213 3.502-.727.05-1.372-.122-1.864-.699 2.015-2.817.684-5.605.066-8.473-.442-2.054-1.554-4.011-1.141-6.225-.405-.78-.505-1.549.083-2.292z"
        />
        <path
          fill="#5C4BB7"
          d="M202.023 220.986c.553-1.288 1.385-.513 2.143-.29.547-.575 1.208-.644 1.933-.438 1.444.854 2.903 1.569 4.684 1.199 4.573-.951 7.966 1.117 10.896 4.336.426 1.987-.653 3.215-2.13 4.243-3.222 1.518-6.149-1.12-9.303-.662-.958-.085-1.764-.514-2.507-1.09-2.023-2.06-4.696-3.574-5.591-6.593a.782.782 0 01-.125-.705z"
        />
        <path
          fill="#E2F0F9"
          d="M230.537 145.829c-.857 2.253-2.352 3.644-4.729 4.474-6.004 2.096-11.349 5.817-17.629 7.276.585-4.712 3.013-6.354 7.266-6.241 2.59.067 5.342-1.071 7.776-2.197 1.184-.548-.537-1.554-.756-2.407-.304-1.186-.417-2.413 1.069-2.86 1.52-.458 1.63.407 2.011 1.773 1.305 4.679 3.374-2.425 4.992.182z"
        />
        <path
          fill="#E5F5FD"
          d="M134.334 270.701c2.63 2.119.796 4.762.875 7.191.069 2.118-.936 5.014 2.971 4.798h2a21.415 21.415 0 019.999 0c12.946 0 25.892-.032 38.838.018 4.799.019 9.584.036 14.307-.976.193.683.055 1.29-.411 1.823-1.569 1.604-3.624 1.511-5.605 1.516-19.292.051-38.583.043-57.875.006-1.82-.003-3.687.076-5.258-1.144-2.037-4.433-2.318-8.85.159-13.232z"
        />
        <path
          fill="#E0F1F9"
          d="M108.228 212.671l2.771 6.078c-.744.265-1.959 1.102-2.211.384-1.96-5.574-6.66-6.623-11.604-7.688-2.354-.508-3.807-2.874-4.315-4.95-.351-1.432 1.771-1.943 3.333-1.857.411-.303.854-.357 1.329-.168.857.548 1.456 1.257 1.445 2.341 1.987 2.874 5.573 2.352 8.202 3.861.912.371 1.466.931 1.05 1.999z"
        />
        <path
          fill="#16398D"
          d="M242.216 87.689c3.271-2.711 6.598 1.198 9.881-.084.157.163.314.326.473.488.599 2.223-.979 3.83-1.6 5.709-.433 1.021-.661 2.114-1.061 3.149-.293.632-.747 1.121-1.327 1.499-1.691.483-2.489 2.752-4.637 2.336-.882-.887-1.44-1.873-.986-3.173l.426-2.953c.532-1.187.287-2.437.27-3.661-.009-.662-.313-1.034-.171-.384.012.054-.241.165-.371.25l-.897-3.176z"
        />
        <path
          fill="#DD7676"
          d="M161.43 147.703c2.218-.003 2.939 2.353 4.739 3.007.828.714.87 1.612.614 2.583-.608 1.323-1.933 1.909-2.921 2.845-.506.45-1.044.859-1.609 1.233-1.373.745-2.563 1.94-4.31 1.783-.72-.256-1.106-.753-1.111-1.529.121-1.34 1.29-2.052 1.949-3.129-1.194-.168-2.297.397-3.423.097a3.525 3.525 0 01-1.24-.569c-1.417-1.772.678-4.705-2.012-6.056a2.334 2.334 0 01-.469-1.206c.392-.97.28-2.037.541-3.038 3.188.295 4.28 3.065 5.981 5.098 2.109 2.519 2.789 1.031 3.271-1.119z"
        />
        <path
          fill="#157ACB"
          d="M256.116 66.566l2.94-2.927c1.399-.78 2.845-1.288 4.465-.782 3.927 2.418 8.548 1.646 12.771 2.748.602 3.155-1.716 3.949-3.907 4.855a8.069 8.069 0 01-1.53.37c-1.547.196-3.104.167-4.657.185-3.106.51-5.618-2.554-9.163-1.134-1.518.609-1.677-1.827-.919-3.315z"
        />
        <path
          fill="#E67F84"
          d="M163.278 132.875l-1.833.8c-1.823-2.153.142-4.937-1.191-7.172l.011-3.619c.878-1.11-.146-2.876 1.304-3.795 1.989-.821 3.906-1.033 5.594.666l-.021 9.938c-.568 1.934-2.352 2.393-3.864 3.182z"
        />
        <path
          fill="#9987D2"
          d="M114.128 223.724c1.099-.487 1.589-1.403 2.113-2.462 1.325-2.68 3.475-2.953 5.972-1.593 1.514 1.335 2.032 3.063 1.976 5.015.46 3.158-3.255 3.163-4.037 5.379-.17.641-.379 1.261-.797 1.788-.428.262-.801.198-1.12-.188l-.311.115c-1.667-1.769-3.813-3.266-3.494-6.16l-.302-1.894z"
        />
        <path
          fill="#F7B8A9"
          d="M238.176 117.792c-2.624-1.223-4.105-3.169-3.917-6.175.641-.664.317-1.669.84-2.376 1.157-1.235 2.303-.887 3.445.004 2.223 1.11 1.631-2.135 3.178-2.066 1.48-.176 2.452.548 3.155 1.763.763 1.871.648 3.813.489 5.763-.319 1.848-1.228 3.229-3.071 3.869-1.5.421-2.878.177-4.119-.782z"
        />
        <path
          fill="#9B89E5"
          d="M203.181 282.637c.057-.3.104-.602.145-.905l5.847-5.048 2.004.009c2.859 2.063 6.783 3.177 6.872 7.715-2.002 1.974-4.42 1.581-6.837 1.22-2.533-1.063-5.486-.007-7.923-1.557-.473-.446-.508-.924-.108-1.434z"
        />
        <path
          fill="#F19BA0"
          d="M244.174 108.683l-2.93-.951c-.615-.89.177-1.83-.119-2.728-.211-.558-.509-1.064-.827-1.568-.99-1.504-2.059-2.901-3.875-3.464-.876.009-2.825-2.117-2.062 1.083.041 1.195.036 2.372-.319 3.519a2.787 2.787 0 01-.871 1.15c-1.614-2.229-1.255-4.862-.932-7.217.615-4.486 5.425-4.828 10.719-.894l1.367 3.03c1.004.517 1.374 1.38 1.358 2.46-.381 1.891.141 4.031-1.509 5.58z"
        />
        <path
          fill="#9A8CE0"
          d="M145.294 197.7l.081-1.086c.807-1.246-.555-2.819.604-4.013 1.731-.655 3.125-.08 4.329 1.177.759 1.267 2.022.773 3.081.781 3.79.029 7.019 1.133 9.209 4.443.354 1.332-.178 2.274-1.297 2.958-2.173.24-4.154-.752-6.165-1.236-2.899-.698-5.35-.336-7.762 1.216-1.609-.965-2.177-2.44-2.08-4.24z"
        />
        <path
          fill="#D1B8EF"
          d="M150.254 194.625l-4.094-1.772c-.916.134-1.299-.369-1.425-1.186.043-1.482.341-2.876 1.427-3.986.744-1.202 1.14-2.497 1.046-3.923.442-.323.876-.313 1.303.03.762 1.026.832 2.232.896 3.435.001 2.912 1.366 2.979 3.41 1.613 2.47-1.309 4.647-3.163 7.404-3.926.764-.053 1.462.116 2.06.619-.046 3.65-2.781 5.595-4.988 7.881-2.242 1-4.403 2.498-7.039 1.215z"
        />
        <path
          fill="#8675D2"
          d="M181.144 172.611l1.954.128c2.409 3.782 1.456 8.387 3.039 12.372a8.104 8.104 0 01-.097 3.168c-.473 1.473-.834 3.021-2.363 3.848-.496.144-.996.14-1.493-.002-1.686-.917-2.308-2.493-2.634-4.254-.478-3.067.541-5.97 1.195-8.909-.272.757.114 2.061-1.35 1.632-.993-.291-.693-1.243-.255-1.983l1.274-5.818a1.85 1.85 0 00.73-.182z"
        />
        <path
          fill="#FCB7A9"
          d="M148.167 183.695a6.81 6.81 0 00-.958.062c-1.038-2.144-3.377-2.68-5.029-4.064-.566-.582-.603-1.242-.292-1.953 1.54-.741 4.706.65 3.904-3.21-.212-1.022 1.347-1.702 2.203-1.101 3.086 2.17 6.78 3.729 8.346 7.59-2.167 2.599-4.887 3.505-8.174 2.676z"
        />
        <path
          fill="#F8BBAA"
          d="M139.316 166.753c-.146-.288-.28-.583-.44-.862-3.929-6.817-3.93-6.817 1.132-12.307.188.123.375.245.565.365.96 1.531 1.041 3.374 1.779 4.982.573 1.655 1.87 2.972 2.235 4.728.02 1.52-.833 2.485-2.046 3.224-1.089.361-2.16.175-3.225-.13z"
        />
        <path
          fill="#1C559B"
          d="M250.194 75.685c-3.328.652-6.41 2.527-9.975 2.008-.148-1.521 1.352-2.028 1.916-3.111 1.617-2.777 4.423-3.29 7.231-3.799l1.534-.215c1.891-.895 3.668-.845 5.278.626.533.658.661 1.399.437 2.207-.38.706-1.026 1.061-1.746 1.315-1.59.146-2.902 1.682-4.675.969z"
        />
        <path
          fill="#FABCAF"
          d="M168.126 145.7l.085-2.031c2.493 3.049 2.608 7.481 5.866 10.086 1.432.962 1.012 2.861 2.04 4.027l.023 1.85c-.776.708-.276 3.08-2.497 1.916-5.663-3.95-7.855-9.111-5.517-15.848z"
        />
        <path
          fill="#0E4E93"
          d="M273.268 55.934l1.92-.685c3.168 1.268 1.523 4.269 2.308 6.401-.174.45-.431.843-.775 1.181a3.81 3.81 0 01-1.305.604c-3.37.206-6.737.968-10.117.069-2.855-1.996.142-2.573.898-3.695l7.071-3.875z"
        />
        <path
          fill="#816AC4"
          d="M105.168 200.721l-4.987 2.97c-4.25-1.027-4.487-4.448-4.703-7.882-.254-1.204-.313-2.374.583-3.379.229 1.449 1.123 1.343 2.155.917 1.264.425 2.019 1.485 2.934 2.346 1.661 1.42 1.766 4.082 4.018 5.028z"
        />
        <path
          fill="#DCF4FC"
          d="M148.202 115.671c-2.129-.033-4.05.805-2.525-3.206 1.375-3.619.381-8.123.525-12.234.067-1.936-.469-3.946.498-5.801l1.492-.104v17.393c1.125 1.315 1.135 2.632.01 3.952z"
        />
        <path
          fill="#1B76C6"
          d="M256.2 71.707l-5.298-1.139 5.215-4.003c.168.899.503 2.71.763 2.463 3.469-3.29 6.178 2.081 9.361.684 1.166 1.179 3.086-.274 4.169 1.198-.188 1.303-1.203 1.617-2.25 1.904-1.341.24-2.697.199-4.05.222-2.18-.093-4.386.211-6.531-.419a6.99 6.99 0 01-1.379-.91z"
        />
        <path
          fill="#FAAAA1"
          d="M140.008 153.584c-.323-3.678 3.252-4.086 5.033-5.999.195.152.39.304.588.454.983 2.289 1.412 4.698 1.561 7.171a6.303 6.303 0 01-.311 1.455c-.72 1.658-1.8 2.947-3.612 3.468a1.765 1.765 0 01-1.313-.404c-.509-1.988-1.204-3.928-1.671-5.932l-.275-.213z"
        />
        <path
          fill="#F99E99"
          d="M152.193 146.688c.047.32.1.64.159.958 2.248 1.364 1.616 3.413 1.284 5.393-.063.538-.33.939-.797 1.211-2.502.97-4.4-.113-6.118-1.805-1.717-1.164-.464-3.255-1.445-4.651l-.234-.207c.211-1.33.67-2.469 2.169-2.802 1.558.902 3.323 1.262 4.982 1.903z"
        />
        <path
          fill="#C090C6"
          d="M148.202 115.671l-.01-3.953c2.004-3.836.425-7.971 1.005-11.92.293-1.997-.93-4.261 1.012-5.975l.03 2.896c1.019 1.507.866 3.308 1.252 4.974.056 2.519.166 5.039.078 7.556.001 1.276.021 2.556-.014 3.828-.519 4.082 2.438 3.239 4.739 3.319 1.531.035 3.071-.02 4.489.711.5.317.719.77.661 1.359-.328.487-.784.733-1.37.742-3.28-.301-6.608.481-9.857-.455l-2.015-3.082z"
        />
        <path
          fill="#DFF2F9"
          d="M249.367 70.783l-7.231 3.799c-1.517-2.2-1.622-6.119-5.954-4.891.326-2.528 2.811-2.577 3.749-1.841 2.868 2.253 6.458 1.503 9.436 2.933z"
        />
        <path
          fill="#C6B7F1"
          d="M145.294 197.7c1.158 1.062 1.66 2.451 1.972 3.936 1.049.523 1.603 1.364 1.634 2.543-.282 2.077-1.688 2.563-3.501 2.473-.788-.183-1.529-.479-2.195-.946-1.85-3.334-2.145-6.261 2.09-8.006z"
        />
        <path
          fill="#7660C5"
          d="M202.148 221.691c1.9 2.105 4.646 3.357 6.041 5.975.807 2.079 2.044 4.372-2.008 4.026l-1.989.017c-.979-1.136-.036-2.977-1.45-3.952l-.594-6.066z"
        />
        <path
          fill="#DFE3F8"
          d="M118.214 189.607l-1.958-1.136c-1.987.416-3.146-1.13-4.619-1.928-1.151-.548-2.285-.785-3.383.126-3.026-4.02-1.259-5.215 2.935-4.98 1.132.462 2.417.694 2.992 1.992 1.682 1.746 4.497 2.721 4.033 5.926z"
        />
        <path
          fill="#9584E5"
          d="M153.221 254.671c1.716-.719 3.166-1.52 2.438-3.875-.417-1.35-2.455-2.427-.747-4.224 1.996-2.1 1.403 3.041 3.267 1.12 1.567 1.999 1.566 3.998.002 5.998.062 2.186-2.653 2.298-3.077 4.121l-1.883-3.14z"
        />
        <path
          fill="#7E63CD"
          d="M112.34 185.61l3.917 2.862c.471 3.232-2.324 3.27-4.158 4.246-.887-1.109-1.946-2.126-2.002-3.687-.31-1.832-1.557-4.281 2.243-3.421z"
        />
        <path
          fill="#E2F0F9"
          d="M114.431 225.619c1.165 2.053 2.331 4.105 3.495 6.159-2.423-.147-4.872-.438-7.158 1.372 1.94-2.288-.16-6.273 3.663-7.531z"
        />
        <path
          fill="#DCF5F9"
          d="M200.182 155.692l-5.963-3.059c3.195-1.499 6.273-1.489 8.779-.5 1.999.789-1.408 2.098-.817 3.557-.666.532-1.332.603-1.999.002z"
        />
        <path
          fill="#A197CD"
          d="M118.235 231.664c.314.016.629.024.944.027 3.755-.172 3.413 3.822 5.472 5.358 1.108.581 2.465-.169 3.529.644-.494 2.869-4.137 1.75-5.101 4.025l-.609-.073-.472.078c.507-4.013-2.882-6.567-3.763-10.059z"
        />
        <path
          fill="#E2ECF8"
          d="M200.182 155.692l1.999-.002c2.252-.155 1.712 2.55 3.227 3.151-.831.556-1.662 1.109-2.495 1.662l-3.75 1.135c-.825-2.181 1.949-3.746 1.019-5.946z"
        />
        <path
          fill="#C7408F"
          d="M195.588 139.826c1.341.048 2.934-.674 3.677 1.202.893 1.871.251 3.344-1.541 3.973-1.849.647-3.077-.584-3.959-2.124-.417-1.627.196-2.642 1.823-3.051z"
        />
        <path
          fill="#806DBF"
          d="M95.479 195.809c.322 3.37 2.861 5.418 4.703 7.882h-.002c-.897.875-1.79 1.765-3.216 1.116a4.323 4.323 0 01-.762-.169c-.088-2.955-1.636-5.792-.723-8.829z"
        />
        <path
          fill="#145D99"
          d="M266.197 59.81c.519 1.244-1.902 1.56-.932 2.947.26.376.273.752.001 1.129-.407.223-.77.178-1.083-.177l-5.127-.07c1.616-2.703 4.227-3.549 7.141-3.829z"
        />
        <path
          fill="#B2A7DC"
          d="M138.1 252.517l-1.909.969c-1.491-3.417.579-6.027 1.989-8.787l1.033-1.057c2.497 3.317-.502 5.946-1.113 8.875z"
        />
        <path
          fill="#F59D93"
          d="M152.193 146.688c-2.566 1.734-4.055.647-4.982-1.904 1.472-1.214 3.163-1.402 4.967-1.061.642.985.627 1.973.015 2.965z"
        />
        <path
          fill="#EAEBFA"
          d="M235.932 141.678c.07.244.1.493.087.747-.78 1.168-1.71 1.018-2.705.31-1.815-2.093-1.311-4.237-.49-6.661 2.614 1.348-.157 5.036 3.108 5.604z"
        />
        <path
          fill="#ECECF3"
          d="M160.168 135.679l.104 7.979c-3.48-2.614-3.228-5.278-.104-7.979z"
        />
        <path
          fill="#D9F6F8"
          d="M236.182 133.692c-8.542-.289 1.299-3.919-1.158-5.314 1.655 1.54.942 3.511 1.158 5.314z"
        />
        <path
          fill="#DEEAF6"
          d="M238.176 117.792l3.988.033c.841 1.939.088 3.952.285 5.924-.033 1.295-.095 2.583-.824 3.723-.376.442-.838.563-1.383.367.257-3.545-.322-6.916-2.066-10.047z"
        />
        <path
          fill="#7158B4"
          d="M114.19 206.72l4.8-1.99c.876 1.518.895 2.884-.697 3.968-.201.101-.401.2-.602.302-1.264-.419-2.692.779-3.881-.394-.262-.707-.153-1.339.38-1.886z"
        />
        <path
          fill="#A1256F"
          d="M194.262 142.735c2.485 1.827 4.764 3.051 5.002-1.708 1.871 1.277 1.473 2.833.062 3.918-1.38 1.062-3 2.747-4.952.69-1.041-.928-1.011-1.897-.112-2.9z"
        />
        <path
          fill="#FEDAFE"
          d="M150.217 118.754l10.854.026c.412.209.51.529.336.945l-1.144 3.157c.12-2.53-1.17-3.245-3.572-3.256-2.154-.008-4.525.877-6.474-.872z"
        />
        <path
          fill="#E0F3F6"
          d="M178.18 119.716c.219 1.962-.682 3.528-2.558 3.499-2.339-.035-1.08-2.243-1.439-3.487 1.329-1.217 2.661-1.215 3.997-.012z"
        />
        <path
          fill="#A36390"
          d="M181.154 107.669l-.847 5.157a2.89 2.89 0 01-1.05-1.335c-.687-2.532-.337-5.123-.42-7.692.052-1.466.092-2.937 1.125-4.134.587-.306 1.108-.216 1.563.265.051 2.588.624 5.201-.371 7.739z"
        />
        <path
          fill="#7E70BA"
          d="M101.151 195.693c-1.435-.007-2.414-.697-2.988-1.995-.825-.919-1.626-1.846-1.093-3.226 2.517-.18 2.894.302 4.081 5.221z"
        />
        <path
          fill="#FED3FE"
          d="M178.18 119.716l-3.997.011-5.884-.021-.347.04-.141-.765a2.188 2.188 0 011.081-1.059c3.231-.941 6.571-.283 9.844-.665.517.04.993.203 1.428.484-.003 1.321-.723 1.92-1.984 1.975z"
        />
        <path
          fill="#8B88D3"
          d="M160.034 263.752c3.129.349 6.089-.759 9.142-1.068-2.816 2.34-5.641 4.595-9.142 1.068z"
        />
    
        <path
      
          fill="#986BA2"
          d="M233.314 142.735l2.706-.31.148 5.24c-.293.441-.616.484-.971.069l-2.069-4.143a6.63 6.63 0 01.186-.856z"
        />
        <path
          fill="#94396C"
          d="M240.242 127.838a2.42 2.42 0 01.749-.313c.711.057 1.284.392 1.789.872 1.136 1.425 2.309 2.841 1.799 4.875-.155.163-.313.326-.47.488-2.68-.066-2.094-3.937-4.728-4.058l.861-1.864z"
        />
        <path
          fill="#9A8FDA"
          d="M143.205 205.705l2.006-.023c.836.897 2.673.325 2.965 2.02l2.384 1.674c-2.724.74-4.438-.87-6.331-1.675l-1.024-1.996z"
        />
        <path
          fill="#DFF2F9"
          d="M236.218 69.659c-.305 1.488.673 3.555-1.866 3.899-.619.084-1.682-.029-1.475-.785.435-1.591 1.486-2.824 3.341-3.114z"
        />
        <path
          fill="#C9C3F0"
          d="M146.162 187.68c-.115 1.4.479 2.98-1.021 4.03-.633.609-1.273.517-1.918.021-1.265-2.979.785-3.552 2.939-4.051z"
        />
        <path
          fill="#FEC3FD"
          d="M181.154 107.669l-.109-7.982c-.973-1.416-1.104-2.781.247-4.057 1.393 4.03 1.489 8.044-.138 12.039z"
        />
        <path
          fill="#EAE1E5"
          d="M142.11 177.721l.07 1.971c-4.266-2.722-1.097-6.822-1.89-10.188.568-.156 1.027.003 1.38.474 1.136 2.523.977 5.123.44 7.743z"
        />
        <path
          fill="#7A75A8"
          d="M121.1 198.635c-.674-2.827-2.662-5.198-2.841-8.197 3.252 1.933 3.435 4.931 2.841 8.197z"
        />
        <path
          fill="#F4A495"
          d="M161.078 143.754c.987-.278.232-2.149 1.741-1.927 1.025.152 1.283.921 1.296 1.816.028 1.915-1.304 2.035-2.715 2.04-.106-.642-.214-1.285-.322-1.929z"
        />
        <path
          fill="#CB388A"
          d="M180.28 99.713l-.14 3.952c-.603.318-1.097.197-1.488-.362-1.486-2.623-.238-5.091.436-7.592l.073-2.193 1.095 1.157c.638 1.676.613 3.356.024 5.038z"
        />
        <path
          fill="#E3EFFC"
          d="M150.181 282.69h-9.999c3.333-1.565 6.666-1.564 9.999 0z"
        />
        <path
          fill="#7878AC"
          d="M202.741 227.756c2.198.688 1.155 2.565 1.45 3.952l-.088 5.278c-1.515-2.918-.82-6.165-1.362-9.23z"
        />
        <path
          fill="#8A7AC2"
          d="M120.164 212.783c-.229 1.262-.885 1.85-1.549.42-.494-1.064-.352-2.424-.493-3.651-.289-.146-.418-.33-.39-.554.031-.244.084-.365.162-.365l.399.065c1.325 1.04 1.602 2.56 1.871 4.085z"
        />
        <path
          fill="#988ECD"
          d="M143.222 191.731l1.919-.021 1.02 1.14c-.09 1.292.422 2.709-.786 3.765l-2.153-4.884z"
        />
        <path
          fill="#ECECF3"
          d="M160.253 126.503c1.55 2.199.709 4.795 1.19 7.172l-1.183 1.188c-.001-2.785-.004-5.572-.007-8.36z"
        />
        <path
          fill="#7466AA"
          d="M112.34 185.61c-2.231.167-2.129 1.865-2.243 3.422l-1.842-2.362c.583-3.354 2.259-2.497 4.085-1.06z"
        />
        <path
          fill="#DAF7F7"
          d="M235.33 122.242c.699.33.83.953.744 1.605-.081.614-.133 1.461-1.067 1.238-.73-.174-.823-.919-.74-1.573.078-.618.11-1.355 1.063-1.27z"
        />
        <path
          fill="#E5EFF6"
          d="M114.181 183.681l-2.992-1.992c.861-.3 1.127-1.907 2.178-1.409 1.433.678.59 2.239.814 3.401z"
        />
        <path
          fill="#DF998E"
          d="M233.173 105.724l.157-1.065c1.978.069 1.937 1.769 2.45 3.025.062.734-.081 1.415-.56 2-.047.78-.164 1.525-.96 1.933l-1.087-5.893z"
        />
        <path
          fill="#DB8A8E"
          d="M141.161 169.713a6.87 6.87 0 01-.872-.209l-.974-2.752c.892-.673 1.822-.719 2.79-.176.654.542.821 1.251.714 2.057-.283.773-.699 1.345-1.658 1.08z"
        />
        <path
          fill="#8773C5"
          d="M112.372 193.69c1.115.313 2.998-.729 3.163 1.136.098 1.112-1.515.736-2.417.859l-.746-1.995z"
        />
        <path
          fill="#E6E8EC"
          d="M176.118 157.782c-1.657-.848-2.026-2.348-2.039-4.027 2.871.232 1.922 2.399 2.039 4.027z"
        />
        <path
          fill="#0F366A"
          d="M243.114 90.866c.284-.348.477-1.699.81-.884.576 1.41.699 3.244-.538 4.678l-.272-3.794z"
        />
        <path
          fill="#857DC1"
          d="M208.182 259.696l-.084 2.289c-1.294-1.491-.865-3.347-1.066-5.069 2.226.163.684 1.887 1.15 2.78z"
        />
        <path
          fill="#E6E8EC"
          d="M174.208 161.714l1.933-2.083.067 2.059c-.099 1.363-.826 2.009-2.196 1.916-.439-.683-.357-1.312.196-1.892z"
        />
        <path
          fill="#7979BE"
          d="M182.249 251.14c-.24-2.086.156-3.661 2.773-3.451-.349 1.613-1.679 2.437-2.773 3.451z"
        />
        <path
          fill="#806DBF"
          d="M97.071 190.472l1.093 3.226c-1.409.754-2.065.26-2.101-1.267-.1-.878.135-1.583 1.008-1.959z"
        />
        <path
          fill="#AA35C3"
          d="M180.164 117.742l-1.046.12a45.24 45.24 0 00-.516-.556c-.759-1.725-.77-3.434.109-5.124.336-.428.777-.61 1.319-.548l.275 1.192c-.046 1.639-.093 3.277-.141 4.916z"
        />
        <path
          fill="#DEEAF6"
          d="M238.365 126.548v-4.599c1.109 2.056.867 3.34 0 4.599z"
        />
        <path
          fill="#A35892"
          d="M180.28 99.713l-.025-5.039 1.037.957-.247 4.056c-.255.005-.51.014-.765.026z"
        />
        <path
          fill="#DEEAF6"
          d="M238.131 135.674c.05.861-.111 1.644-.83 2.217-.722-1.307-1.286-2.655-1.119-4.199h-.001l1.95 1.982z"
        />
        <path
          fill="#C0A7ED"
          d="M295.314 168.689c3.615 1.074 5.857 4.826 9.899 5.064.77.673 2.209.355 2.531 1.697.475 1.97 2.055 3.039 3.469 4.244l-.043-.042c1.521 1.884 3.738 3.321 3.918 6.074-.107 1.35-.633 2.356-2.121 2.561-2.119.072-4.117-2.254-6.334-.312a5.567 5.567 0 01-1.25.575c-2.26.205-4.299.734-5.956-2.021-.816-1.36-3.822-.874-5.006.753-3.357 4.621-4.484 1.816-5.645-1.45-.057-.722.164-1.377.473-2.012 1.131-2.771.572-5.717.898-8.498-.332.596-.137 1.261-.436 1.801-.768 1.643-1.225 3.425-2.266 4.94-.441.494-1.18.771-1.477 1.289-2.441 4.275-4.895 7.278-10.668 4.144-2.158-1.172-5.419 1.754-8.537 1.067-1.928-.425-4.01-.214-5.011-2.437.951-4.041 5.329-5.376 6.987-8.864.7-.757 1.535-1.317 2.475-1.731 6.108-2.638 12.413-4.72 18.84-6.399 1.675-.435 3.421-1.428 5.26-.443z"
        />
        <path
        className="desaparecera"
          fill="#DCF1FA"
          d="M316.157 181.709c2.902.054 4.416 3.146 7.4 3.344 2.504-4.95 1.305-10.331 1.701-15.522.629.012 1.123.274 1.488.787 1.383 3.078.566 6.346.826 9.522-.014 3.188-.008 6.377.002 9.564.152 3.681-.498 7.4.545 11.039.168.557.268 1.125.324 1.701-.289 5.116 1.203 10.351-.994 15.341-4.131.71-4.256-3.093-5.879-5.212-1.072-2.241-2.168-4.483-1.898-7.087-.775-3.837-1.422-7.7-2.369-11.504a14.953 14.953 0 01-.404-3c.564-3.057-1.699-5.884-.742-8.973z"
        />
        <path
          fill="#906ECD"
          d="M295.314 168.689l-24.133 8c-1.571-3.347 1.618-5.607 1.926-8.528 1.746-3.33.408-7.874 4.088-10.444 2.025 1.304 3.551 3.334 5.952 4.091.49.139.824.447 1 .926l11.167 5.955z"
        />
        <path
        className="desaparecera"
          fill="#E0F0FB"
          d="M319.19 81.642c-1.318-2.946-3.143-5.719-3.109-9.126-1.523-1.047-2.254-2.086.029-3.097 2.297.891 4.871.643 7.125 1.716 1.75-.17 3.307.568 4.916 1.057 3.014-.41 4.035.815 3.037 3.699-.652.512-1.307 1.023-1.959 1.534-.646 1.409-1.703 2.434-3.02 3.211.008 3.163-4.08 3.983-4.082 7.141-2.269-1.428-2.587-3.788-2.937-6.135z"
        />
        <path
          fill="#DBF3FB"
          d="M290.184 155.691c-.186.771-.98 2.078-1.305 1.309-1.131-2.665-2.117-4.664-5.668-3.783-.686.17.217-1.696-.064-2.606a1.133 1.133 0 01-.242-1.129c.473-.943 1.238-1.654 1.924-2.433.414-.491.84-.974 1.25-1.473 2.531-3.107 3.92-6.771 5.158-10.504.91-2.918 1.625-5.876 1.881-8.936.1-.489.266-.951.492-1.396.631-.856 1.367-1.478 2.533-1.13.176 7.77-2.389 14.924-4.963 22.076-.664 3.303 1.052 6.841-.996 10.005z"
        />
        <path
          fill="#1065A8"
          d="M285.182 58.685c3.045-.027 6.746-1.86 8.035 2.926 1.031 3.384 1.033 6.896 1.307 10.375-.035 1.774-.346 3.463-1.576 4.85-2.146 1.918-3.473.882-4.496-1.252-.775-2.47-.551-5.119-1.342-7.59.127-5.577-4.779-5.648-8.129-7.428 1.377-2.906 3.787-2.4 6.201-1.881z"
        />
        <path
          fill="#E0F2FE"
          d="M285.182 58.685c-1.676 1.424-4.234.358-5.813 2.057-.199 1.387-.896 1.602-2.006.854-3.42-1.19.335-4.843-2.175-6.346 1.222-2.59.755-4.244-3.125-4.382 4.371-.39 7.167-4.362 11.984-2.549-2.646 1.947-6.945 3.929-.539 5.984 1.17.376.314 2.62 1.676 3.394-.002.329-.002.659-.002.988z"
        />
        <path
          fill="#F4AEA6"
          d="M294.102 110.83c-.01.291.039.571.145.842.9.885 1.236 2.103 1.861 3.149-.031.293-.006.58.074.862 1.605 2.003 1.477 4.001-.012 5.997l-.25-.047c-.936 1.088-2.191 1.229-3.508 1.195-1.775-.162-3.447-.646-4.963-1.607a3.46 3.46 0 01-.867-1.135 3.232 3.232 0 01.004-2.039c.35-.794.998-1.389 1.436-2.121.506-.847.998-1.692.379-2.707-.434-1.23-.918-2.449-.5-3.787 1.164-1.393 2.23-2.933 4.33-2.957 1.326 1.15.818 3.088 1.871 4.355z"
        />
        <path
          fill="#6E4FB2"
          d="M277.195 157.716l-3.014 10.977c-2.795.128-3.373 5.092-7.079 3.242-1.461-2.661 1.188-4.255 1.65-6.418.19-.657.421-1.302.65-1.945.475-1.265.688-2.602 1.031-3.904.336-1.094.477-2.225.618-3.356.231-.919.551-1.801 1.071-2.599l.242-1.14c1.893-.396 3.203.409 4.135 2.001-.773 1.27.281 2.135.696 3.142z"
        />
        <path
          fill="#074390"
          d="M292.154 76.678c.748-1.254 1.141-2.6 1.051-4.07.436-.431.629-1.141 1.381-1.215 1.17.259 1.635 1.309 2.348 2.082.564.941 1.531 1.467 2.291 2.206 1.109 2.308-1.629 3.799-1.262 5.949-1.24.725-1.934 1.699-1.467 3.204a.938.938 0 01-.369.829c-1.705 1.179-2.291-.078-2.814-1.333-.496-1.191-.332-2.597-1.17-3.686a5.285 5.285 0 01-.611-1.283c-.19-.985.001-1.884.622-2.683z"
        />
        <path
          fill="#5541CD"
          d="M354.25 116.704c-.971 2.51-3.006 4.147-5.43 4.48-1.33.184-2.475-2.301-2.256-3.395.533-2.682 3.213-3.529 5.523-3.97 1.591-.302 1.775 1.599 2.163 2.885z"
        />
        <path
          fill="#D9F6FC"
          d="M299.443 130.034c2.234 4.357-2.402 7.241-1.281 11.833-2.867-4.222-2.767-4.854 1.281-11.833z"
        />
        <path
          fill="#50B9F2"
          d="M316.157 181.709c1.467 2.824 2.174 5.809 1.891 9-.363.265-.732.287-1.111.034-.799-.943-.99-2.18-1.555-3.237-.252-.73-.693-1.357-1.107-2.001-.477-2.247-3.424-3.183-3.104-5.853 2.154-.508 2.927 2.334 4.986 2.057z"
        />
        <path
          fill="#4E3A6F"
          d="M291.98 106.867c-.77 1.341-1.539 2.682-3.469 1.891-.809-.083-.885-.696-.959-1.314.166-1.241.061-2.513.383-3.744.805-1.241 1.736-2.134 3.324-1.202 2.381.44 1.191 1.966.971 3.196.282.468.2.859-.25 1.173z"
        />
        <path
          fill="#CC6267"
          d="M291.26 102.497c-1.406.12-2.52.677-3.078 2.063-.803.715-1.6.685-2.393-.024-1.102-2.187-1.035-4.121 1.203-5.59 1.867-.717 3.617-.598 5.191.742.45 1.186-.486 1.915-.923 2.809z"
        />
        <path
          fill="#EA7587"
          d="M293.006 95.563c.236 1.153.223 2.254-.662 3.173-1.926.171-3.695-.51-5.496-1.033-.559-.873-.557-1.788-.221-2.732.482-.927 1.328-1.403 2.229-1.812.455-.169.93-.261 1.414-.292 1.876-.085 2.316 1.297 2.736 2.696z"
        />
        <path
          fill="#E6F0FD"
          d="M290.184 155.691c.695-3.299-1.805-6.915.996-10.005 1.045 3.473 2.832 7.018-.996 10.005z"
        />
        <path
          fill="#ECECF8"
          d="M296.17 121.68l.012-5.996c1.443.243 3.689-.672 3.793 1.75.101 2.336-1.616 3.648-3.805 4.246z"
        />
        <path
          fill="#172458"
          d="M283.301 149.806a3.06 3.06 0 01-.154.804c-1.297.395-2.492 1.264-3.961.854-3.377.662-6.681.425-9.907-.791l-.993-.145c.372-2.272 2.256-2.087 3.783-2.129 3.258-.089 6.537-.392 9.78.3a3.113 3.113 0 011.452 1.107z"
        />
        <path
          fill="#234C8D"
          d="M292.061 79.818c2.207-.05 2.107 1.547 2.148 3.028.039 1.355.107 2.675 1.918 2.817-.131 1.284-.543 2.411-1.732 3.104-.189-.072-.379-.146-.572-.216-.748-.735-1.15-1.685-1.615-2.6-.377-.762-.713-1.539-.9-2.376a6.59 6.59 0 01-.143-1.313c.03-.911.175-1.784.896-2.444z"
        />
        <path
          fill="#87A2C1"
          d="M325.321 157.67c-.059-4.986-.117-9.973-.178-14.959.551-.217 1.025-.107 1.428.327.318.438.541.92.676 1.444.416 2.384.174 4.796.311 7.194-.059 1.906.113 3.849-.832 5.624-.36.534-.829.658-1.405.37z"
        />
        <path
          fill="#2A266E"
          d="M290.035 93.487l-.967.33c-1.441.018-1.447-.95-1.367-1.982.256-.699.723-1.228 1.336-1.634 1.709-.441 3.154-1.814 5.094-1.473l.264.041-.367 3.702c-.997 1.653-2.79.181-3.993 1.016z"
        />
        <path
          fill="#4ABCFC"
          d="M294.318 71.8l-1.113.808.012-10.996c1.779 2.042 1.766 4.598 2.025 7.075-.078 1.106-.058 2.241-.924 3.113z"
        />
        <path
          fill="#DEECFA"
          d="M276.5 154.574l-4.135-2.002a1.838 1.838 0 01-.055-.814c1.977-.814 3.94-1.005 5.877.122-.041 1.225-.578 2.138-1.687 2.694z"
        />
        <path
          fill="#E1F0F5"
          d="M332.18 129.63c-.902-.959-2.139-2.217.371-2.333 2.197-.102 4.424.439 6.895.727-1.732 1.364-3.975-.153-5.262 1.603-.666.579-1.334.579-2.004.003z"
        />
        <path
          fill="#CBDEF4"
          d="M332.18 129.63l2.004-.003 8.203.2a4.502 4.502 0 00-.334.779c-3.338 2.456-7.002 1.347-10.602.968a2.437 2.437 0 01-1.236-1.124c.655-.273 1.311-.546 1.965-.82z"
        />
        <path
          fill="#98A9C0"
          d="M325.321 157.67c.273.015.549.023.822.027.977.79 1.201 1.904 1.338 3.061-.125 2.805.557 5.688-.771 8.386-.211.189-.426.377-.643.564a2.501 2.501 0 01-.809-.176l.063-11.862z"
        />
        <path
          fill="#5FB9E1"
          d="M311.213 179.695c-3.543-.759-4.314-1.552-4.154-4.271 1.475-.466 2.303.383 3.004 1.481.564.856 1.402 1.598 1.15 2.79z"
        />
        <path
          fill="#AEB5C6"
          d="M323.198 71.559c-2.291-.806-4.93-.309-7.014-1.878-.346-.185-.463-.373-.352-.563.113-.192.225-.288.34-.288 2.295.784 4.912.327 7.018 1.835.344.196.459.394.348.594-.114.199-.227.3-.34.3z"
        />
        <path
          fill="#A1ADBC"
          d="M319.19 81.642l2.938 6.134c-3.297-.935-3.524-3.339-2.938-6.134z"
        />
        <path
          fill="#D96572"
          d="M287.289 97.73c1.947-.989 3.518-.067 5.055 1.006.066.338.012.655-.16.952l-5.039-.012c-.569-.694-.473-1.34.144-1.946z"
        />
        <path
          fill="#2D2B81"
          d="M278.187 151.879l-5.877-.122c-1.079-.173-2.325.121-3.033-1.085 3.298.332 6.708-.76 9.908.791l-.998.416z"
        />
        <path
          fill="#6A7BAB"
          d="M326.19 142.75l-1.047-.038c.189-3.016-1.355-6.264 1.205-8.96.428-.355.795-.284 1.111.156.289 2.353-.164 4.68-.248 7.022a4.362 4.362 0 01-.494 1.334 49.7 49.7 0 01-.527.486z"
        />
        <path
          fill="#DFBCB9"
          d="M291.863 121.787l4.059-.153c.072.659.146 1.318.221 1.978l-1.893 1.15c-2.297.212-2.842-.979-2.387-2.975z"
        />
        <path
          fill="#D5F3F2"
          d="M310.063 176.906l-3.002-1.479c-.617-.56-1.232-1.116-1.848-1.673 2.196.162 5.358-1.167 4.85 3.152z"
        />
        <path
          fill="#2F79B9"
          d="M299.225 75.681c-1.42-.035-2.955.109-3.072-1.965-.664-1.149.273-1.458.988-1.883 1.5.847 1.957 2.257 2.084 3.848z"
        />
        <path
          fill="#EBEAEE"
          d="M291.98 106.867c.084-.392.168-.782.25-1.174 3.207.771 1.541 3.316 1.873 5.136-1.568-.86-1.865-2.401-2.123-3.962z"
        />
        <path
          fill="#1C70B1"
          d="M297.141 71.833l-.988 1.883-1.834-1.916c-.123-1.165-.244-2.33.924-3.113 1.351.615.968 2.276 1.898 3.146z"
        />
        <path
          fill="#A6AFC0"
          d="M331.188 75.891c-.186-1.848-.398-3.672-3.004-3.349-.342-.182-.455-.364-.344-.548.113-.184.227-.275.342-.275 3.151-.158 5.34.377 3.006 4.172z"
        />
        <path
          fill="#A9B3C4"
          d="M316.172 68.83c.006.284.01.567.012.852-1.574.892-.504 1.877-.102 2.837-2.08.235-2.477-1.475-2.471-2.735.007-1.702 1.559-.96 2.561-.954z"
        />
        <path
          fill="#DBF3FB"
          d="M284.146 162.733c-.332-.309-.666-.617-1-.926.121-1.285.6-2.234 2.109-1.913.414.088 1.039.501 1.074.818.171 1.55-1.968.763-2.183 2.021z"
        />
        <path
          fill="#7285B1"
          d="M327.151 133.724a43.27 43.27 0 00-.805.026c.436-2.101 2.238-2.599 3.869-3.3l-.074.376c.359.345.525.761.469 1.262-.721 1.459-1.756 2.257-3.459 1.636z"
        />
        <path
          fill="#234C8D"
          d="M296.496 84.834c-2.182-2.289-.926-3.007 1.467-3.204l-1.467 3.204z"
        />
        <path
          fill="#986283"
          d="M290.035 93.487c1.043-1.466 2.615-.856 3.992-1.015l-1.02 3.092c-.892-.835-1.507-2.064-2.972-2.077z"
        />
        <path
          fill="#A6B0C2"
          d="M328.182 71.719c0 .274 0 .55.002.824l-4.986-.983c-.01-.299-.012-.598-.008-.896 1.75-.055 3.471.023 4.992 1.055z"
        />
        <path
          fill="#A8B3C1"
          d="M326.209 80.636l3.02-3.209c-.057 1.963-.834 3.249-3.02 3.209z"
        />
        <path
          fill="#EBEAEE"
          d="M296.107 114.821c-1.156-.732-1.955-1.678-1.861-3.149 2.068.194 1.971 1.667 1.861 3.149z"
        />
        <path
        className="desaparecera"
          fill="#E0F2FE"
          d="M314.18 343.687c-3.707-1.211-6.465 2.296-9.987 2.012-.555-.581-1.334-.698-2.031-.983v-.012c-.635-1.348-.875-2.89-1.969-4.015l-.006-.012c-1.764-2.619-1.521-4.859 1.484-6.68-1.93 1.404-3.666.826-5.41.177-1.262-.675-1.945-1.825-2.51-3.071a4.388 4.388 0 01-.262-1.253c.004-1.021.414-2.021.156-3.059-.637-1.431-1.834-2.313-3.061-3.168-.758-.52-1.457-1.096-1.936-1.897a5.414 5.414 0 01-.441-1.311 7.925 7.925 0 01.215-3.41c.271-.853.676-1.645 1.129-2.412.693-1.062 1.479-2.066 2.121-3.165.83-1.195 1.428-2.458 1.154-3.978-1.258-4.334-4.602-7.552-6.215-11.69-.414-1.808.629-3.07 1.611-4.355 1.172-1.346.895-2.757.172-4.187a12.81 12.81 0 01-.451-1.277c-.281-.884-.514-1.777-.609-2.703.023-4.505-.445-9.009-.037-13.515.168-.45.43-.842.773-1.176 2.314-.206 1.135 1.955 1.865 2.743a2.952 2.952 0 01-.262-1.102c-1.047-3.694-.893-7.45-.879-11.196-.053-2.773.17-5.516.928-8.193.014-2.409.986-4.672 1.078-7.07-.008-2.947.51-5.749 2.285-8.2 1.646-1.745 1.84-4.979 5.131-5.06 1.322.937 1.736 2.378 2.139 3.828.457 2.072 1.146 4.078 1.854 6.077 1.098 3.021 2.237 6.024 3.624 8.928a131.773 131.773 0 002.391 4.879c1.824 4.364 4.793 7.989 7.576 11.731 1.414 1.676 3.318 2.738 5.051 4.015 2.535 1.69 4.73.498 6.906-.81.977-.508 1.982-.96 2.936-1.519 2.453-1.459 4.773-3.116 7.135-4.716 2.861-1.832 5.65-3.76 8.254-5.952 4.686-3.866 9.664-7.386 13.457-12.248 1.648-2.112 3.842-3.576 6.539-4.157 2.688-.195 5.381-.481 8.002.454 5.714 2.368 11.48 1.665 17.267.303.623.039 1.098.321 1.434.845 1.33 3.287.008 6.405-.598 9.568-.447 3.047-2.406 5.756-2.01 8.99-3.188 3.522-3.879 8.286-6.1 12.293-1.438 2.593-2.25 5.657-4.109 7.861-3.566 4.227-4.593 8.878-3.947 14.137-1.971-.326-1.715-2.181-2.365-3.413-.189-.35-.379-.703-.602-1.032-.912-1.122-2.469-1.41-3.348-2.573a9.34 9.34 0 01-.727-1.042c-1.197-2.388-3.73-2.642-5.807-3.622-.592-.327-1.096-.761-1.563-1.245-1.566-1.624-3.162-2.342-4.877-.191-.414.558-.914 1.013-1.541 1.322a3.11 3.11 0 01-2.049.001c-.641-.29-1.189-.717-1.711-1.182-.881-.773-1.852-1.37-3.125-1.559-.221 1.144.906 2.006.646 3.118-.072.947-.467 1.788-.865 2.627-.9 1.65-.527 3.593-1.191 5.299-.783 3.61-5.574 3.099-6.607 6.45-.41.785-.953 1.479-1.523 2.14-1.33 2.778 3.121 3.289 2.311 5.859-.133 1.575-1.053 2.521-2.443 3.085-3.641 1.733-.572 3.688-.16 5.538.344.483.701.96 1.139 1.362.775.608 1.723.728 2.646.919.385.096.746.246 1.088.446 1.076.801 1.246 1.933 1.166 3.156.051.369.113.737.217 1.097.287.676.895 1.272.553 2.11-.33.06-.66.119-.99.181-7.814.63-11.979 6.222-16.111 11.855-4.939-.674-7.861 2.017-10.004 6.005-1.57.191-3.666-.67-3.994 2z"
        />
        <path
          fill="#DB89D8"
          d="M400.076 300.542c.014-.284.049-.565.107-.844 22.405-.006 44.809-.036 67.211.029 1.756.006 4.184-1.091 4.965 1.839-.551.803-1.369 1.14-2.279 1.322-3.244.329-6.502.1-9.754.202-1.477.104-2.955.066-4.434.004-5.623-.038-11.248.002-16.869-.014a84.23 84.23 0 01-2.563-.019c-1.377-.016-2.756-.04-4.137-.003-3.016.343-6.031.078-9.053.017-6.787-.049-13.568.117-20.352-.078-.922-.075-1.793-.301-2.557-.849-.513-.458-.609-.994-.285-1.606z"
        />
        <path
          fill="#FB8DF7"
          d="M470.186 301.684a789.63 789.63 0 002.172-.116l1.813.146c.793 1.854 2.039 3.247 3.984 3.933l.041.082c.973 1.979.25 4.088.463 6.122-2.34 2.799-2.994-.885-4.537-1.165-.758-.539-1.543-1.051-2.203-1.717a4.292 4.292 0 01-.613-1.197c-.254-1.508-.695-2.953-1.52-4.267-.203-.68-.168-1.31.4-1.821z"
        />
        <path
          fill="#05427A"
          d="M375.12 297.513l-.973 1.112c-.588.688-1.191 1.356-2.16 1.5-2.041-.039-3.801-1.272-5.834-1.376a5.156 5.156 0 01-1.318-.464c-1.756-1.587-.287-2.449.76-3.414.826-.52 1.711-.886 2.689-1.002 1.715-.086 3.271.527 4.838 1.104.968.606 2.287.945 1.998 2.54z"
        />
        <path
        className="desaparecera4"
          fill="#8161B1"
          d="M417.174 281.184c2.1-3.76 5.299-4.685 8.494-2.036 2.268 1.883 4.398 4.834.65 7.728-6.503 3.659-8.56.166-9.144-5.692z"
        />
        <path
          fill="#E2EFF1"
          d="M372.125 299.654c.391-.899 1.279-.822 2.021-1.028-.617 2.745.969 4.835 2.1 7.06-.119.857-.289 1.679-1.348 1.852-.822-1.097-1.857-2.003-2.736-3.057-1.019-1.604-1.417-3.211-.037-4.827z"
        />
        <path
          fill="#B48AB6"
          d="M478.065 312.639c.043-2.304.086-4.607.131-6.911.24.055.482.082.727.084.639 5.277.293 10.563.127 15.846-.563.303-1.025.191-1.395-.33a4.773 4.773 0 01-.609-1.532c-.114-2.449-.784-4.98 1.019-7.157z"
        />
        <path
        className="desaparecera4"
          fill="#64527F"
          d="M417.174 281.184c1.518 4.359 4.445 6.454 9.148 5.69-.842 3.818-3.57 4.056-6.365 2.827-3.824-1.681-4.216-4.901-2.783-8.517z"
        />
        <path
          fill="#F792F6"
          d="M478.155 305.647c-3.143.528-4.377-.879-3.984-3.933 1.66.975 3.208 2.062 3.984 3.933z"
        />
        <path
          fill="#1E75B8"
          d="M375.12 297.513c-.666-.593-1.334-1.187-2.002-1.779-.354-1.968-.551-3.9 1.205-5.397.564 1.547 1.131 3.093 1.695 4.641-.277.853.777 2.177-.898 2.535z"
        />
        <path
        className="desaparecera3"
          fill="#6996F4"
          d="M450.223 108.082c2.477 4.518.123 7.459-3.814 8.548-4.199 1.163-8.039.006-8.48-5.5 2.613-7.011 7.847-3.447 12.294-3.048z"
        />
        <path
          fill="#6398CF"
          d="M454.188 129.774l39.977-.239c.328.626.221 1.166-.318 1.622-4.736 1.841-9.676.521-14.504.94-7.699-.146-15.404.201-23.105-.188a4.643 4.643 0 01-1.65-.622c-.556-.391-.689-.897-.4-1.513z"
        />
        <path
        className="desaparecera"
          fill="#C51E8B"
          d="M480.641 99.769c1.145 4.179-.482 6.97-4.676 7.39-4.045.406-6.396-1.863-6.398-6.135 3.576-1.453 7.449-.248 11.074-1.255z"
        />
        <path
        className="desaparecera"

          fill="#D52883"
          d="M480.641 99.769c-3.254 4.275-7.244 2.049-11.074 1.255-.523-1.984.557-3.053 2.176-3.816 2.318-.876 4.648-.657 6.984-.075 1.285.409 1.959 1.261 1.914 2.636z"
        />
        <path
        className="desaparecera3"
          fill="#846EDD"
          d="M450.223 108.082c-2.523-.305-4.492 3.833-7.711.392-1.572-1.683-2.881 1.908-4.582 2.656-1.039-4.099.672-6.738 4.639-7.512 3.601-.704 6.992-.251 7.654 4.464z"
        />
        <path
          fill="#68A1D7"
          d="M494.165 130.638v-1.104c4.123-.633 8.303-1.852 12.072 1.163-.225.208-.449.415-.67.625-3.865.867-7.733 1.721-11.402-.684z"
        />
        <path
          fill="#6F93CC"
          d="M426.196 130.703c-2.633-.414-5.445.854-7.938-.854l19.934-.04c.252.661.07 1.167-.543 1.52-3.879.951-7.744 1.562-11.453-.626z"
        />
        <path
          fill="#658FC3"
          d="M438.186 130.681c-.002-.291 0-.582.006-.873l15.996-.034c0 .291.002.581.004.871-5.33 2.307-10.666 2.252-16.006.036z"
        />
        <path
          fill="#78BBF2"
          d="M506.237 130.698c.658.64 1.318 1.278 1.977 1.917.893 1.481 1.215 3.023.502 4.678-.996 1.219-1.867.493-2.742-.176-.676-.861-.867-1.877-.924-2.935a6.422 6.422 0 01.27-2.238c.221-.443.492-.858.805-1.246h.112z"
        />
        <path
          fill="#79BDEC"
          d="M508.174 137.708c.014-1.697.025-3.395.039-5.093 1.039.356 1.713 1.006 1.746 2.171-.895 2.225.459 4.721-.83 6.897-.311.008-.621.018-.932.028-1.202-1.328-1.142-2.663-.023-4.003z"
        />
        <path
          fill="#6D9BCF"
          d="M509.129 141.683c.42-2.281-.73-4.753.832-6.897.02 2.62.041 5.241.063 7.861-.262.488-.535.494-.816.017a31.88 31.88 0 00-.079-.981z"
        />
        <path
          fill="#8BB4D6"
          d="M509.208 142.664c.271.008.545.002.816-.017.004 2.318.008 4.638.01 6.956-1.655-2.149-.51-4.632-.826-6.939z"
        />

        <path
          fill="#86E2F9"
          d="M508.176 143.687c-.006 2.006-.012 4.013-.02 6.019-1.477 5.353.541 10.697.037 16.054-.227 2.432.295 4.909-.387 7.312-1.334 1.612-1.965.381-2.352-.722-.543-1.549-.158-3.226-.354-5.346.105 6.109.715 11.692.51 17.3-.082 2.201.475 4.229 1.566 6.141.789 7.662.439 15.315.002 22.966-.004 5.666 0 11.334-.002 16.995-.002 1.621-.08 3.255.469 4.826.217 1.965-1.219 2.663-2.609 3.395l-.855 1.113a5.021 5.021 0 01-1.738.881c-35.111.155-70.223.028-105.331.064-1.178-.064-2.4.155-3.506-.461-.35-.334-.838-.768-.516-1.226 5.484-7.771 4.625-16.981 5.578-25.697.533-4.885.492-9.905.348-14.868a9.434 9.434 0 01.141-2.325c.313-1.508 1.234-2.681 2.133-3.865 1.408-2.496 3.688-4.617 3.348-7.853-.947-2.145-3.621-1.582-4.932-3.145-1.086-1.001-1.959-2.126-2.17-3.646.16-4.183-2.602-7.977-1.646-12.271 1.406-1.919 3.811-2.46 5.486-4.109 3.881-3.824 4.807-8.441 4.391-13.578-.156-1.907-.928-4.051 1.744-4.998 1.801-.465 3.635-.354 5.456-.355 29.357-.014 58.715-.021 88.072.011 2.446 0 5.03-.458 7.137 1.388z"
        />
        <path
          fill="#C8E8FE"
          d="M398.242 240.823c-.029.284-.061.567-.094.852l-2.938.051c-1.016.771-2.025.785-3.027-.024l-1.008-.001c-5.664 1.467-11.326 1.681-16.99.002l-8.988-.003c-.09-.685.152-1.219.725-1.605 9.906-1.474 19.806-1.093 29.703.113.908.052 1.889-.201 2.617.615z"
        />
        <path
          fill="#E3F3FA"
          d="M392.184 241.701l3.025.024c-.064 3.61-1.17 6.904-3.025 9.971v-9.995z"
        />
        <path
          fill="#76AECB"
          d="M508.293 210.777c.014 4.641.029 9.281.045 13.922l-.313 1.964c-.625.326-1.045.154-1.264-.514-.143-3.941-.029-7.885-.064-11.825.018-1.381-.047-2.764.057-4.145.209-.601.629-.852 1.258-.753.574.351.666.801.281 1.351z"
        />
        <path
          fill="#8AB6D3"
          d="M507.209 226.677c.273 0 .545-.004.816-.015.092 2.35.186 4.7.277 7.05.432 1.117.67 2.128-1.117 2.018-1.465-1.049-.814-2.623-.992-3.991 1.218-1.512-.214-3.554 1.016-5.062z"
        />
        <path
          fill="#D7F4F6"
          d="M418.225 49.672c-.037.382-.074.765-.109 1.146-1.197 1.065-2.668 1.234-4.172 1.241-12.543.059-25.088.076-37.631-.01-1.162-.008-2.309-.144-3.352-.729-.598-.392-.859-.944-.791-1.654 15.351.003 30.703.004 46.055.006z"
        />
        <path
          fill="#DEF6F9"
          d="M372.17 49.667c-.008.252-.025.503-.051.754.045.276.088.553.135.829.586 4.179.133 8.382.311 12.571.178 3.918-.5 7.877.584 11.751.467 2.854.602 5.708.025 8.565a5.318 5.318 0 01-.928 1.459l-.115.238c-1.893-5.679-2.004-11.554-1.963-17.455.033-4.79-.084-9.582-.025-14.371.022-1.677-.66-3.841 2.027-4.341z"
        />
        <path
          fill="#3D8CF0"
          d="M110.13 360.762l.095-3.041c2.96-1.078 5.767-1.178 8.329 1.076.737.648 1.747 1.033 2.728 1.104 10.801.785 21.484 2.736 32.31 3.26.951.045 1.355-.826 1.94-1.369 3.671-.402 7.156-1.504 10.833 1.123 3.841 2.744 5.361-1.895 7.746-3.627.641-.377 1.334-.592 2.066-.695a7.068 7.068 0 012.168.059c3.177.795 2.397 2.871 1.607 4.807 2.895-1.121 5.79-1.797 8.627.348.615 2.678.131 5.211-.967 7.67-.409.469-.884.547-1.423.236-1.772 4.74-5.334 3.42-9.01 3.023-10.436-1.125-20.869-2.473-31.295-3.549-6.939-.717-14.446.027-21.182-3.117-3.489-1.629-6.105.35-8.519 2.621l-.002-.998c-1.159-2.045-3.064-.988-4.691-1.121-.79-.168-1.447-.504-1.747-1.318.112-2.17-.486-4.375.387-6.492z"
        />
        <path
          fill="#226BE2"
          d="M186.189 371.711c.312-.021.624-.031.937-.033 1.044-1.814 2.417-3.193 4.674-3.172 5.603.051 11.205-.758 16.784.945 3.64 1.109 7.516.057 11.287.035.719-.332 1.444-.379 2.183-.074 4.423 3.568 2.718 7.619.924 11.684a2.909 2.909 0 01-1.055 1.156c-.744.35-1.542.395-2.345.408-1.325-.037-2.706.15-3.768-.938-.846-4.041-3.685-5.094-7.369-4.959-5.157.189-10.318.475-15.478.313-3.468-.109-4.898 2.33-6.49 4.684-.757.471-1.497.527-2.208-.088 1.002-3.25 1.765-6.549 1.924-9.961z"
        />
        <path
          fill="#3468D8"
          d="M184.265 381.672l1.919.016c1.163-1.059 2.583-1.457 4.101-1.496a432.574 432.574 0 0121.792 0c1.517.037 2.938.434 4.103 1.49l4.006.021c-.441 2.738-2.588 1.369-3.884 1.402-6.818.184-13.644.035-20.458.398a7.21 7.21 0 01-1.49.828c-.818.24-1.648.246-2.481.105-2.572-.504-5.24-.619-7.674-1.748l.066-1.016z"
        />
        <path
          fill="#355BC7"
          d="M184.199 382.689c2.655.424 5.53-.967 8.001.971-1.968 1.756-3.98 1.539-6.019.133-.632-.076-1.264-.154-1.895-.232a2.113 2.113 0 01-.087-.872z"
        />
        <path
          fill="#2A81B3"
          d="M58.019 149.649l.344 2.074-.253 9.917-.465.13-.483-.001a3.264 3.264 0 01-1.143-1.045c-1.479-2.638-1.087-5.514-1.066-8.346a6.224 6.224 0 01.538-2.228 1.884 1.884 0 011.141-.936c.53-.072.992.074 1.387.435z"
        />
        <path
          fill="#1165B2"
          d="M368.237 313.87l-1.934 2.921c-2.963.678-5.383-.381-7.52-2.339a3.707 3.707 0 01-.361-1.37c.438-4.441 5.275-3.358 7.305-5.809.951-.15 1.953.567 2.883-.17a2.864 2.864 0 011.93.352c.922.739 1.824 1.493 2.186 2.686.142 3.212-3.528 1.84-4.489 3.729z"
        />
        <path
          fill="#185BA4"
          d="M366.403 320.746c-1.959 3.177-4.078 5.941-8.332 3.269-.451-.809-1.396-1.11-1.914-1.86a2.062 2.062 0 01-.266-1.348c.533-1.487 1.537-2.484 3.049-2.965 3.006-.363 5.637.238 7.463 2.904z"
        />
        <path
          fill="#1D8DC2"
          d="M345.28 323.648c-.521-.894-2.113-.591-2.197-1.972 1.729-1.277 3.115-2.924 4.697-4.359 3.777-3.432 5.865-2.604 7.033 2.756-1.193 2.326-5.188-.227-5.709 3.276a4.315 4.315 0 01-1 .891l-2.824-.592z"
        />
        <path
          fill="#2781CC"
          d="M366.403 320.746c-2.633-1.021-5.178-2.406-8.164-1.954.242-1.696-1.871-3.815.908-5.056l7.156 3.055c-.179 1.324.865 2.616.1 3.955z"
        />
        <path
          fill="#185BA4"
          d="M348.307 323.667c.018-4.853 2.387-4.99 5.857-2.923.836-.104 1.461.263 1.971.885l.061.078c1.18 3.011-1.318 3.258-3.061 4.074l-.951-.249c-1.01-1.207-2.701-1.001-3.877-1.865z"
        />
        <path
          fill="#1F66A3"
          d="M368.237 313.87c-.453-3.045 4.199-1.309 3.922-4.188-.773-.981-.902-2.003-.189-3.077 1.119-.429 2.209-.788 2.279 1.056-.317 3.701-1.258 6.799-6.012 6.209z"
        />
        <path
          fill="#1C5C9F"
          d="M353.135 325.781c.42-1.81 3.105-1.917 3.061-4.074 1.477.077 1.996.932 1.875 2.308-1.975-.329-2.016 4.735-4.936 1.766z"
        />
        <path
          fill="#396385"
          d="M374.249 307.66l-1.949-1.063c-.357-.377-.516-.82-.449-1.34.414-.731.939-1.127 1.777-.594 2.1.216 1.465 1.643 1.271 2.873-.219.029-.438.07-.65.124z"
        />
        <path
          fill="#1C5C9F"
          d="M348.307 323.667c1.488.216 3.486-.63 3.877 1.865l-4.078-1.291c.086-.186.152-.376.201-.574z"
        />
        <path
          fill="#3B8FF6"
          d="M112.18 367.693c2.347-1.363 4.574-2.488 4.001 1.998-1.394.119-1.947.916-1.996 2.271-.051 1.42.47 3.256-1.107 3.992-1.985.928-.757-2.84-2.815-2.258-.673-.5-.556-1.191-.458-1.879.391-1.604 1.036-3.063 2.375-4.124z"
        />
        <path
          fill="#E44FEB"
          d="M473.292 358.764c-.355.895-1.146.992-1.949 1.064-1.545.74-3.189.865-4.869.859-20.973-.057-41.947.119-62.913-.09-2.508.023-4.285-1.641-6.303-2.758l-.305-2.008c.18-.221.361-.443.537-.669 3.678-2.699 7.922-1.775 11.983-1.784 15.375-.033 30.75-.259 46.125-.089 2.371.026 5.072-.647 6.789 1.898-.354 1.474-1.666 1.296-2.324 1.46 4.141.796 9.285-2.614 13.229 2.117z"
        />
        <path
          fill="#FA8DF8"
          d="M472.18 307.687c0 .334 0 .669.002 1.003-1.932 3.062-4.695 1.537-7.23 1.317-.889-.537-1.566-1.393-2.617-1.687-16.895-.584-33.785.095-50.67-.229-2.262-.043-3.844.736-4.567 2.951-.438.708-1.059 1.139-1.898 1.204-1.977-1.46-3.986-2.829-6.645-1.867-.996.462-1.691 1.45-2.848 1.635-1.064-.158-1.691-.794-1.979-1.804.096-1.205-.422-2.502.545-3.571l1.811-2.129c2.375.491 2.813-1.811 4.121-2.857l1.971.041c.127.104.246.284.383.3 7.223.825 14.442 1.34 21.629-.315l7.988.001c1.176 1.486 3.238.654 4.566 1.738 3.805 2.733 8.141.481 11.535 1.271-2.18-.044-4.979.123-7.766-.079-1.543-.113-1.535-.238-1.709-2.401 5.268-.013 10.525.01 15.77-.013 2.039-.253 3.646 2.807 5.936.789 1.15-.317 2.291-.347 3.422.074 2.01 1.423 3.607 3.588 6.426 3.566.717.168 1.295.574 1.824 1.062z"
        />
        <path
          fill="#B853BE"
          d="M402.135 359.736c23.069.029 46.137.061 69.208.092l-1.275 1.799c-20.902-.039-41.805-.066-62.706-.139-1.785-.006-3.668.48-5.328-.658-.27-.27-.346-.521-.227-.756.115-.224.224-.338.328-.338z"
        />
        <path
          fill="#D771D6"
          d="M395.098 353.873c-1.85-8.282-.57-16.693-1.035-25.032-.682-3.303-.365-6.626-.197-9.945 4.15.618 2.07 3.975 2.709 6.137.107 1.404-.102 2.814.055 4.221.248 1.643.66 3.259.834 4.916.201 2.594.215 5.178-.314 7.741-1.595 3.831.866 8.36-2.052 11.962z"
        />
        <path
          fill="#F493F5"
          d="M400.205 301.654c-.063 2.841-.025 5.824-4.119 2.858.596-2.063 2.232-3.076 3.99-3.968l.129 1.11z"
        />
        <path
          fill="#C465CD"
          d="M395.098 353.873c.668-4.026-.998-8.253 1.043-12.162.443.346.76.784.955 1.313.605 2.146.344 4.351.459 6.533a9.504 9.504 0 01-.018 1.67c-.119 1.411-.154 2.853-1.398 3.853-.346-.404-.694-.805-1.041-1.207z"
        />
        <path
          fill="#B394B2"
          d="M394.273 306.64l.02 4.067c1.172 2.13 1.627 4.308.451 6.598-.373.567-.855.683-1.447.349.348-3.67-1.328-7.518.976-11.014z"
        />
        <path
          fill="#C3A0C7"
          d="M393.297 317.654c.279.025.557.042.836.05.238.189.33.393.279.609-.055.225-.117.337-.188.337l-.16 10.189c-1.5-3.642-.72-7.442-.767-11.185z"
        />
        <path
          fill="#B273B3"
          d="M402.135 359.736l-.1 1.094c-2.203-.023-3.791-1.027-4.777-2.99 2.181-.795 3.021 1.853 4.877 1.896z"
        />
        <path
          fill="#F054F0"
          d="M396.139 355.079l.131-4.341c3.982.919 3.469 2.723.967 4.917l-.281.178c-.274-.251-.546-.503-.817-.754z"
        />
        <path
          fill="#DE58EC"
          d="M102.182 285.692l-.004-2.005c-.018-.823-.194-1.567-.997-1.998-1.146-1.872-.969-3.321 1.55-2.725 1.602.38 2.434.194 3.103-1.188 2.386-1.219 3.375.905 4.798 1.978 1.028.257 1.871-.355 2.791-.598 1.056-.534 1.948 1.425 3.056.187 1.298-.123 2.584-.396 3.891-.16 3.611 1.121 5.925-.433 7.455-3.617.939-.956 2.05-1.418 3.404-1.199a3.254 3.254 0 011.661 1.67c.257.809.258 1.645.276 2.481-.203 1.949.611 4.11-1.204 5.722-5.791 1.656-11.711.606-17.565.84-4.136-1.154-8.054 2.189-12.215.612z"
        />
        <path
          fill="#FAEDFB"
          d="M93.93 281.582l-2.583-.05c-1.487-1.223-.856-2.679-.464-4.109 1.21-2.253 2.256-4.591 3.363-6.898a22.57 22.57 0 002.208-4.259c1.177-2.616 1.628-5.525 3.223-7.977.99-1.274 2.177-2.243 3.828-2.507 1.806-.108 3.131.51 3.616 2.395.602 2.874-1.504 4.688-2.683 6.866-1.86 3.312-3.492 6.743-5.165 10.154-1.398 2.447-2.139 5.451-5.343 6.385z"
        />
        <path
          fill="#EB6BEE"
          d="M95.292 270.856l-3.26 6.888c-2.037-.313-2.037-.313-1.834 3.939l-2.007.001a5.464 5.464 0 01-.833-1.169c-.247-3.655-1.575-6.654-4.713-8.856-2.289-1.606-2.257-3.52.129-5.196 2.466-.607 4.918-.718 7.329.268 1.439.559 3.144-.16 4.482.908.647.982 1.172 1.991.707 3.217z"
        />
        <path
          fill="#EB5FF0"
          d="M68.26 285.644c-.057-2.614-.113-5.228-.171-7.84l.106-2.097c3.08-2.347 6.773-2.497 10.401-2.91 2.542.632 4.099 2.187 4.522 4.812-.225 3.077-2.261 3.966-4.937 4.081h-.001c-.665-.957-1.332-.978-1.999-.003-5.035-2.527-5.69-2.2-7.921 3.957z"
        />
        <path
          fill="#E25CEE"
          d="M93.93 281.582l4.383-6.842c2.703-1.382 5.329-3.614 8.421-.765.599 1.355.501 2.608-.553 3.717.276 2.577-.344 4.477-3.244 2.612-2.694-1.732-1.456.595-1.757 1.385l-7.25-.107z"
        />
        <path
          fill="#E55FEA"
          d="M78.183 281.69c1.888-.947 4.074-1.609 4.127-4.313 3.828-2.404 4.24 1.471 5.833 3.173l.048 1.135c-3.057.219-6.281-.738-9.074 1.476-.347.274-.84-.806-.934-1.471z"
        />
        <path
          fill="#CB67CE"
          d="M90.198 281.683c-.92-1.594-1.338-3.258-.74-5.078l2.575 1.139-.686 3.789-1.149.15z"
        />
        <path
          fill="#E55FEA"
          d="M76.183 281.687c.248-1.159-.589-2.638 1-3.473 1.587.837.752 2.315 1 3.476l-2-.003z"
        />
        <path
          fill="#DC4CEC"
          d="M102.182 285.692c3.726-.455 7.085-2.987 11.073-1.955.282.481.258.947-.065 1.401-3.063 1.775-3.876 5.982-7.61 7.044-6.465-.377-12.971.741-19.396-.618 2.913-1.77 6.112-.531 9.165-.848 1.47-.152 2.968-.013 4.453-.043 1.533-.031 3.003-.41 3.956-1.666 1.506-1.987-2.288-1.608-1.576-3.315z"
        />
        <path
          fill="#F282F7"
          d="M106.399 258.63c-.287-1.95-1.823-1.801-3.207-1.907-1.953-.584-4.015.463-6.042-.985-2.716-1.94-3.801 1.5-5.688 2.385-1.012.289-1.936-1.718-3.015-.115-.671-.042-1.258-.307-1.838-.61-.924-.798-2.819-.733-2.428-2.705 1.668-1.4.757-3.316 1.002-5.001a1.869 1.869 0 011.618-.162c7.644 1.702 15.389.506 23.083.715 3.558.097 7.233.79 10.707-.706a5.072 5.072 0 011.218-.949c3.509.737 4.321 4.305 6.615 6.322-1.676 3.058-4.506 1.877-6.96 1.792-3.061-.106-6.158-1.25-9.085.562-1.062.777-1.348 2.401-2.877 2.668-.904-.742-1.747-1.635-3.103-1.304z"
        />
        <path
          fill="#F48BF7"
          d="M86.182 249.692l-.999-.001-1.002-.001c-.874-1.454-2.757-2.868-.175-4.459 10.756-.059 21.512.012 32.268-.046 1.623-.009 3.313.419 4.865-.454l1.048-.069c.157.15.313.301.473.45.205.389.335.803.399 1.238.052.906-.102 1.738-.876 2.336l-.007 1.001c-.949.8-2.085.97-3.272.976-9.815.042-19.631.041-29.447 0-1.188-.005-2.323-.175-3.275-.971z"
        />
        <path
          fill="#F680F4"
          d="M84.181 254.692l2.997 1.792c-.021.962-.085 1.913-.688 2.73-.928 1.171-2.002 2.082-3.621 2.009-4.476-.203-9.049-1.463-13.249 1.234-.35.841-.65 1.709-1.443 2.259a14.166 14.166 0 01-.965-.065l.029-5.999c1.768-1.606.457-3.812 1.218-5.93 4.508 7.017 10.619-.264 15.722 1.97z"
        />
        <path
          fill="#FC8EF8"
          d="M83.182 245.697c.684 1.243 1.154 2.54.999 3.993-2.396-.133-4.695-.713-7.211-.121-3.024.712-6.099.081-8.729-1.856.32-1.019 1.001-1.673 2.008-2.002 4.311-.818 8.622-.798 12.933-.014z"
        />
        <path
          fill="#6AA9E7"
          d="M406.156 131.667l8.038.039c.809.782 1.939.273 2.82.683 1.801.837 5.006-.788 5.393 2.229.406 3.161.371 6.704-3.854 7.888-4.736-.182-9.647 1.46-14.124-1.358-2.252-1.194-4.176-2.798-5.816-4.745-1.875-2.271-4.568-2.141-7.113-2.395-1.92-.19-3.912.19-5.734-.771-.643-.584-1.109-1.188-.229-1.95 1.729-.15 3.457-.049 5.186-.078 5.144.253 10.316-.538 15.433.458z"
        />
        <path
          fill="#6BADEA"
          d="M419.182 141.689c2.869-1.691.391-5.167 2.367-7.241.25-.262-.891-.677-1.52-.732-2.113-.187-4.154-.574-5.838-2.01l11.988-.033c1.84-.931 3.791-.301 5.691-.414 7.355 1.162 7.373 1.184 7.102 9.36-.83 2.202-2.742 2.039-4.545 2.054-3.943.032-7.889.023-11.836.004-1.214-.057-2.481.059-3.409-.988z"
        />
        <path
          fill="#84ADE1"
          d="M432.192 131.7l-6.012-.027c.002-.323.008-.646.016-.97 3.996-.007 7.992-.015 11.99-.021l16.006-.035-.014.11c.289.629.143 1.131-.436 1.513-.793.488-1.674.667-2.588.737a67.086 67.086 0 01-18.962-1.307z"
        />
        <path
          fill="#697EB0"
          d="M330.182 131.715a18.86 18.86 0 00-.041-.89l11.914-.219 16.096.213c.279.652.109 1.152-.506 1.503-5.607 1.587-11.34.368-17.002.764-.895.012-1.793.009-2.689.007-2.639-.184-5.461.659-7.772-1.378z"
        />
        <path
          fill="#7695C3"
          d="M406.156 131.667l-15.982-.01c-.322-.202-.43-.407-.328-.616.104-.209.209-.313.314-.313 5.324.456 10.766-1.11 15.996.939z"
        />
        <path
          fill="#7189C1"
          d="M390.16 130.727c.014.31.018.62.014.93l-4.98.07c-3.408 2.131-6.96 1.544-10.537.569-.598-.376-.762-.893-.496-1.547l15.999-.022z"
        />
        <path
          fill="#6B85B9"
          d="M374.161 130.75c.012.303.018.604.016.907-2.029 2.046-4.689 1.13-7.072 1.523-3.031-.201-6.27.784-8.936-1.534.006-.276 0-.553-.018-.827l16.01-.069z"
        />
        <path
          fill="#3293BB"
          d="M372.247 85.597a1.342 1.342 0 01.084-.906c.379-.426.779-.832 1.195-1.223 3.492-1.91 7.294-.87 10.96-1.158 2.09-.01 4.176.019 6.264-.069 6.758-.36 13.516.097 20.272-.073 1.822-.046 3.639.156 5.088 1.492l-.053 1.896-43.81.041z"
        />
        <path
          fill="#476BC4"
          d="M109.193 316.706c-.004 8.74.016 17.481-.037 26.223-.01 1.589.527 3.332-.836 4.703l-.288-19.672c-.609-6.719-.449-13.441-.077-20.167 3.226 2.025 3.518 4.134 1.238 8.913z"
        />
        <path
          fill="#747A97"
          d="M108.229 307.716l-.197 20.242c-1.189-7.061-.769-14.176-.703-21.28.343-.28.694-.305 1.055-.034.198.394.146.751-.155 1.072z"
        />
        <path
          fill="#7E50C3"
          d="M107.209 293.787l-.433-1.039a.947.947 0 00.508-.112c6.182-2.179 12.395-1.865 18.624-.236.465.512.488 1.046.071 1.6-2.421 1.598-5.168.849-7.78 1.077-3.166-.157-6.363.384-9.507-.381a6.347 6.347 0 01-1.483-.909z"
        />
        <path
          fill="#5C6193"
          d="M107.209 293.787c.313-.057.628-.075.946-.056.958.882 1.162 2.039 1.199 3.259.019 1.162-.025 2.322-.252 3.469a3.583 3.583 0 01-.594 1.225c-.398.287-.802.305-1.207.008l-.092-7.905z"
        />
        <path
          fill="#6A6D8F"
          d="M107.302 301.691l.827-.014c1.512 1.679 1.517 3.353-.014 5.022a51.408 51.408 0 01-.785-.021l-.028-4.987z"
        />
        <path
          fill="#ACB6C3"
          d="M508.293 210.777l-.25-1.045c-1.494-2.508-.609-5.273-.857-7.917.193-3.856-.42-7.741.393-11.578.322-.62.813-.808 1.467-.564-.157 7.037.878 14.119-.753 21.104z"
        />
        <path
          fill="#90A4B4"
          d="M509.135 173.712c-.033 3.652-.064 7.304-.098 10.956-.568.288-1.029.166-1.385-.363-1.057-2.041-.74-4.255-.814-6.423.076-1.358.064-2.743.939-3.909.366-.534.819-.621 1.358-.261z"
        />
        <path
          fill="#8DA8C0"
          d="M509.135 173.712l-.428-.01-.428.003c-1.193-2.445-.367-5.026-.512-7.543.283-.645.725-.786 1.328-.423l.18 4.112c-.044 1.289-.093 2.575-.14 3.861z"
        />
        <path
          fill="#9DAFBD"
          d="M508.254 184.68c.262.002.523-.002.783-.012l.008 5.004c-.264.01-.529.014-.793.012-.695-.524-.984-1.26-1.094-2.091-.04-1.123.126-2.171 1.096-2.913z"
        />
        <path
          fill="#4188EB"
          d="M156.185 361.695c-.114 2.986-1.186 4.426-4.314 2.768-.701-.371-1.57-.818-2.285-.711-8.821 1.311-17.211-2.529-25.962-2.105-2.67.129-5.716-.188-7.156-2.633-1.836-3.115-4.646 1.184-6.243-1.293l-.015-5.016c6.138-.951 12.286-.453 18.423-.139a4.57 4.57 0 011.393.566c1.721 1.583 1.636 4.807 4.689 5.198 2.261-.039 4.702.902 6.553-1.264.308-.33.662-.594 1.064-.797 1.946-.598 2.621 1.416 4.023 1.941 1.348.303 2.757.344 4.025.967 1.623 1.557 4.266.772 5.805 2.518z"
        />
        <path
          fill="#4E76D3"
          d="M110.182 325.691l-.003-8c1.26-1.954-.306-5.571 2.716-6.187 3.086-.629 1.721 3.814 3.995 4.608 3.129 1.229 6.631-.212 9.662 1.219 3.905 1.842 7.399 4.23 8.663 8.758a3.94 3.94 0 001.274.925c9.253.645 18.502.085 27.743.297 2.278.052 4.656-.403 6.739 1.017.469.511.51 1.057.129 1.636-2.029 1.529-4.408 1.039-6.674 1.112-9.689.312-19.4-.576-29.064.501-1.158.52-2.384.479-3.234-.428-5.945-6.352-13.6-5.311-21.1-5.005-.318.014-.603-.202-.846-.453z"
        />
        <path
          fill="#487EDF"
          d="M110.191 339.695l-.007-6.004c2.005-1.675-.33-5.479 2.763-6.333 3.128-.863 3.72 2.591 5.532 4.026 1.933 1.53 4.446.849 6.718.886 7.608.123 8.242.639 9.521 8.196.18.506.31 1.024.41 1.55.097.525.12 1.057.093 1.589-.066.799-.3 1.536-.826 2.159-1.054.505-1.947.028-2.837-.463-4.893-3.938-10.954-2.884-16.505-3.36-2.303-.198-3.637-.594-4.862-2.246z"
        />
        <path
          fill="#4582E4"
          d="M110.191 339.695c4.695.656 9.496 2.226 14.052 1.691 3.87-.453 5.834.908 7.938 3.305 1.517 1.882 1.001 4.509 2.378 6.443.209.433.356.884.471 1.349a5.156 5.156 0 01-.015 2.146 3.092 3.092 0 01-.716 1.219c-2.013.508-2.936-1.073-4.118-2.157-1.267-1.587-2.665-2.635-4.919-2.815-3.509-.283-7.209.191-10.38-2.15-1.702-1.257-2.662 2.736-4.682.971l-.009-10.002z"
        />
        <path
          fill="#4B79D8"
          d="M134.169 341.705c-2.988-7.99-2.988-7.953-12.233-8.037-2.585-.024-5.977 1.133-5.94-3.573.01-1.291-1.38-1.992-2.513-1.938-1.703.082-1.232 1.658-1.279 2.71-.064 1.433-.231 2.676-2.02 2.824l-.002-8c3.948-2.06 7.996-2.088 12.115-.587.307.112.636.445.888.387 5.575-1.298 7.838 3.241 10.997 6.199.137.119.274.239.414.357.18.321.297.665.371 1.024.067.358.099.722.119 1.086.035.362.043.727.048 1.091.026.547.03 1.096.032 1.645.021.557.015 1.113.001 1.671.002.571-.038 1.138-.128 1.703a3.397 3.397 0 01-.416 1.074c-.15.123-.302.243-.454.364z"
        />
        <path
          fill="#4285E8"
          d="M110.2 349.696c1.795.013 1.797-1.591 2.453-2.647.668-1.075 2.146-1.925 2.806-.786 2.669 4.603 7.081 3.227 10.894 3.326 3.103.081 4.183 1.206 3.828 4.103-6.649-.504-13.401 1.089-19.973-.986a3012.06 3012.06 0 00-.008-3.01z"
        />
        <path
          fill="#5472CA"
          d="M116.179 317.69c-3.48-.456-.918-4.033-2.85-5.425-2.545.922.453 5.178-3.149 5.426l-.986-.986c-.461-2.98.961-6.164-.964-8.988l-.113-1.017.013-5.022.115.041c.741-.672 1.962-.585 2.04.108.47 4.208 4.574 5.045 6.77 7.628.696 2.853 1.079 5.67-.876 8.235z"
        />
        <path
          fill="#178ABB"
          d="M57.056 160.716l.107 1.052c-4.782 1.154-9.588.631-14.393.21-3.608.228-7.217.5-10.813-.143-1.29-.247-2.69 2.265-3.895-.155-.597-1.221-.286-2.055 1.042-2.456 4.761-.186 9.603.943 14.264-.857 1.209-.621 2.621-.729 3.771-1.495.856-.671 1.165-1.828 2.125-2.407 1.766.091 1.905 1.583 2.404 2.765 1.954.886 4.897 2.802 5.388 3.486z"
        />
        <path
          fill="#1AA2CF"
          d="M29.182 159.701l-1.118 1.981c-1.437-4.527-.984-9.182-.938-13.809-.845-2.575-.321-5.211-.345-7.819.31-.572.779-.764 1.401-.572 1.911 2.04 1.159 4.632 1.458 7.001-.13 2.38 2.625 2.745 3.244 4.606.747 2.07.729 4.148.089 6.238-.798 1.534-1.814 2.724-3.791 2.374z"
        />
        <path
          fill="#3996AA"
          d="M28.173 139.714c-.33.013-.659.042-.987.085-.335.396-.567.362-.681-.164a1.732 1.732 0 01-.238-.795c9.972-.092 19.943-.188 29.914-.269.846-.007 1.657.153 1.928 1.157a5.826 5.826 0 01-1.555.965 7.782 7.782 0 01-1.816.326c-6.972.334-13.948.163-20.923.176-2.004.004-4.007-.049-5.642-1.481z"
        />
        <path
          fill="#10B2DF"
          d="M26.506 139.635c.229.045.456.099.681.163l-.061 8.074c-1.097-2.677-.755-5.465-.62-8.237z"
        />
        <path
          fill="#159AC8"
          d="M416.11 83.66l-25.932.015c-1.59-1.788-4.023-.371-5.781-1.516-.35-.296-.521-.683-.539-1.137.666-1.159 2.006-2.165.867-3.756-.551-2.496-1.318-4.992.104-7.451 2.459.521 4.131 2.235 5.857 3.877 1.469 3.635 5.385 5.024 8.496 2.667 1.24-.939 2.98-1.583 3.533-3.336.092-.729.111-1.456.111-2.194a32.546 32.546 0 01-.023-1.622c.295-2.535-.742-7.101 1.643-7.009 3.523.136 1.773 4.51 2.059 7.066.256 2.289.229 4.654-.209 6.951 1.09.892-4.072 2.867.549 3.141 1.033-.198 1.477-1.111 2.137-1.771a2.1 2.1 0 011.186-.246c2.191.522 3.773 1.884 5.053 3.662.313.549.484 1.173.887 1.676l.002.983z"
        />
        <path
          fill="#1BA4CE"
          d="M372.12 50.421l45.996.397c-.078.33-.154.659-.23.989-.676 2.676.352 5.481-.629 8.134.102 5.675.287 11.354-.906 16.959-2.221-1.97-1.318-4.636-1.58-7.039.01-4.462-.031-8.93.014-13.395.021-2.3-.842-3.259-3.199-3.232-4.463.049-8.928-.17-13.397-.118-3.943-.128-7.883.115-11.822.02-4.551-.187-9.171.761-13.644-.795-.623-.361-.789-.874-.502-1.534l-.101-.386z"
        />
        <path
          fill="#0B96C5"
          d="M416.079 69.692l.27 7.21c-.08 1.924-.16 3.85-.242 5.774l-.93-.996c-1.918-2.988-1.498-6.277-1.244-9.551.351-1.13.501-2.447 2.146-2.437z"
        />
        <path
          fill="#0DB5E0"
          d="M417.256 59.942c.23-2.71-.811-5.518.629-8.134.194 2.742.543 5.497-.629 8.134z"
        />
        <path
          fill="#F699F9"
          d="M83.182 245.697l-12.933.014c.011-.314.017-.629.019-.941 16.958-.013 33.915-.025 50.871-.039-1.484 1.603-3.426.92-5.166.93-10.93.062-21.86.034-32.791.036z"
        />
        <path
          fill="#CC6FDA"
          d="M127.164 243.625l1.194-.052c1.232-.624 1.954-.22 2.22 1.104-.717 2.245-2.562 1.142-3.971 1.35-1.604-.017-3.175-.153-4.437-1.318l.016-.046-.045-1.007.015-.043c1.672-.675 3.341-.61 5.008.012z"
        />
        <path
          fill="#A17DC6"
          d="M127.164 243.625l-5.007-.012-.117-1.01c.142-.319.285-.639.43-.958.202.049.406.073.611.073l4.083 1.907z"
        />
        <path
          fill="#83DEF7"
          d="M508.176 143.687l-101.997.009c-.686.075-1.068-.229-1.145-.918a1.793 1.793 0 011.566-.603c5.393.071 10.784.009 16.178.031 15.803-.051 31.572-1.54 47.387-.941 10.453.037 20.908-.018 31.361.031 2.291.011 4.697-.352 6.641 1.394.019.332.021.664.009.997z"
        />
        <path
          fill="#69C2EB"
          d="M508.168 142.69c-12.666-.01-25.33-.021-37.996-.03-.281-.658-.119-1.178.482-1.563 4.977-1.612 10.102-.594 15.156-.765 5.416-.184 10.846-.039 16.252-.047 1.957.266 2.906-.784 3.285-2.567.199-.417.494-.748.871-1.011l1.955 1 .023 4.004c-.002.328-.012.654-.028.979z"
        />
        <path
          fill="#8DE7FE"
          d="M508.27 165.711c.002 2.665.006 5.329.01 7.994l-.205 3.924c-2.512-.811-1.865-2.339-.895-3.941 0-6.442-.031-12.886.025-19.329.014-1.585-.547-3.349.953-4.653.025 2.681.053 5.361.08 8.042.702 2.652.659 5.306.032 7.963z"
        />
        <path
          fill="#94B2CC"
          d="M508.27 165.711l-.031-7.964c1.865 2.494.563 5.329.857 7.991l-.412-.029-.414.002z"
        />
        <path
        className="desaparecera2"

          fill="#7A86FC"
          d="M49.481 219.059l.023 2.561-2.527.01c-1.715 1.342-3.43 1.342-5.145-.001l-2.526-.005.056-2.55 10.119-.015z"
        />
        <path
        className="desaparecera2"
          fill="#6A8CFE"
          d="M41.833 221.628l5.145.001c-.158 1.761-1.115 2.559-2.883 2.448-1.556-.098-2.089-1.097-2.262-2.449z"
        />
        <path
          fill="#F270F3"
          d="M68.177 264.716l.013-3.013c2.609.104 4.856 2.043 7.846.91 1.586-.602 3.356.901 3.529 3.12-.277 1.278-1.046 2.203-2.084 2.938-.533.394-1.131.692-1.598 1.188-3.572 3.785-4.19 3.769-7.692-.17l-.014-4.973z"
        />
        <path
          fill="#E96BEC"
          d="M68.191 269.69c2.654 1.583 5.32 3.495 6.985-1.194.162-.456 1.42-.522 2.169-.77.405 1.957 1.983 3.724.957 5.913-3.288 1.086-6.596 2.075-10.108 2.068l-.003-6.017z"
        />
        <path
          fill="#3E2089"
          d="M253.148 348.742l-6.026-.249c-3.289.436-6.335-.34-9.24-1.842-.901-.464-1.668-1.063-2.021-2.062.696-3.654 2.979-5.034 6.488-4.223 2.5.578 4.97-.063 7.436.179 1.38.136 3.463-.063 3.285 1.995-.156 1.803-1.865 2.069-4.17 1.445 2.954 1.043 4.623.417 6.271-1.486 2.226-2.57 4.275-2.092 5.561 1.127-1.159 3.737-4.05 4.903-7.584 5.116z"
        />
        <path
          fill="#341A80"
          d="M238.17 345.699l8.952 2.794c-3.363.224-2.471 3.614-3.918 5.263l-.998-1.082c-2.186-.6-4.527-.759-6.408-2.24-.914-.74-1.984-1.38-1.875-2.804.792-2.016 2.781-1.397 4.247-1.931z"
        />
        <path
          fill="#2D1974"
          d="M253.148 348.742c2.227-1.847 5.431-2.329 7.04-5.041 1.264-.876 2.045-.261 2.665.861.326 1.155.25 2.225-.68 3.104-.329.005-.657.013-.986.025-1.509 3.928-4.141 4.001-7.337 2.136l-.702-1.085z"
        />
        <path
          fill="#2F167D"
          d="M253.85 349.828c2.824.588 5.354.162 7.337-2.136l-1.18 8.091c-2.053-.448-1.317-3.635-3.659-3.42-.436.039-.796.904-1.191 1.389-1.147-1.072-1.089-2.544-1.307-3.924z"
        />
        <path
          fill="#633AA2"
          d="M266.187 355.684c-.172-1.583-.723-2.978-1.996-4.013-1.024-1.156-.88-2.234.211-3.25 4.438.016 7.196-2.978 9.646-5.958 2.52-3.065 5.441-4.53 9.301-4.401 2.227-.208 3.879 1.274 5.805 1.966 2.166 1.688 4.715 2.83 6.783 4.661.348.288.664.61.967.944 1.141 1.645 3.051 2.653 3.838 4.6.074.757-.115 1.409-.738 1.896-2.035.916-3.492-.172-4.875-1.437a31.76 31.76 0 00-6.477-4.569c-5.408-2.887-12.379.001-15.266 6.015-1.154 2.406-1.371 5.662-4.912 6.23-1.713-.085-1.562-1.759-2.287-2.684z"
        />
        <path
          fill="#452B96"
          d="M266.187 355.684l1.97 2.016c2.432 1.986 2.575 5.109 3.831 7.68.529 1.314 1.109 2.617 1.139 4.068-.197 1.975-1.021 3.332-3.196 2.301-1.58-.75-3.19-.693-4.815-.855-.95-1.27-1.154-2.881-1.941-4.225l.021.031c-.491-1.766-1.86-3.182-2.027-5.078 1.123-1.057.658-4.717 4.176-2.021.899.686.347-2.568.842-3.917z"
        />
        <path
          fill="#402189"
          d="M265.182 348.692c-1.18.71-.976 1.881-.991 2.979-.201.593-.111 1.982-1.174.589-1.022-1.341-.856-3.005-.843-4.593l.051-2.977c2.003-2.474 4.048-3.899 6.297-.249.156 2.411-1.453 3.44-3.34 4.251z"
        />
        <path
          fill="#6046B2"
          d="M261.168 361.621c1.555 1.342 2.096 3.088 2.027 5.078-.665-.676-1.329-1.354-1.993-2.031-.389-1.012-1.609-2.014-.034-3.047z"
        />
        <path
          fill="#5E43B0"
          d="M232.186 374.699h-1.01c-2.07-3.34 1.03-5.668 1.648-8.484 1.167-2.068 1.118-5.105 4.361-5.539l-1.005 5.012-3.994 9.011z"
        />
        <path
          fill="#4A36A4"
          d="M266.192 390.674c-.104-1.479.303-3.297-.411-4.371-1.932-2.902-.507-4.725 1.4-6.615 3.91 2.453 3.818 6.113 3.011 9.988-1.049 1.472-2.612.885-4 .998z"
        />
        <path
          fill="#614AB9"
          d="M270.193 389.676c-.474-3.488-1.59-6.785-3.011-9.988-.424-1.768-.66-3.611-1.985-5.023l-.022-2.969c.241-.053.483-.105.725-.16 3.458 3.191 4.03 7.711 5.468 11.838.195 1.432.661 2.877-.137 4.277l.936 2.045h-1.004c-.325-.007-.648-.012-.97-.02z"
        />
        <path
          fill="#432792"
          d="M237.186 360.676c-1.725 1.629-2.5 3.748-3.081 5.969-2.318.516-2.354-1.711-3.347-2.787.101 2.484-1.04 2.807-2.995 1.717-1.433-4.793 1.2-8.9 2.225-13.279.968-1.178 2.097-2.565 3.716-1.796 2.101.997 1.364 3.048 1.225 4.677.859-1.613-.545-3.938 1.253-5.481 1.911 1.189 4.499 1.011 6.025 2.979l-1.073.048c-1.717 2.464-2.864 5.211-3.965 7.981l.017-.028z"
        />
        <path
          fill="#5E43B0"
          d="M237.168 360.703c.216-3.211 1.402-5.938 3.965-7.981-.727 2.956-1.925 5.676-3.965 7.981z"
        />
        <path
          fill="#452C99"
          d="M228.185 365.691c1.812.221 1.981-1.963 3.435-2.365.862 1.09.83 2.855 2.485 3.318-.904 2.711-3.103 4.951-2.929 8.055-.002.311.001.619.012.93a10.95 10.95 0 01-.974.092c-1.681.414-2.406-.881-3.32-1.85-1.196-2.98-2.041-5.912 1.291-8.18z"
        />
        <path
          fill="#614AB9"
          d="M263.174 366.668c1.33.99 1.778 2.443 2.086 3.969.262.254.338.494.229.723-.106.219-.208.33-.304.33l-.011.006c-1.58-1.313-2.039-3.071-2-5.028z"
        />
        <path
          fill="#653EA4"
          d="M271.188 365.688c-1.722-2.393-2.204-5.256-3.031-7.988 2.86-.82 3.139-3.597 3.913-5.712 2.832-7.741 12.094-10.547 18.961-6.171 3.047 1.942 4.777 6.058 9.156 5.874.645-.592 1.287-.59 1.928.008.322 1.008.645 2.016.969 3.023-.244 1.71-.127 3.681-2.68 3.73-3.51-.561-5.492-3.52-8.217-5.312-7.5-4.937-11.618-3.77-15.819 4.107-1.536 2.882-1.929 6.581-5.18 8.441z"
        />
        <path
          fill="#6547AD"
          d="M310.18 383.697c-2.395-1.297-3.594-3.387-3.998-6.008-1.432-3.41-3.278-6.545-6.069-9.047a11.298 11.298 0 01-1.061-.98c-1.559-1.791-2.553-3.695-1.156-6.049 1.895-1.176 3.105.398 4.531 1.123.695 2.344 2.702-.297 3.68.957.057.604.113 1.207.172 1.811 1.172 1.172.537 3.164 1.928 4.236.313.721.623 1.441.934 2.162 1.043.701-.213 2.17.947 2.832.088.309.131.623.127.945.469 2.675 1.875 5.354-.035 8.018z"
        />
        <path
          fill="#5E47AA"
          d="M306.108 363.693c-1.307-.043-2.618 2.324-3.924-.002-.775-1.963-3.223-3.369-2.004-5.998 2.164.178 1.699-2.215 2.904-2.973 1.043 2.979 3.596 5.45 3.024 8.973z"
        />
        <path
          fill="#D9F1F7"
          d="M296.414 333.676c1.125-1.77 2.83 1.512 3.697-.312.869-1.823 2.047-2.172 3.318-.964.301.285-.67 2.921-1.422 3.125-3.398.922-.793 3.631-1.82 5.151l-.994-.35c-2.057-1.289-2.646-3.468-3.385-5.56-.001-.474.202-.838.606-1.09z"
        />
        <path
          fill="#5F39A0"
          d="M300.188 349.696c-2.117-.553-3.455-1.885-4.006-4.005.52-1.085 1.447-1.669 2.529-2.065.221-.032.441-.062.664-.091.645 1.662 1.287 3.323 1.932 4.984.384 1.114-.133 1.368-1.119 1.177z"
        />
        <path
          fill="#5F39A0"
          d="M296.281 334.527c.971 1.936 1.941 3.872 2.912 5.805l.18 3.204-.266.184c-3.189-2.375-5.296-5.08-2.826-9.193z"
        />
        <path
          fill="#5051AD"
          d="M308.208 369.74c-2.727-.461-1.889-2.549-1.93-4.234 2.392.615 1.877 2.555 1.93 4.234z"
        />
        <path
          fill="#D9F1F7"
          d="M302.162 344.715c1.094-.534 2.059-.8 2.031.982a1574.89 1574.89 0 01-.09 3.072c-1.152-1.108-1.841-2.44-1.941-4.054z"
        />
        <path
          fill="#5E47AA"
          d="M300.188 349.696l1.119-1.176c.996.874.984 2.005.809 3.178l-1.928-.008v-1.994z"
        />
        <path
          fill="#6156B6"
          d="M310.088 374.734c-3.66.172-.006-2.1-.947-2.834.316-.074.637-.092.959-.049l-.012 2.883z"
        />
        <path
          fill="#D9F1F7"
          d="M300.193 340.689c1.814.771 2.105 2.288 1.969 4.015-1.133-1.105-1.844-2.415-1.969-4.015z"
        />
        <path
          fill="#3371C4"
          d="M315.161 395.623l-.465.037-.465-.018.021-5.084c1.403 1.491.897 3.325.909 5.065z"
        />
        <path
          fill="#6156B6"
          d="M310.18 383.697c.012-2.672.023-5.346.033-8.018 2.406 2.498 1.217 6.201 2.992 8.908l-.037 1.104c-1.451.016-2.894.022-2.988-1.994z"
        />
        <path
          fill="#755EBD"
          d="M196.184 393.691c.682-1.445 1.967-2.51 2.083-4.342.19-2.996 1.644-5.16 4.92-5.57.997-.807 1.993-.809 2.989.002 5.16 2.395 2.328 6.406 2.005 9.91h-11.997z"
        />
        <path
          fill="#4B32A3"
          d="M228.183 373.701l2.031 2.02-4.079 12.936-3.979-3.99a34.688 34.688 0 00-.031-.967c-.536-.682-.533-1.332.114-1.945l-.048-.049c.437-.465.931-.852 1.514-1.113 1.109-.426 1.374-1.461 1.732-2.43.165-.41.384-.785.63-1.148.862-1.005 1.028-2.456 2.116-3.314z"
        />
        <path
          fill="#355BC7"
          d="M222.238 381.754c-.038.648-.075 1.297-.114 1.945-3.651.023-7.302.049-10.952.074-1.666.002-3.332.004-4.997.008l-2.989-.002-7.002.008c-.708.51-1.379.441-2.021-.123 6.384-2.156 12.966-.375 19.424-.99 2.209-.211 4.625.861 6.598-.973l2.053.053z"
        />
        <path
          fill="#6D54B7"
          d="M194.164 383.664c.673.041 1.347.08 2.021.123-.024 2.303-.21 4.277-2.396 6.004-2.424 1.914.212 5.48-1.607 7.898-2.874.209-1.125-4.203-3.997-3.998.524-2.047 2.768-3.521 1.994-6 .784-1.871 2.288-3.01 4.005-3.93l-.02-.097z"
        />
        <path
          fill="#725DBD"
          d="M288.182 393.691c.408-2.936-2.408-5.064-1.998-8 1.301-1.445 1.158-4.43 4.24-3.979 1.236 1.518.736 3.48 1.313 5.166.439 1.287 1.104 2.689 2.584 2.592 1.912-.127 1.352-1.873 1.404-3.1.027-.662.057-1.305.418-1.889 2.32-1.041 3.043.832 4.039 2.209 2.025 3.42 2.266 7.164 2 11-5.221.609-10.284.66-14-3.999z"
        />
        <path
          fill="#755AB8"
          d="M300.182 386.691c-1.385-.563-2.26-2.146-4-2-.986-.717-1.186-1.895-1.68-2.895-1.387-2.809-2.818-2.66-4.322-.105-1.463 1.201-2.025 3.303-3.996 4-.021-.824-.197-1.57-1.002-2-.701-.568-.969-1.35-1.086-2.207-.219-1.699.391-3.277.795-4.873.664-2.629 1.525-5.381 4.695-5.732 3.441-.385 5.521 1.664 6.598 4.814-.373 2.139.627 3.695 2.008 5.203 1.211 1.318 2.295 2.799 1.99 4.795v1z"
        />
        <path
          fill="#6D54B6"
          d="M285.18 381.689l.002 2.002-2 4-3-4c-1.946-2.336-1.467-4.926-.803-7.539.523-1.129 1.377-1.818 2.633-1.963 4.592 1.002 1.754 5.151 3.168 7.5z"
        />
        <path
          fill="#6D49B0"
          d="M300.18 367.691c3.355 2.52 6.958 4.891 6.002 9.998-3.516.939-3.137-3.959-6-4-1.483-1.998-1.75-3.998-.002-5.998z"
        />
        <path
          fill="#7355B4"
          d="M285.18 381.689c-1.896-1.949-.303-5.393-2.998-7-.963-4.125 1.969-6.484 4.543-8.445 2.33-1.773 5.045-.484 7.266 1.307 1.537 1.242 3.361 2.145 4.49 3.863.328.813.291 1.58-.295 2.275-.037 1.299-.701 1.969-2.002 2.004-7.537-5.951-8.451-5.613-10.844 4.059-.152.621-.111 1.291-.16 1.937z"
        />
        <path
          fill="#6753B7"
          d="M298.186 373.689l-.006-1.998c-1.012-1.25-1.203-2.568-.33-3.975.77-.689 1.549-.594 2.332-.025h-.002c.002 2 .002 4 .002 5.998h-1.996z"
        />
        <path
          fill="#694EB3"
          d="M280.182 375.691l-.001 8c-.812.436-.979 1.191-1.008 2.018-.327-.012-.654-.02-.98-.021-2.353-1.9-2.436-4.949-3.758-7.375-.41-.859-.777-1.73-.66-2.719 1.058-2.113 1.94-4.381 4.468-5.252 1.06.189 1.938.656 2.504 1.613.556 1.358.233 2.582-.565 3.736z"
        />
        <path
          fill="#674EBB"
          d="M194.184 383.762c-1.272 1.373-1.656 3.654-4.005 3.93-3 .41-4.443-.777-3.998-3.898 2.006-.043 4.012-.088 6.019-.133.661.032 1.322.068 1.984.101z"
        />
        <path
          fill="#644CBF"
          d="M184.219 393.68l.002-3.98c1.383.107 1.975.871 1.891 2.232-.074 1.201-.833 1.629-1.893 1.748z"
        />
        <path
          fill="#4D36A3"
          d="M275.206 377.68c1.687 2.412 2.186 5.266 2.987 8.008-2.924-.033-1.227 3.451-3.271 4.225-1.679.094.552-6.664-3.692-2.262l-.998-3.988c1.699-1.962.963-5.946 4.974-5.983z"
        />
        <path
          fill="#C1A7EF"
          d="M226.179 170.657c5.97 2.076 11.66 4.969 17.939 6.142 2.004-.428 3.698.399 5.375 1.313 2.184 1.737 5.073 2.754 5.981 5.805-.09.055-.58 1.626-.523 1.725.407.715.155 1.239-.514 1.571-1.681.832-4.362 1.574-5.155.628-3.669-4.377-7.435-.016-11.044-.605-2.315-.075-4.011-1.443-5.746-2.737-3.178-3.3-6.32-6.631-8.341-10.83-.535-1.819-1.236-3.759 2.028-3.012z"
        />
        <path
          fill="#906DD1"
          d="M238.186 165.689c1.381-.139 2.948.465 3.998-1.001 3.175-.348 3.525 2.895 5.349 4.274 1.542 1.166 2.753 2.762 4.287 3.983 1.462 1.41 3.943 2.093 3.519 4.866-1.129 1.062-2.588 1.155-4.008 1.367a2.724 2.724 0 01-1.355-.347c-4.834-3.568-9.319-7.453-11.79-13.142z"
        />
        <path
          fill="#C3A7F1"
          d="M214.184 170.689c-4.417-.309-5.825-4.075-7.999-6.961l14.02 4.93c.174.183.349.364.526.546.688 1.453.688 2.887-.13 4.292-2.952.928-3.974-2.566-6.417-2.807z"
        />
        <path
          fill="#7E5EC4"
          d="M238.186 165.689c3.257 5.008 8.311 8.359 11.98 12.987-.297.435-.647.482-1.051.146-1.665-.675-3.331-1.351-4.996-2.024-1.114-4.192-4.967-6.503-6.939-10.105-.391-1.055.098-1.229.995-.993l.011-.011z"
        />
        <path
          fill="#7253B9"
          d="M220.205 168.658c-.185-3.661-.098-7.291 1.485-11.312 2.092 4.133 1.317 8.465 2.491 12.343-1.742 1.325-2.846.037-4.016-.98l.04-.051z"
        />
        <path
          fill="#9A85D7"
          d="M220.165 168.708l4.016.98c.808.03 1.555.188 1.999.968-2.56.279-1.555 1.724-.988 3.024.112 2.683-1.539 2.919-3.597 2.595-1.08-.532-1.43-1.448-1.355-2.587a4073.46 4073.46 0 01-.075-4.98z"
        />
        <path
          fill="#7E5EC2"
          d="M251.171 173.702c-3.757-2.245-5.833-6.167-8.988-9.014-.003-.33-.006-.66-.011-.991-.517-.951.116-1.166.846-1.323.701.139 1.267.514 1.769 1 1.379 1.672 2.498 3.601 4.522 4.651 1.188.959 2.599 1.686 3.332 3.131.109.441.118.884.021 1.329-.285.665-.764 1.093-1.491 1.217z"
        />
        <path
          fill="#8664C9"
          d="M238.175 165.699l-.995.993c-2.346-2.623-4.261-5.485-4.999-9.001v.001c2.744 2.11 3.608 5.629 5.994 8.007z"
        />
        <path
          fill="#8968C2"
          d="M239.17 157.692c-2.644-1.647-2.606-4.432-2.986-7.039 1.671-.608 1.29 1.441 2.261 1.742.845 1.525 1.823 2.993 2.094 4.771-.073.212-.148.422-.224.633-.411.283-.793.246-1.145-.107z"
        />
        <path
          fill="#8D6BC7"
          d="M232.181 157.691l-3.649-5.077c3.048.499 3.603 2.621 3.649 5.077z"
        />
        <path
          fill="#8164C9"
          d="M239.17 157.692l.983-.007c2.084 1.022 3.361 2.53 3.022 5.014l-1.003.998c-1.653-1.675-2.563-3.723-3.002-6.005z"
        />
        <path
          fill="#A77BCE"
          d="M238.162 152.732l-1.977-2.079-.988-2.919c.324-.012.648-.035.971-.068 1.262 1.005 1.909 2.333 2.065 3.92.246.271.316.531.214.781-.101.243-.196.365-.285.365z"
        />
        <path
          fill="#FCB3A3"
          d="M141.161 169.713l1.055-.964c1.75-2.104 4.119-2.792 6.725-2.94 1.241.079 2.418.464 3.613.764 3.435 2.795 6.98 4.424 11.458 2.044 1.304-.693 3.252-.891 4.231 1.108-.346 2.05-1.744 3.459-3.015 4.944-.564.654-.998 1.473-1.99 1.603-1.742.313-3.669.379-3.677 2.896-.76 1.35-1.742 2.184-3.39 1.438l-9.137-6.502c-1.628 1.969 1.767 3.971-.135 5.307-1.842 1.293-2.894-1.849-4.79-1.69-1.907-2.48-.561-5.346-.948-8.008z"
        />
        <path
          fill="#A28BE3"
          d="M180.157 187.697l2.014 4.017c-.344 2.89-.938 5.697 1.835 8.062.79.673.745 2.71.171 4.138-2.719.006-2.226 2.36-2.846 3.902-.434.19-.869.19-1.305.007-1.225-1.344-.963-3.11-1.294-4.7-.778-3.738-1.963-.457-2.978-.203-2.524-1.335-1.575-3.807-1.934-5.848-.004-1.411-.584-2.636-1.275-3.822-.388-.806-.906-1.599-.306-2.522-.687-3.779 1.299-5.501 4.714-6.122 2.688-.648 2.453 1.732 3.204 3.091z"
        />
        <path
          fill="#FCABA1"
          d="M174.208 161.714l-.194 1.893-2.66 2.156c-5.089 1.406-9.659-.182-14.113-2.438-.889-1.703.484-2.24 1.546-2.852 1.569-.902 2.813-2.034 3.272-3.855.362-.32.723-.642 1.084-.963 2.487-.343 1.522 2.524 3.132 3.261 1.158-1.828-1.709-3.593-.15-5.328l.044-2.878 1.958-5.01c-.179 5.381-.445 10.769 5.57 13.688.443.214.353 1.526.511 2.326z"
        />
        <path
          fill="#FDB0A3"
          d="M157.18 162.689c4.654 1.344 9.322 2.626 14.172 3.073-.404 1.817-1.536 3.063-3.109 3.963-1.246-.827-2.638-.562-3.75-.007-4.648 2.32-8.781 2.138-12.313-2.027-.264-1.984.968-3.468 1.71-5.121a3.033 3.033 0 011.3-.62c.778-.056 1.451.162 1.99.739z"
        />
        <path
          fill="#C67889"
          d="M163.132 175.595l2.096-.926-1.117 3.979c-.49 1.433-.352 3.025-1.106 4.395-.472 1.436-1.809 1.905-2.927 2.62l-6.777 4.133c-.93.459-1.857-.013-1.977-.738-.373-2.262-1.928-1.313-3.13-1.373l-.026-3.989c2.58-1.26 5.665-1.207 8.005-3.087l2.978-1.932c.429-2.187 2.517-2.231 3.981-3.082z"
        />
        <path
          fill="#AF9DEF"
          d="M161.169 201.679l1-2.989c-.584-2.694 1.809-4.684 1.707-7.265.124-1.195.185-2.406.844-3.471.357-.394.777-.496 1.267-.268l.281 4.902c.478.688.94 1.385 1.081 2.236.284 1.945.155 3.875-.21 5.799-1.218 1.907.431 5.217-2.946 6.076-.332-.865.344-4.06-1.79-1.184-2.384 3.214-2.391.279-3.225-.831-.636-1.861.809-2.346 1.991-3.005z"
        />
        <path
          fill="#CDB8F4"
          d="M166.168 200.68l.055-6c1.021-2.04 3.541-1.626 4.953-3.024l1.063-.93.963 1.984c.229.24.339.503.331.787-.009.295-.043.442-.099.443-.198.91-.558 1.74-1.19 2.438-1.386 1.226-1.622 2.664-1.24 4.478.396 1.881.895 3.988-1.333 5.306-3.254-.496-4.59-2.217-3.503-5.482z"
        />
        <path
          fill="#8C7CDC"
          d="M180.157 187.697c-1.257-.833-1.498-2.72-3.202-3.092.727-1.999 1.456-3.996 2.184-5.995.802.423.964.326 1.766-1.686.597 4.186.11 7.487-.748 10.773z"
        />
        <path
          fill="#B5A9D4"
          d="M165.986 187.687a38.56 38.56 0 00-.761.005c-1.697-1.528-1.149-3.683-1.565-5.572-.056-1.133.522-1.872 1.48-2.374 2.045 2.459.661 5.284.846 7.941z"
        />
        <path
          fill="#C7BCEB"
          d="M171.176 191.656c-.826 2.36-3.391 1.871-4.954 3.024l.044-2.09 4.91-.934z"
        />
        <path
          fill="#E6B5DC"
          d="M165.14 179.746l-.839 2.124c.542.961.4 1.692-.706 2.102-.801-.062-1.077-.706-1.418-1.278.234-1.545.812-2.926 1.936-4.045l1.027 1.097z"
        />
        <path
          fill="#9281EB"
          d="M158.181 253.691l-.002-5.998c3.919-.823 8.07-1.058 11.025-4.324.203-.225.282-.562.419-.846.185.423.501.837.53 1.27.111 1.665 1.06 1.26 2.024.896.583-.063 1.036-.37 1.438-.778.827-.927 1.446-2.055 2.63-2.611 1.398-.36 2.198-3.266 4.007-1.385 1.613 1.676 1.498 3.864-.07 5.775-2.032 1.937-5.578 1.874-6.583 5.322-.316 1.085-2.015.681-3.124.302-2.04-.697-5.062-.035-5.403.978-1.677 4.97-4.239 2.84-6.891 1.399z"
        />
        <path
          fill="#9685E6"
          d="M180.182 245.689v-4.888c-2.328-1.836-1.51 4.102-3.993.896-1.02-1.218-.465-2.473-.099-3.727 1.168-3.978 2.677-7.872 2.918-12.079 1.3-3.669-.447-7.96 2.306-11.327 1.521 2.152.93 5.138 2.819 7.146-.051 3.36 1.623 6.535 1.07 9.949.552 4.342-1.744 8.327-1.56 12.636.15 3.507-2.269 1.009-3.461 1.394z"
        />
        <path
          fill="#BDABF2"
          d="M161.175 223.685c-.489-2.767.948-5.29 1.013-7.986 1.604-.877.385-3.145 1.981-4.025 1.505 1.514 2.935 3.354 5.177.947 1.963-2.106 2.672-.252 3.518 1.152.314.949.299 1.906.091 2.871-1.031 2.987-1.612 6.22-4.422 8.258-2.58.392-5.734 4.19-7.358-1.217z"
        />
        <path
          fill="#C3B1F1"
          d="M172.166 213.687c-.714.114-1.613-2.174-1.834-.412-.505 4.029-3.446 1.545-4.89 1.824-1.901.368-.946-2.161-1.273-3.426l.022-4.973c2.068-1.544-.09-4.476 1.977-6.021-.005 2.746 1.535 4.253 4.014 5.007.603-.579 1.292-.619 2.036-.328.843.61 1.288 1.488 1.642 2.429.388 1.207.421 2.421.063 3.644-.34.941-.823 1.776-1.757 2.256z"
        />
        <path
          fill="#9A93E7"
          d="M161.169 201.679l-1.992 3.007c-1.943 2.076-3.931 3.997-7.04 2.028-3.143 1.371-3.048-1.482-3.953-3.03l-.919-2.048c3-3.753 7.909-3.737 13.904.043z"
        />
        <path
          fill="#BFB2FA"
          d="M148.185 203.684c1.349.969 1.77 3.149 3.954 3.029-1.036 1.477-2.601.823-3.962.987l-2.965-2.02c1.46.035 2.885.015 2.973-1.996z"
        />
        <path
          fill="#A07DCD"
          d="M243.176 162.699l-3.021-5.014.056-.008c.425-.778.88-1.499 1.955-.979l1.884 1.043c.688.567 1.442 1.051 2.101 1.659 1.134 1.321 3.393 2.129 2.116 4.567-.614.463-1.312.634-2.07.599-.731-.161-1.432-.393-2.025-.873l-.996-.994z"
        />
        <path
          fill="#BA5A7B"
          d="M252.181 153.703l2.957 3.98c-2.334 1.329-4.215 4.651-7.525 1.704-.619-1.359-.386-2.584.57-3.696 1.568-.19 3.663.681 3.998-1.988z"
        />
        <path
          fill="#A37AC3"
          d="M242.166 156.699l-1.955.979-2.049-4.945.071-1.146c2.531.765 2.36 3.609 3.933 5.112z"
        />
        <path
          fill="#BC5E6A"
          d="M248.184 155.691l-.007 3.999c-1.003.89-2.011.693-3.022.015-.885-.364-1.001-1.16-1.104-1.963 1.376-.684 2.755-1.367 4.133-2.051z"
        />
        <path
          fill="#7460B7"
          d="M114.19 206.72l-.011 1.969c.351.218.469.438.355.661-.114.223-.229.335-.346.335-2.287.397-3.22 3.495-5.96 2.986l-1.05-1.998c1.574-2.673 4.868-2.293 7.012-3.953z"
        />
        <path
          fill="#8171BD"
          d="M96.963 204.807l3.216-1.116c-.02 1.187.123 2.436-1.203 3.119l-2.013-2.003z"
        />
        <path
          fill="#9B8AE8"
          d="M160.18 237.69l-1.02-1.05c.829-4.422 4.532-6.591 7.378-9.437 4.308-2.347 6.1-6.41 7.382-10.826.518-1.271.314-3.439 2.803-2.268 1.399 3.043.893 6.184.505 9.321-1.458 3.51.246 7.472-1.55 10.935-.404.533-.903.643-1.494.329-1.157.034-2.49-.156-3.195.964-1.339 2.126-1.394 6.936-5.561 1.964-.63-.752-.726 2.506-1.956 3.509-2.071-.172-.709-3.775-3.292-3.441z"
        />
        <path
          fill="#A999ED"
          d="M174.185 234.695c.327-.006.655-.012.982-.02 1.441.947 1.354 2.659 2 4.004l-.979 3.018c-.843 1.44-1.201 3.245-2.985 3.98-1.085-2.215-.156-4.109.951-5.976l.031-5.006z"
        />
        <path
          fill="#9685DF"
          d="M174.155 239.702l-.951 5.976-1.025-.989c.435-1.752-1.213-4.328 1.976-4.987z"
        />
        <path
          fill="#9C85DF"
          d="M184.159 203.788c-1.375-1.822-1.193-4.251-3.432-5.997-2.184-1.703.244-4.157 1.444-6.078l.954-.003c2.101 1.278 3.191 3.785 5.65 4.629.877.549 1.096 1.366.952 2.331-2.072 1.899.278 5.419-2.565 7.04l-2.045-.883c-.884.173-1.163-.21-.958-1.039z"
        />
        <path
          fill="#967FD9"
          d="M187.161 205.709c1.324-2.155-1.464-5.501 2.034-7.026.314-.333.688-.445 1.13-.306 1.164.633 1.696 1.855 2.584 2.747.597.773 1.802 1.258 1.264 2.584-2.326 2.026.677 3.971.093 5.97-2.957-.265-5.213-1.792-7.105-3.969z"
        />
        <path
          fill="#624EB0"
          d="M184.159 203.788l.958 1.038c-2.098.947-3.523 2.299-2.933 4.864l-.813 1.982c-1.4-1.205-1.276-2.534-.32-3.932.844-1.468-1.702-5.601 3.108-3.952z"
        />
        <path
          fill="#BA5D76"
          d="M245.154 159.705l3.022-.015c2.937 1.468 4.061-3.356 6.963-2.007.631 1.2 1.542 1.994 2.965 2.046 1.741 1.428 3.765.65 5.678.714.886-.066 1.736-.296 2.583-.561 1.349-.275 2.702-1.016 4.042.017.523 1.338-.196 2.367-.842 3.417-3.152 5.639-8.379 5.968-13.935 5.46a7.453 7.453 0 01-1.405-.368c-1.473-.695-2.96-1.37-4.492-1.948-1.042-.618-2.033-1.271-1.703-2.74.189-2.162-2.437-2.305-2.876-4.015z"
        />
        <path
          fill="#282E8F"
          d="M253.226 144.854c-1.688-1.507-3.734-2.725-4.205-5.213.12-.176.24-.352.353-.531 2.139-1.567-.114-3.469.385-5.165.226-.417.544-.73.971-.937 5.021-.853 6.473 3.935 9.61 6.063 1.596 1.818 2.524 4.159 4.465 5.707 1.537 1.101 3.559.491 5.135 1.458.394.35.558.781.499 1.305-.28.455-.666.774-1.16.969-2.865.739-5.761-.112-8.633.189-3.355.42-5.066-2.332-7.42-3.845z"
        />
        <path
          fill="#97306B"
          d="M264.181 161.703c-2.21-.088-4.693.661-6.076-1.975 5.836-.989-.063-3.646.887-5.662 2.043-.548 4.462-.513 6.499-2.071 1.142-.874 2.502-.034 2.688 1.695-1.4 2.638-1.919 5.714-3.998 8.013z"
        />
        <path
          fill="#2D2B81"
          d="M260.084 147.73l10.118-.062c5.712-2.563 9.961-1.877 11.976 1.933-4.606.686-9.371-.988-13.894.929-2.337-.301-4.676-.599-7.015-.897-.792-.388-1.574-.781-1.185-1.903z"
        />
        <path
          fill="#942F70"
          d="M260.084 147.73l1.184 1.902c-4.511 3.574-6.27 2.954-7.171-2.473-.132-.796-.574-1.541-.872-2.308 2.733-.103 4.132 2.972 6.859 2.879z"
        />
        <path
          fill="#97306B"
          d="M270.095 159.635c-1.197.728-2.461 1.223-3.897 1.117-1.338-2.471 1.271-3.395 1.984-5.062 1.719.146 2.59-1.396 3.941-1.979l-.009 2.889c-.581.849-.839 1.881-1.518 2.674-.167.122-.334.241-.501.361z"
        />
        <path
          fill="#8F346D"
          d="M268.181 155.691c.664 2.206-1.977 3.116-1.984 5.061-.449.79-1.197.947-2.016.951.227-3.223 1.142-6.102 3.998-8.013l.002 2.001z"
        />
        <path
          fill="#94396C"
          d="M249.021 139.641c-3.702-.236-4.896-2.567-4.913-5.881l.083-.077c3.482.513 4.651 3.008 5.183 6.049l-.353-.091z"
        />
        <path
          fill="#FBF0F9"
          d="M156.295 98.717c.323.013.775-.11.951.057 4.347 4.145 8.641 2.923 12.932-.078 1.94.527 2.776 1.798 2.553 3.784-2.088 2.464-2.977 5.054-.813 7.959.076.471.068.94-.01 1.41a2.815 2.815 0 01-.72 1.186c-1.085.624-2.392.729-3.235-.024-3.345-2.992-6.167-1.539-8.976.785a3.125 3.125 0 01-1.393.281c-2.042-.722-3.28-1.983-2.907-4.327.73-1.339 1.591-2.502 3.373-2.405-.746-1.256-1.907-2.243-2.722-3.501-1.456-2.045-.409-3.617.967-5.127z"
        />
        <path
          fill="#ED63C3"
          d="M156.295 98.717c-.382 1.64-1.618 3.284.023 4.914-3.878 3.255-3.878 3.255-6.074-1.899l-.006-5.013c1.776 1.405 2.815 5.041 6.057 1.998z"
        />
        <path
          fill="#F562C4"
          d="M172.178 97.695c1.998-1.411 3.997-1.429 5.998-.007.832 1.213.45 2.534.345 3.832-1.979 1.723-3.375-.4-5.041-.759-1.134-.723-2.458-1.371-1.302-3.066z"
        />
        <path
          fill="#E566C5"
          d="M172.178 97.695c.034 1.302.706 1.965 2.004 2.001 1.034 1.464 1.34 3.022-.307 4.115-.859.57-1.846.122-1.759-1.255.324-1.773-1.478-2.48-1.938-3.86.431-.804 1.174-.986 2-1.001z"
        />
        <path
          fill="#FB52C7"
          d="M178.181 101.689l-.005-4.001c.025-.788.167-1.522.913-1.977l.178 7.942c.505.735.443 1.47-.006 2.203-.565.099-1.04-.063-1.429-.485-.794-1.314-.631-2.537.349-3.682z"
        />
        <path
          fill="#A190EF"
          d="M158.176 229.69c-2.115 3.724-6.671 4.165-9.51 7.074-.973-1.277-.256-2.741-.485-4.073-.024-4.146 4.154-4.702 6.359-6.703 1.314-1.193 4.33.454 3.636 3.702z"
        />
        <path
          fill="#B6A4F3"
          d="M167.108 227.635l-7.948 9.005c-2.923-.673-.124-2.759-.974-3.943 2.201-2.604 1.005-6.335 2.989-9.012 1.735 4.394 4.81-.549 6.954.997.704 1.346-.03 2.193-1.021 2.953z"
        />
        <path
          fill="#C1A8ED"
          d="M220.238 173.689c.775.44.918 1.195.988 1.986 2.085 1.354 3.211 3.298 3.544 5.733-2.534 2.738 1.612.97 1.441 2.119.197.459.189.907-.046 1.352-4.051 3.461-8.818 2.189-13.291 1.687-4.974-.56-9.978-1.151-14.806 0-4.525 1.079-8.607-.464-12.882-.878-1.814-4.137-2.21-8.502-2.088-12.95 2.574-1.476 5.859-.716 8.331-2.799.8-.674 2.346-.223 2.627 1.337.429 2.379-.729 5.459 2.905 6.371.481-3.013 4.275-2.216 5.302-4.62.798-1.869 2.519-1.161 3.918-1.337 2.654-.438 5.543 1.003 8.002-1.001 3.648-2.288 3.926 2.225 6.055 3zM198.182 165.693c1.152.199 2.685-.583 3.367.753.53 1.039-.69 1.044-1.367 1.246-1.298-.035-1.967-.699-2-1.999z"
        />
        <path
          fill="#BBA8F1"
          d="M181.051 207.741l.319 3.932-.057 2.892c-.371 4.043.424 8.196-1.14 12.127-.869 1.356-2.465 2.637-3.631 1.891-1.676-1.071-.967-3.188-.376-4.909l-.05-9.995c-1.102-1.057-1.193-2.451-1.297-3.841.319-2.178-1.838-4.737.98-6.535 3.983.948 1.872 4.589 2.997 6.805.488-.814.51-1.899 1.426-2.467.278.019.554.053.829.1z"
        />
        <path
          fill="#A392D9"
          d="M124.168 238.693c-2.716-1.583-1.921-5.669-4.989-7.002l-.003-1.999c1.855-2.297 2.745.996 4.491.591.562-1.002.112-2.737 1.52-3.599 2.301 2.55 1.011 6.295 2.982 8.955-.628 1.942-2.737 1.944-4.001 3.054z"
        />
        <path
          fill="#9C8BD8"
          d="M125.187 226.684c-.771 6.103-1.15 6.293-6.011 3.008-.995-.95-.774-1.758.513-1.89 2.139-.22 3.145-1.878 4.5-3.118.793.438.97 1.182.998 2z"
        />
        <path
          fill="#B7A0E4"
          d="M138.181 244.699c1.006 3.308-1.942 5.722-1.99 8.789l-1.832.421c-1.636-1.271-1.394-3.004-1.178-4.734.535-1.567.607-3.356 2.076-4.495.977-.306 1.959-1.571 2.924.019z"
        />
        <path
          fill="#E0DAF6"
          d="M135.257 244.679c-.328 1.327.462 2.944-1.028 3.972-.693-.021-1.26-.334-1.782-.758-1.043-.852-1.785-1.91-2.165-3.212-.643-.369-1.285-.737-1.926-1.107 2.855-3.084 4.939-1.369 6.901 1.105z"
        />
        <path
          fill="#CAC0F7"
          d="M124.168 238.693c.668-1.89 2.669-2.032 4-3.054 1.18.678.115 1.368.011 2.054-1.263.625-2.547 1.176-4.011 1z"
        />
        <path
          fill="#B7A0EE"
          d="M209.373 217.547l-5.393-5.785c.895-2.055 2.099-3.632 4.284-1.49 1.217 1.194 2.846.521 4.038 1.393.796 1.424 1.44 3.142 3.533 2.825 2.526-.382.687-2.428 1.211-3.615.393-.89.385-1.953 1.309-2.579.734-.249 1.417-.172 2.034.314.392 1.067.327 2.159.165 3.255.013.666 1.009-.503.459-.126-.353-2-.745-3.991-1.146-5.989a19.418 19.418 0 01-.058-2.388c.128-1.961-.158-3.995 1.036-5.762a4.002 4.002 0 011.472-.9c3.715-.683 7.465-.283 11.204-.342.884.023 1.755.115 2.592.427.563.232 1.002.61 1.322 1.125.045.642-.214 1.121-.774 1.438-3.31 1.396-6.801.427-10.188.781-5.562 1.591-2.288 6.037-2.727 9.131-.446 3.145 2.576 2.888 4.598 2.988 4.123.205 8.259.044 12.397.033 6.688.162 13.377-.303 20.052.275 4.919 1.411 9.957.475 14.93.734 3.286.009 6.574.024 9.828.664 4.035.792 7.795.664 10.158-3.472.758.194.932.772.941 1.679.146-1.664-1.008-3.627.824-4.396 1.883-.791 3.379.461 4.418 2.111.936 2.476.732 4.993.318 7.521-1.5 3.257.521 7.351-2.406 10.275-1.828 1.049-3.635.247-5.449-.055-1.895-.725-3.959-.562-5.893-1.092-.932-.272-1.828-.646-2.74-.97-2.389-.896-4.892-.414-7.338-.61-1.924-.153-4.066.087-4.827-2.667-.784 2.158 2.657 2.646 1.351 4.404-1.168 1.572-3.024.806-4.596.408-2.457-.622-4.941.131-7.375-.213-1.524-.215-3.856.414-3.658-2.478 1.245-.341 2.507-.15 3.668-.176-1.896-.271-3.818.012-5.707.725-9.363.306-18.715.074-28.062.141-1.681-.014-3.366-.045-5.045-.06a9.058 9.058 0 01-1.561-.082c-4.488-1.369-8.75-3.22-12.506-6.11a3.626 3.626 0 01-.693-1.29z"
        />
        <path
          fill="#BCA4ED"
          d="M222.185 197.687l-1.003.005c-.822 1.993-.805 3.988-.013 5.984l.002 2.025c-.964.787-.046 2.198-.993 2.99h-1.996c-.902 1.686-2.564-3.546-3.221.369-.433 1.072-1.254 1.776-2.164 2.402-.203.079-.409.153-.615.228-1.753.593-3.344 2.632-4.832-.932-1.098-2.63-1.783 1.979-3.369 1.002-2.57-2.355-5.743-4.014-7.898-6.847-.627-1.878-2.161-2.667-3.882-3.23l-2.076-2.956c1.512-5.011 6.23-5.198 10.024-5.971 4.987-1.017 10.204-1.172 15.19.729 3.034 1.156 6.226.636 9.354.777 2.052.094 4.182-.014 5.876 1.977-2.847 1.945-5.896.009-8.384 1.448z"
        />
        <path
          fill="#4B38A4"
          d="M209.373 217.547c.268.047.504.159.71.336.015 2.766-1.975 2.74-3.901 2.803l-2.015.01c.445-3.183 3.851-1.47 5.206-3.149z"
        />
        <path
          fill="#B79DF5"
          d="M192.201 201.684c2.271-.1 4.423-.054 3.882 3.229l-1.909-1.205a1883.25 1883.25 0 01-1.973-2.024z"
        />
        <path
          fill="#AA6673"
          d="M163.278 132.875c.21-2.369 3.061-1.533 3.864-3.183v7.313c-2.754-.463-1.382-3.976-3.864-4.13z"
        />
        <path
          fill="#F07CBB"
          d="M168.152 118.697c-.066.35-.132.699-.2 1.049l-.396-.017-.395.026-5.756-.028-.334-.947.335-.207c2.28-1.589 4.53-1.633 6.746.124z"
        />
        <path
          fill="#725CA9"
          d="M114.188 209.685a41.34 41.34 0 01-.009-.996c1.242.09 2.464-1.061 3.717-.056.119.295.195.603.226.919-1.311.043-2.622.088-3.934.133z"
        />
        <path
          fill="#AD98EF"
          d="M216.13 269.709c-4.228-3.847-3.541-9.091-3.984-14.014l.037-8.993c.305.016.61.026.915.034.667.599 1.424 1.092 2.031 1.762 3.448 3.892 5.732 8.819 10.397 11.622 2.905 2.924 6.506 5.126 8.925 8.559-1.453 2.765-3.861 2.499-6.195 1.705-1.653-.563-2.791-1.329-3.582 1.176-.735 2.329-3.434 1.814-5.248 2.598a1.773 1.773 0 01-1.206-.484c-.02-.323-.035-.646-.048-.971.647-1.831.608-1.845-1.027-2.023-.412-.046-.703-.61-1.015-.971z"
        />
        <path
          fill="#7562CB"
          d="M206.18 231.692c2.692-.332 1.802-2.452 2.008-4.025l1.992 1.025c2.679.703 5.018 2.048 7.156 3.782.515 1.161.165 2.306-.062 3.455-.184.7-.487 1.328-1.095 1.766-1.521.002-2.529-3.645-4.475-.631-2.019-1.607-4.422-2.821-5.524-5.372z"
        />
        <path
          fill="#8070D7"
          d="M214.199 248.681c-.366-.648-.732-1.297-1.1-1.945 2.244.171 2.737-2.008 4.082-3.045.17.129.341.258.515.383 1.144 1.703 1.811 3.876 4.253 4.31 2.085 1.649 3.687 3.577 3.722 6.414-1.76 2.35-3.204.313-4.547-.478-2.577-1.516-4.32-4.115-6.925-5.639z"
        />
        <path
          fill="#7D6BCA"
          d="M216.18 237.695l.05-2.089c3.44 1.98 3.508 5.406 3.761 8.757-1.778 3.311-2.014.148-2.81-.673v.001c-1.192-1.856-1.02-3.939-1.001-5.996z"
        />
        <path
          fill="#D76EE4"
          d="M133.156 247.464l1.073 1.187.129 5.257-.024 16.793-.123 12.976-.69.172c-1.913-1.654.048-4.134-1.261-5.917l-.123-2.291c-2.159-4.159-1.408-8.565-1.115-12.931.71-2.557.938-5.152.533-7.793-.04-1.559.279-3.089.376-4.641.128-1.06.346-2.081 1.225-2.812z"
        />
        <path
          fill="#16398D"
          d="M250.194 75.685c1.448-.653 2.453-2.365 4.395-1.839.108.404.102.807-.01 1.209-.258.775-.592 1.523-.835 2.306-.584 1.9-.431 3.717.595 5.447.763 2.233 1.423 4.431-1.961 5.041l-.28-.243c-.272-1.282 1.279-3.305-2.241-2.891-3.297.388-1.702-3.05-1.161-4.107.829-1.623 1.675-3.059 1.498-4.923z"
        />
        <path
          fill="#8975DE"
          d="M218.22 273.673c.312.015.625.026.937.036.828.386 1.483.913 1.58 1.904-1.27 2.561 1.728 1.331 2.145 2.397.335.289.552.651.683 1.067.277 1.436 1.761 1.871 2.451 2.943 1.202 1.865.57 3.047-1.507 3.589-2.315-.024-4.572-.233-6.347-1.979-2.504-2.136-5.218-4.061-6.985-6.938 2.252-1.228 3.661-4.424 7.043-3.019z"
        />
        <path
          fill="#A995EF"
          d="M216.13 269.709c.303.106.626.173.904.325 2.022 1.104 2.45-3.743 4.004-1.462 1.05 1.541-2.54 2.216-2.866 4.13-1.292-.579-1.976-1.575-2.042-2.993z"
        />
        <path
          fill="#7B66CA"
          d="M222.167 223.714c.339-.01.677-.019 1.016-.027 2.501 1.063 5.151.944 7.787 1.034 1.58.054 3.422-.498 4.42 1.43-.48 1.959-2.182 2.349-3.742 2.613-4.05.688-7.823 2.22-11.665 3.554a2.974 2.974 0 01-1.514-.247c-1.187-1.214-.045-1.739.706-2.382.588-1.373 2.122-2.255 2.058-3.967-.066-.845.337-1.472.934-2.008z"
        />
        <path
          fill="#5747B2"
          d="M222.167 223.714c.008.818-.148 1.56-.936 2.008-3.78-1.264-6.873-5.45-11.723-2.515-.596.36-3.046-.532-3.327-2.521.943-1.432 3.34-.841 3.902-2.803 3.886 2.238 7.28 5.495 12.084 5.831z"
        />
        <path
          fill="#6150BD"
          d="M219.173 229.689l-.943 2.079c.097.825-.192 1.204-1.059.918-2.87-.388-4.933-2.187-6.992-3.994 3.252-1.954 5.911 1.435 8.994.997z"
        />
        <path
          fill="#7C81CB"
          d="M203.181 282.637l.01 1.075c.073.675-.171 1.203-.731 1.591a5.322 5.322 0 01-1.771.629c-20.707.354-41.416.101-62.124.133-1.162.002-2.321-.068-3.415-.539-.629-.297-.984-.791-1.068-1.48l.129-.369c21.081.006 42.161.011 63.241.018 1.975-.001 3.993.239 5.729-1.058z"
        />
        <path
          fill="#EB8387"
          d="M249.344 96.701c-.072-1.092-.575-2.271.625-3.107 1.73-1.801 3.972-2.992 5.703-4.797 1.505-1.244 3.187-.533 4.816-.453 1.208.1 2.422.082 3.63.207 1.262.147 2.438.529 3.484 1.269.825.654 1.282 1.475 1.128 2.56-1.261 2.725-3.868 4.603-4.768 7.563-.394.615-.914 1.044-1.667 1.12-.922-.085-1.697-.489-2.35-1.104-.675-1.34-1.214-.48-1.776.152-.578.357-1.204.521-1.87.577a4.511 4.511 0 01-2.023-.391c-1.553-1.948-1.553-1.948-3.883-1.211-1.047-.489-.734-1.575-1.049-2.385z"
        />
        <path
          fill="#21388D"
          d="M241.21 123.812c-.473-2.123.087-4.081.955-5.988 1.3-.624 1.864-1.731 2.028-3.101.981-1.189.229-2.649.613-3.932.557-2.002.533-4.009.056-6.021-.177-.678-.21-1.345.136-1.986l-.67-2.14c1.229-1.154 1.776-3.293 4.112-2.85.255 4.264.77 8.481 2.204 12.538.032.479-.031.949-.171 1.407-1.344 4.855-6.125 7.419-7.974 11.945-.404.301-.833.354-1.289.128z"
        />
        <path
          fill="#DB7B8B"
          d="M256.171 89.691c-1.172 2.724-3.899 2.977-6.203 3.902l2.408-5.745c2.75-1.388 1.417-3.409.825-5.315-.807-1.926-.765-3.854-.03-5.788-.014-.838-.006-1.663 1.045-1.923.818.672 1.007 1.613 1.125 2.587.106.969-.205 2.138.325 2.883 2.19 3.075 1.673 6.198.505 9.399z"
        />
        <path
          fill="#D28C9A"
          d="M250.14 110.759c-2.318-4.092-3.81-8.292-1.7-12.965l.904-1.094.865 1.98c2.018 2.49 1.156 5.433 1.303 8.218-.018.854-.094 1.7-.369 2.517a2.944 2.944 0 01-1.003 1.344z"
        />
        <path
          fill="#FDA79B"
          d="M166.125 153.587c.01 1.302 1.277 1.919 1.654 2.945.553 1.508 1.188 3.765-.467 4.386-1.093.41-3.513-.593-3.165-3.134.118-.863-.254-1.614-1.004-2.129.613-1.239 1.637-1.885 2.982-2.068zM157.18 162.689l-2.051-.024c-.943-1.214-.362-2.182.499-3.106.711-.696 1.795-.299 2.552-.869 1.362-.561 2.233-2.044 3.88-2.07.565 3.201.565 3.201-4.88 6.069z"
        />
        <path
          fill="#F27E86"
          d="M155.186 153.708c2.163.53 4.222-2.103 6.778-.078l-4.774 4.068c-2.601-.36-3-1.824-2.004-3.99z"
        />
        <path
          fill="#EC817E"
          d="M155.186 153.708c.16 1.585.703 2.979 2.004 3.99l.99.991c-.395.781-1.096 1.002-1.898 1.036-.738.518-1.503.603-2.305.145-1.25-1.924-2.06-3.912-.879-6.183l.154.008c.309-.477.618-.5.928 0l1.006.013z"
        />
        <path
          fill="#DF7276"
          d="M154.18 153.695h-.929c-.066-2.051-.043-4.115-.901-6.048 3.072.817 3.148 1.068 1.83 6.048z"
        />
        <path
          fill="#115BA5"
          d="M272.135 69.642c1.62-1.024 3.534-1.751 4.001-3.946-.498-.52-.73-1.132-.655-1.854.136-.44.369-.822.698-1.146l.054-.092c4.675 1.699 6.666 4.969 5.695 9.352-3.512.278-6.725-.711-9.793-2.314z"
        />
        <path
          fill="#0A82C9"
          d="M276.189 63.707l-.053 1.989c-4.314 1.326-8.348.956-11.952-1.986.323-.031.647-.043.972-.034 3.679-.646 7.357-.97 11.033.031z"
        />
        <path
          fill="#084593"
          d="M272.135 69.642c3.606-.575 6.77 1.016 10.046 2.05l.396.553c.188 1.088-.314 1.722-1.326 2.021a3.74 3.74 0 01-1.337-.094c-1.633-.67-3.263-1.353-4.981-1.797-1.292-.469-2.729-.544-3.865-1.433-.271-.442-.246-.857.122-1.236.315-.025.63-.045.945-.064z"
        />
        <path
          fill="#0256A6"
          d="M271.19 69.707c.004.308.012.615.024.922-.319.343-.668.394-1.05.105-1.337-.229-2.907.433-3.924-1.022 1.651-.003 3.3-.004 4.95-.005z"
        />
        <path
          fill="#F9A3AA"
          d="M235.22 109.684l-.086-2.068c-.563-1.825-.905-3.684-.835-5.604a2.967 2.967 0 01.668-1.484c2.662-1.01 4.119.295 5.043 2.623a5.358 5.358 0 01-.026 1.594c-.608 1.665-.274 3.706-1.932 4.967-.937-.704-1.882-.618-2.832-.028z"
        />
        <path
          fill="#D07083"
          d="M238.052 109.71c.304-1.715-.504-3.642.979-5.131 1.056.206 2.129-.223 3.181.091 2.068 1.777-.894 1.962-.969 3.062-.354 1.456.559 3.557-1.328 4.199-1.31.447-1.548-1.186-1.863-2.221z"
        />
        <path
          fill="#EEB6BF"
          d="M245.189 110.707c-.172 1.378.191 2.89-.996 4.017l-.019-6.04c.333-1.959-.764-4.116.823-5.899l.227 1.952c.678 1.993.728 3.983-.035 5.97z"
        />
        <path
          fill="#4D42A9"
          d="M218.162 283.631l6.916 1.143c1.432.492 2.589 1.224 2.574 2.969-.931 2.856-3.534-1.085-4.632 1.138-2.771-1.719-5.822-1.961-8.98-1.874-1.94.053-3.952.22-5.714-.957-.403-.438-.494-.932-.277-1.485 1.062-.457 2.108-.583 3.119.129 2.374-.076 4.864.621 6.994-1.063z"
        />
        <path
          fill="#504BB1"
          d="M211.168 284.693l-2.988.045c-1.392 1.136-2.893 1.299-4.502.505-.19-.188-.379-.38-.568-.571.052-.317.079-.638.081-.959 2.643.455 5.493-.767 7.977.98z"
        />
        <path
          fill="#D2778D"
          d="M239.251 103.756c-.316-2.359-2.091-2.771-4.003-3.001-.749-1.948 1.402-1.201 1.874-2.016 1.999 1.094 3.791 2.361 4.112 4.871-.616.666-1.281.655-1.983.146zM235.087 101.611l.047 6.006-1.805-2.958-.077-4.008c1.038-.493 1.354.391 1.835.96z"
        />
        <path
          fill="#BE5D75"
          d="M235.087 101.611l-1.835-.959c-.411-4.083 2.471-1.498 3.871-1.912l-1.875 2.016c-.058.284-.112.569-.161.855z"
        />
        <path
          fill="#A7466A"
          d="M239.251 103.756l1.982-.145.979 1.059c-1.04-.744-2.213 3.266-3.18-.09.067-.276.14-.551.219-.824z"
        />
        <path
          fill="#9588DC"
          d="M165.096 191.633c-.247 2.655-1.369 4.946-2.927 7.057-3.717-2.107-7.628-3.493-11.986-3.243-.049.003-.17-.264-.156-.395.016-.148.145-.285.226-.427 2.559.359 4.417-1.659 6.771-1.992 2.078-1.496 4.327-2.275 6.913-1.654.435.133.82.353 1.159.654z"
        />
        <path
          fill="#9284D5"
          d="M164.197 191.68l-7.17.953 5.019-6.965c.031-1.107.562-1.401 1.549-.95 1.759 2.186 1.226 4.571.602 6.962z"
        />
        <path
          fill="#CE8397"
          d="M148.193 187.684c1.207-.448 1.076-2.689 2.692-2.328 1.908.427.433 2.229.982 3.233.279.51.942.81 1.432 1.205-2.814 1.99-5.477 3.609-5.106-2.11z"
        />
        <path
          fill="#E3BBED"
          d="M163.152 184.651l-1.105 1.018-1.968-.005 2.098-2.971 1.031 1.025c.209.221.271.432.185.635-.085.199-.165.298-.241.298z"
        />
        <path
          fill="#BFA5EE"
          d="M222.185 197.687c1.951-2.075 4.804-.209 7.404-1.613-9.002.551-17.155-2.584-25.648-2.415-5.238.104-9.699 2.048-13.815 5.068a35.737 35.737 0 01-.93-.044l-.896-2.055c-2.472-2.089-3.322-4.81-3.097-7.948l-.016-2.992c1.723-.951 3.634-5.68 5.05.256.056.235.93.526 1.289.402 9.88-3.403 19.889-.555 29.833-.653 1.901-.019 3.579-.507 4.843-2.021 1.877-.691 3.15.533 4.535 1.416 3.833 3.558 9.007 4.988 13.067 8.201.55.588.947 1.256 1.132 2.048.135 1.186-.037 2.252-1.124 2.976-2.32.957-4.559 1.039-6.632-.621l-.998-.004c-.255-.448-.093-1.168-1-1.168-.907.001-.746.72-1.001 1.169l-11.996-.002z"
        />
        <path
          fill="#7E65C6"
          d="M185.202 188.68c1.032 2.649 2.063 5.299 3.096 7.948-3.218-.068-4.243-2.443-5.172-4.919l2.076-3.029z"
        />
        <path
          fill="#E98582"
          d="M149.184 166.694c-2.323.685-4.646 1.369-6.968 2.055l-.109-2.171 2.025-2.851c-.237-.253-.328-.516-.273-.789.055-.277.119-.416.19-.418 2.071.655 3.762-.1 5.296-1.438.935-.313 1.862-.307 2.782.068.66.356 1.123.878 1.345 1.602-.121 2.736-2.14 3.41-4.288 3.942z"
        />
        <path
          fill="#E9938C"
          d="M140.283 153.797c1.346 1.731 1.82 3.748 1.924 5.885-.326.428-.649.404-.969-.006-.4-1.946-1.504-3.778-.955-5.879z"
        />
        <path
          fill="#E8A091"
          d="M141.238 159.676c.323.005.646.008.969.006.33-.011.659-.013.989-.006 1.338.671 2.017 1.562 1.003 3.015l-.066 1.036-2.895-4.051z"
        />
        <path
          fill="#D56E7F"
          d="M254.207 77.691l.01-2.869.371-.976 1.574-.263c3.868-1.783 7.956-.512 11.924-.861.56.012 1.117.077 1.665.185a5.678 5.678 0 011.465.706c4.338 1.313 8.814.763 13.235.948 1.553.279 2.803 1.117 3.945 2.148.896 1.426 2.627 1.87 3.686 3.108h-.02l.229 2.731c-1.824 1.159-3.01-.725-4.549-.942-.889-.368-1.758-.78-2.633-1.179-3.402-.869-6.9-.055-10.317-.577-1.428-.157-2.824-.768-4.292.045-1.36.754-3.239.916-4.266.187-3.729-2.645-8.248-.563-12.027-2.391z"
        />
        <path
          fill="#304D8D"
          d="M269.223 73.611l-13.062-.027c.013-.626.025-1.252.039-1.877l1.05.062c2.31.668 4.616.769 6.914-.055l3.973-.004c.421.363.988.516 1.367.942.122.383.04.706-.281.959z"
        />
        <path
          fill="#084593"
          d="M282.182 71.692c-.9-3.737-3.011-6.684-5.95-9.087l1.131-1.01 2.006-.854c7.688-.085 7.688-.085 8.823 6.947-2.166 1.085-3.346 3.646-5.992 4.014l-.018-.01z"
        />
        <path
          fill="#217DC7"
          d="M276.189 63.707c-3.678-.01-7.355-.021-11.033-.03.028-.309.064-.614.109-.92 3.64.288 7.272-.856 10.915-.061l.009 1.011z"
        />
        <path
          fill="#2673C1"
          d="M269.241 72.687l-1.104-.978c.81-.047 1.576-.184 2.027-.976l1.05-.104c1.387.204 2.944-.282 4.064 1.005-.777 1.125-1.992 1.447-3.213 1.768-1.027.111-1.995-.033-2.824-.715z"
        />
        <path
          fill="#353E75"
          d="M264.164 71.713c-2.293 1.546-4.599 1.469-6.915.055l6.915-.055z"
        />
        <path
          fill="#FCB5A6"
          d="M144.199 162.691l-1.004-3.015 2.984-2.984c1.475.261 2.191 1.369 2.859 2.539.335.81.778 1.616.162 2.487-1.202 2.712-2.896 2.901-5.001.973z"
        />
        <path
          fill="#E9928C"
          d="M145.275 147.793c1.541.857.284 3.07 1.887 3.897.664.853.958 1.799.741 2.878-.31.756-.721 1.354-1.69 1.082-.061-2.649-1.632-5.117-.938-7.857z"
        />
        <path
          fill="#F2A495"
          d="M146.213 155.651l.977-.961c3.053 1.797 3.283 2.938 1 4.98l-2.011-2.979.034-1.04z"
        />
        <path
          fill="#FBADA1"
          d="M148.19 159.67c1.584-2.045-.154-3.423-1-4.98l-.028-2.999c1.773 1.278 3.586 2.439 5.937 1.996l1.133 6.017c.283 1.636-.409 2.295-2.028 2.025l-3.004-.011-1.01-2.048z"
        />
        <path
          fill="#E456CD"
          d="M150.245 101.732c1.592 2.013 3.184 4.029 6.074 1.899 4.293 2.684 1.661 4.403-.854 6.139-1.753 1.151-3.495 1.401-5.214-.067l-.006-7.971z"
        />
        <path
          fill="#DC48D8"
          d="M150.25 109.703l5.213.067c-.177 1.91 1.186 2.784 2.489 3.698 1.684 2.34-.253 2.852-1.796 3.561-2.846.448-5.565.667-5.938-3.316l.032-4.01z"
        />
        <path
          fill="#DB42DF"
          d="M156.182 116.679c.628-1.049 2.329-1.506 1.771-3.21l.085.054c1.385-.937 2.892.293 4.361-.317 4.913-2.041 4.936-1.993 4.634 3.604a2.543 2.543 0 01-.998 1.211c-1.629.141-3.264.456-4.848-.238l-4.993-.182c-.36-.2-.481-.402-.366-.609.117-.208.235-.313.354-.313z"
        />
        <path
          fill="#D03ED5"
          d="M156.182 116.679l.013.923c-2.742-.145-6.676 1.542-5.978-3.89 1.034 2.908 3.299 3.343 5.965 2.967z"
        />
        <path
          fill="#D35F9D"
          d="M161.188 117.783l4.983-.158c.591-.52 1.238-.555 1.928-.222.249.253.345.518.287.792-.059.28-.126.421-.202.421l-.031.081-6.748-.123a1.89 1.89 0 01-.217-.791z"
        />
        <path
          fill="#462D62"
          d="M241.21 123.812c.309-.066.621-.093.936-.077 1.458 1.661 1.462 3.319-.01 4.976l-1.146-1.186.22-3.713z"
        />
        <path
          fill="#BF29B6"
          d="M179.111 105.707l.154-2.053c.292.02.583.023.875.013-.036 2.655-.071 5.313-.108 7.969-.265.041-.53.064-.797.068-.197-.192-.394-.385-.594-.575-.845-1.894-.99-3.728.47-5.422z"
        />
        <path
          fill="#B47CBE"
          d="M168.184 118.616a13.4 13.4 0 01.008-.874c1.436-1.626 3.387-1.254 5.215-1.36.77-.011 1.541.013 2.309.057a8.274 8.274 0 012.235.356c.452.213.88.472 1.286.767l-.118.3c-3.536 1.84-7.298.394-10.935.754z"
        />
        <path
          fill="#1E3292"
          d="M242.136 128.71l.01-4.976c.138-1.287-.34-2.828.825-3.752 2.927-2.319 4.567-5.714 7.167-8.291l.483.469c.29.614.532 1.38.179 1.896-2.113 3.089 1.596.171 1.325 1.304.355.277.638.616.844 1.016.987 2.405 1.824 5.005 5.36 4.019 2.042-.134 4-2.026 6.123-.29.266.86.116 1.767-.622 2.165-3.29 1.773-3.611 4.689-3.249 7.925-.212 3.166 2.283 6.445-.403 9.498-2.33-.402-3.351-2.473-4.817-3.917-1.495-1.473-3.041-2.412-5.182-2.084-1.201-.963-.735-2.358-1-4.385-.667 2.269.041 3.358 1 4.383-.327 2.007 5.622 4.852-.808 6.042l-5.182-6.049c.033-1.954-1.45-3.281-2.053-4.973z"
        />
        <path
          fill="#C14CDA"
          d="M179.237 117.561l-1.095.056c-.938-1.024-1.186-2.258-1.097-3.597.061-.788.279-1.525.735-2.181.41-.43.864-.479 1.36-.151l.095.016.002 5.857z"
        />
        <path
          fill="#BEA5EE"
          d="M238.173 186.72c2.126-1.861 5.59-.358 7.48-3.1.675-.979 2.302-.228 2.426.642.682 4.805 4.054 1.562 6.217 1.977l-3.344-1.759c1.252-1.82 3.154 1.242 4.224-.736 2.017-1.543 3.486.61 5.255.766.692.229 1.265.635 1.748 1.173 3.242 2.673 6.662 1.981 10.271.792 3.271-1.078 6.552-1.289 8.898 2.757.953-3.496 1.477-7.162 5.85-7.54.555.571.668 1.263.561 2.018-1.582 3.74-3.115 7.513-5.936 10.563-2.278 2.186-4.477 4.463-7.159 6.19-1.252.501-2.568.548-3.889.581-2.72.012-5.438.015-8.155.01-1.293.018-2.568-.099-3.764-.627-1.465-.798-.644-1.796-.257-2.749-2.864-1.693-6.132-.054-9.044-1.155-1.838-.632-3.398-1.719-4.861-2.966-.506-.527-.903-1.087-.496-1.857.42-.462.984-.796 1.328-1.469-.665.531-1.007 1.219-1.559 1.723-3.506-.003-5.54-1.635-5.794-5.234z"
        />
        <path
          fill="#BDA5EE"
          d="M301.174 209.689c-6.16-3.807-3.02 2.595-4.406 4.064-1.008-.934-.396-2.154-.654-3.197-1.051-1.004-.98-2.214-.645-3.472.592-1.817 2.65-1.81 3.934-3.142-2.221.627-3.811-1.185-5.801-.94-1.457-.052-2.914-.095-4.342-.423-1.684-.576-3.428-.581-5.176-.563-1.801-.048-3.618.086-5.368-.494a3.278 3.278 0 01-1.686-1.439c.239-3.414 3.981-3.581 5.436-5.869 2.281-1.979 4.883-3.699 5.633-6.93.223-.648.537-1.229 1.143-1.6l2.676 3.667c.496-5.242 4.793-4.332 7.811-5.463.465-.174 1.176.31 1.773.489-1.842 5.909 3.063 2.291 4.68 3.313.641.813 1.582.995 2.518 1.192-.844-.389-1.889-.357-2.518-1.194 2.004-4.156 4.002-1.259 6 .005 1.113 1.078 1.359 2.484 1.504 3.934-.088 1.78-1.195 3.114-2 4.584-1.309 1.91-2.523 3.889-3.961 5.701-1.135 1.429-2.344 2.897-4.545 2.102-.357-.664-.914-1.453-.109-1.994.254-.171.172-.812.107-.478-1.023 1.462-.037 2.607-.061 3.754-.01.472-.086.931-.201 1.387-.385 1.116-.701 2.273-1.742 3.006z"
        />
        <path
          fill="#6E4EB9"
          d="M267.001 171.635c1.264-.016 2.815.265 3.062-1.498.464-3.318 2.272-2.325 4.118-1.444l-3 7.996-1.84 1.221c-2.304 1.43-4.737 1.379-7.228.633-2.79-2.322.544-3.465.993-5.171 1.011-1.217 2.129-2.209 3.895-1.737z"
        />
        <path
          fill="#957BD4"
          d="M261.215 177.667l8.125.241c-1.321 3.574-4.623 5.322-7.161 7.773h-1.992c-.554-.817-.393-1.738-.396-2.636-.081-2.256-1.499-2.975-3.49-3.101-1.58-.1-3.218.108-4.678-.758-.151-.172-.3-.348-.45-.522 1.083-1.434 2.691-.816 4.082-1.048 1.352-1.294 2.952-1.23 4.613-.853.518.197.967.5 1.347.904z"
        />
        <path
          fill="#9881D4"
          d="M289.242 185.685l-.084 1.98c-2.664-.336-2.676-1.997-2-4.001l.039-1.974c-.07-1.965.502-3.685 1.941-5.071 1.201.87 1.012 2.332 1.492 3.509-.139 1.521.502 3.127-.488 4.558l-.9.999z"
        />
        <path
          fill="#BAA2F9"
          d="M312.885 191.678c-1.059-1.183-.596-2.634-.703-3.983 1.422-.037 1.988-.89 2.092-2.188.77.149 1.541.295 1.889 1.142-.613.727-.119 1.698-.541 2.47-.623 1.16-1.11 2.471-2.737 2.559z"
        />
        <path
          fill="#BDA5EE"
          d="M290.143 184.686l.037-4.996c-.75-2.003-.783-4.003.023-6 1.549 3.674 1.66 7.34-.06 10.996z"
        />
        <path
          fill="#9178C9"
          d="M290.203 173.69l-.023 6c-1.195-.735-.938-1.963-1.039-3.069.507-.921-1.075-2.602 1.062-2.931z"
        />
        <path
          fill="#6E58BF"
          d="M303.32 203.478c4.625-.68 4.629-5.827 7.723-7.986.961-.19 2.445-.847 2.787.009.949 2.376 3.047 1.77 4.703 2.325 1.268 2.506-.359 5.921 2.492 7.927-.705 2.156.941 3.757 1.336 5.653.197.326.279.801.047.886-2.475.905-4.184-.479-6.32-1.499-1.4-.667-4.094 2.438-5.975-.596-.174-.281-.35-.624-.611-.777-.369-.218-.338.364-.482.463-2.717 1.837-2.729 1.818-3.547-1.53.172 1.926 1.088 3.965 1.049 6.178-.203 2.992.68 6.093-.938 8.934-.461.466-.988.568-1.59.312-.65-.682-.936-1.519-1.066-2.425-.354-5.97-.28-11.929.392-17.874z"
        />
        <path
          fill="#735CC5"
          d="M305.19 213.701v-7.497c1.617 1.563.299 3.817 2.203 4.703 1.734-1.031-.008-3.109 1.332-4.34 1.441 1.532 2.273 3.659 4.373 4.599 2.115-.555.117-3.279 2.193-4.035 2.039 1.832 2.771 6.129 7.07 4.276 1.285 2.093 2.57 4.188 3.857 6.281.297.402.383.846.266 1.33-3.049 4.115-3.109 4.118-5.891.244-.699 4.091-1.828 4.753-4.621 2.229-1.729-1.564-3.75 2.423-4.967-.653-5.02 1.976-4.389-2.31-5.273-4.828-.255-.729.132-1.647-.542-2.309z"
        />
        <path
          fill="#6859B8"
          d="M318.145 197.708c-2.418-.124-1.426 2.673-3.174 3.575-1.543-1.745.34-6.087-3.926-5.791.613-1.272 1.229-2.543 1.84-3.813l2.191-3.12c.939.221 1.293.945 1.523 1.774.332-.095-.51 1.647.578.369a9.33 9.33 0 01.869.008l.236 2.646c.476 1.469.728 2.929-.137 4.352z"
        />
        <path
          fill="#5F6FC2"
          d="M318.145 197.708c.047-1.449.094-2.897.139-4.349 1.541 3.99 1.912 8.241 2.742 12.393-5.408-1.087-1.776-5.415-2.881-8.044z"
        />
        <path
          fill="#87A4BA"
          d="M326.125 218.694c.031-.335.063-.671.092-1.006 2.297-5.207.209-10.681.969-15.98.619-.319 1.127-.193 1.525.376 1.738 4.605.668 9.383.873 14.086-.117 1.18-.299 2.341-1.07 3.308-1.107.698-2.131 1.125-2.389-.784z"
        />
        <path
          fill="#8DBBDB"
          d="M327.112 200.814c-1.619-3.656-.648-7.487-.762-11.246.939-1.233-.5-3.175 1.244-4.172.584.048 1.006.331 1.275.851.99 2.444.693 4.935.297 7.432-1.056 2.269.077 5.176-2.054 7.135z"
        />
        <path
          fill="#7AABD0"
          d="M327.211 185.648c-.215 1.323.416 2.833-.863 3.921l-.061-9.893c.594-.27 1.07-.132 1.434.41.953 1.956.904 3.822-.51 5.562z"
        />
        <path
          fill="#6BB1D3"
          d="M327.133 179.679l-.424.002-.422-.005-.219-9.968.188-.022c.646-.274 1.154-.111 1.523.485.93 3.246 1.579 6.476-.646 9.508z"
        />
        <path
          fill="#89AECC"
          d="M327.112 200.814c.533-2.336-.816-4.937.996-7.093 2.053 2.672 2.066 5.338-.02 8a18.108 18.108 0 00-.902-.014 2.339 2.339 0 01-.074-.893z"
        />
        <path
          fill="#2E3D9D"
          d="M286.178 146.739l-.922 1.036c-1.469-.836-1.885-2.263-2.137-3.782-.086-5.536-1.451-6.444-6.44-4.247-.449.197-.855.513-1.334.638-1.973.515-4.135.927-5.393-1.055-1.274-2.006.372-3.327 1.824-4.508 3.565-1.937 5.982-6.527 11.124-4.837.689.298 1.238.771 1.672 1.38 1.367 2.382.277 6.271 4.316 7.025 1.768 3.651-1.814 5.563-2.71 8.35z"
        />
        <path
          fill="#2A3799"
          d="M284.182 143.687l1.074 4.089c-.279 1.034-.947 1.695-1.955 2.029-.375-.066-.748-.135-1.123-.203-3.475-3.853-8.025-1.037-11.976-1.933-.013-.326-.02-.651-.021-.977 2.512-.099 1.137-4.312 4.13-3.907 3.14 1.941 6.575.65 9.871.902z"
        />
        <path
          fill="#326FAD"
          d="M286.178 146.739c-.574-2.965 4.186-4.86 1.648-8.219-.016-1.577.957-2.481 2.184-3.215.693-.22 1.34-.189 1.883.365-.881 4.219-2.407 8.104-5.715 11.069z"
        />
        <path
          fill="#4F72A5"
          d="M291.863 121.787c.436 1.28.885 2.549 2.387 2.974a2.644 2.644 0 01-.176.918c-.52.645-1.092 1.217-1.928 1.438a2.564 2.564 0 01-1.209-.128c-.543-.29-.994-.694-1.408-1.139-.67-.714-1.512-1.232-2.213-1.914-.574-.876-.391-1.859-.393-2.817.111-.157.225-.313.338-.47l4.602 1.138z"
        />
        <path
          fill="#3675A3"
          d="M292.105 126.824c.396-.829 1.109-1.111 1.969-1.146.576 3.615-.5 6.87-2.182 9.993l-1.598.02c-.604-.417-.73-1.023-.686-1.702.117-.639.352-1.238.596-1.835.131-.402.283-.798.426-1.196.509-1.372.319-2.997 1.475-4.134z"
        />
        <path
          fill="#0E3F8F"
          d="M282.199 71.703c1.67-1.826 2.48-4.936 5.992-4.014 1.529 2.52.855 5.323 1.035 8.018.596 1.204.66 2.118-1.109 2.031l-2.908-2.054c-1.178-1.008-2.676-.18-3.941-.687-.252-.229-.374-.485-.362-.768.012-.297.049-.445.116-.445.88-.416 1.126-1.194 1.177-2.081z"
        />
        <path
          fill="#234C8D"
          d="M288.117 77.738c.83-.427 1.049-1.186 1.107-2.031.883.608 1.457 2.145 2.93.973l-.074 3.139c-1.656-.056-3.244-.238-3.963-2.081z"
        />
        <path
          fill="#FCB9AF"
          d="M289.197 113.697c1.119.984-.359 1.967-.004 2.95-2.979 1.431-5.91 1.496-8.778-.3-2.426-5.514-.303-9.722 5.206-10.332.492.174.891.48 1.193.905.889 2.22 1.155 4.667 2.383 6.777z"
        />
        <path
          fill="#C36977"
          d="M280.205 115.604c2.979.505 5.92 1.326 8.989 1.043-.344.84-1.07 1.075-1.875 1.188-2.34 1.809-5.248.823-7.803 1.594-.843.109-1.65.003-2.41-.397-1.003-1.07-1.789-2.189-.769-3.684 1.35-.859 2.633-.666 3.868.256z"
        />
        <path
          fill="#B67898"
          d="M279.037 118.791c2.549-2.138 5.512-.707 8.282-.957-.09.64-.182 1.279-.273 1.918-1.293 1.201-2.896 1.219-4.514 1.202-1.08-.026-2.129-.187-3.073-.769-.472-.362-.613-.829-.422-1.394z"
        />
        <path
          fill="#E69A97"
          d="M289.197 113.697c-2.021-1.469-1.797-4.054-2.959-5.949.676-.64 1.359-.673 2.049-.019.074.346.148.691.223 1.033.23 1.642.459 3.288.687 4.935z"
        />
        <path
          fill="#3368AC"
          d="M282.18 119.766c1.623-.004 3.244-.009 4.865-.015.172.274.244.573.217.897l-.264.167c-1.482 2.459-3.146 1.439-4.82.251-.291-.432-.289-.866.002-1.3z"
        />
        <path
          fill="#A988D0"
          d="M254.233 167.631c5.635.305 11.234.502 14.923-5.001.968-.189 1.447.104 1.154 1.164l-.325 1.904c-3.777 5.326-8.948 7.415-15.372 6.621a2.282 2.282 0 01-1.063-1.056c-.451-1.341-.471-2.597.683-3.632z"
        />
        <path
          fill="#A387DA"
          d="M254.169 171.701c5.833-.525 11.147-2.417 15.817-6.002l-2.983 5.938-2.838 2.028c-5.28 2.307-7.748 1.823-9.996-1.964z"
        />
        <path
          fill="#9E7CC4"
          d="M270.31 163.794c-.385-.388-.77-.775-1.154-1.164l.939-2.994.071.015c.381-.307.739-.296 1.068.081-.1 1.401.31 2.92-.924 4.062z"
        />
        <path
          fill="#9A5C96"
          d="M271.234 159.732l-1.068-.081c-.002-1.433.763-2.375 1.949-3.049.068 1.145.254 2.322-.881 3.13z"
        />
        <path
          fill="#574FA6"
          d="M317.178 190.703c-.1.632-.074 1.751-.32 1.813-1.109.284-.49-.768-.693-1.209-.412-.894-.73-1.829-1.088-2.748.361-.638.725-1.274 1.086-1.911.718 1.256 1.121 2.592 1.015 4.055z"
        />
        <path
          fill="#DEC5D5"
          d="M288.287 107.729l-2.051.018-.188-1.139a1.378 1.378 0 01-.418-.933c.068-.357.236-.656.52-.888l2.033-.228c2.028.991.854 2.088.104 3.17z"
        />
        <path
          fill="#FCA499"
          d="M286.15 104.788c-.01.275-.043.549-.098.819-3.563-1.699-2.453-5.017-2.971-8.021.07.047-.135.166-.133.521.023 2.182 1.07 5.333-1.834 5.771-3.102.467-1.934-3.057-2.727-4.787-.203-.444-.475-.856-.684-1.307a5.027 5.027 0 01-.266-1.425c.534-2.583-.027-5.47 2.097-7.611 3.246-1.143 2.75 3.317 5.158 3.433 1.037.655 2.957.451 2.516 2.552l.078 2.997c-.047.649-.094 1.299-.143 1.947-1.444 1.487-.952 3.35-.993 5.111z"
        />
        <path
          fill="#F49F9C"
          d="M287.209 94.732a2290.22 2290.22 0 00-3.033-2.044c.338-2.891.898-3.009 4.197-.88-.066.772-.086 1.53.697 2.009l-1.861.915z"
        />
        <path
          fill="#FA9F96"
          d="M288.373 91.808c-1.314.696-3.375-2.172-4.195.88-3.588.919-1.775-3.553-3.994-3.999a2.38 2.38 0 01-.688-1.188c-.033-2.185 1.496-3.907 1.734-6.05.418-3.765 3.727.024 4.957-1.782.66.347 1.322.692 1.984 1.039 1.002 1.476 2.584 2.161 4.066 2.979.391.774.779 1.549 1.168 2.323-.777 2.007-1.527 4.038-3.941 4.662-.362.379-.726.757-1.091 1.136z"
        />
        <path
          fill="#4A4687"
          d="M289.465 90.672l3.939-4.663c.244.906.486 1.813.727 2.718-1.225 1.441-2.654 2.391-4.666 1.945z"
        />
        <path
          fill="#F6989B"
          d="M292.238 83.687c-2.129.063-4.35.249-4.066-2.979 1.756-.242 2.609 1.53 4.117 1.843-.018.377-.033.757-.051 1.136z"
        />
        <path
          fill="#7ADEF9"
          d="M328.088 201.721c.008-2.667.014-5.334.02-8l.059-8.001c-.938-7.522-.223-15.123-1.053-22.648-.131-.852-.396-1.655-.865-2.387-.035-.996-.068-1.992-.104-2.987l.135-6.063c.563-.896.518-1.921.393-2.871-.555-4.189 1.213-5.85 5.336-5.101 3.186 1.328 6.813-.147 9.943 1.533 1.68 2.854-.582 3.288-2.436 3.733-1.766.424-3.598.55-3.857 2.897-.141 7.112-.215 14.215.205 21.312-.295 3.576-.447 7.154.008 10.732-.588 3.807-.117 7.639-.258 11.451-.053 1.155.02 2.324-.074 3.476-.336 4.044 1.406 5.791 5.508 5.56 6.568-.369 13.242 1.174 19.709-1.102 1.785-.233 2.904.758 3.842 2.082.484.897.613 1.856.473 2.857-.145.678-.455 1.261-1.037 1.666-.934.375-2.027.142-2.91.745-1.373.886-2.213 2.521-3.986 2.838a4.508 4.508 0 01-1.297-.034c-2.234-.646-3.965-2.707-6.563-2.313-2.539.735-3.211 3.201-4.609 4.978-1.313 1.666-2.139 3.815-4.523 4.374-1.244.165-2.334-.311-3.418-.811-1.705-.876-3.541-.757-5.336-.56-1.861.204-2.723-.687-3.1-2.336-.07-5.005-.136-10.012-.205-15.02z"
        />
        <path
          fill="#7FC6FD"
          d="M326.245 143.718a12.582 12.582 0 01-.055-.97l.031-.042c1.744-1.638 3.943-1.396 6.053-1.407 7.211-.041 14.42-.009 21.629-.028 7.459.041 14.92.016 22.379.011a47.694 47.694 0 011.814 0c2.939.194 5.998-.619 8.781.993 1.1 1.726-.451 1.917-1.416 2.455-1.176.308-2.381.302-3.584.33-1.832.028-3.664.012-5.498.038-16.088-.024-32.178.283-48.242-.911-.672-.05-1.312-.102-1.892-.469z"
        />
        <path
          fill="#7CE3FA"
          d="M326.245 143.718c16.982-.009 33.967-.019 50.951-.027.361.48.383.977.068 1.492-.541.718-1.266 1.082-2.162 1.132-.291-.02-.578-.046-.873-.065-.297-.025-.588-.06-.883-.087-7.982-.168-15.963.064-23.938-.102-5.76-.12-11.484-.886-17.227-1.369-6.529-1.564-4.113 4.479-5.902 6.943l-.034-7.917z"
        />
        <path
          fill="#6EBEDD"
          d="M326.249 160.685l.926 1.008c.771 2.679.857 5.353-.057 8.019-.287-.009-.574-.018-.861-.025l-.008-9.002z"
        />
        <path
          fill="#6092D7"
          d="M330.182 131.715l7.996.009c.559.56.648 1.225.445 1.957-2.414 1.736-5.104 3.219-5.955 6.415-.861.828-1.752 1.619-2.902 2.037-1.186-.079-2.443.415-3.529-.444.064-2.683-.588-5.448.914-7.966 1.012-.669 2.021-1.339 3.031-2.008z"
        />
        <path
          fill="#5399D2"
          d="M326.237 141.689l3.943-.005c3.555-2.268 7.529-1.102 11.322-1.391 3.625.04 7.258-.167 10.877.257a4.324 4.324 0 011.521.633c.49.398.58.877.271 1.431l-27.951.093c.007-.339.011-.679.017-1.018z"
        />
        <path
          fill="#B19BEE"
          d="M217.172 232.686l1.058-.918c.328-.012.655-.013.983-.004 1.697.217 2.321 1.513 3.181 2.792 2.713 4.034 6.905 4.829 10.599 1.87 2.189-1.754 4.09-2.226 6.104-.156 1.959 2.013 4.388 2.108 6.916 2.134 9.977.096 19.955-.217 29.931.16.761.029 2.157.57 2.127-.453-.157-5.203 3.71-3.109 6.009-3.247 1.873-.112 2.99-.651 3.686-2.297 1.861-1.116 3.172.064 4.529 1.062.73.603 1.488 1.187 1.885 2.091-1.389 2.477-2.275 5.086-2.096 7.976-1.533 2.047-1.424 4.438-1.43 6.807-.453 1.773-1.982 3.239-1.512 5.279-.033.715-.184 1.392-.641 1.967-1.516.864-2.809.34-2.824-1.25-.037-3.553-1.949-2.241-3.674-1.676-.719.133-1.442.173-2.17.186-9.797.017-19.597.209-29.383-.064-5.406-.151-10.566 2.75-16.154.758-1.88-.671-3.188 3.572-5.998 1.916a4.634 4.634 0 01-1.402-.535c-.903-.563-1.306-1.481-1.695-2.409l-3.986-6.026c-1.737-.806-1.419-2.632-1.996-4.015-.357-3.22-1.923-6.039-2.991-9.024l.944-2.924z"
        />
        <path
          fill="#A691EF"
          d="M288.994 285.796c.092.287.113.579.064.876-.375 1.574.686 3.278-.428 4.787-.629 1.033-1.598 1.772-2.338 2.712-.934.838-2.082 1.267-3.221 1.721-4.122 1.797-8.378 3.164-12.796 4.02-1.78.103-3.446.81-5.21.994-1.742.146-3.489.095-5.232.099-5.451-.184-10.758-.56-15.607 3.267-1.8 1.42-5.086 1.086-7.473 2.357-3.563-.703-6.51-2.343-8.449-5.53-.728-3.655-1.003-7.3.233-10.913 3.407-2.028 6.241.956 9.407 1.075 3.955 1.396 8.066 1.001 12.137 1.05 1.877.021 3.755.024 5.63.023 1.781-.002 3.573.107 5.301-.484 7.52-1.146 15.047-2.269 21.161-7.424a7.162 7.162 0 011.811-1.201 3.064 3.064 0 012.061-.005c1.035.792 1.912 1.778 2.949 2.576z"
        />
        <path
          fill="#9787E8"
          d="M320.18 270.699c-1.873-1.132-3.871-2.115-4.969-4.17-1.76-3.284-1.197-6.972-1.832-10.451a6.455 6.455 0 01.104-1.488c.529-1.885.488-3.819.455-5.756-.02-.496.008-.988.055-1.482.227-1.238.371-2.535 1.918-2.896 1.018.389 1.482 1.239 1.836 2.183.557 1.755-.658 3.592.689 6.312.182-6.895 6.371-9.593 7.762-15.12.254-1.01 1.6-.988 2.629-.807 1.32.421 2.352 1.383 3.607 1.927 1.014.505 2.166.771 2.932 1.7.143.778-.252 1.289-.836 1.708-3.176 1.85-.014 5.589-2.285 7.71-3.008 2.374-4.383 6.176-7.428 8.516-.846 1.662-2.918 2.084-3.76 3.751-.807 1.031-1.672 1.894-.629 3.429 1.061 1.561 1.264 3.362-.248 4.934z"
        />
        <path
          fill="#7B66D3"
          d="M289.082 320.76c.064.26.102.522.109.79-1.641 3.658-5.258 4.337-8.487 5.342-8.424 2.624-17.175 3.43-25.921 4.188-4.961-.076-9.92.111-14.879.086-1.398-.103-2.806-.156-4.183-.46-2.275-.95-4.838-.425-7.126-1.358a2.448 2.448 0 01-1.106-1.242c-.42-1.515-.257-2.87 1.058-3.915 1.894-1.043 3.873-.613 5.831-.295 15.78 2.566 31.386 1.511 46.853-2.241 1.418-.289 2.803-.686 4-1.558.891-.634 1.545-1.685 2.822-1.658.857.545.431 1.66 1.029 2.321z"
        />
        <path
          fill="#A999E5"
          d="M365.256 240.933c-.023.255-.043.51-.059.766-5.689 3.684-9.232 9.742-14.904 13.464-1.355.889-2.295 2.401-4.053 2.703-4.355-4.231-3.955-5.669 3.348-11.817-1.164-.661-2.451.77-3.506-.262-.605-2.002.463-3.508 1.477-5.038a3.707 3.707 0 011.355-.934c5.031-.745 10.064-.765 15.102-.013.545.232.957.611 1.24 1.131z"
        />
        <path
          fill="#1796C8"
          d="M356.135 321.628c-.801.025-1.545-.076-1.971-.885-1.33-5.162-2.367-5.52-5.939-2.122-1.473 1.399-2.588 3.454-5.143 3.056l.109-1.005c1.457-1.254 2.832-2.514.264-4.028-.723-.246-1.43-.568-2.219-.29-.717.294-1.484.384-2.219.596-.301-.423-.604-.846-.904-1.27-.27-2.344-2.945-4.661-.08-7.041.666-.971 2.852-.625 2.299-2.651.107-.54.43-.699.939-.531.754.563 1.18 1.352 1.525 2.192.357 1.037.285 2.374 1.809 2.606 2.049 2.324.9-2.106 2.322-1.11.436-.1.871-.122 1.314-.083 1.982.589 3.965.054 5.949.004.463.096.855.314 1.186.651.107 2.404-1.695 2.348-3.125 2.6 2.127 1.086 4.73-3.251 6.885.354.004.354.008.71.01 1.064-1.168 1.529 1.971 3.834-.908 5.056-.7.946-1.402 1.892-2.103 2.837z"
        />
        <path
          fill="#3A1C7D"
          d="M255.204 329.74c11.621-1.52 23.557-1.73 33.987-8.189.643.447 1.285.895 1.928 1.341-3.516 4.204-8.84 5.31-13.35 7.807-2.104.296-4.511-.136-5.707 2.375a4.136 4.136 0 01-1.34.388c-3.61-.003-7.116.773-10.641 1.428-1.528.15-3.043.403-4.579.478-3.942-.251-7.815-.675-10.625-4.481 5.287-2.023 10.226 1.072 14.847.251-1.258-.714-3.549 1.522-4.52-1.398z"
        />
        <path
          fill="#0FADDA"
          d="M366.184 295.566c-.555.631-2.146.752-1.072 2.183.693 1.368.049 2.34-.947 3.209-1.502.354-2.838-.067-4.084-.888-1.092-1.087-1.082-2.905-2.514-3.766-1.584-1.286-3.451-1.438-5.377-1.355-2.627-.604-2.838 2.272-4.471 3.107-5.158-1.03-2.158-4.033-1.568-6.455.844-1.958-1.186-4.223.65-6.074a2.289 2.289 0 011.357-.142c3.162 3.866 6.646 4.667 12.604 2.865.131-.46.396-.783.807-1.005 1.385-.329 2.369.34 3.262 1.257 1.445 2.164 3.355 4.243 1.353 7.064z"
        />
        <path
          fill="#5F359C"
          d="M296.281 334.527c-.85 3.615 1.73 6.176 2.826 9.192-.496 1.368-1.52 1.954-2.926 1.972-.645-1.925-1.941-2.852-7-4.999-2.426.611-3.783-1.982-6-2-.41-1.618-2.027-3.092-.592-4.94a4.873 4.873 0 011.039-1.063c3.406-1.632 6.545-4.683 10.756-2.036a2285.04 2285.04 0 012.029 3.023c-.056.282-.1.566-.132.851z"
        />
        <path
          fill="#A695EB"
          d="M346.2 245.694c.709-.373 1.5-.646 2.109-1.141 1.201-.977 2.607-1.332 3.434-.007.871 1.4-.369 2.239-1.58 3.056-6.479 4.365-6.523 4.589-3.922 10.263-2.146 2.685-5.094 4.276-8.027 5.886-4.146-1.668-2.793-5.009-1.09-6.854 2.098-2.272.324-3.452-.166-5.104.791-1.212 2.33-1.19 3.342-2.042 2.083-1.182 3.439-3.425 5.9-4.057z"
        />
        <path
          fill="#A192EB"
          d="M337.178 251.712c1.102 1.55 3.09 1.654 5.506 3.138-3.934.289-4.711 2.731-5.813 5.056-.922 1.947 1.1 2.509 1.342 3.845l-7.107 4.725c-1.033-.249-2.049-.537-2.85-1.303a1.94 1.94 0 01-.488-1.169c.057-.444.17-.871.309-1.292-1.156-5.678 2.996-8.788 6-12.461a9.017 9.017 0 011.85-.859c.462-.08.878.037 1.251.32z"
        />
        <path
          fill="#816FDD"
          d="M315.159 247.672l.012 1.019c-1.275 1.846.248 4.15-.986 6.003l.002-.001c-2.303 2.493-4.553-1.647-6.85-.054-.969-1.512-1.963-3.014-2.168-4.865-.318-.367-.398-.786-.271-1.25.205-1.345.047-2.792 1.072-3.906 1.668.604 1.836-2.233 4.732-1.303 2.986.959 3.523 2.347 4.457 4.357z"
        />
        <path
          fill="#5C2F97"
          d="M277.208 329.705l13.911-6.813c1.738.806 3.469 1.619 3.883 3.785-.803.934-1.693 1.748-2.891 2.15-3.416 1.213-6.922 2.135-10.393 3.172-2.357.54-4.546 2.061-7.138 1.237-.438-.271-.699-.658-.759-1.175.334-1.928 2.317-1.485 3.387-2.356z"
        />
        <path
          fill="#8575E3"
          d="M307.336 254.639c2.311-3.453 4.563.509 6.85.054 1.41 3.854.887 7.874 1.025 11.837a34.431 34.431 0 01-7.875-11.891z"
        />
        <path
          fill="#9D8FED"
          d="M320.18 270.699c-.219-1.861.48-3.738-1.508-5.397-2.311-1.929 1.826-2.016 1.514-3.611 1.715-1.204 2.371.193 2.992 1.316 1.119 2.018 2.865 3.094 5 3.686l.004.003c1.781 1.029 1.244 2.1.057 3.181-2.485 2.254-5.059 3.616-8.059.822z"
        />
        <path
          fill="#5A46B8"
          d="M304.186 221.691l.029 1.979c2.116 6.25 2.272 6.297-4.887 10.981-.424-1.255-.846-2.51-1.268-3.766-.939-1.48-.254-2.521.93-3.424 2.268-2.998.197-6.898 2.078-9.977 1.219 1.451.514 2.984.441 4.366 1.018-.587-.877-3.193 1.422-3.031 1.358.098.229 2.14 1.255 2.872z"
        />
        <path
          fill="#604DC3"
          d="M299.328 234.652c1.619-1.088.496-4.766 4.381-4.206.797.114.178-4.411.506-6.775.319.017.635.028.952.035.719.565 1.037 1.35 1.215 2.209.205 4.084.381 8.172-.113 12.246-.764 2.589-3.215 1.834-4.965 2.483-1.406-1.751-1.527-3.925-1.976-5.992z"
        />
        <path
          fill="#17A7D4"
          d="M346.151 291.601c1.195 1.841-2.787 5.385 1.988 6.049.127.174.252.348.381.522.051.439-.008.864-.146 1.282-.723 1.304-.918 3.007-2.66 3.55-2.207-1.62-5.74-1.647-6.305-5.243.721-1.84.072-4.884 3.9-3.916.713.18 1.883-1.449 2.842-2.244z"
        />
        <path
          fill="#0D7CC2"
          d="M374.323 290.336c-.516 1.773.584 3.907-1.205 5.396l-4.975-1.093c-1.16-2.027-2.434-4.027-1.617-6.547.797-1.296 1.912-1.723 3.363-1.226l.242 1.203c.877 1.473 2.727.706 3.828 1.662.284.106.405.308.364.605z"
        />
        <path
          fill="#12A2CD"
          d="M339.409 297.761c1.85 2.203 5.143 2.426 6.771 4.932.85.803.881 1.778.604 2.82-1.105 1.603-1.156 3.741-2.6 5.18-3.723 1.025-1.314-2.035-2.016-3.023-1.156-1.366.027-3.666-1.896-4.733-1.51-.568-3.229-.986-2.225-3.259l1.362-1.917z"
        />
        <path
          fill="#0A4D81"
          d="M369.889 286.868l-2.709.82c-.836.806-1.629 1.729-2.99 1.083l-2.951-1.212c-1.055-2.331-.771-4.159 1.914-5.084 2.644.851 6.185.328 6.736 4.393z"
        />
        <path
          fill="#3D1B7D"
          d="M281.215 330.763l10.986-3.04c.965.357 1.582 1.067 2.004 1.974.125.307.184.625.18.956-4.248-.888-7.393 2.242-11.172 3.064-2.282.108-2.301-1.314-1.998-2.954z"
        />
        <path
          fill="#E3F3FA"
          d="M374.186 241.702l16.99-.002c-3.504 2.876-14.22 2.877-16.99.002z"
        />
        <path
          fill="#8975CD"
          d="M298.99 227.462l-.93 3.424c-2.045 1.008-2.242 3.498-3.881 4.832-.828-.032-1.561-.246-1.986-1.045-.096-2.317 2.361-4.793-.734-6.991-.857-.609-.467-1.159 2.775-1.021 1.647-.096 3.245.103 4.756.801z"
        />
        <path
          fill="#695BC7"
          d="M301.303 240.644c1.148-.871 1.736-3.988 3.856-.962 2.514 2.991.01 6.003.039 9.004l-.029 1.088c-2.056-2.719-2.935-5.936-3.866-9.13z"
        />
        <path
          fill="#74AAD7"
          d="M287.146 295.628c3.002 3.635 5.506 7.559 7.018 12.06-.568.573-1.229.619-1.947.343-.969-.751-1.293-1.922-1.906-2.905-1.412-2.625-4.236-4.326-4.902-7.445a4.008 4.008 0 01.127-1.396c.115-.204.234-.407.354-.61.407-.303.827-.319 1.256-.047z"
        />
        <path
          fill="#D6F5FC"
          d="M288.129 269.581c.184 4.725.689 9.449.029 14.177-.465.254-.902.211-1.311-.129-.619-.779-1.314-1.511-1.551-2.526-.455-1.766-.381-3.532-.002-5.299.744-1.906.334-4.102 1.457-5.915.384-.442.845-.544 1.378-.308z"
        />
        <path
          fill="#D6F6FD"
          d="M348.184 283.71c.148-1.922-3.549-3.355-1.273-5.009.893-.649 4.303.33 5.266 2.854-.911 1.499-1.993 2.677-3.993 2.155z"
        />
        <path
          fill="#D6F5FC"
          d="M290.182 271.691l-1.994-2.992c-1.387-1.291-1.201-2.908-.959-4.541.615-1.721.533-3.647 1.506-5.27.385-.449.85-.554 1.391-.314.019 4.372.036 8.745.056 13.117z"
        />
        <path
          fill="#D9F6FE"
          d="M330.952 292.396c1.533 2.183 1.432 4.409.568 7.258-2.266-2.652-.906-5.019-.568-7.258z"
        />
        <path
          fill="#78B1ED"
          d="M288.256 263.865c-.023 1.611-.047 3.223-.068 4.834a2.287 2.287 0 00-.057.883c-.248.088-.5.154-.76.2-.535.348-1.039.309-1.518-.116-1.184-1.78-1.02-3.768-.891-5.753.104-.862.373-1.657.945-2.329.773-.521 1.564-.55 2.373-.082.458.791.476 1.581-.024 2.363z"
        />
        <path
          fill="#19A9DC"
          d="M348.184 283.71l3.992-2.154.932 1.027c.209 1.388.121 2.683-1.133 3.613-1.352.65-2.607.49-3.768-.456l-1.406-.214 1.383-1.816z"
        />
        <path
          fill="#19B4DC"
          d="M363.153 282.475c-1.225 1.475-1.727 3.221-1.914 5.085l-.059 1.115c-2.645-1.239-2.645-1.239-1.83-6.133a3.12 3.12 0 01.822-1.171c.717-.314 1.391-.27 2.012.235.322.291.647.58.969.869z"
        />
        <path
          fill="#19B4DC"
          d="M355.151 282.84l1.031-1.178c1.332-1.374 2.658-2.977 4.086-.091l-.215.301c-1.305 1.323-.738 5.002-4.338 3.443-.556-.739-.968-1.515-.564-2.475z"
        />
        <path
          fill="#9BB3EA"
          d="M290.125 258.574c-.273.087-.549.171-.824.252-1.201-.742-.098-2.29-1.082-3.107-.391-2.079.334-3.728 1.945-5.032.297-.455.592-.434.887.001l-.926 7.886z"
        />
        <path
          fill="#CEEEF8"
          d="M338.047 299.677c-.254 2.319 2.01 2.145 3.104 3.129.682.89.771 1.762-.082 2.604-.26.174-.506.366-.738.576-.102-1.523-1.133-2.259-2.346-2.938-1.979-1.108-1.953-2.283.062-3.371zM338.034 308.639c-1.471 2.364.555 4.688.08 7.041-1.66-1.875-2.922-3.838-1.957-6.536.439-1.228 1.144-.75 1.877-.505z"
        />
        <path
          fill="#1D8DC2"
          d="M343.186 315.688c1.271.074 3.23-.216 3.23 1.331 0 1.648-1.074 3.383-3.225 3.654-.021-.949.92-1.938-.119-2.845.126-.708-.523-1.458.114-2.14z"
        />
        <path
          fill="#D8F2F8"
          d="M360.268 281.572c-1.4-1.654-2.738-.545-4.086.092.273-.896-.715-2.463 1.482-2.296 1.883.144 4.078-.689 4.52 2.239l-1.916-.035z"
        />
        <path
          fill="#A2AEE3"
          d="M291.051 250.687l-.443.002-.443-.003c.717-2.31-1.656-5.469 1.92-6.991l-1.034 6.992z"
        />
        <path
          fill="#8099F1"
          d="M288.24 291.678c.158-1.688-.672-3.537.82-5.006 1.404 1.594 2.711 3.195.336 5.042-.398.373-.783.361-1.156-.036z"
        />
        <path
          fill="#017AAD"
          d="M355.151 282.84l.982 1.782c-.898 1.807-2.129 2.354-3.854 1.011-.012-1.095-.291-2.263.83-3.049l2.042.256z"
        />
        <path
          fill="#D6F5FC"
          d="M291.682 275.553c-2.002-1.327-1.285-2.714-1.5-3.862.305.074.641.09.91.233 1.586.85.928 2.016.59 3.629z"
        />
        <path
          fill="#E2F4F3"
          d="M341.028 288.265c.957-.064.977.685 1.053 1.303.082.66-.029 1.407-.768 1.566-.943.203-.975-.651-1.049-1.269-.076-.655.047-1.283.764-1.6z"
        />
        <path
          fill="#D9F1F7"
          d="M297.182 328.258c.871.123.896.809.896 1.449-.002.642-.049 1.412-.92 1.405-.879-.008-.896-.786-.893-1.427.005-.638.026-1.326.917-1.427z"
        />
        <path
          fill="#8BA4E9"
          d="M292.229 307.659l1.936.029c.318 1.787-.395 3.128-1.805 4.166l-.621-.515c-.643-1.334-.68-2.588.49-3.68z"
        />
        <path
          fill="#3F64B1"
          d="M288.24 291.678l1.156.036c-.771 1.293-2.428 2.077-2.25 3.915-.313.039-.627.07-.941.09-.594-.718-.627-1.468-.125-2.247.721-.597 1.44-1.196 2.16-1.794z"
        />
        <path
          fill="#9B8DE8"
          d="M328.239 269.875c.42-1.067.646-2.133-.057-3.181 1.346-.014 2.324.574 2.924 1.781l-2.867 1.4z"
        />
        <path
          fill="#9892CA"
          d="M289.082 320.76l-.93-2.102c-1.814-1.108-1.445-2.177.061-3.224.758.062 1.406.212.957 1.223l-.088 4.103z"
        />
        <path
          fill="#341573"
          d="M294.205 329.697c-.955-.365-1.625-1.023-2.004-1.975.934-.348 1.867-.696 2.801-1.046.365 1.173-.094 2.129-.797 3.021z"
        />
        <path
          fill="#91A3DF"
          d="M292.359 311.854c-.289 1.293-.945 2.333-2.088 3.039a2.23 2.23 0 01-.773-1.427c.207-1.593.697-2.773 2.65-1.812l.211.2z"
        />
        <path
          fill="#9A8AE9"
          d="M290.148 313.685l.123 1.207-1.102 1.766-.979-.952c-.702-1.988-.19-2.798 1.958-2.021z"
        />
        <path
          fill="#075A9B"
          d="M343.186 315.688c.178.725 1.037 1.485-.113 2.141l-.467.015-.428-.193c-.584-.533-1.641-.825-1.018-1.979.686-1.097 1.352-.121 2.026.016z"
        />
        <path
          fill="#1B62A6"
          d="M341.161 315.67l1.018 1.979c-1.125.091-2.305.428-3.16-.7.407-.938 1.19-1.251 2.142-1.279z"
        />
        <path
          fill="#1E75B8"
          d="M373.959 289.733c-1.438-.186-3.271.544-3.828-1.663 1.301.5 2.881.353 3.828 1.663z"
        />
        <path
          fill="#75BAEB"
          d="M287.207 283.676c.318.001.637.027.951.08.279.68.559 1.359.836 2.039-1.42-.057-2.828-.13-2.906-2.068.357-.368.73-.385 1.119-.051z"
        />
        <path
          fill="#F792F6"
          d="M424.188 301.679c-.32 2.421-2.225 2.164-3.758 1.968-4.838-.621-9.65-.079-14.475.024-1.564.033-3.441.438-3.779-1.977 7.338-.004 14.674-.009 22.012-.015z"
        />
        <path
          fill="#FB8DF7"
          d="M438.184 302.692c3.018 2.001 6.395.562 9.576.993 1.898.257 3.922-.524 5.773.642-3.801 2.315-14.967 1.88-17.352-.635-.596-.672-.59-1.343.004-2.012l1.992-.003c.352.223.469.448.354.675-.113.227-.23.34-.347.34z"
        />
        <path
          fill="#F792F6"
          d="M464.182 303.691l-4-.001c-.533-.67-.6-1.34-.004-2.013l10.008.008c0 .668 0 1.336-.002 2.005-.199.189-.396.379-.594.572-1.916.887-3.726.763-5.408-.571zM438.184 302.692l-.006-1.015 18.008-.001c.254.228.338.453.252.679-.086.225-.172.337-.258.337h-17.996z"
        />
        <path
          fill="#FB8DF7"
          d="M456.18 302.692l.006-1.016 3.992.002c.002.67.004 1.341.004 2.012-.125 1.371-.844 2.049-2.248 1.912-1.885-.183-1.678-1.633-1.754-2.91z"
        />
        <path
          fill="#F792F6"
          d="M436.186 301.68l-.004 2.012c-1.578-.188-3.682.671-4.006-2.012h4.01z"
        />
        <path
          fill="#E052E9"
          d="M473.292 358.764c-4.043-2.047-8.375-.73-12.564-1.047-1.969-.148-3.957-.025-5.922-.699 2.342-1.869 4.928-1.096 7.377-1.326 3.514-1.698 7.762-1.739 10.703-4.74 1.049-.311 2.076-.275 3.074.194 1.234.865 1.445 2.11 1.287 3.49-.981 1.7-1.055 4.268-3.955 4.128z"
        />
        <path
          fill="#CE5ACD"
          d="M477.247 354.636c-.369-.983-.738-1.968-1.109-2.951-1.432-1.697-1.328-3.701-1.154-5.722a9.897 9.897 0 01.295-1.674c1.098-4.429.186-8.949.584-13.412.066-1.191.273-2.333 1.127-3.248.607-.28 1.125-.162 1.555.351.08 2.924.451 5.855-.219 8.762-.468 5.959.792 12.021-1.079 17.894z"
        />
        <path
          fill="#C29FC2"
          d="M478.325 336.742l-.193-8.978c-1.42-2.063-1.744-4.1.133-6.089.264.002.525-.003.785-.018-.079 5.037.812 10.119-.725 15.085z"
        />
        <path
          fill="#F581F3"
          d="M477.213 327.708c-.02.992-.039 1.984-.057 2.977-.492.341-.943.296-1.359-.135-.459-.647-.68-1.379-.781-2.153-.145-1.233-.127-2.475-.143-3.712.463-3.459-.539-5.571-4.541-5.481-1.547.035-3.227-.243-4.5-1.429-1.373-3.436.105-5.386 3.48-5.046 2.801.282 3.723-1.274 4.869-3.033 2.127-.117 2.203 2.473 3.883 2.944l.057 8.042c-1.206 2.226.296 4.801-.908 7.026z"
        />
        <path
          fill="#F885F9"
          d="M474.182 309.696v5.545c-6.342-2.589-7.389-2.208-7.998 2.449-.154 1.35-.695 1.477-1.592.505-.955-2.915-1.453-5.8.6-8.504 2.24-.959 4.848.643 6.99-1.001.824.021 1.572.196 2 1.006z"
        />
        <path
          fill="#F792F6"
          d="M472.18 307.687l-1.996.002c-1.063-1.331-1.061-2.663-.004-3.997l.004-.002c2.674.33 1.809 2.426 1.996 3.997z"
        />
        <path
          fill="#1568BC"
          d="M373.627 304.664l-1.418 1.007c-.779.569-1.029 1.673-2.029 2.022l-1.998-.001c-.541-3.355-1.615-6.604-1.988-9.994 2.271-.238 4.021 1.1 5.932 1.956.609 1.637-.461 3.777 1.501 5.01z"
        />
        <path
          fill="#0874BC"
          d="M366.194 297.698c2.799 2.907 3.33 6.265 1.988 9.994-.709 1.107-1.383.047-2.072-.033-.49-.422-.607-.979-.58-1.588.027-.38.074-.762.113-1.139.061-.852-.52-1.386-.994-1.976-.477-.691-1.02-1.369-.475-2.268.313-.98.627-1.961.938-2.94l1.082-.05z"
        />
        <path
          fill="#1EA4E1"
          d="M364.19 288.771c.916-.584 1.805-1.242 2.99-1.083.322 2.317.643 4.635.963 6.952l-1.959.927c.828-2.704-1.701-4.422-1.994-6.796z"
        />
        <path
          fill="#DA7CDD"
          d="M477.213 327.708c.283-2.345-.861-4.874.908-7.026.047.331.094.662.143.993-.043 2.029-.088 4.059-.133 6.088a5.32 5.32 0 00-.918-.055z"
        />
        <path
          fill="#83BCF2"
          d="M506.124 130.698c.018.341.033.682.051 1.022-.91.786-1.971 1.284-3.168 1.259-7.758-.17-15.551.939-23.27-.634-.65-.378-.83-.916-.547-1.61l14.975-.096 11.959.059z"
        />
        <path
          fill="#81B5EC"
          d="M479.19 130.735c-.004.315-.006.631-.006.946-1.197 1.349-2.832 1.301-4.426 1.392-4.988.036-9.979.055-14.967-.005-1.959-.023-4.047.287-5.615-1.393.004-.307.004-.613.002-.919 8.338-.006 16.676-.014 25.012-.021z"
        />
        <path
          fill="#6ABEF1"
          d="M475.186 131.703l3.998-.021c8.996.013 17.994.025 26.99.039l.008 1.977c-.727.6-1.514 1.079-2.465 1.223-8.227.198-16.455.423-24.682-.117-1.566-.679-3.71-.649-3.849-3.101z"
        />
        <path
          fill="#79BDEC"
          d="M504.149 133.713l2.033-.017c.012 1.003.023 2.007.037 3.011-.016.329-.027.658-.035.987-.34.338-.723.412-1.154.183-.789-.842-1.049-1.912-1.297-2.988-.033-.451.1-.847.416-1.176z"
        />
        <path
          fill="#7ADEFA"
          d="M400.162 197.662c.184 9.224.477 18.451-1.305 27.586-.314 1.614-.594 3.258-.65 4.896-.137 3.998-.91 7.59-5.021 9.445-8.793 1.308-17.64.228-26.449.589-3.613-1.224-2.609-3.578-1.463-5.97 4.777-2.673 7.539-6.492 6.895-12.234.188-.963.551-1.861.996-2.729 1.408-2.199 2.59-4.585 4.861-6.098 4.439-1.25 8.238-3.568 11.429-6.896a16.608 16.608 0 011.586-1.327c2.189-1.461 3.375-3.856 5.234-5.615 1.071-1.013 1.819-2.934 3.887-1.647z"
        />
        <path
          fill="#6DBEF5"
          d="M436.184 198.677l.045-5.964c.363-.333.754-.356 1.152-.132.264 1.364.842.755 1.744.463 1.662-.536 3.426-.872 5.23-.843 16.736.043 33.457-.082 50.176.057 1.641.014 3.705-1.03 4.918 1.134-1.887 4.472-5.293 5.459-9.977 5.404-17.156-.2-34.32-.261-51.48.007a2.28 2.28 0 01-1.808-.126z"
        />
        <path
          fill="#85DDFB"
          d="M499.165 203.658c-1.971 1.357-.943 2.725-.012 4.091-1.805 1.596-4.031 1.339-6.164 1.338-24.064-.005-48.127.087-72.193-.032-1.344-.087-2.67-.22-3.615-1.363l-.996-1.008c1.078-.962 2.359-1.308 3.771-1.252.754.061 1.504.223 2.26.246 4.654.015 9.318.064 13.619-.02-.459.073-1.283.014-2.117.029h-5.75c-1.527-.012-3.049.03-4.57-.079-.82-.144-1.748-.227-2.051-1.136-.377-1.135.662-1.356 1.359-1.548 1.287-.353 2.639-.226 3.965-.226 22.408-.007 44.816-.013 67.225.01 1.798.001 3.683-.308 5.269.95z"
        />
        <path
          fill="#6FC2EA"
          d="M499.159 210.732c.01.321.021.642.035.963.086 1.268-.818 1.678-1.771 2.05-6.277.76-12.584.309-18.877.333-18.408.071-36.816.044-55.227.006-2.443-.005-5.029.456-7.135-1.394l.004-1.992c1.615-1.52 3.645-1.409 5.635-1.41 23.902-.019 47.805-.022 71.707.005 1.986.001 4.023-.093 5.629 1.439z"
        />
        <path
          fill="#7DD1FD"
          d="M416.192 231.702v-2.017c2.723-1.569 5.75-1.381 8.701-1.386 22.537-.041 45.074-.036 67.611-.005 2.285.003 4.691-.363 6.645 1.358l-.01 2.078c-1.066.656-2.256.436-3.4.437-25.385.011-50.771.011-76.156-.001-1.143.001-2.336.234-3.391-.464z"
        />
        <path
          fill="#69BFED"
          d="M422.194 206.665l-2.012.008c-.533-.501-.766-1.116-.701-1.845.125-.45.363-.828.732-1.12.316-2.508 2.268-1.982 3.832-1.983 23.744-.021 47.49-.021 71.234.002 1.557.002 3.512-.552 3.885 1.932h-76.967c.23.445.307.839.488.896.465.146.977.145 1.471.201.575 1.899-1.527 1.046-1.962 1.909z"
        />
        <path
          fill="#6CBFEC"
          d="M420.241 207.713l78.912.034v1.887c-1.359.945-2.904.52-4.363.521-23.445.028-46.891.057-70.334-.066-1.495-.007-4.737 1.743-4.215-2.376z"
        />
        <path
          fill="#87E1FD"
          d="M485.45 147.343h-76.553l-.006-1h76.6l-.041 1z"
        />
        <path
          fill="#7FD3FB"
          d="M420.221 219.74l-.035-1.064c1.34-2.159 3.535-2.34 5.715-2.334 22.793.061 45.588-.376 68.379.214.307.034.615.074.924.115l2.988 2.988c-1.184 1.238-2.744.974-4.209 1.015-22.699.643-45.404.406-68.107.415-1.979 0-4.018.135-5.655-1.349z"
        />
        <path
          fill="#79C5ED"
          d="M416.192 165.685v-6.994c7.186-1.104 14.416-.172 21.619-.488 1.207-.053 2.225.507 2.916 1.556.682 2.22.586 4.351-.715 6.348-7.972 1.673-15.926 2.305-23.82-.422z"
        />
        <path
          fill="#7BD3F4"
          d="M470.172 167.687c.002 2 .004 4 .004 6-4.389 2.807-9.281 1.134-13.938 1.53-2.117.18-4.266.059-6.398-.08-2.586-.169-4.381-1.252-4.832-3.982-.621-2.948-.215-5.931-.262-8.896.188-.637.611-.91 1.27-.818.723.483 1.078 1.204 1.283 2.014.033 2.501 1.107 3.298 3.742 3.075 6.407-.542 12.805-.094 19.131 1.157z"
        />
        <path
          fill="#7ACDF1"
          d="M499.159 158.683l.016 8.008c-.475 2.479-1.449 3.823-4.492 3.913-5.135.151-10.252.634-15.41.355-3.494-.188-5.381-1.405-4.432-5.209.662-2.875 2.906-3.325 5.334-3.427 3.809-.161 7.619.003 11.428-.099 2.141-.057 4.408.051 5.531-2.407.493-.702 1.007-1.371 2.025-1.134z"
        />
        <path
          fill="#7ACFF2"
          d="M416.192 165.685h23.984c.893 5.707-.025 7.09-5.436 7.298-6.289.241-12.605.376-18.553-2.295.003-1.668.003-3.335.005-5.003z"
        />
        <path
          fill="#7FD3FB"
          d="M416.196 216.711c.004-.354.01-.707.016-1.061 2.199-1.867 4.863-1.943 7.543-1.95 22.109-.06 44.217-.074 66.32.603 1.809.055 3.707-.14 5.117 1.402-.004.321 0 .644.01.965a.344.344 0 01-.027.027c-1.727.932-3.594.449-5.385.453-21.123.039-42.244.1-63.365-.051-3.395-.023-6.911 1.782-10.229-.388z"
        />
        <path
          fill="#7DDAF8"
          d="M445.192 170.687c1.135 2.151 2.621 3.206 5.35 3.092 6.535-.273 13.09-.09 19.635-.092.564 3.789-.789 5.373-4.865 5.086-4.941-.348-9.932-.248-14.887-.029-3.766.166-5.738-1.036-5.244-5.054-.688-1.003-.675-2.005.011-3.003z"
        />
        <path
          fill="#7CD9F8"
          d="M499.174 172.69c.643 4.465-.998 6.498-5.77 6.068-3.789-.341-7.633-.068-11.453-.068-7.773-.002-7.773-.002-7.762-7.998 6.221 2.361 12.713 1.348 19.109 1.535 1.966.058 3.982-.491 5.876.463z"
        />
        <path
          fill="#79C3EC"
          d="M446.182 163.69l-.004-1.996c-.582-.71-.619-1.483-.268-2.302 1.479-2.042 3.719-1.988 5.871-2.037 3.994-.09 7.99-.04 11.986-.01 1.816.014 3.707.184 4.955-1.6.459-.408.938-.43 1.432-.068l.012 4.016c-.057 4.607-2.83 5.923-6.859 5.531-5.705-.554-11.646 1.517-17.125-1.534z"
        />
        <path
          fill="#85C6DA"
          d="M398.164 177.705c.678.995 1.355 1.989 2.035 2.983 1.236 1.688.59 3.01-.188 3.686 1.256-2.11 3.406-3.14 6.15-.645.387 3.748-2.098 6.226-3.969 8.976-3.973-.872-7.105-4.532-11.656-3.519-.842-1.979-.736-3.984-.199-6.007 1.434-2.472 3.121-4.713 5.693-6.132.816-.116 1.546.038 2.134.658z"
        />
        <path
          fill="#7DD9F8"
          d="M440.18 176.691v1.997c-5.291 2.776-10.914 1.477-16.357.97-1.801-.168-3.832-.261-5.641-.966-3.207-.651-1.574-3.238-2-5.002 1.479-1.308 3.293-1.698 5.129-1.413 4.633.721 9.291.504 13.92.344 3.17-.111 4.484 1.272 4.949 4.07z"
        />
        <path
          fill="#6BBEEA"
          d="M495.192 215.706c-19.568.22-39.1-1.662-58.68-1.029-6.773.219-13.578-.294-20.303.976l-.021-1.951c1.549-.906 3.248-.472 4.873-.474 25.387-.027 50.775-.027 76.162-.018 1.012.018 1.986.087 1.957 1.481-1.047 1.448-2.613.853-3.988 1.015z"
        />
        <path
          fill="#7BD4F4"
          d="M499.174 172.69c-7.273 2.111-14.709.533-22.057.946-2.027.114-1.672-2.238-2.928-2.944l.004-7.005c.42-.312.838-.326 1.254.004.248.711.299 1.396-.264 1.998-.363 2.589.408 3.482 3.354 3.844 6.105.749 12.092-.788 18.133-.224 1.912.179 1.219-2.173 2.504-2.618v5.999z"
        />
        <path
          fill="#7ACBF0"
          d="M446.182 163.69c5.816 0 11.646-.237 17.445.091 3.441.194 5.551-.812 6.539-4.088l.006 7.994c-5.545 2.134-11.07-.864-16.645-.064-2.26.325-4.623-.078-6.689 1.402-1.214-1.75-.412-3.608-.656-5.335z"
        />
        <path
          fill="#91A4B6"
          d="M398.242 240.823l-2.07-.315c.008-.231.014-.463.021-.695l107.34-.078c-1.85 1.666-4.117.961-6.197.966-33.031.075-66.062.091-99.094.122z"
        />
        <path
          fill="#7CD5F5"
          d="M440.18 176.691c-1.148-2.133-2.621-3.212-5.354-3.089-6.203.281-12.428.089-18.645.088l.006-3.002c6.057-.558 11.922 1.544 18.031 1.122 4.285-.297 6.641-1.468 5.957-6.125 0-2 0-3.999-.002-5.999-.449-.682-.811-1.42-1.316-2.063-2-2.121-4.629-1.316-7.049-1.569-5.197-.543-10.613 1.4-15.617-1.354 3.707-2.107 7.725-.731 11.588-.949 4.451-.252 8.928-.059 13.393-.059.984 3.664.686 7.329.012 10.995.182 4.045-.07 8.053-1.004 12.004z"
        />
        <path
          fill="#88DBFE"
          d="M420.241 207.713c.451 2.83 2.703 1.941 4.328 1.943 24.861.03 49.725-.003 74.586-.022 0 .365.002.731.004 1.098l-82.971-.034.992-3.007c1.02.008 2.039.016 3.061.022z"
        />
        <path
          fill="#77BEE9"
          d="M440.17 157.683l.006 2.003c-6.074.001-12.146-.01-18.219.011-1.988.007-3.979.11-5.766-1.006l.018-1.008c1.07-1.577 2.32-2.58 4.463-2.522 5.297.141 10.604.14 15.9-.002 2.018-.054 3.044.763 3.598 2.524z"
        />
        <path
          fill="#6ABEE7"
          d="M416.196 216.711l78.979-.014c-.135.909-.436 1.301-1.576 1.294-22.195-.143-44.393-.182-66.588-.329-2.365-.017-4.578.487-6.824 1.013-1.542-.226-3.667.735-3.991-1.964z"
        />
        <path
          fill="#83D7FE"
          d="M499.172 227.682l-.018 1.053c-1.068.651-2.258.432-3.402.433-25.393.011-50.785.012-76.178-.001-1.143-.001-2.338.241-3.387-.474.861-1.626 3.191-.38 4.027-2.059a3.171 3.171 0 011.857-.436c23.311.193 46.621.013 69.932.102 2.455.01 5.05-.47 7.169 1.382z"
        />
        <path
          fill="#68BCE4"
          d="M416.188 228.693l82.969.041c.006.307.004.613-.008.919l-82.957.032a10.94 10.94 0 01-.004-.992z"
        />
        <path
          fill="#67BCE7"
          d="M416.192 231.702l82.949.029c-1.297 1.545-3.076.957-4.66.959-24.549.035-49.096.035-73.645.003-1.584-.002-3.365.579-4.644-.991z"
        />
        <path
          fill="#87DAFE"
          d="M498.182 213.672l-81.994.028-.004-1.011 81.998.026c.293.212.393.424.295.637s-.197.32-.295.32z"
        />
        <path
          fill="#8ADFFB"
          d="M507.18 173.688c.148 1.349-.451 2.867.896 3.942.059 2.35.117 4.7.178 7.05l-.131 3.004c-.637.628-.299 1.623-.859 2.28-.426.17-.783.079-1.078-.272-.852-.14-1.832-.461-1.84-1.354-.068-8.648-.041-17.298.469-25.98 2.814 3.427-.178 7.926 2.365 11.33z"
        />
        <path
          fill="#8AE1FE"
          d="M499.11 193.693c-1.123-1.442-2.729-.967-4.16-.968-17.604-.008-35.207.021-52.811.042-1.65.603-3.301.678-4.955.008a27.605 27.605 0 00-.957-.062c-.162-.03-.371-.009-.479-.103-.193-.167-.324-.404-.48-.611 1.27-.103 2.541-.293 3.811-.295 13.805-.021 27.625.364 41.408-.197 5.605-.229 11.129.385 16.688.182 4.996-.184 1.967 4.802 4.258 6.686 1.09.896-1.281 1.075-2.248 1.315a6.198 6.198 0 01-.887-1.361c-.491-1.679-.317-3.242.812-4.636z"
        />
        <path
          fill="#6BBDEB"
          d="M420.221 219.74l77.971-.081.963 1.011c-6.828 1.266-13.805.883-20.66 1.172-17.863.754-35.779.285-53.676.235-.994-.003-1.988-.063-2.955-.338a4.015 4.015 0 01-1.645-1.083 15.54 15.54 0 01.002-.916z"
        />
        <path
          fill="#68BCE8"
          d="M421.184 226.715a17.493 17.493 0 01-.969-.081l.006-.878c1.744-1.691 3.969-1.459 6.104-1.463 17.068-.031 34.156-.493 51.197.212 7.189.298 14.48.029 21.645 1.229-.012.305-.021.61-.029.916-1.029.781-2.23.514-3.367.515-23.73.014-47.461.014-71.189.002-1.146 0-2.337.226-3.398-.452z"
        />
        <path
          fill="#82D7FD"
          d="M499.167 225.735l-78.947.021-.039-1.062c1.734-1.768 3.994-1.387 6.105-1.393 16.918-.045 33.838-.037 50.756-.01 2.139.003 4.357-.218 6.143 1.398 5.314.565 10.776-1.163 15.982 1.046z"
        />
        <path
          fill="#78CAF8"
          d="M421.18 220.713l77.975-.044c-5.203 2.173-10.658.453-15.965 1.035-1.787 1.6-4 1.381-6.133 1.384-16.549.026-33.098.062-49.645-.039-2.244-.013-5.089.903-6.232-2.336z"
        />
        <path
          fill="#79CCF8"
          d="M421.184 226.715l77.953-.064.035 1.031c-24.268.003-48.537.02-72.805-.021-1.747-.001-3.697.659-5.183-.946z"
        />
        <path
          fill="#77BFE9"
          d="M499.159 158.683l-.979 1.009c-1.463 1.16-3.141.713-4.729.531-6.063-.694-12.029.65-18.053.774-.861-.612-.686-1.467-.539-2.313.406-2.023.936-4.017 3.574-3.927 6.9.236 13.869-.957 20.693.945l.033 2.981z"
        />
        <path
          fill="#81D5FE"
          d="M421.18 220.713c1.486 1.604 3.436.944 5.182.948 18.943.051 37.885.038 56.828.042-.006.33-.01.659-.014.989-1.414 1.181-3.127.982-4.775.983-19.143.019-38.287.019-57.43 0-1.648-.001-3.359.199-4.779-.975.855-1.642 3.18-.389 4.027-2.045l.961.058z"
        />
        <path
          fill="#7ACEF8"
          d="M483.184 224.691l-63.004.004c-1.375-.153-2.949.478-3.988-1.008.729-.496 1.559-.479 2.391-.48 20.732-.002 41.467-.002 62.199 0 .832 0 1.66-.015 2.391.477l.011 1.007z"
        />
        <path
          fill="#68BCE6"
          d="M483.172 223.683l-66.98.004a13.48 13.48 0 010-.985l66.984-.009c.014.33.012.66-.004.99z"
        />
        <path
          fill="#84C4D6"
          d="M400.162 197.662c-2.789.948-3.889 3.655-5.672 5.616-.982 1.083-1.6 2.406-3.291 2.443-2.469-2.908-.484-6.413-1.293-9.543-.061-1.627-1.066-3.386.609-4.789 3.949-.206 6.244 3.313 9.664 4.302l-.017 1.971z"
        />
        <path
          fill="#85DFFC"
          d="M418.182 178.692l21.998-.004c.049 2.762-1.555 4.214-3.977 5.017-.262-.053-.523-.106-.785-.156-2.703-.822-5.486-.385-8.234-.527-1.758-.091-3.625.196-5.002-1.332.026-2.813-3.18-1.314-4-2.998z"
        />
        <path
          fill="#84DAFC"
          d="M499.167 198.663l.018 1.027c-19.279.001-38.559.02-57.84-.027-1.742-.004-3.701.677-5.16-.985h1.01c1.393-.815 2.922-.439 4.391-.456 18.59-.212 37.184.366 55.773-.304.669-.024 1.274.323 1.808.745z"
        />
        <path
          fill="#81BBCE"
          d="M400.18 195.691c-4.156 1.267-5.941-2.801-9-4.003-.338-.25-.512-.588-.549-1.003.064-.408.256-.744.574-1.009 3.977-2.693 6.588-1.975 10.988 3.027-.67.997-1.341 1.993-2.013 2.988z"
        />
        <path
          fill="#7BDEF8"
          d="M398.164 177.705l-1.967-.019c-.34-.288-.672-.587-1-.893-1.107-1.675-2.297-3.278-3.971-4.458a3.75 3.75 0 01-.783-1.183c-.379-1.209-.393-2.417-.008-3.627.189-.476.477-.883.852-1.232 1.545-.892 3.08-1.873 4.891-.597.668 4.003 3.32 7.677 1.986 12.009z"
        />
        <path
          fill="#91ECFD"
          d="M396.178 165.697l-4.982.987c-.135-.196-.268-.392-.404-.588-.129-.769.131-1.384.732-1.865 1.422-.82 3.139-.735 4.58-1.505 6.557-3.426 9.252-8.7 7.768-16.031-.258-1.277-.662-2.598.045-3.885.408-.326.826-.337 1.252-.037l1.012.923c2.893 8.692.126 18.721-10.003 22.001z"
        />
        <path
          fill="#8BE1FC"
          d="M441.184 164.688l-.012-10.995c.799 2.496 3.068-.945 4.008.992 2.006 2.328.713 4.665.018 7.001l-.006 9.001-.012 3.003c-2.123-3.371-.471-7.099-1.002-10.62-.277-1.847.766-3.977-1.25-5.672-1.826 2.226.481 5.343-1.744 7.29z"
        />
        <path
          fill="#7ACDF1"
          d="M475.188 158.684c0 .668 0 1.335-.002 2.003.838 1.005.852 2.008-.01 3.007-.326-.001-.654-.003-.982-.007-.033-9.988-.027-10.18 9.859-9.908 5.021.138 10.186-1.325 15.08.949-6.463 1.036-12.975.393-19.451.337-2.947-.025-4.096 1.042-4.494 3.619z"
        />
        <path
          fill="#82A2C1"
          d="M396.193 239.812l-.021.696c-10.307.14-20.611.281-30.917.424.002.001-.117-.307-.117-.307-.096-.196-.189-.394-.285-.59l.42-.504 27.914.059 3.006.222z"
        />
        <path
          fill="#70BCE3"
          d="M475.188 158.684c-.363-2.883.68-4.137 3.801-4.045 6.709.196 13.43.078 20.145.089.021.325.021.649-.006.975-.863.332-1.15 1.995-2.311 1.389-5.738-3.006-11.869-.564-17.74-1.428-2.524-.372-2.67 1.925-3.889 3.02z"
        />
        <path
          fill="#71BCE1"
          d="M440.17 157.683c-1.051-.71-1.65-2.022-3.246-2.004-5.449.066-10.902.104-16.352-.012-1.895-.041-2.598 2.05-4.363 2.016l-.018-2.982c6.73-.004 13.461.023 20.191-.03 2.158-.017 4.068.064 3.788 3.012z"
        />
        <path
          fill="#68BEEF"
          d="M493.549 183.318h-13.668c4.494-2.067 9.07-1.473 13.625-1.479l.043 1.479z"
        />
        <path
          fill="#6ABFEE"
          d="M450.907 183.024c4.518-1.45 9.055-1.505 13.623 0h-13.623z"
        />
        <path
          fill="#85DFFC"
          d="M436.204 183.705c.123.701 1.504 1.825.729 1.822-4.73-.014-9.52.909-14.186-.486-.293-.087-.381-.857-.566-1.31 4.66-1.649 9.326-1.57 13.996-.045l.027.019z"
        />
        <path
          fill="#69BFE7"
          d="M436.176 183.686l-13.996.044c-.998-.681-1.033-1.361.002-2.041 3.414.007 6.83-.016 10.244.034 1.545.023 3.438-.472 3.75 1.963z"
        />
        <path
          fill="#70BCE1"
          d="M470.155 155.677c-.322.009-.646.014-.971.016-2.209 1.939-4.924 1.56-7.484 1.441-5.014-.231-10.109.884-15.041-.829-.633-.398-.795-.941-.488-1.624 6.451-.005 12.902-.045 19.354.012 1.577.014 3.356-.585 4.63.984z"
        />
        <path
          fill="#9CE0FB"
          d="M506.186 189.692l.994.005c1.076 3.91.203 7.9.486 11.842-.189 2.722.418 5.482-.398 8.173l-.145 3.974c-.305.469-.615.45-.932.012l-.005-24.006z"
        />
        <path
          fill="#A1D8F5"
          d="M506.192 213.697l.932-.012.086 12.992c-.318 1.69.588 3.627-1.016 5.061l-.002-18.041z"
        />
        <path
          fill="#89DBF1"
          d="M406.162 183.729c-4.281-2.467-5.439 1.96-8.139 4.17-.344-3.164 2.928-4.606 2.176-7.211 1.739 1.501 4.916.183 5.963 3.041z"
        />
        <path
          fill="#85DDFB"
          d="M420.213 203.708l-.023 1.034c-1.342 1.011-2.676 1.019-4-.033.51-3.676 2.094-3.035 4.023-1.001z"
        />
        <path
          fill="#6CC0E7"
          d="M416.19 204.708l4 .032-.008 1.932-3.998.011.006-1.975z"
        />
        <path
          fill="#7ACBF0"
          d="M446.17 154.681l.012 1.015c1.092 1.329.908 2.66.004 3.991l-.008 2.007-.98-.008-.018-7.001c.33-.003.66-.004.99-.004z"
        />
        <path
          fill="#85DDFB"
          d="M498.182 213.672v-.957l1.012-1.021c1.563 1.006 3.121 2.012-.014 2.996-.334-.339-.666-.679-.998-1.018z"
        />
        <path
          fill="#79B9D5"
          d="M507.268 209.711l-.039-7.998c.293-.485.582-.461.869.006l-.053 8.013-.389-.022-.388.001z"
        />
        <path
          fill="#015993"
          d="M373.288 84.613a9.304 9.304 0 01-.957.078c-.096-2.934-.191-5.868-.289-8.803-.617-1.973-.35-3.974-.189-5.974.467-.476.992-.556 1.58-.241.631.699.9 1.544 1.016 2.455-.146 4.184 1.057 8.495-1.161 12.485z"
        />
        <path
          fill="#296891"
          d="M372.219 50.807c.057.306.102.613.137.923 1.686 2.261 1.121 4.889 1.217 7.41-.1 1.401-.078 2.828-.805 4.107-.344.554-.814.695-1.41.428.295-4.288-1.727-8.732.861-12.868z"
        />
        <path
          fill="#3B80A5"
          d="M371.358 63.675c.275.003.551.003.826.001 1.73 1.971 1.512 3.996.172 6.054l-.313 6.158c-1.187-4.016-.783-8.123-.685-12.213z"
        />
        <path
          fill="#4484E8"
          d="M176.186 359.688c-.665.004-1.329.01-1.994.016a29.97 29.97 0 00-.519-.424c-.725-1.598-1.872-2.486-3.729-2.205-1.839-.023-3.671.104-5.479-.229-1.816-.334-3.11-1.24-3.072-3.274.039-2.063 1.43-2.96 3.238-3.085 4.636-.323 9.281-.348 13.911.021 3.845 1.469 7.71 2.841 11.967 2.12.789-.134 1.077.594 1.355 1.196.303 2.233-.459 4.333-.809 6.487-.358 1.184-.72 2.367-1.525 3.348-.43.334-.873.332-1.324.041-3.942-.84-7.601.93-12.632 2.375 4.57-4.287 4.57-4.287 2.6-6.389-.663-1.7-1.326-1.676-1.988.002z"
        />
        <path
          fill="#2567DD"
          d="M188.207 363.699c.319-.01.638-.021.957-.035 8.623 1.512 17.392.004 26.064 1.332 2.836.436 4.09 1.51 4.781 3.928.06.256.117.514.174.77-1.257 1.354-1.748 6.406-4.445.922-.093-.189-.616-.352-.843-.268-7.059 2.629-13.816-2.311-20.921-.789-2.398.514-4.843.465-6.848 2.119a21.972 21.972 0 011.081-7.979z"
        />
        <path
          fill="#4484E8"
          d="M156.185 361.695c-1.999-.674-4.96 1.592-6.013-1.969 2.545-2.301 5.669-1.258 8.553-1.393 3.467-.162 6.948-.059 10.422-.025 1.194.025 2.395.025 3.548.414a7.177 7.177 0 011.482.963l.015.016c-1.103 4.307-3.356 6.627-8.212 5.219-.75-.217-1.481.104-1.737-.934-.735-2.979-2.35-2.975-4.129-.984-2.5 2.797-2.013-2.752-3.929-1.307z"
        />
        <path
          fill="#4386DB"
          d="M176.186 359.688c.138-1.816-.357-3.75.816-6.098 1.729 2.311.945 4.297 1.174 6.096l-1.99.002z"
        />
        <path
          fill="#3992F9"
          d="M110.241 371.662l-.034-3.965 1.973-.004c-.15 1.567-.697 2.938-1.939 3.969z"
        />
        <path
          fill="#216EE6"
          d="M216.18 381.682l-29.996.006c-.16-4.131 1.839-6.049 5.956-6.012 6.225.057 12.482.395 18.666-.111 5.194-.426 5.841 2.099 5.374 6.117z"
        />
        <path
          fill="#2567DD"
          d="M224.088 381.633c-.632.023-1.265.049-1.898.072.244-4.004 2.874-8.01-.012-12.012.063-.254.127-.51.188-.766 1.794-4.113 2.12-4.281 4.363-2.244-.833 3.637 1.354 7.424-.563 11l.004-.004c-1.147 1.079-.649 3.024-2.082 3.954z"
        />
        <path
          fill="#2567DD"
          d="M222.179 369.693h-1.995l-.002-.002c-1.061-2.225-1.693-4.248 1.995-4.236 1.238 1.408 1.032 2.82.007 4.234l-.005.004z"
        />
        <path
          fill="#047EB0"
          d="M57.217 139.747c.297-.025.595-.031.893-.018l-.091 9.921c-.281.018-.562.026-.842.025-1.562-1.693-1.286-3.818-1.385-5.858.003-1.522.344-2.927 1.425-4.07z"
        />
        <path
          fill="#149CCD"
          d="M57.056 160.716c-1.517-1.225-3.138-2.002-5.129-1.199-.492.199-1.13 1.098-1.416-.016-.132-.516.422-1.206.666-1.817-.29-1.96-1.275-3.814-.899-5.883a4.23 4.23 0 01.561-1.28c.328-.353.7-.644 1.116-.882 2.33-1.258 3.524-.159 4.191 2.026.255 3.022-.615 6.157.91 9.051z"
        />
        <path
          fill="#12A7D4"
          d="M56.146 151.666c-1.108-1.21-2.24-2.319-3.978-.983-2.123-1.777-2.475-4.048-1.847-6.595.632-3.216 3.821-2.985 5.847-4.33l1.048-.011-.043 3.948c-1.286 1.85.244 4.153-.971 6.014l-.056 1.957z"
        />
        <path
          fill="#2696C8"
          d="M56.203 149.708c.274-2.013-.806-4.244.971-6.014l.003 5.981-.974.033z"
        />
        <path
          fill="#179CCE"
          d="M366.198 305.705l-.088 1.955c-1.025.955-1.092 3.095-3.291 2.607-2.018-.448-2.785 1.094-3.682 2.403-2.498-1.25-4.646 1.04-7.156.706-1.205-.16-2.037-.431-3.275-1.111 2.357-1.223 5.588.527 6.391-2.901.555-3.985 3.799-7.417 2.422-11.802-.02-.741.141-1.411.766-1.89 2.563.4 1.709 2.467 1.951 3.999.972 3.013 3.065 4.92 5.962 6.034z"
        />
        <path
          fill="#096CB2"
          d="M370.18 307.693c.033-1.319.73-1.973 2.029-2.022.021.311.051.619.088.928-.045 1.027-.092 2.056-.139 3.083-1.298-.027-1.941-.707-1.978-1.989z"
        />
        <path
          fill="#E653EC"
          d="M473.18 351.689c-2.643 4.147-6.691 4.428-10.998 4.002-1.129-1.397-2.715-.974-4.154-.987-11.738-.104-23.484-.428-35.215-.154-6.537.152-13.029.126-19.557-.083-1.76-.057-3.84 1.46-6.02 1.189.996-1.901 1.535-3.709-.969-4.918l-.02-1.075c2.582-3.49 6.016-2.36 9.355-1.732 1 .463 1.459 1.412 2.023 2.26 3.608 2.951 7.393 1.814 11.194.485 1.068-.284 2.152-.338 3.25-.361 13.494-.092 26.982.09 40.455-.108.51-.07 1.037-.131 1.551-.195 1.633.091 3.236.024 4.898-.237 1.537-.244 3.645-.525 4.207 1.914z"
        />
        <path
          fill="#D072F4"
          d="M406.148 311.683c-.551-3.863.965-5.123 4.971-5.066 16.137.226 32.277.081 48.418.114 1.6.004 3.373-.526 4.686.977-.203.152-.408.305-.611.459-7.238.023-14.477-.002-21.715.069-.664.105.412.839.043.283-.135-.204-.012-.326.371-.324 5.83.028 11.662-.036 17.492.037 1.521.02 3.736-.724 3.922 1.81.176 2.372-1.877 3.302-3.678 3.222-6.982-.31-13.984.173-20.953-.534-.66-.066.023.202-.459-.158-3.381-2.524-4.076 3.169-6.77 2.195-2.182-.789-3.352-3.205-6.793-1.531-3.756 1.826-8.482 1.655-12.543-.532-1.309-.704-2.686-2.054-2.264-3.581.439-1.59 2.289-.807 3.527-.887 1.404-.09 2.826-.093 4.893.053-9.915-.104-9.453-1.654-10.272 7.133-.135.84-.443 1.595-1.018 2.233-.584.271-1.1.175-1.551-.282-1.211-1.968-1.108-3.865.304-5.69z"
        />
        <path
          fill="#F683F6"
          d="M406.148 311.683l.061 6.021c-.16.169-.322.338-.48.51-1.057.616-2.334.933-3.355.484-4.852-2.131-5.217.709-4.988 4.326-.336 1.183-.275 2.693-2.139 2.621-.447-2.315.773-4.875-1.021-6.995a6.978 6.978 0 00-.09-.947c.051-2.331.104-4.663.158-6.995l1.889.983c.768.17 1.488.58 2.314.46 1.82-1.161 3.746-.896 5.686-.461l1.965-.007z"
        />
        <path
          fill="#FD86FA"
          d="M404.182 311.69c-1.27 2.857-4.652-.626-6 2-1.07-1.333-1.068-2.665-.002-3.999.854-3.493 4.033 1.358 5.088-1.418 1.535.81.646 2.268.914 3.417z"
        />
        <path
          fill="#FB8DF7"
          d="M470.18 303.692c0 1.333.002 2.665.004 3.997-3.072.277-5.111-.998-6.002-3.998l5.998.001z"
        />
        <path
          fill="#F072F3"
          d="M465.192 309.691l.006 8.988c1.113 1.219 1.104 2.522.295 3.888-.492.4-1.012.441-1.561.124-.795-.921-.98-2.045-1.088-3.198-.021-1.995-.064-3.992.076-5.989.975-1.813.381-3.961 1.223-5.804l.08.008c.791.432.932 1.182.969 1.983z"
        />
        <path
          fill="#F08CF3"
          d="M398.18 309.691c.002 1.333.002 2.666.002 3.999-1.301-.031-1.967-.698-2-1.999.033-1.299.697-1.968 1.998-2z"
        />
        <path
          fill="#ED67F1"
          d="M396.203 342.685c-.02-.325-.039-.65-.063-.975l.029-8.015c3.441-2.182 6.77-1.723 10.027.425.416.431.717.935.92 1.496.514 1.995.568 3.966-.383 5.866-3.251 2.637-6.991 1.031-10.53 1.203z"
        />
        <path
          fill="#F375F4"
          d="M395.246 325.645c1.133-.723.891-1.883.939-2.952 3.02-1.529 6.168-1.459 9.371-.755.477.205.855.525 1.15.951.791 1.687.764 3.412.244 5.157-.201.444-.496.82-.885 1.118-3.566.774-7.207.084-10.799.479l-.02-3.998z"
        />
        <path
          fill="#F06FF2"
          d="M395.268 329.643c3.365-3.314 7.27-.52 10.889-.963 1.68 2.004 1.684 4.006-.01 6.005-3.24-1.182-6.613-1.035-9.977-.989l-.902-4.053z"
        />
        <path
          fill="#E95FF0"
          d="M396.203 342.685c3.121-2.476 6.713-.273 10.01-1.004 2.258-1.936 5.014-1.521 7.637-1.53 14.309-.053 28.619.049 42.928-.059 5.766-.043 5.766-.165 5.984-5.875-.141-1.825-.008-3.652-.029-5.479.043-2.131-.268-4.352 1.502-6.053l.936.017c.707.548 1.014 1.313 1.188 2.152.387 2.949.08 5.914.17 8.864.016.491.004.99-.012 1.482-1.414 4.284 1.52 4.569 4.465 4.82 1.498.128 2.779-.947 4.293-.821 2.443 1.483 1.365 3.546.91 5.506.01.331.006.663-.01.994-3.027 3.934-7.57 3.403-11.742 3.987-6.873-1.26-13.807-.406-20.707-.566-6.096-.142-12.199-.07-18.287.001-1.375-.087-2.129.95-3.031 1.718-.434.219-.877.24-1.33.068-.891-.765-1.193-1.926-1.91-2.808-3.969-2.064-7.9-1.548-11.817.121-.402.228-.83.389-1.283.481-3.279.261-6.684-.764-9.82.961l-.045-6.977z"
        />
        <path
          fill="#FBEBFC"
          d="M109.233 259.758l1.889-3.009c3.091.642 3.823 3.782 5.874 5.527 2.327 2.831 6.023 4.808 5.803 9.237-.639 2.063-2.149 3.42-3.791 4.67-1.083.606-2.245 1.09-3.201 1.917-.752.699-1.86.822-2.567 1.596-.616 1.037-1.488 1.71-2.7 1.899-2.408-3.753-1.04-6.882 1.603-9.798 1.081-1.036 3.149-1.683 1.491-3.808-1.194-1.592-2.801-2.785-4.068-4.304-.674-1.261-1.521-2.511-.333-3.927z"
        />
        <path
          fill="#E970F0"
          d="M122.285 271.704c-.38-4.137-4.465-5.773-6.112-9.055.062-2.368 1.854-1.905 3.128-1.669 2.241.417 4.542.404 6.746 1.014 1.733.43 3.335-.146 4.948-.655.449-.041.848.084 1.197.367l-.055 13.936-.967-.957c-.375-.337-.485-.875-.787-1.205-.367-.401 1.356-3.264-1.269-1.155-.341.273-.956.083-1.433-.064-1.308.208-.554-4.151-3.027-1.35-.668.64-1.369 1.171-2.369.793z"
        />
        <path
          fill="#BB26DB"
          d="M113.153 284.67c.027-.313.061-.624.101-.935 6.302.01 12.604.02 18.906.028.861.884.882 1.862.33 2.901-3.088 1.765-4.667-3.135-7.369-1.489.629.332 1.789-.254 2.699.276 1.184.69 1.33 1.846 1.039 3.057-.264 1.102-1.075 1.943-2.15 1.528-4.533-1.75-10.051-1.038-13.556-5.366z"
        />
        <path
          fill="#E65FEE"
          d="M122.285 271.704l1.888-1.009c.382.319.669.708.853 1.173.353 1.19.335 2.388.049 3.586-.347 1.192-1.156 1.967-2.258 2.474-.823.284-1.618.613-2.13 1.384-.166.131-.336.255-.507.379-1.333.038-2.666.972-3.998-.003-.589-.502-.68-1.114-.402-1.808.615-.965 1.754-1.354 2.452-2.229l4.053-3.947z"
        />
        <path
          fill="#E459F6"
          d="M122.179 277.691l2.003-1.99c.945-.748 1.133-2.277 2.584-2.505 1.566.212 2.396.843 1.419 2.499-.563 4.569-4.124 6.347-8.005 3.995v.001c.703-.63 1.229-1.437 1.999-2z"
        />
        <path
          fill="#DF63EA"
          d="M113.449 271.81c-2.109 2.923-4.405 5.791-2.911 9.786-1.75-.967-2.025-3.583-4.357-3.904l.005-3.992c2.397-.724 4.243-3.563 7.263-1.89z"
        />
        <path
          fill="#DF68EB"
          d="M128.186 275.695c-.039-1.295-.696-1.968-2-1.992-.55-.595-.595-1.256-.258-1.967.407-.328.827-.345 1.259-.05 2.873-1.053 4.945-1.043 3.983 2.998l-2.984 1.011z"
        />
        <path
          fill="#854AC3"
          d="M132.041 286.665l.119-2.9c.033-1.946.065-3.893.099-5.836 1.836 1.673-.263 4.518 1.824 6.115.08.229.137.462.171.7.329.4.529.856.602 1.371-.152 1.555-.881 2.333-2.527 1.875-.449-.365-.545-.807-.288-1.325z"
        />
        <path
          fill="#D960E5"
          d="M116.212 277.752l-.029 1.935c-.972 2.843-1.965-.963-2.942.01.196-1.109 1.09-1.537 1.952-1.995.363-.463.702-.423 1.019.05z"
        />
        <path
          fill="#E668EF"
          d="M113.449 271.81c-2.731-.565-4.211 3.684-7.263 1.89-2.809-1.045-5.122 1.662-7.874 1.04l4.943-10.01c2.074-.578 3.155.531 3.873 2.257 1.313 3.144 2.496-.231 3.749-.096 1.284-.363 2.422-.074 3.446.741 1.345.147 1.907.923 1.801 2.24-.135 1.693-1.327 1.922-2.675 1.938z"
        />
        <path
          fill="#EB78F0"
          d="M88.341 257.702c.938-2.668 1.888-1.873 2.841-.01.837.752 1.964.898 2.712.296 2.476-1.997 4.466-.986 6.446.723-.884 2.727-1.391 5.601-3.131 7.991-1.389-.481-1.176-2.909-3.194-2.611-2.544-.144-2.379 2.601-3.842 3.6-2.142-1.257-4.696.36-6.826-.979-.46-2.603 1.962-3.798 2.8-5.768.927-.946.914-2.536 2.194-3.242z"
        />
        <path
          fill="#ED7EF4"
          d="M100.34 258.71c-2.39-.229-4.752-.389-6.993.824-2.175 1.177-1.828-.771-2.166-1.843 1.506-4.519 4.36-5.184 7.78-2.249 1.409 1.21 3.732-1.882 4.23 1.279-.949.664-1.9 1.327-2.851 1.989z"
        />
        <path
          fill="#E777EE"
          d="M106.187 267.69c-.029-1.927-1.671-2.255-2.932-2.961.469-2.329 3.232-3.478 3.143-6.098 1.029-.441.867-2.584 2.295-1.991.521.217.379 2.031.541 3.117l1.014 3.766c.515.671.608 1.404.331 2.195-1.246 1.142-2.039 3.297-4.392 1.972z"
        />
        <path
          fill="#E571ED"
          d="M94.183 263.693c3.119-1.119 2.402 1.619 3.025 3.009-.286 1.547-.85 2.967-1.917 4.153l-1.118-3.168c-.985-1.333-1.204-2.665.01-3.994z"
        />
        <path
          fill="#FBEDFB"
          d="M87.181 261.675l-3.835 5.035c-1.648 1.671-1.947 2.982.434 4.497 3.319 2.111 5.538 5.006 4.363 9.343-2.184-.617-2.901-3.934-5.834-3.172-.633-2.001-2.013-3.2-4.007-3.739-.146-1.999-3.371-3.499-.958-5.913l1.782-2.161c.7-2.191 1.903-3.952 4.141-4.823l2.738-2.179c2.585.209 1.578 1.774 1.176 3.112z"
        />
        <path
          fill="#EA70FB"
          d="M94.183 263.693l-.009 3.994c-1.333-.354-2.666 1.805-4.001.003-.32-2.156.442-3.873 2.188-5.123 1.402-1.004 1.595.132 1.822 1.126z"
        />
        <path
          fill="#B627D7"
          d="M132.041 286.665l.169 1.049c1.109 2.552-.95 3.43-2.434 4.621a4.535 4.535 0 01-2.608.338c-6.635-1.344-13.398.284-20.039-.874 0 0-.093-.201-.095-.202.441-3.722 2.667-5.865 6.12-6.926 4.068 1.172 7.917 3.124 12.27 3.31.775.033 1.196 1.867 2.362.696.276-.277.281-.939.23-1.404-.138-1.276-1.118-1.494-2.169-1.554-.807-.046-1.614-.08-3.646-.179 4.388-1.647 7.167-.619 9.84 1.125z"
        />
        <path
          fill="#774ABC"
          d="M107.129 291.798l21.079-.069c.572.688.549 1.399.09 2.13-.759.41-1.474.382-2.132-.213-6.199-2.114-12.605-.364-18.882-1.01a2.815 2.815 0 01-.155-.838z"
        />
        <path
          fill="#ED7BF4"
          d="M126.174 262.689c-3.34 1.521-6.659-2.305-10.001-.04a15454 15454 0 00-5.05-5.899c2.375-3.966 6.01-1.263 8.982-1.448 2.686-.167 5.465 1.2 8.07-.594 1.33-1.164 2.666-1.166 4.006-.018 1.569 2.336 1.517 4.675.011 7.016a342.83 342.83 0 01-1.014-.014c-1.479 1.281-3.503-.173-5.004.997z"
        />
        <path
          fill="#EF87F9"
          d="M86.182 249.692l35.995-.005c-.245 2.114-1.821 2.003-3.338 2.003-9.771-.002-19.541-.002-29.311 0-1.517 0-3.093.112-3.346-1.998z"
        />
        <path
          fill="#E573EE"
          d="M132.181 254.69c-1.335.006-2.671.011-4.006.018-3.651-.361-4.285-3.725-5.991-6.021l.014-2.991c3.192-1.307 4.082 2.488 6.493 2.912 1.486.65 3.185.838 4.426 2.019.227 1.478-.241 2.796-.936 4.063z"
        />
        <path
          fill="#FBE4FA"
          d="M87.181 261.675c-.009-1.182.104-2.408-1.175-3.111l1.172-2.078 1.161 1.216c-.418 1.314.461 3.008-1.158 3.973z"
        />
        <path
          fill="#E17EF0"
          d="M128.209 249.67c-2.748-.201-3.3-3.722-6.012-3.976a325.72 325.72 0 01-.026-.988l5.009-.017c1.152 1.494 2.371 2.974 1.029 4.981z"
        />
        <path
          fill="#F47AF3"
          d="M83.267 260.742c-.988 1.945-2.482 3.454-4.14 4.824-1.392-1.76-2.378-3.108-5.124-1.128-2.286 1.649-3.942-1.55-5.812-2.734.17-.456.285-1.279.52-1.315 4.866-.746 9.755-1.728 14.556.353z"
        />
        <path
          fill="#629FE5"
          d="M367.208 131.723l6.969-.065 11.017.069.988.966c.305.638.162 1.154-.42 1.553-5.854 2.06-11.541-.048-17.277-.746-.828-.101-1.377-.805-1.277-1.777z"
        />
        <path
          fill="#81C0F7"
          d="M405.168 142.773l-.48-.045-.484.008c-.404.305-.832.358-1.289.125-2.492-3.573-6.965-4.454-9.975-7.332.07-.86.607-1.284 1.381-1.492 1.738.199 3.59.071 4.836 1.679l4.967 3.997c.82.804 1.576 1.632 1.059 2.921l-.015.139z"
        />
        <path
          fill="#64ACDE"
          d="M405.182 142.633c-.352-.974-.705-1.947-1.059-2.921 4.682 3.223 10 1.607 15.059 1.977l3 .003c.33.217.438.431.326.644-.111.211-.223.316-.334.316l-16.992-.019z"
        />
        <path
          fill="#69A3DF"
          d="M399.156 135.715l-4.941-1.055c-2.051-.336-3.969.501-5.963.696-.732.094-1.428-.002-2.063-.401-.33-.419-.334-.842-.014-1.267.004-.332.006-.664.006-.996 3.988-.139 7.947-.003 11.848.983 1.225.311 2.582.34 1.127 2.04z"
        />
        <path
          fill="#6BB2EC"
          d="M432.192 131.7l19.992.006c.527.52.609 1.136.4 1.813-.643 1.14-2.146 1.088-2.889 2.082-.291.724-.324 1.435.102 2.126 4.777.592 9.557.62 14.338.676 1.932.022 4.061-.346 5.465 1.611.205.931.008 1.68-.92 2.118-8.334.098-16.664-.049-24.99.085-2.354.038-4.266-.376-5.508-2.522.094-4.231-1.015-7.562-5.99-7.995z"
        />
        <path
          fill="#68B3E3"
          d="M438.182 139.695c2.617 2.037 5.658 2.063 8.785 2.024 7.402-.088 14.807-.028 22.209-.028.336-.346.672-.363 1.008.001-.002.323-.004.646-.012.968l-47.998-.008c.004-.32.008-.641.008-.96 4.078-.001 8.154.02 12.23-.013 1.569-.012 3.434.42 3.77-1.984z"
        />
        <path
          fill="#69B7EF"
          d="M452.186 133.657c-.002-.65-.002-1.301-.002-1.951l1.992-.029 21.01.026 2.998 1.936c-1.781 1.886-4.137 1.271-6.311 1.459-4.73-.01-9.463.04-14.195-.028-1.924-.029-3.972.26-5.492-1.413z"
        />
        <path
          fill="#5F99DE"
          d="M386.176 133.689c0 .321-.004.644-.01.966-3.004 3.238-6.1 6.35-10.58 7.525-7.137-.282-14.293.566-21.404-.485v-.006c-1.826-7.177-1.826-7.18-9.959-7.677-1.332-.081-2.67-.106-3.832-.906-.459-.404-.523-.863-.195-1.376l17.973-.083 9.039.075c6.209 1.754 12.571 2.025 18.968 1.967z"
        />
        <path
          fill="#6194D1"
          d="M340.196 131.73c-.008.319-.012.64-.012.959.746.745 2.883.631 2.32 1.953-1.025 2.418.662 4.764-.324 7.044l-12-.002c.035-1.286.688-1.957 1.982-1.987 2.438-1.573 5.734-2.286 6.02-6.015-.002-.653-.004-1.306-.004-1.959l2.018.007z"
        />
        <path
          fill="#1891C5"
          d="M373.288 84.613l-.063-12.934c.443-.289.865-.247 1.271.075.201.266.334.567.479.861.422.854-.053 1.825.367 2.675-.246-1.977 3.851-.606 2.631-3.472-.361-.851-.154-1.964-.143-2.968.459-2.528-1.166-5.661 2.14-7.353.807.468 1.139 1.239 1.354 2.089.342 2.19.17 4.4.223 6.597.014 2.877-.205 5.764.117 8.627.256.79.836 1.21 1.633 1.375.377.09.674.297.895.611.008.3.016.599.02.898.566.661.563 1.318-.012 1.972-3.632.391-7.399-.79-10.912.947z"
        />
        <path
          fill="#1494CE"
          d="M384.199 83.667l.012-1.972c1.986.673 4.951-1.615 5.967 1.979l-5.979-.007z"
        />
        <path
          fill="#5168C4"
          d="M126.166 293.646l2.01.027c1.075.649 1.116 2.24 2.441 2.656.805.238 1.628.408 2.402.74.8.401 1.34 1.045 1.723 1.832.16.375.272.771.352 1.167.084.372.151.755.228 1.129.142.342.302.678.51.985.807.557 1.859.68 2.533 1.46.25 1.323-.765 1.831-1.576 2.473a5.92 5.92 0 00-1.695 1.768c-.36.56-.755 1.068-1.505 1.083-3.887-6.605-11.673-5.521-17.25-8.735-.373-.077-.579-1.008-.869-.564-.346.529.425 1.007.838 1.444.3.382.516.795.67 1.246.282 1.23.256 2.404-.609 3.428-2.924.45-3.858-1.843-5.086-3.711-.981-1.492-2.024-2.938-3.078-4.379l-.051-3.965 10.028.016c2.674 1.443 5.344 1.479 8.008-.028l-.024-.072z"
        />
        <path
          fill="#5765BE"
          d="M126.192 293.717c-2.659 3.188-5.329 3.15-8.009.027 2.67-.008 5.339-.017 8.009-.027z"
        />
        <path
          fill="#536EC6"
          d="M108.206 297.695c4.315 1.013 4.052 6.592 7.975 7.996.576.485.749 1.123.694 1.846-.11.457-.342.842-.694 1.154-3.324-.474-7.077-.411-6.18-5.626.157-.912-.913-1.218-1.757-1.347l-.038-4.023z"
        />
        <path
          fill="#7FC9E3"
          d="M508.098 201.719l-.436-.015-.436.009-.047-12.017c.035-.802.186-1.55.943-2.013.041.666.084 1.333.127 2-.047 4.013-.1 8.025-.151 12.036z"
        />
        <path
          fill="#E8FDFE"
          d="M170.158 359.508c-6.662.072-13.324.145-19.985.219l-4.765-.145c-.96-.818-.768-1.609.055-2.387 4.965-1.736 10.1-.867 15.14-.738 3.272.082 6.579-.008 9.843.412.759.098 1.71.354 1.604 1.412-.109 1.059-1.25.823-1.892 1.227z"
        />
        <path
          fill="#4C7EBB"
          d="M145.278 357.799l.129 1.783c-1.598-.332-1.018-3.193-3.245-2.795-2.45 1.688-5.004 1.547-7.614.432-.55-.402-.68-.914-.391-1.533a25.1 25.1 0 00.061-.907c.874-.815 1.893-1.373 3.097-1.363 7.396.063 14.814-.788 22.178.507.585.283.905.757.958 1.405-3.226 2.745-7.16.622-10.649 1.538-1.413.759-3.218-.366-4.524.933z"
        />
        <path
          fill="#4285E8"
          d="M134.157 355.686l.107 1.121c.282.289.49.625.625 1.008.101.619.008 1.195-.366 1.713-3.405-.49-4.506-2.691-4.342-5.836 1.733-.148 2.606 1.418 3.976 1.994z"
        />
        <path
          fill="#E2FAFE"
          d="M134.523 359.527l-.126-1.689c2.534-1.014 5.075-.949 7.62-.041-1.799 3.599-5.049.92-7.494 1.73z"
        />
        <path
          fill="#93C9FE"
          d="M142.018 357.797l-7.621.041-.133-1.031 7.898-.021-.144 1.011z"
        />
        <path
          fill="#4E72D1"
          d="M116.181 308.691l.002-.999c.649-.374 1.458-.347 1.832.151 4.411 5.881 12.086 6.137 17.527 10.225 4.417.727 8.9-.187 13.31.59.526.16.988.432 1.389.801.268.509.238 1.003-.085 1.479-4.427 2.371-9.367.146-13.891 1.541-.503.41-.721.989-.894 1.59-.07.402-.172.797-.278 1.191-.116.397-.3.761-.541 1.097-.179.1-.36.196-.541.294-2.041-5.647-6.349-8.442-12.458-8.313-1.786.038-3.583-.418-5.374-.647l.002-9z"
        />
        <path
          fill="#CCDDF1"
          d="M134.182 331.69c-.014-2.22 1.554-2.168 3.097-2.159l33.886.199a2.11 2.11 0 01.313 1.792 3.26 3.26 0 01-1.481 1.149c-10.704.902-21.427.264-32.142.35-1.361.011-2.601-.405-3.602-1.387l-.071.056z"
        />
        <path
          fill="#BFCCDE"
          d="M134.205 327.518a1.69 1.69 0 00-.194-.868l.457.055c1.254-1.393 2.955-1.381 4.606-1.388 12.932-.056 25.865-.061 38.797 0 1.328.007 2.659.08 3.848.801.606.424.796.989.571 1.693-3.714 2.002-7.51 1.78-11.348.419-10.647-.129-21.295.012-31.942-.086-1.598-.014-3.336.606-4.795-.626z"
        />
        <path
          fill="#476CB5"
          d="M134.205 327.518l36.964.331c.23.183.308.367.234.553-.074.188-.148.28-.224.28-10.637-.001-21.273.031-31.909-.037-1.721-.012-3.717.744-5.065-1.127z"
        />
        <path
          fill="#4774CB"
          d="M171.179 328.682c0-.277-.004-.556-.01-.833l10.971-.281c1.143 3.508-2.045 3.66-3.818 4.508-2.419 1.157-5.132 1.776-6.91-1.336l-.248-1.01.015-1.048z"
        />
        <path
          fill="#4780E1"
          d="M134.125 351.693c-3.037-1.671-1.597-4.585-1.944-7.002l2.039.987c.739-.999 1.962-.782 3.198-1.228-1.438.413-2.424.08-3.251-.807l.033-.975c.909-.797 1.971-1.272 3.173-1.271 11.457.008 22.919-.589 34.368.312.867.434 1.737.871 1.421 2.104-1.653 1.503-3.723 1.232-5.694 1.256-6.662.078-13.326-.043-19.973.073-1.831-.045-2.134 1.66-3.03 2.69-.578.44-1.24.594-1.95.571-2.073-.334-4.145-.787-6.246-.278-.315.162-.582.39-.765.702-.121.336-.243.668-.336 1.015a6.203 6.203 0 01-.302 1.055c-.091.162-.187.319-.282.479-.153.108-.306.212-.459.317z"
        />
        <path
          fill="#4A74C3"
          d="M172.158 342.655l-37.959.015a34.538 34.538 0 01-.029-.965l.13-.146c1.817-1.587 4.048-1.231 6.167-1.246 6.458-.047 12.916-.025 19.369-.018a39.637 39.637 0 011.758.009c.854.002 1.712.018 2.568.03 1.393-.041 2.788-.003 4.184.047 1.519.337 3.58-.219 3.812 2.274z"
        />
        <path
          fill="#BED7EF"
          d="M134.166 343.644c2.59.159 7.253-1.468 7.209.964-.048 2.65-4.597.77-7.155 1.07l-.054-2.034z"
        />
        <path
          fill="#4F7ABC"
          d="M160.18 355.689c.002-.17.006-.34.012-.51-.82-2.233-2.777-1.419-4.276-1.449-5.496-.109-10.995-.012-16.492-.061-1.791-.016-3.707.408-5.229-1.038a16.36 16.36 0 00-.068-.938l.116-.028c3.275-2.373 7.03-1.048 10.568-1.322 2.46-.191 4.947.043 7.409-.204a6.12 6.12 0 011.64-.17c2.599.442 5.194.624 7.752-.277 5.123-.858 10.326.158 15.445-.672a5.73 5.73 0 001.152-.92c.37-.359.804-.602 1.299-.74.554.013.965.261 1.24.742.514 1.299.528 2.516-.583 3.546-4.935.019-9.869.027-14.804.062-1.508.01-3.169-.035-3.036 2.184.114 1.887 1.626 1.756 2.933 1.778 2.302.037 4.605.029 6.908.041.332.563.224 1.02-.323 1.375-3.29.184-6.581.066-9.873.066-.889-.133-1.514-.586-1.79-1.465z"
        />
        <path
          fill="#BFDAE4"
          d="M134.194 352.631c7.906-.068 15.812-.172 23.717-.179 1.638-.002 4.235-.441 2.28 2.726-8.658-.133-17.316-.268-25.974-.4l-.023-2.147z"
        />
        <path
          fill="#5B79A4"
          d="M134.309 338.783l.104-2.299c5.786-2.47 11.864-.601 17.776-1.209 8.481.461 17.017-.888 25.461.764.594.344.845.86.753 1.54-2.856 2.467-6.288 1.317-9.504 1.518-1.401-.028-2.808.023-4.211-.057-.824.015-1.65.027-2.476.085-1.139.129-2.197.616-3.337.758-6.632.411-13.268.144-19.899.181-1.661.008-3.34-.022-4.667-1.281z"
        />
        <path
          fill="#708EC6"
          d="M134.27 334.828l-.096-1.192c1.429-1.129 3.129-.933 4.769-.93 12.75.024 25.501-.099 38.25.048a3.413 3.413 0 011.768.567c.48.52.512 1.067.095 1.641-6.114 1.549-12.338.369-18.505.707-2.448.135-4.909-.044-7.36.092a8.127 8.127 0 01-1.746.175c-5.684-.996-11.553.865-17.175-1.108z"
        />
        <path
          fill="#416AC8"
          d="M178.061 333.55c-14.629.029-29.258.058-43.888.085.004-.314.012-.628.023-.941 9.272-1.125 18.58-.198 27.867-.476 2.828-.084 5.66-.008 8.489-.018 2.459.687 5.448-1.565 7.509 1.35z"
        />
        <path
          fill="#708EC6"
          d="M171.166 332.687l-36.97.007.056-1.06 36.896.084c.298.21.4.424.306.641-.094.219-.19.328-.288.328z"
        />
        <path
          fill="#E8FBFE"
          d="M134.27 334.828c5.975-.111 12.002-1.421 17.874.79.233.199.304.389.214.57-.088.178-.174.267-.257.267l-17.688.028-.143-1.655z"
        />
        <path
          fill="#BADBFE"
          d="M134.309 338.783l25.864-.215c1.809.062 1.547 1.126 1.104 2.279a2.107 2.107 0 01-1.633.017c-7.898-.337-15.798-.203-23.697-.069a1.943 1.943 0 01-1.625-.152l-.013-1.86z"
        />
        <path
          fill="#AABFD1"
          d="M134.321 340.642c.318.014.636.007.954-.021 8.281-.662 16.561-.732 24.84.03.315.034.631.038.947.011.309.232.401.45.281.653-.117.196-.23.295-.343.295-8.9-.017-17.801-.033-26.7-.051a3.275 3.275 0 01.021-.917z"
        />
        <path
          fill="#1D9FCB"
          d="M29.182 159.701l3.029-2.03c.366-.42.557-.982 1.049-1.298a4.298 4.298 0 011.05-.14c.568-.196.713-.71.879-1.216.169-.607.433-1.15.887-1.591 2.438.48 3.758-2.271 6.088-2.108 1.262 1.25 3.212 1.378 4.424 2.713.383 2.162-1.272 3.266-2.408 4.64-.17 1.075-.646 2.017-1.852 1.923-4.38-.338-8.892 1.231-13.146-.893z"
        />
        <path
          fill="#A4EDF6"
          d="M51.13 150.709c.085.318.098.639.038.963-1.06.775-.897 2.174-1.598 3.132-.185 1.306-.047 2.759-1.574 3.452-.92-.592-4.5 1.401-1.805-2.65 2.412-3.627.625-8.118-1.229-12.007 1.772-2.324 3.598-2.255 5.47-.128.356 2.4.209 4.85.698 7.238z"
        />
        <path
          fill="#2B9DC4"
          d="M45.311 143.855c3.11 2.12 4.239 9.084 1.498 12.187-2.361 2.672.649 1.587 1.189 2.213-1.203.794-2.537.363-3.818.416-.666-2.194 1.938-3.076 1.998-4.979a3.305 3.305 0 01-1.03-1.883 7.573 7.573 0 01-.039-2.11c1.842-2.227-1.168-2.902-1.44-4.46.134-.955.167-2.03 1.642-1.384z"
        />
        <path
          fill="#0D90BB"
          d="M49.571 154.804c-.4-1.52-.812-3.045 1.598-3.132l.008 6.012-1.606-2.88z"
        />
        <path
          fill="#10B2DF"
          d="M45.311 143.855c-.97.244-1.049 1.019-1.082 1.819a2.128 2.128 0 01-1.128.562c-2.09.437-3.772-.423-5.338-1.67-.976-.597-1.981-.675-3.015-.19-.329.248-.651.5-.947.785-.695 1.092-.789 2.585-2.161 3.221-1.277.405-2.435.25-3.421-.715l-.044-7.952 27.995.042c-.375 2.953-4.219 1.507-5 3.943-.322.487-.632.506-.929-.022-1.678-.899-3.336-1.244-4.93.177z"
        />
        <path
          fill="#0EACCE"
          d="M28.218 147.667l3.929.008c.549.383.74.941.776 1.577a2.78 2.78 0 01-.351 1.164l-.502.355c-1.107-1.255-3.835-.497-3.852-3.104z"
        />
        <path
          fill="#2E93B3"
          d="M33.341 156.384l-1.131 1.287c-.046-2.301-.092-4.602-.14-6.901l.083-.088c.989-.253 1.454.354 1.833 1.111.472 1.626.58 3.204-.645 4.591z"
        />
        <path
          fill="#10A6D3"
          d="M404.158 70.674l-.004 1.009c-.129.1-.262.292-.385.286-2.867-.147-2.936-.112-3.793 2.113-.777.256-1.496.152-2.158-.338-1.703-2.662-4.227-4.088-7.229-4.782-1.973-.456-3.791-1.267-5.164-2.761-2.27-2.469-1.498-4.676 1.975-5.928 1.539.055 3.086.08 4.492.833 1.172.054.213 2.714 2.42 1.786 2.264-.952 4.389.622 6.588 1.039 3.68.995 2.059 4.548 3.258 6.743z"
        />
        <path
          fill="#10A2D0"
          d="M387.18 61.691c-3.254.776-2.271 2.204-.707 3.938 2.393 2.649 6.08 1.937 8.973 3.625 2.141 1.25 2.924 2.256 2.736 4.437-2.666 2.163-5.332.977-8 .002-2.377-.443-3.771-2.12-5.01-3.993-.514.329-.977.267-1.389-.185-1.439-2.386-.588-5.157-1.299-7.669-.021-2.688 1.557-3.692 3.994-3.795.797.137 1.398.567 1.836 1.238.522 1.222-.31 1.81-1.134 2.402z"
        />
        <path
          fill="#D7F8FA"
          d="M408.193 80.688c-.996-.046-1.998-.041-2.988-.152-1.102-.123-2.672.172-2.859-1.333-.26-2.085 1.949-1.203 2.855-1.958.688-5.5 1.119-10.996-.332-16.453a4.311 4.311 0 01-1.012-2.178c-.043-.594.178-1.063.658-1.412 1.637-.794 3.236-.753 4.801.206.396.425.684.915.871 1.465.588 5.146.553 10.293.02 15.442-.968 2.028-1.459 4.211-2.014 6.373z"
        />
        <path
          fill="#149DCE"
          d="M390.182 73.692c2.666-1.299 5.334.759 8-.002h1.998c1.32-1.063 2.643-1.083 3.969-.012-2.85 5.214-8.016 5.527-12.854 5.225-2.149-.135-.693-3.41-1.113-5.211z"
        />
        <path
          fill="#13ABD6"
          d="M405.092 59.317c1.811 5.966 1.17 11.946.107 17.929.002-4.771.002-9.54.002-14.311l-1.043-.054v7.793c-1.877-1.63-.324-5.537-3.977-5.985-1.48-1.524-1.311-3.378-1.057-5.251.258-1.034.725-1.903 1.834-2.236.48-.054.947.024 1.396.206.884.672 1.459 1.795 2.738 1.909z"
        />
        <path
          fill="#1BA4CE"
          d="M415.178 71.704l-.002 9.977-5.021-4.023c.055-.238.107-.477.158-.716.764-1.834.4-3.839.852-5.707.406-1.68.658-3.604 3.049-3.699 1.449 1.128-.217 2.976.964 4.168z"
        />
        <path
          fill="#4197AB"
          d="M409.141 74.194l.428-16.46c2.26.865 1.729 2.918 1.982 4.641.045 5.141.311 10.303-1.369 15.289l-.027-.006c-.303.041-.605.089-.906.142-.878-1.177-.573-2.389-.108-3.606z"
        />
        <path
          fill="#10A2D0"
          d="M404.148 73.678l-3.969.012c-.75-4.781 2.133-2.362 3.975-2.007l-.006 1.995z"
        />
        <path
          fill="#1690BD"
          d="M384.188 69.634c.328.024.656.046.986.064-.016 2.57-.029 5.14-.045 7.709l-.66.488a2.248 2.248 0 01-1.121-1.159c-.543-2.463-1.061-4.926.84-7.102z"
        />
        <path
          fill="#BFF2FC"
          d="M384.191 80.797l-.488-.099-.494.054a1.094 1.094 0 01-.279-.734c.004-.27.031-.405.076-.403.678-.676 1.756-.869 2.221-1.813l-.098-.395c.896.229 2.049.219 1.969 1.576-.114 1.903-1.828 1.38-2.907 1.814z"
        />
        <path
          fill="#1BA4CE"
          d="M409.141 74.194c.035 1.201.07 2.401.107 3.604-.109 1.053.121 2.228-1.055 2.89.545-2.132-.211-4.452.948-6.494z"
        />
        <path
          fill="#0DB5E0"
          d="M410.268 61.72c-.219-1.332.301-2.793-.701-3.986l-.44-.026c-1.654-.935-3.33-.688-5.012-.095l-.031-.02c-.617.702-1.262.676-1.93.074l-.031-.059c.008-2.763-1.795-1.517-3.094-1.392a1.966 1.966 0 01-1.146-.63c-.436-1.312-.797-2.619.297-3.812 4.771-.023 9.545.057 14.313-.108 2.764-.095 3.834.919 3.729 3.712-.178 4.766-.107 9.541-.141 14.313-.303.671-.602 1.341-.902 2.012-1.441-1.062-.855-2.627-.998-4.011-2.32-3.345-.043-7.324-1.357-10.483.158 1.214.391 2.751.307 4.294-.068 1.226.236 3.049-1.568 3.027-1.518-.018-.4-2.046-1.295-2.81z"
        />
        <path
          fill="#0EACDC"
          d="M372.268 59.655l.086-7.926c4.615.009 9.23.018 13.845.025.939 1.111 1.119 2.333.539 3.662-1.061 1.496-2.721 1.461-4.273 1.545-1.555.085-2.771.539-3.346 2.099-1.031 1.896-3.265 1.811-4.789 2.904-.41.127-.818.116-1.223-.024-.573-.652-.245-1.638-.839-2.285z"
        />
        <path
          fill="#09B5DD"
          d="M386.197 55.641c0-1.296 0-2.592.002-3.887l11.98.021c.08 1.306.957 2.611 0 3.917-.533.477-1.24.69-1.801.342-2.609-1.619-3.672-.223-4.326 2.102-1.129.663-2.299.656-3.5.241-1.159-.587-1.966-1.482-2.355-2.736z"
        />
        <path
          fill="#F58BFA"
          d="M128.209 249.67l-1.029-4.98c1.032-.311 2.07 1.093 3.102-.009l2.875 2.785-.04 3.16c-1.741.216-3.394-.01-4.908-.956z"
        />
        <path
          fill="#6CBDF3"
          d="M470.184 141.692l-1.008-.001c.004-.666.006-1.331.008-1.997 1.574-1.661 3.658-1.364 5.615-1.384 6.314-.062 12.627-.021 18.939-.033 3.391.303 6.898-.652 10.176.924.816.748.918 1.578.271 2.488l-34.001.003z"
        />
        <path
          fill="#78BBF2"
          d="M504.186 141.689l-.006-2.002c-.58-.522-.559-1.124-.23-1.766.338-.336.732-.407 1.176-.248l1.059.021c-.198 1.566.685 3.673-1.999 3.995z"
        />
        <path
          fill="#3D1E83"
          d="M281.215 330.763l1.998 2.954a9.26 9.26 0 00-.041.927c-3.854 3.143-8.059 5.82-11.866 9.026-.864.728-1.776 1.583-3.106 1.028-1.989-2.451-3.983-.858-5.976-.009-.449-.802-1.199-.985-2.036-.989-1.71-2.084-3.424-3.815-4.365.492-.505 2.311-2.305 1.468-3.547 1.409-2.045-.096-4.028-1.251-6.26.042 1.305-3.192 4.957-.752 6.647-3.492-4.349-1.224-8.612.445-12.718-.996-1.291-.453-2.84 1.924-3.764 3.527-3.466.427-6.27-.877-8.647-3.309-.696-1.646-.683-3.254.266-4.808 3.247-2.598 6.502-2.729 10.575-1.397 5.806 1.896 11.94 2.185 17.805-.479 1.051-1.464 2.619-.858 4-1 3.334 2.412 6.438 1.251 9.496-.614 1.591 1.068 2.992-.343 4.502-.347 2.522-.025 4.734-1.16 7.037-1.965z"
        />
        <path
          fill="#2D1478"
          d="M228.16 341.648c2.83.6 5.475 1.689 8.022 3.035l1.988 1.016-3.989 1.991c-2.997.657-4.729-1.29-6.505-3.154-.394-1.055-.373-2.042.484-2.888z"
        />
        <path
          fill="#3F2388"
          d="M228.194 344.702c2.398.189 3.792 2.391 5.987 2.988l2 2.005c-.152 2.374.553 4.913-1.37 7.227-1.688-1.393 1.454-8.184-4.602-4.246-3.8-2.014-4.135-3.339-2.015-7.974z"
        />
        <path
          fill="#5F39A0"
          d="M268.2 344.699c4.896-3.49 8.938-8.256 14.972-10.054-1.23 1.352 1.207 2.695.01 4.047-6.011.848-9.061 5.743-13.104 9.355-1.094.977-3.029 2.326-4.896.645l3.018-3.993zM289.182 340.692c3.305.308 7.938-1.245 7 4.999-2.379-1.604-5.602-2.023-7-4.999z"
        />
        <path
          fill="#6944A9"
          d="M300.18 357.693c.539 2.043 2.771 3.52 2.004 5.998l-4.002-2c-2.492.666-3.938-1.299-5.662-2.381-6.461-4.055-7.178-4.053-12.887.928-1.889 1.393-3.285 2.885-2.879 5.613.346 2.314-.646 4.117-3.346 4.346a1.734 1.734 0 01-1.227-.506l-.993-4.004c2.362-5.018 3.667-10.612 7.96-14.573 3.674-3.391 7.618-2.895 11.415-.444 3.33 2.149 6.419 4.668 9.617 7.023z"
        />
        <path
          fill="#482FA0"
          d="M272.181 369.691c.326.012.65.021.977.029 1.654 1.756 1.866 3.768 1.061 5.961l.987 1.998c-2.709 1.119-1.883 5.18-4.974 5.982-1.348-4.133-2.403-8.389-5.047-11.973l.075-1.051c1.289-2.336 3.024-1.104 4.389-.313 1.286.748 2.227 1.854 2.532-.633z"
        />
        <path
          fill="#3841AC"
          d="M228.194 344.702c.151 2.79-.955 5.897 2.015 7.975.962 4.593-2.544 8.49-2.024 13.015-1.157 2.67-1.846 5.34-.002 8.01-.207 1.563.684 3.68-2.015 3.982l-.043-11.979c-1.916-2.346-1.24-5.139-1.35-7.795-.166-2.622.069-5.243.02-7.864-.035-1.146-.093-2.292-.009-3.438a373.151 373.151 0 01-.042-6.774c.109-1.938.056-3.88.073-5.82.023-1.915-.134-3.858.779-5.652.968-1.267 1.825-.737 2.658.168l-.034.091c1.802 2.693 1.909 5.383-.014 8.07l-.045 4.957.033 3.054z"
        />
        <path
          fill="#6C4BAD"
          d="M279.181 359.691c4.676-5.833 6.565-6.148 12.805-2.1 2.078 1.348 4.131 2.732 6.195 4.1-.428 2.365.666 4.223 2 6-.666.002-1.332.002-2 .002-1.992.166-3.328-1.07-4.777-2.152-5.535-4.139-7.555-3.668-11.051 2.359-.73 1.26-.932 2.826-2.173 3.789-.823-.018-1.569-.193-1.999-1-2.078-3.884-1.515-7.531 1-10.998z"
        />
        <path
          fill="#3841AC"
          d="M224.088 381.633c.025-1.67.317-3.201 2.084-3.953-.172 1.593.713 3.744-2.084 3.953z"
        />
        <path
          fill="#775FBC"
          d="M290.18 381.691c.182-1.563-.666-3.803 1.424-4.283 1.428-.328 2.291 1.658 3.387 2.633 1.438 1.275 1.168 3.004 1.191 4.65.211.451.514.885.619 1.361.473 2.131 1.189 4.805-1.734 5.314-2.605.455-4.172-1.857-4.73-4.201-.417-1.737-.13-3.644-.157-5.474z"
        />
        <path
          fill="#6F50B1"
          d="M280.18 371.689c-.646-4.068 2.236-7.043 4.376-9.361 2.334-2.527 6.316-.461 8.74 1.436 1.611 1.262 3.527 2.303 4.885 3.93 0 1.334 0 2.666-.002 3.998-1.338.055-1.914-1.141-2.857-1.734-9.594-6.039-7.693-3.609-13.141 4.732l-2 1.002-.001-4.003z"
        />
        <path
          fill="#6848AF"
          d="M279.181 359.691c-.771 3.627-1.275 7.277-1 10.998l-3.964 4.992c-.39-1.98-1.367-3.857-1.06-5.961 1.566-.803 3.416-1.625 2.566-3.811-1.409-3.624.784-4.997 3.458-6.218z"
        />
        <path
          fill="#A18DDD"
          d="M230.172 185.698l-3.971-2.025-.002-.001c-.78-.556-1.649-1.026-1.987-2.019l-2.986-5.978c1.718.124 3.213-.196 3.965-1.994l7.971 10.029c.055 2.245-1.333 2.318-2.99 1.988z"
        />
        <path
          fill="#A594E3"
          d="M230.172 185.698l2.99-1.987 5.011 3.01c1.629 2.106 3.027 4.493 6.003 4.974l.001.001.988 1.015c.029 1.725-.821 1.681-1.992.99-4.423-2.522-9.55-3.901-13.001-8.003z"
        />
        <path
          fill="#9F83DA"
          d="M261.126 183.609l-.939 2.074-5.011-1.94-6.061-4.922 1.051-.145 1.006-.011.115.121c3.573 1.01 6.84 2.642 9.839 4.823z"
        />
        <path
          fill="#7456BC"
          d="M260.163 177.676c-1.637-.02-3.273-.038-4.909-.059l-4.082-3.916 1.007-1.011c2.834 1.387 6.656 1.188 7.984 4.986z"
        />
        <path
          fill="#8166C7"
          d="M260.163 177.676l-7.984-4.985.013-1.029c.673-.595 1.333-.55 1.981.041l-.004-.002c2.849 3.114 6.588 1.698 9.996 1.965-.478 1.706-1.817 2.778-2.95 4.002l-1.052.008z"
        />
        <path
          fill="#A689DA"
          d="M254.173 171.703l-1.981-.041-3.032-2.949c-1.311-1.486-4.202-2.024-3.012-5.014l1.882.021 2.144 1.992c1.022 1.333 2.716 1.26 4.052 1.937l.008-.017-.061 4.071z"
        />
        <path
          fill="#8E73D0"
          d="M246.147 163.699c-.043 2.301 2.347 3.139 3.013 5.014-3.033-.312-3.829-2.847-4.989-5.019l1.976.005z"
        />
        <path
          fill="#FCABA1"
          d="M149.184 166.694c1.227-1.441 3.278-2.052 4.021-3.982.341-.285.668-.271.982.045.348 2.058-.415 3.664-2.005 4.935l-2.998-.998z"
        />
        <path
          fill="#F8B2AE"
          d="M163.132 175.595l-3.981 3.081c-1.758-5.013 2.51-2.24 3.981-3.081z"
        />
        <path
          fill="#C6B2F6"
          d="M180.223 207.639c-.011.333.033.679-.042.997-.384 1.618.985 4.497-1.411 4.584-2.662.097-1.237-2.809-1.562-4.393-.353-1.717.637-3.71-1.089-5.143-.266-.222-.352-.44-.26-.657.091-.216.182-.324.272-.324.39-1.085-.744-2.989 1.039-3.19 1.479-.167 2.766 1.049 2.918 2.74.16 1.786.099 3.59.135 5.386z"
        />
        <path
          fill="#8873CC"
          d="M176.129 202.704c.042.327.038.654-.011.981-2.232 1.993.862 4.001-.016 5.999-1.011.947-.737 2.453-1.5 3.485-.371.502-.968.884-1.559.193-.504-.591-.264-1.174.11-1.729l-.039-3.999.041-.764c-.186-3.075-.506-6.15-.063-9.233.357-.985.553-2.15 2.05-1.91.394 2.316-.792 4.856.987 6.977z"
        />
        <path
          fill="#937DCE"
          d="M175.142 195.727c-.799.43-.938 1.183-.978 1.985-.508.32-.953.249-1.335-.215-.502-1.28-.203-2.518.207-3.748l.166-1.039 1.94 3.017z"
        />
        <path
          fill="#DC8078"
          d="M154.186 162.756a5.374 5.374 0 00-.982-.046l-1-.981 2.028-2.025 2.049.021-1.151 2.94c-.316.016-.63.046-.944.091z"
        />
        <path
          fill="#857DC1"
          d="M163.152 184.651a32.2 32.2 0 01.055-.933l1.093-1.851c1.734 1.717.485 3.904.924 5.824l-.127 3.942c-.299.034-.6.05-.9.047-.084-2.382.366-4.844-1.045-7.029z"
        />
        <path
          fill="#C9B8ED"
          d="M172.178 205.687h-1.997c-.251-2.039.217-4.03-.913-6.138-1.246-2.325 1.057-3.193 2.905-3.853 1.021 3.331 1.848 6.66.005 9.991z"
        />
        <path
          fill="#CBB8FE"
          d="M172.178 205.687l-.004-9.99a1655 1655 0 00.863-1.948c.085 1.298.172 2.594.259 3.89.562 3.36.688 6.717-.071 10.067l-.11-.07c-.788-.422-.911-1.162-.937-1.949z"
        />
        <path
          fill="#B3A2F2"
          d="M176.167 223.672c-.767 3.798.758 4.553 4.007 3.019.042 4.258-1.937 8.009-3.006 11.988-1.835-.751-2.062-2.306-2-4.004.519-3.65-1.088-7.494.999-11.003z"
        />
        <path
          fill="#8C7BDC"
          d="M167.108 227.635l1.021-2.953 3.972-8.097c1.778-1.805 2.478-.574 3.027 1.076-1.453 2.59-2.736 5.299-4.438 7.714-.752 1.069-1.263 3.348-3.582 2.26z"
        />
        <path
          fill="#8B79D6"
          d="M175.129 217.662c-.51-1.763-2.125-.414-3.026-1.075l.064-2.899c.329-.685.659-1.368.987-2.054.237.404.207 2.236.936.343.441-1.146.557-2.193 2.013-2.292l.015 3.993c-1.355 1.073-.791 2.623-.989 3.984z"
        />
        <path
          fill="#9D89F3"
          d="M168.189 231.806c-.208.318-.434 1.097-.868 1.238-.903.294-.967-.597-1.052-1.21-.091-.656.012-1.401.739-1.575.934-.223.922.641 1.181 1.547z"
        />
        <path
          fill="#AA89CE"
          d="M254.225 167.648c-1.601-.123-3.674.745-4.051-1.937 1.662-.007 2.97.728 4.051 1.937z"
        />
        <path
          fill="#2B37A0"
          d="M274.181 143.691c-1.999.113-.646 4.693-4 3.002l-.002-.002c-1.838-1.303-4.151.249-6-.997-2.118-1.478-3.35-3.545-4.001-6.001.61-3.426-1.154-6.618-.99-10 2.703.149 4.446 1.679 5.678 3.944.458 4.159 2.67 6.579 6.908 7.104 1.653.204 3.632.319 2.407 2.95z"
        />
        <path
          fill="#2A3799"
          d="M264.18 145.694c2.001.321 4.246-.817 6 .997-2.002-.326-4.246.81-6-.997z"
        />
        <path
          fill="#DC48D8"
          d="M166.187 116.697c-.146-1.429.346-2.937-.812-4.769-1.705 4.697-4.425 3.802-7.336 1.597 2.979-3.707 6.099-5.869 10.231-1.332.493.542 1.836.309 2.785.435 3.324-.198 4.637 1.035 3.077 4.316-2.658.262-5.32.62-7.945-.247z"
        />
        <path
          fill="#ED59CA"
          d="M178.181 101.689v3.998l-.528.441c-1.587.479-3.832-.288-4.296 2.29-.427.975-.374 2.397-2.04 2.235-3-3.021-3.757-5.822.799-8.098 2.011.82 2.011.82 2.066-2.86l3.999 1.994z"
        />
        <path
          fill="#E44ED5"
          d="M171.316 110.654c1.059-.76.824-1.9.872-2.959 1.565-1.961 4.318-.355 5.991-1.994l.001-.014c.311.003.621.01.931.02l.028 5.981c-.313.006-.625.01-.938.012-2.293 1.86-4.587 1.265-6.88-.001l-.005-1.045z"
        />
        <path
          fill="#E245D8"
          d="M171.321 111.699l6.88.001-.025 1.983c-1.367.952-.646 2.965-1.994 3.928l-1.988.035c-.357-.205-.479-.415-.367-.631.113-.218.228-.327.345-.327.396-2.454-1.317-3.29-3.115-4.061.067-.315.154-.625.264-.928z"
        />
        <path
          fill="#BFA5EE"
          d="M224.212 181.653l1.987 2.02c-1.027-.234-2.297.659-3.045-.538-.124-.197.682-.973 1.058-1.482z"
        />
        <path
          fill="#B59EED"
          d="M288.211 232.613c-1.32 1.777.93 2.389 2.004 4.277-4.121-2.027-7.551.319-11.385-1.582 2.243 4.646 2.167 5.32-3.093 4.724-9.845-1.118-19.906-.303-29.877-.359-3.056-.018-6.406.739-8.115-3.17-.492-1.125-1.945-1.001-3.046-.188-7.102 5.235-10.321 4.441-14.449-3.515-.214-.413-.686-.693-1.038-1.035 4.786-3.344 10.534-3.684 15.936-5.104 3.294-2.313 7.093-1.853 10.787-1.965 3.914.168 7.78-.83 11.703-.483a2.104 2.104 0 011.547.499c1.307 1.521 3.1 1.038 4.67.933 3.384-.229 6.76-.831 11.018 2.171-1.283-2.798-3.011-3.783-2.705-5.628.205-1.241.335-2.39 1.898-2.373 1.866.021 1.465.774.996 2.211-.773 2.37 1.443 1.45 2.475 1.639 2.856.523 5.959-1.008 8.645 1.029-2.393 2.175-5.262.77-8.236 1.004-.331-.047.497.896.304.257 3.491-.421 5.543 2.431 8.323 3.641.988.765 2.013 1.515 1.638 3.017z"
        />
        <path
          fill="#6B59B7"
          d="M289.168 201.551l4.898.188c2.648.81 3.734 2.299 2.152 4.947l-.105 3.87c-.357 4.579-2.873 5.8-7.195 5.125-4.205-.656-8.498-.751-12.752-1.093a1.21 1.21 0 01.293-1.218c1.336-.958 2.996-.603 4.437-1.11.357-.189.716-.382 1.054-.606.295-.281.596-.555.881-.849.701-.776 1.35-1.639 2.559-1.595 1.48.221 2.125 1.882 3.607 2.083.57.021 1.117-.046 1.566-.456.627-1.646.463-3.31.211-4.952-.129-.3-.338-.55-.631-.716-.004.021-.492-.021-.492-.021s-.479.104-.48.125c-.816.491-1.588 1.101-2.637.865-1.174-.462-1.848-1.291-1.922-2.572.113-1.074.705-1.788 1.666-2.227.978-.139 1.958-.289 2.89.212z"
        />
        <path
          fill="#7F43A4"
          d="M240.188 213.519c-4.818.038-9.636.081-14.454.109-.662.003-1.609.205-1.943-.145-3.438-3.596-1.013-8.049-1.598-12.085-.462-3.191 1.979-2.761 3.985-2.635.318.284.42.632.316 1.036-.321 1.579 1.289 1.044 1.848 1.667.318.338.548.723.718 1.148.688 2.18.053 4.513.805 6.671 2.25 2.015 4.672 1.289 7.094.467.733-.538 1.42-1.146 2.314-1.421.498-.022.923.146 1.293.472.569.854.69 1.803.615 2.797-.105.757-.459 1.385-.993 1.919z"
        />
        <path
          fill="#8E79D7"
          d="M288.211 232.613l-2.002-1.951c.328-1.784-.299-3.948 1.969-4.965 2.025.277 4.254-.72 6.057.965-.484.027-.98-.004-1.447.099-.367.081-1.166.352-.371.772 4.863 2.576 1.59 4.821-.223 7.141-1.407-.534-2.299-2.059-3.983-2.061z"
        />
        <path
          fill="#4F3BA5"
          d="M304.186 221.691l-1.691-2.401c-.236 1.323-.428 2.405-.619 3.487-.182-.043-.361-.087-.541-.131-.09-1.719-.178-3.438-.266-5.159l.105-7.798.908-3.173c.98 1.087.586 2.304.516 2.688-.186-.63.568-2.119-.416-3.515-.021-.929-.119-1.863-.031-2.781.041-.43-.336-1.47.709-1.123.307.102.314 1.104.461 1.694 1.771 6 .466 12.146.865 18.212z"
        />
        <path
          fill="#8050A5"
          d="M226.186 199.688c-.002-.309-.005-.616-.009-.925l11.011-.261a1.654 1.654 0 011.462-.002c1.853.494 4.626-.041 3.826 3.423-.651.977-1.576 1.494-2.724 1.649-3.738-.919-7.815.389-11.376-1.711l-.259-.203c.573-1.848-1.516-1.088-1.931-1.97z"
        />
        <path
          fill="#9682DE"
          d="M288.178 225.697c-.367 1.77.236 3.924-1.969 4.965l-10.436-5.97h10.409c.812.042 1.564.205 1.996 1.005z"
        />
        <path
          fill="#BAA1F3"
          d="M214.182 209.689c.192-1.805-.461-3.749.847-5.866 1.509 1.65 1.321 3.979 3.152 4.869v7.733c-2.074-1.541-6.703.623-6-4.734.382-.953 2.798.129 2.001-2.002z"
        />
        <path
          fill="#764DA2"
          d="M240.188 213.519l.049-1.95c3.321-1.569 6.864-1.07 10.349-1.119a10.6 10.6 0 011.477.146c.481.071.956.185 1.423.315 2.808.807 5.627.642 8.454.082a5.274 5.274 0 012.25.088c1.001.374 1.909.858 2.306 1.946.012.603-.276.973-.864 1.107-1.567-.042-3.163.328-4.685-.336-6.92-.092-13.84-.186-20.759-.279z"
        />
        <path
          fill="#9982D4"
          d="M258.158 224.667l-12.03.969c-4.966-1.087-10.02.572-14.981-.474-1.076-.227-2.815.823-2.948-1.409l29.963-.04c.341.213.454.426.34.638-.114.21-.228.316-.344.316z"
        />
        <path
          fill="#8E76D3"
          d="M228.199 223.752c3.494 2.006 7.297.432 10.917.945 2.335.331 4.878-.878 7.012.938-3.66.342-7.32.684-10.98 1.024-3.667-2.286-8.589.48-11.966-2.973l5.017.066z"
        />
        <path
          fill="#BFA2F1"
          d="M238.22 198.782l-1.032-.278a73.513 73.513 0 01-.008-.812l7.003-.003c5.333-1.972 10.666-1.397 15.998.004l-2 1.567c-4.619 2.773-9.501.573-14.236.558-1.799-.006-3.872-.371-5.725-1.036z"
        />
        <path
          fill="#7658A8"
          d="M260.947 213.798l5.229-.118c1.082-.979 2.39-1.287 3.803-1.292 1.901.041 3.841-.204 5.628.731.193.192.385.389.576.585-.002.296-.008.591-.018.886-5.076-.185-10.211.745-15.218-.792z"
        />
        <path
          fill="#C3A1F4"
          d="M220.177 208.692c.044-1.093-.177-2.272.993-2.99v7.25c-1.615-1.47-.701-2.979-.993-4.26z"
        />
        <path
          fill="#BCA4ED"
          d="M234.18 197.689c-.362-.498-.725-.995-1.086-1.493 1.391-.85 2.783-.848 4.175-.001l-1.086 1.493-2.003.001z"
        />
        <path
          fill="#A891E1"
          d="M258.158 224.667c.013-.318.015-.637.004-.954h5.854l.042.998h-4.873l-1.027-.044z"
        />
        <path
          fill="#C3A1F4"
          d="M221.168 203.676c-1.502-1.998-1.5-3.993.013-5.984l-.013 5.984z"
        />
        <path
          fill="#B7A0EE"
          d="M214.182 209.689c1.96.261 2.613 1.714 1.557 2.985-1.302 1.568-2.087-1.506-3.558-.983.033-1.301.702-1.966 2.001-2.002z"
        />
        <path
          fill="#A995EF"
          d="M220.189 275.672l-1.032-1.963c1.786-1.63 5.751-.942 5.285-4.969 1.114.039 2.42-1.479 3.186-.419 2.149 2.977 4.339.949 6.547.419 1.199-.674 2.311-.185 3.278.433 5.365 3.425 11.398 5.39 17.104 7.947.272-.002.522.131.704.381.137-.328-.007-.456-.474-.394-2.716-1.245-5.535-2.154-8.156-3.503-1.387-.714-3.25-1.233-2.383-3.528.892-1.135 2.158-1.583 3.5-1.611 9.082-.191 18.164-1.449 27.25-.054 1.156.178 2.265.395 3.256 1.097.173.124.473 1.696.945.184.42-1.344.836-2.776 2.592-2.127 1.602.593 1.777 2.239 1.885 3.754.049.668-.115 1.315-.281 1.96-.402 1.306-1.199 2.33-2.256 3.166-2.895 1.902-5.618 4.103-8.897 5.382-4.467 1.586-8.439 4.476-13.285 5.081-1.04.107-2.081.143-3.125.14-4.895-1.019-9.281 1.62-13.987 1.954-7.442-1.22-13.559-4.839-18.629-10.342l-.007.011c-1.225-.78-2.39-1.62-3.02-2.999z"
        />
        <path
          fill="#8A74D7"
          d="M244.177 270.692c3.665 2.66 7.677 4.629 11.983 6.01.251.898.063 1.37-.981 1.013-7.464-1.908-14.52-4.772-21.003-8.975-3.441-2.202-6.642-4.676-9.074-8.021.591-1.382-.623-3.69 2.055-4.001l.078-.066c5.641 4.686 11.694 8.878 16.942 14.04z"
        />
        <path
          fill="#8D79DC"
          d="M227.157 256.718c-2.217.548.959 3.862-2.054 4.001-5.582-2.249-7.528-7.792-10.904-12.038 2.825.284 4.535 2.329 6.579 3.951 1.227.975 2.385 2.622 4.424 2.041.937.409 1.603 1.077 1.955 2.045z"
        />
        <path
          fill="#796AD2"
          d="M219.22 244.631c1.175 1.085 1.765 2.461 1.995 4.015-2.578.063-3.398-.945-4.034-4.956.902-.168.67 2.121 2.039.941z"
        />
        <path
          fill="#D56E7F"
          d="M253.172 76.745l.03 5.789c-1.424-1.923-1.416-3.853-.03-5.789z"
        />
        <path
          fill="#8571D9"
          d="M223.217 278.66c4.46 2.129 8.1 5.649 12.761 7.457 1.688.655 3.21 1.768 5.147 1.601 1.668.773 3.511.652 5.254 1.032 1.152.25 2.307.623 1.804 2.256-1.868 2.15-4.373 1.674-6.752 1.581-1.406-.056-2.806-.875-4.203.036-2.674-1.044-5.641-1.278-8.093-2.934-1.879.458-1.275-1.37-1.902-2.064l-2.154-2.852c2.141-2.591-.645-2.907-1.854-3.474-2.272-1.065-.537-1.774-.008-2.639z"
        />
        <path
          fill="#8571D9"
          d="M220.189 275.672c1.331.673 2.342 1.667 3.02 2.998-1.451-.55-4.138.142-3.02-2.998z"
        />
        <path
          fill="#5960B9"
          d="M130.102 291.606c-.094-1.729 2.301-2.11 2.108-3.893 1.309-.039 1.937-.755 2.013-2.021 1.719-.927 3.579-.459 5.366-.463 19.056-.039 38.111-.01 57.167-.047 1.791-.003 3.648.439 5.375-.448.326-.03.652-.051.979-.063l.151.038c1.314.821 2.302 1.925 2.933 3.35.691 1.492 1.126 3.008.418 4.625-.517.898-1.251 1.745-2.251 1.816-8.263.592-16.548 1.163-24.805.226-2.686-.305-3.476-1.805-.38-3.624-12.718.076-25.251.207-37.773-.078-3.703-.084-6.996 2.305-10.713 1.165-.196-.192-.392-.388-.588-.583z"
        />
        <path
          fill="#50559F"
          d="M202.132 284.735c-1.484 1.616-3.435.923-5.173.927-20.912.05-41.824.031-62.736.031a3.476 3.476 0 01.03-.95l67.879-.008z"
        />
        <path
          fill="#E07584"
          d="M254.207 77.691c1.366-.133 2.554-3.549 4.137-.213.155.327.893.75 1.053.647 5.091-3.249 9.797 2.846 14.817.587-1.2 3.339-5.022 3.236-7.095 5.425a12.445 12.445 0 00-2.339 2.171c-.993 1.839-2.971 2.34-4.563 3.366-1.346.396-2.704-1.784-4.044.017a337.17 337.17 0 01-.966-.227c2.703-4.182-1.482-7.779-1-11.773z"
        />
        <path
          fill="#E88084"
          d="M280.173 87.707c-.001.328.002.655.011.982-1.723 2.404-.293 5.597-2.002 8.004-1.491.679-3.054.285-4.59.307-1.882-1.344-3.035-3.601-5.414-4.327-.021-.826-.208-1.567-1.017-1.991-.147-1.867 1.356-1.8 2.502-2.153 2.597-.511 5.562.874 7.8-1.52a3.104 3.104 0 011.236-.607c.857.022 1.031.816 1.474 1.305z"
        />
        <path
          fill="#EE8D8A"
          d="M256.18 99.693l2.003-.005c.666-.591 1.331-.591 1.997 0 .857.026 1.615.244 2.054 1.072.6.305 1.286.427 1.833.848 1.771 1.497 3.779 2.471 6.098 2.77 1.213.207 2.466.313 3.323 1.372.139 3.682-2.582 2.291-4.176 2.101-4.444-.532-8.668-2.315-13.197-2.512-2.489-1.91-1.133-3.777.065-5.646z"
        />
        <path
          fill="#E36B73"
          d="M268.179 92.672c4.199-1.92 3.994 2.683 5.981 4.038.281.45.258.884-.067 1.302-2.243 1.612-5.304.201-7.489 2.036a4.509 4.509 0 01-1.405.435c-.779.027-1.458-.209-2.011-.77.436-3.217 2.371-5.372 4.991-7.041z"
        />
        <path
          fill="#EE9090"
          d="M256.18 99.693l.021 5.017c.682 1.379.585 2.834.42 4.299-1.938 1.582-3.89 3.058-6.27.704l-.092-2.032c1.559-2.538 1.631-5.807 3.92-7.987l2.001-.001z"
        />
        <path
          fill="#F18D88"
          d="M254.18 99.693c-.179 3.216-1.143 6.048-3.921 7.988l-.05-8.999c1.521-.436 3.342-2.054 3.971 1.011z"
        />
        <path
          fill="#683B73"
          d="M260.216 89.674c.68-2.041 3.131-2.318 4.077-4.096.746-.422 1.52-.551 2.339-.229 3.261 2.27 7.682-.495 10.784 2.474-1.82 2.763-4.584.756-6.834 1.352-2.192.185-4.436-.321-6.583.487l-3.783.012z"
        />
        <path
          fill="#E7898E"
          d="M260.18 99.688h-1.997c.244-1.16-.592-2.638.997-3.474 1.59.835.753 2.314 1 3.474z"
        />
        <path
          fill="#C686B2"
          d="M263.999 89.663c1.887-1.426 4.058-.942 6.161-.916.341.199.457.402.347.608-.11.208-.221.312-.334.312-1.095.067-2.292-.171-3.01 1.015l-3.164-1.019z"
        />
        <path
          fill="#B37183"
          d="M263.187 99.713l2.074.037c.309.388.417.829.352 1.317-.511 1.031-1.226 1.397-2.267.693l-1.111-1.002.952-1.045z"
        />
        <path
          fill="#F59F94"
          d="M250.353 109.712c2.152.841 3.96-.277 5.833-1.026 3.654-.006 3.011 3.543 4.458 5.371.201.437.342.892.456 1.357.25 1.453.309 2.888-.458 4.23-.687.71-1.58 1.043-2.491 1.339-2.908-.277-4.285-2.544-5.879-4.528a1.035 1.035 0 00-.177-.753c-1.278-1.01-1.018-2.764-1.916-3.957l-.041-.054a7.447 7.447 0 01.002-.933l.213-1.046z"
        />
        <path
          fill="#C8A9CE"
          d="M245.189 110.707l.035-5.972c1.466 2 1.282 3.989-.035 5.972z"
        />
        <path
          fill="#954F6E"
          d="M281.021 73.785c.025.34.053.679.078 1.019-3.647.528-7.291.746-10.918-.151a33.287 33.287 0 00-.072-.775c1.728-1.191 3.718-1.106 5.678-1.163 1.417.063 2.814.213 4.071.96.388.035.775.073 1.163.11z"
        />
        <path
          fill="#227FCE"
          d="M279.859 73.673l-3.423-.003c-1.245-1.032-3.017.104-4.236-1.03.755-1.164 1.984-.874 3.077-1.006 1.781.113 3.579.182 4.582 2.039z"
        />
        <path
          fill="#4E4DB5"
          d="M227.233 287.625l1.902 2.064-.017 12.071c.904 1.144 1.355 2.435 1.292 3.897-.164 1.356-.275 2.75-1.896 3.254-.297-.141-.756-.344-.74-.562.633-8.404-7.021-8.569-11.65-11.729-1.999-1.351-4.813-1.798-5.347-4.781 2.683-3.775 7.784-3.894 11.184-.207 1.429-.452 1.029-2.318 2.218-2.945-.01-3.303 2.57.822 3.054-1.062z"
        />
        <path
          fill="#504BB1"
          d="M224.18 288.688c-.093 1.138-.038 2.314-.333 3.396-.191.702-.809 1.678-1.388 1.798-.978.202-1.867-.476-2.156-1.572-.925-3.506-2.318-3.717-4.304-.682-.649.993-1.315.695-1.74-.268-1.384-3.138-2.057.197-3.079.33-3.769.071-4.714-3.055-6.247-5.517.9-1.371 2.034-1.189 3.246-.489 2.616.002 5.247.187 7.843-.038 3.277-.283 6.086.286 8.158 3.042z"
        />
        <path
          fill="#4E43A6"
          d="M208.181 285.685c-1.097.045-2.281-.172-3 1.004.311.233.412.464.304.692-.106.227-.213.34-.319.34l-1.906-3.011 4.919.026c.002.317.002.633.002.949z"
        />
        <path
          fill="#B8A4F2"
          d="M260.181 197.693l-15.998-.004V194.7c1.918-.936 3.213 1.285 5.005.989 3.65.012 7.318-.187 10.944.114 2.186.183 2.338 1.185.049 1.89z"
        />
        <path
          fill="#B19AE7"
          d="M249.189 195.689c-2.112 1.915-3.313-.782-5.005-.989l-1.009-1c.814-.029 1.562-.19 1.993-.99l4.021 2.979z"
        />
        <path
          fill="#F6989B"
          d="M280.173 87.707l-1.051-1.115c-.814-.644-.582-2.524-2.391-1.988-.456.11-.9.177-1.358.236-.999.127-1.991.166-2.991.186-2.142-.144-4.444.473-6.224-1.331 2.177-2.482 5.375-3.313 8.054-4.981 3.985.401 8.12-1.064 11.975.956l-.27 3.329c-2.396.587-1.293-2.718-3.545-2.386.362 2.637-1.03 4.826-2.199 7.094z"
        />
        <path
          fill="#BF7EA1"
          d="M270.181 74.652l10.918.15c1.445-.061 2.951-.402 4.109.882-4.998-.501-10.148 1.215-15.027-1.032z"
        />
        <path
          fill="#02529F"
          d="M272.2 72.64c1.453.167 3.042-.228 4.233 1.03l-6.323.206a8.313 8.313 0 01-.888-.266 4.326 4.326 0 01.019-.924l2.959-.046z"
        />
        <path
          fill="#CF3FD4"
          d="M174.171 116.688l.022.958-6.002.095c-.673-.038-1.347-.076-2.021-.116.008-.31.013-.619.016-.928l7.985-.009z"
        />
        <path
          fill="#D744E1"
          d="M176.182 117.611c.171-1.56-.633-3.614 1.994-3.928l-.034 3.935-1.96-.007z"
        />
        <path
          fill="#FAAEA3"
          d="M258.12 120.737c.426-.833 1.198-1.037 2.037-1.119.892-1.637.803-3.278.025-4.924l-.003-.005c-.731-1.565-1.421-3.482.297-4.471 1.888-1.085 4.181-2.371 6.474-1.002 2.563 1.53 5 2.317 7.995 1.123 1.494-.595 3.004.34 3.657 1.877.976 2.294-.951 2.76-2.421 3.454l.928 2.899c-.342.34-.75.528-1.232.551-1.806-.146-3.616-.248-5.43-.2-1.901.017-3.845-.268-5.604.789-.205.058-.411.109-.617.162l-5.878 1.752c-.417-.103-.589-.269-.519-.497.081-.258.177-.389.291-.389z"
        />
        <path
          fill="#2242A5"
          d="M264.188 133.687l-4.999-3.995c-1.732-5.022 2.33-7.074 5.037-9.82l.048-.364c.61-.446 1.282-.722 2.044-.755.993-.017 1.989-.053 2.906.436.844.6 1.38 1.363 1.284 2.454-1.802 2.52-5.01 3.849-6.004 7.059-.762.64-1.341-.27-2.272-.401.938.521 1.593.979 2.378 1.188 1.014.832 1.456 1.875 1.217 3.18-.297.74-.706 1.3-1.639 1.018z"
        />
        <path
          fill="#243188"
          d="M250.181 133.69c-1.736-.093-2.71-1.402-3.274-2.672-.556-1.251.965-1.968 1.768-2.652.511-.435 1.752-.663 2.253-.341 1.78 1.145-.437 1.77-.531 2.714-.098.981-.146 1.969-.217 2.953l.001-.002z"
        />
        <path
          fill="#21388D"
          d="M258.12 120.737c.065.299.141.594.228.887-4.417 1.089-5.712-1.492-6.077-5.168 2.518.651 3.471 3.439 5.849 4.281zM250.179 111.746c1.014 1.137 1.765 2.401 1.916 3.957-2.403-.066-1.378 2.664-3.416 3.832-.936-3.096 2.154-5.222 1.5-7.789z"
        />
        <path
          fill="#15379C"
          d="M248.144 121.776c.638.06 1.424.035 1.419.92-.004.875-.783.9-1.424.907-.647.006-1.425-.029-1.42-.907.006-.865.775-.876 1.425-.92z"
        />
        <path
          fill="#7952AB"
          d="M238.22 198.782l19.962.48c1.336.162 2.672.327 4.007.492 2.587 1.281 5.321.031 7.957.457.46-.007.87.141 1.234.42.213 1.325-.814 1.966-1.528 2.783-.49.458-1.055.771-1.728.866-1.499-.091-3-.264-4.507.029a6.58 6.58 0 01-1.395-.101c-3.441-.514-6.853-.081-10.271.271-3.25-.948-6.793-.87-9.771-2.771.028-2.8-3.07-1.369-3.96-2.926z"
        />
        <path
          fill="#A18DDE"
          d="M287.158 183.665c.188 1.572.697 2.985 2 4.001-.598 3.522-3.281 5.281-5.957 7.047-1.178.634-2.068.699-2.043-1.038l6-10.01z"
        />
        <path
          fill="#AA96E4"
          d="M281.158 193.674c.441.816 1.207.997 2.043 1.037-1.09 2.774-4.298 2.979-6.03 4.974-.688.535-1.369.533-2.043-.022 1.217-2.795 3.914-4.098 6.03-5.989z"
        />
        <path
          fill="#C1A7EF"
          d="M244.177 191.694c.315-1.26-.812-3.217 1.308-3.566.964-.159 2.604.557 2.46 1.799-.252 2.173-2.481 1.181-3.766 1.769l-.002-.002z"
        />
        <path
          fill="#775AB6"
          d="M271.277 200.602c-2.985-.759-6.281 1.813-9.088-.849l8.834.021c.348.095.5.249.46.462-.046.244-.114.366-.206.366z"
        />
        <path
          fill="#C0A7ED"
          d="M276.148 187.776c.638.06 1.42.037 1.416.921-.005.873-.781.902-1.422.906-.646.005-1.423-.031-1.418-.908.006-.862.774-.874 1.424-.919z"
        />
        <path
          fill="#AE92F6"
          d="M271.277 200.602a7.978 7.978 0 00-.252-.828l4.104-.111c.681.008 1.361.016 2.043.022l1.039.87c-1.586 1.791-3.574 1.483-5.584 1.075a4.083 4.083 0 01-1.393-.983l.043-.045z"
        />
        <path
          fill="#B7A0EE"
          d="M296.219 206.687c-.035-1.945.107-3.968-2.15-4.948 1.914-1.032 3.441 2.804 5.572.497.072-.079.506 1.365.521 2.152.014.803.059 1.584-1.178 1.642-.929.044-1.843.426-2.765.657z"
        />
        <path
          fill="#775AB6"
          d="M272.166 200.669l6.045-.113 5.807.248c.398.623.279 1.122-.357 1.5-2.691 1.21-5.532.766-8.313.624-1.39-.071-3.136-.093-3.182-2.259z"
        />
        <path
          fill="#C0A7ED"
          d="M306.182 187.69c.162 0 .34-.041.488.007 1.246.405 2.986-.941 3.754 1.002.107.273-.426 1.15-.666 1.152-1.586.01-3.391.204-3.576-2.159v-.002z"
        />
        <path
          fill="#402E94"
          d="M302.182 205.69c1.74 1.484.719 3.267.264 4.986l-.363-4.159a1.067 1.067 0 01.099-.827z"
        />
        <path
          fill="#A991E6"
          d="M284.35 201.571c-.102-.26-.211-.516-.33-.768 1.748.018 3.604-.688 5.148.748l-2.988.141c-.651.573-1.266.628-1.83-.121z"
        />
        <path
          fill="#BDA4F1"
          d="M261.126 183.609c-4.113.091-6.666-3.001-9.839-4.823 1.609-.048 3.223-.021 4.822-.161 3.685-.324 5.533 1.12 5.017 4.984z"
        />
        <path
          fill="#7760CC"
          d="M305.198 225.71l-.029-2.005.021-10.005c1.131 2.279 2.262 4.559 3.434 6.917 1.174-.461.123-2.648 1.891-2.702 2.256-.069 1.119 2.495 2.52 3.195 2.414-.784-.02-3.836 2.188-4.822 1.752 1.115.432 3.096 1.242 4.424.545.891 1.34 1.533 2.428 1.24.646-.174 1.137-.817.766-1.539-.676-1.316-2.707-2.987-.426-3.854 1.262-.479 2.904 1.688 3.455 3.534.123.412.287.812.467 1.313l2.975-2.713c.418.78 1.129 1.007 1.947 1.033l.271.606a3.623 3.623 0 01-.561 1.198c-.949 1.244-1.986 2.408-3.201 3.405-2.008 3.479-6.543 2.417-9.088 5.042-.496.511-1.68-.141-2.078-.865-1.898-3.455-4.492-1.745-6.967-1.034-.999-.481-.517-1.746-1.255-2.368z"
        />
        <path
          fill="#69C1F2"
          d="M328.292 216.743c2.465 2.988 6.402-.851 8.914 1.923-1.801 2.371-4.422 3.688-6.814 5.295a1.819 1.819 0 01-1.236-.226c-1.383-1.073-.031-2.828-.99-4.013l-.088.005c.069-.995.141-1.989.214-2.984z"
        />
        <path
          fill="#95D7FA"
          d="M327.118 169.711l.057-8.019c2.129 4.058.668 8.403.949 12.605.256 3.791.047 7.613.043 11.422a61.322 61.322 0 01-.955-.072l-.078-5.969c-.007-3.321-.01-6.643-.016-9.967z"
        />
        <path
          fill="#F6B2A7"
          d="M264.147 128.663c.133-3.931 2.966-5.56 5.988-7.027 3.008-2.043 5.354-.183 7.764 1.303.347.34.558.756.613 1.239-.073.372-.259.571-.552.596-.112.009-.223.031-.334.047 2.356 1.943 5.563 1.088 8.102 2.456 1.176 2.853-.254 3.642-2.805 3.541-4.952-1.448-6.956 3.661-10.733 4.824-.309.354-.688.462-1.137.328a25.547 25.547 0 01-4.861-1.812c-.55-.441-.699-1.091-.891-1.718.314-1.2-.672-1.86-1.136-2.737-.338-.226-.454-.454-.347-.688.109-.235.218-.352.329-.352z"
        />
        <path
          fill="#2938A3"
          d="M265.302 132.44l1.006.893c1.136 2.14 3.508 1.403 5.205 2.238.243-.14.469-.116.678.07-.494 1.179-3.095 1.877-1.252 3.517 1.229 1.095 3.329 1.023 4.625-.052 1.146-.951 1.926-1.953 3.668-1.946 4.651.017 6.131 2.205 4.95 6.527-3.333 2.591-6.667 2.597-10 .004-.164-1.064-.764-2.24-1.799-1.869-4.633 1.655-6.096-2.96-9.041-4.521-1.982-1.051 1.486-2.136.847-3.613l1.113-1.248z"
        />
        <path
          fill="#F3B0A0"
          d="M282.924 130.817c1.143-.775 3.025-1.048 2.158-3.185-.338-.783.414-1.304.467-1.997.045-.368.145-.717.289-1.058a2.59 2.59 0 01.791-.776c.182-.044.363-.085.547-.125 1.096.35 2.605-.122 3.037 1.539 1.283 2.356.703 4.918.816 7.403l-.418 1.179c-3.457 2.966-3.457 2.966-6.66-2.034-.342-.315-.683-.631-1.027-.946z"
        />
        <path
          fill="#E9B4B3"
          d="M283.951 131.763c.619.11 1.756.154 1.779.342.506 3.925 2.93 2.104 4.879 1.693l-.314 1.893-2.469 2.829c-4.006-.697-3.18-4.162-3.875-6.757z"
        />
        <path
          fill="#2C79CB"
          d="M282.152 120.661c1.613.127 3.189 1.476 4.848.154.795.908.84 1.862.176 2.861l.064.114c-1.547.704-3.102 1.347-4.807.477-1.009-1.128-2.836-2.198-.281-3.606z"
        />
        <path
          fill="#E3C2D4"
          d="M291.029 132.619c-1.619-2.317-.545-4.933-.816-7.4.361.434.723.869 1.084 1.306.561 1.755.609 3.505-.049 5.249a3.6 3.6 0 01-.219.845z"
        />
        <path
          fill="#B895A5"
          d="M291.248 131.773l.049-5.248c.279.075.549.175.811.298-.143 1.676.566 3.498-.86 4.95z"
        />
        <path
          fill="#FBA89E"
          d="M276.181 115.67c.621-1.14 3.032-1.778 1.318-3.566-1.325-1.384-2.184-1.064-3.824.555-1.588 1.567-4.486-.789-6.589-1.501-4.146-1.403-6.585-.623-6.908 3.531-2.293-1.361-1.275-4.925-3.994-6.003-.911-1.329-.928-2.655.017-3.977 4.083-1.694 7.508 1.318 11.297 1.539 1.834.106 4.192 2.574 5.588-.778-.146-.463-.023-.822.406-1.067 3.641-.778 1.832-5.402 4.729-6.704 4.1.337-.174 4.701 2.827 5.724 1.469-2.078.877-4.62 1.443-7.377 2.496 3.111 1.633 6.863 3.561 9.563l-.002 1c-6.114.294-5.072 5.234-5.846 8.995l-4.023.066z"
        />
        <path
          fill="#513D67"
          d="M269.18 119.777l-3.246-.094c.686-2.629 2.842-1.003 4.272-1.477 1.988.132 4.006-.303 5.971.302.305.103.615.122.932.062.643.073 1.287.146 1.929.221.13.219.251.443.361.674-3.319 2.952-6.786 1.098-10.219.312z"
        />
        <path
          fill="#384298"
          d="M269.18 119.777l10.218-.312 2.782.301c-.002.299-.012.598-.025.895-1.166 1.026.297 1.994.066 2.999-1.354 1.318-2.755 1.062-4.178.128-2.811-.073-4.915-2.742-7.907-2.152-.32-.62-.638-1.24-.956-1.859z"
        />
        <path
          fill="#EE878F"
          d="M278.222 97.699c-.608 2.224-1.301 4.428-1.805 6.675-.732 3.262-1.973 1.461-3.177.395-.944-1.512-.118-3.088-.185-4.636.04-.459.143-.904.289-1.34.221-.402.486-.775.791-1.12.012-.32.021-.642.023-.962 1.337-.957 2.68-.552 4.022-.018.016.336.028.671.042 1.006z"
        />
        <path
          fill="#6EC3F5"
          d="M340.112 219.763c2.705-1.741 3.602-4.878 5.52-7.233 1.016-1.245 1.568-2.889 3.568-2.82 2.455 3.52-.107 7.216.391 10.804.084 3.561-.457 7.147.439 10.672.158.506.262 1.026.334 1.55.043 2.531.805 4.409 3.703 4.927 1.057.189 3.162.511 1.293 2.518-4.924-.599-9.684 1.217-14.586.924-1.951-.116-3.928.048-5.744-.879-2.447-1.297-1.156-3.397-.982-5.153.193-1.938.654-3.854.842-5.802.825-3.669 2.669-6.783 5.222-9.508z"
        />
        <path
          fill="#7DBDD3"
          d="M391.18 195.69c.006 3.344.012 6.688.02 10.031l-1.012.988c-7.268.924-14.564.282-21.833.402-1.34-.083-2.064.918-2.92 1.694-.441.225-.861.199-1.256-.111-.002-.993-.006-1.986-.01-2.98-.643-2.101-2.26-3.118-4.205-3.774-1.387-2.193-1.258-4.833-2.123-7.179-.254-1.08-.131-2.181-.172-3.277.035-.451.176-.864.414-1.248.678-.7 1.453-1.089 2.451-.762a3.739 3.739 0 011.531 1.395c.547 1.752.775 2.997 3.322 3.823 8.615 2.791 17.187 1.251 25.793.998z"
        />
        <path
          fill="#72D6F7"
          d="M358.145 193.694c2.041 2.311 2.029 5.157 2.086 7.986.523.57 1.555.898.957 2.004-.578 1.954-1.988 2.09-3.781 2.051-5.633-.121-11.27-.035-16.906-.047-6.299-.014-6.301-.022-6.316-6.499-.004-1.166.004-2.332.006-3.498 5.41.574 10.699.171 15.77-2.001 2.729.026 5.459-1.803 8.184.004z"
        />
        <path
          fill="#62B6EE"
          d="M356.167 239.591c-.57-.285-1.193-.89-1.701-.804-5.191.88-5.707-2.184-5.279-6.104-.051-5.185.256-10.321 1.309-15.433.678-3.282 2.27-4.914 5.672-4.54h1.004c1.248 1.252 1.232 2.788.994 4.373-1.309 6.165-1.215 12.073 3.191 17.168 1.877.081 3.01-2.518 5.154-1.415.295.691.184 1.308-.328 1.853-2.086 1.279.334 3.407-.912 4.843.002-.001-.08.229-.08.229-3.021.561-6.034.839-9.024-.17z"
        />
        <path
          fill="#7CDCFB"
          d="M334.192 150.71c.385-2.505 2.346-2.78 4.303-2.996 1.527-.168 3.414.397 3.688-2.022a229.62 229.62 0 0132.98-.01l.02.009c1.365 1.815 1.443 3.598-.131 5.342-1.121.825-2.434 1.118-3.771 1.124-11.816.05-23.637.39-35.443-.434a6.073 6.073 0 01-1.646-1.013z"
        />
        <path
          fill="#73C8F6"
          d="M357.165 217.714l.006-5.003c1.752-.462 1.855-3.063 3.969-3.054 1.551 1.258 1.201 3.26 1.916 4.846.725 2.896 1.912 5.656 2.523 8.585.455 3.178 4.465 6.141.598 9.585-1.754.43-2.16 4.21-4.975 1.997-4.352-4.936-4.877-10.784-4.037-16.956z"
        />
        <path
          fill="#85C8D7"
          d="M364.178 208.695l.977.011c3.852 2.945 7.172 6.328 8.977 10.951l-.975 2.086c-1.088 2.19-1.648 5.006-5.152 4.324-4.236-3.23-3.686-8.798-6.266-12.842.424-1.222-1.256-3.313 1.479-3.576l.96-.954z"
        />
        <path
          fill="#71D2F4"
          d="M349.178 194.726c-4.836 2.82-9.795 3.723-14.99.965.492-3.983-1.061-8.131.969-11.989.877.418 1.363 1.203 1.873 1.969 2.611 4.949 7.603 6.704 12.148 9.055z"
        />
        <path
          fill="#70C1EB"
          d="M334.192 150.71c.33-.013.66-.017.99-.013 2.264 3.485 1.223 7.258.945 10.963-.012.147-.242.391-.219.411.287.244.57.175.838-.189 2.5-1.029 4.975-2.033 6.686 1.188.258.741.172 1.452-.178 2.139a4.909 4.909 0 01-.916 1.091c-1.652 1.158-3.309 2.32-4.092 4.311-.361.799-.795 1.555-1.393 2.206-.469.47-1.01.802-1.691.85-2.07-4.73-.547-9.701-.932-14.546-.222-2.788-.04-5.607-.038-8.411z"
        />
        <path
          fill="#58ADE5"
          d="M356.167 212.711c-6.908 2.762-4.156 9.542-5.928 14.431-.629 1.736.658 3.935-1.053 5.542-.002-.331-.004-.662-.004-.992-1.336-3.579.379-7.431-.988-11.006l1.006-10.977c2.894-.327 4.797 1.652 6.967 3.002z"
        />
        <path
          fill="#54AAE8"
          d="M340.112 219.763c-.193 3.468-3.307 5.651-3.93 8.93-2.477.007-4.49-1.249-6.551-2.394-.334-.979-.248-1.868.541-2.611 1.666-2.625 4.123-4.141 7.033-5.022l2.907 1.097z"
        />
        <path
          fill="#77DEF5"
          d="M375.163 145.682l-32.98.01c-3.32-.457-6.836 1.04-10-1 12.607 0 25.213-.026 37.818.03 1.74.008 3.691-.675 5.162.96z"
        />
        <path
          fill="#8ADFFB"
          d="M335.163 173.667l1.037-1.019c1.455 4.162.453 8.577 1.326 12.801-.373.501-.822.582-1.348.243-.801-.427-.98-1.173-1.021-1.99-1.461-3.346-1.453-6.692.006-10.035z"
        />
        <path
          fill="#70C0DC"
          d="M361.188 203.684c-.318-.668-.639-1.336-.957-2.003 3.125-.425 4.389.967 3.938 4.033-.995-.676-1.987-1.353-2.981-2.03z"
        />
        <path
          fill="#69BFE9"
          d="M363.217 209.649c-1.477 1.059-.9 2.638-1.023 4.039.277.238.365.469.26.691-.102.219-.203.328-.301.328-1.623-1.425-.713-3.358-1.012-5.049.688-.995 1.381-.991 2.076-.009z"
        />
        <path
          fill="#FAFCFC"
          d="M385.32 143.758c.678-.319 1.355-.638 2.035-.956 1.041-2.778 3.279-2.243 5.428-1.971 1.033.283 1.996.733 2.928 1.254 7.105 6.24 6.031 13.208-2.627 17.131a7.117 7.117 0 01-1.473.412c-.496.092-1 .114-1.502.091-2.574-.297-4.633-1.532-6.293-3.491a8.029 8.029 0 01-.77-1.257 10.789 10.789 0 01-1.004-3.545c-.133-2.016-.039-3.994.984-5.815.519-.921 1.423-1.366 2.294-1.853z"
        />
        <path
          fill="#60A0DC"
          d="M392.963 141.857c-1.918.029-3.883-.22-5.609.945l-9.119-.138c1.224-4.145 4.298-5.969 8.308-6.625 2.402 1.877 5.248 3.098 7.588 5.066.258.217.055.623-.293.821-.246.142-.541.114-.875-.069z"
        />
        <path
          fill="#76E1F5"
          d="M377.182 144.693c.006-.334.01-.668.014-1.002l4.984.018c.543.611.861 1.309.818 2.143-.393 1.251-.207 2.586-.545 3.846-1.004 1.329-2.311 1.843-3.943 1.462-1.851-1.863-.603-4.368-1.328-6.467z"
        />
        <path
          fill="#56A0D6"
          d="M354.182 141.695l22.986-.008c.316.238.412.458.283.66-.121.193-.24.29-.359.29l-22.92-.022c.006-.308.01-.614.01-.92z"
        />
        <path
          fill="#80BEF9"
          d="M377.092 142.637a3.23 3.23 0 00.076-.95c2.087-3.509 5.421-5.425 8.998-7.032l2.01.01c.186.229.273.472.266.73-.01.267-.037.4-.086.401-.568.716-1.572.311-2.205.859-3.664.655-5.967 3.101-7.917 6.009l-1.142-.027z"
        />
        <path
          fill="#7AE1F2"
          d="M382.182 145.688c0-.66 0-1.32-.002-1.98l3.139.05c-.42.64-.842 1.279-1.264 1.919-.621.565-1.244.618-1.873.011z"
        />
        <path
          fill="#88DCFA"
          d="M377.182 144.693c4.076 1.333.779 3.9.984 5.881-.752.642-1.48.57-2.188-.078-.334-1.624-.645-3.248.199-4.824l1.005-.979z"
        />
        <path
          fill="#91EDFE"
          d="M376.178 145.671l-.023 4.971-.268.307c0 .001-.408.009-.408.011l-.295-.282c0-1.662 0-3.324-.002-4.986.332-.005.664-.011.996-.021z"
        />
        <path
          fill="#92BEF2"
          d="M338.182 133.682c1.957 1.917-1.922 3.898.41 5.986-2.402-.953-4.414-.389-6.43.028 1.445-1.653.502-3.584.357-5.675 2.101.349 4.013 1.145 5.663-.339z"
        />
        <path
          fill="#5D95DA"
          d="M342.18 141.686c-.715-2.191-3.326-4.104-.609-6.778.752-.741-1.092-1.331-1.387-2.219 2.326.001 4.682.241 6.971-.041 8.229-1.013 8.875 3.048 7.027 9.041l-12.002-.003z"
        />
        <path
          fill="#AE98EF"
          d="M244.177 270.692c-6.533-3.611-12.443-7.975-16.943-14.04 1.012-1.543 4.692 2.516 4.399-2.111-.03-.483 1.651-.691 2.716-.426 7.497 1.873 14.862-1.166 22.408-.562 7.763.621 15.614.139 23.426.139.665.969 1.331.971 1.995 0 1.945.296 1.656-2.141 2.947-2.54 3.059 1.324-.184 5.347 2.988 6.533.844 1.31.795 2.627.037 3.95l-1.941.115c-1.275.622-.582 1.282-.037 1.938l-.002 6.006c.621.505.484 1.17.385 1.827-.4.852-1.176 1.298-1.916 1.785-.768.418-1.52.956-2.449.417.334-1.93.881-3.89-.832-5.591-2.282.997-.332 3.451-1.954 4.985-2.606-6.369-8.691-3.604-12.875-3.93-6.535-.509-13.349.375-20.047.623-.778.03-1.537.576-2.305.882z"
        />
        <path
          fill="#84B2E0"
          d="M288.15 261.635l-.035-3.95.102-1.967c1.193.745.875 2.017 1.084 3.106-.223 1.706.348 3.576-1.047 5.039a571.13 571.13 0 00-.104-2.228z"
        />
        <path
          fill="#B19BE4"
          d="M282.178 253.692c-.244 1.161.592 2.639-.996 3.477-1.588-.838-.752-2.315-.999-3.477h1.995z"
        />
        <path
          fill="#A28EEE"
          d="M290.148 313.685c-1.291.054-1.943.729-1.957 2.021-.611.978-.615 1.962-.039 2.954l-1.939 2.122c-1.938-.688-3.564-3.092-5.995-1.064-2.563.456-5.225.138-7.721 1.074-3.193.454-6.404.216-9.607.307-6.701-.029-13.4.011-20.097-.013-1.482-.024-2.967-.047-4.428-.339-3.045-1.334-6.814.388-9.559-2.228-.848-1.284-.885-2.755-.887-4.223-.008-4.718 1.485-5.986 6.246-5.819 1.444.052 2.98 1.702 4.354-.068-.471-.914-1.862-1.353-1.357-2.711 1.793-.951 2.607-5.494 5.84-1.479.438.544.596-1.324 1.647-2.02 4.632-3.063 9.588-2.47 14.559-2.493-.014 2.025-1.55 1.854-2.869 1.995-1.796-.623-3.867.187-5.382-.669 7.292 1.214 14.607 3.72 22.401 3.3 1.096-.006 2.187-.12 3.282-.046 4.83.633 9.73-1.376 14.523.406 1.17.696.98 1.88 1.063 2.966l-.078 3.996c-1.287.065-1.929.765-2 2.031z"
        />
        <path
          fill="#A793F0"
          d="M248.219 290.671c-2.049-1.74-5.162-.93-7.093-2.954 5.037-.557 9.816-3.032 15.063-2.022-.498 3.244-3.462 1.229-4.966 2.328-.653.134.496.919.09.391 2.527-1.363 5.519-.387 8.076-1.609 4.737-.596 9.458-1.261 14.012-2.758 3.082-.644 5.664-2.323 8.239-4.021.879-.461 1.762-.92 2.777-.379.504.606.672 1.32.672 2.089-.031.789-.387 1.43-.918 1.988l-.99.969c-8.742 5.781-18.595 7.493-28.813 7.878-2.012-.753-4.466-.08-6.149-1.9z"
        />
        <path
          fill="#7C6ED4"
          d="M291.166 304.693c-4.938 1.211-9.963 1.092-14.987.999-.663-1.511 1.497-2.029 1.156-3.69-2.667-.201-5.418.176-8.129-.099-1.572-.159-3.701.38-4.014-2.201l5.035-.97c4.291.77 8.145-1.459 12.272-1.802 1.189-.3 2.369-.885 3.609-.19.525 3.389 4.035 4.882 5.058 7.953z"
        />
        <path
          fill="#826DD0"
          d="M254.255 291.657c10.166-.147 19.666-3.06 28.927-6.965-5.94 6.4-13.905 7.278-21.912 8.044-1.553 1.067-3.534-.223-5.073.922l-6.015.039c-.364-4.116 2.303-2.183 4.073-2.04z"
        />
        <path
          fill="#8072DD"
          d="M265.193 299.702c3.539 2.101 7.402.464 11.074.977 1.26.176 2.959-1.898 3.74.525.607 1.884-1.039 2.51-2.314 3.272-.551.328-1.012.806-1.514 1.216l-2.999.004c-2.669-3.344-6.467-2.343-9.963-2.703-2.452-.252-5.567 1.141-7.025-2.285 1.095-.066 2.273.121 3.018-1.001l5.983-.005z"
        />
        <path
          fill="#816ED4"
          d="M254.255 291.657c-1.569.259-3.74-.686-4.073 2.04-4.358.121-8.703.085-12.954-1.073 3.434-1.949 7.53-.156 10.991-1.952 2.016.301 4.241-.675 6.036.985z"
        />
        <path
          fill="#6F5CC3"
          d="M283.178 297.704c-4.267.968-8.443 3.086-12.95 1.028l12.961-4.005c.328.304.475.68.445 1.127-.058.639-.355 1.22-.456 1.85z"
        />
        <path
          fill="#7562D2"
          d="M237.164 305.698l2.972 2.033c-1.268 3.45-3.582.82-5.33.771-2.156-.061-4.169-1.017-5.616-2.806l-.071-3.936c2.892.882 4.838 3.698 8.045 3.938z"
        />
        <path
          fill="#73B0F3"
          d="M284.172 283.723l.061-2.054c.662-.573 1.326-.572 1.988.002.328.668.656 1.337.986 2.005l-1.119.05-1.916-.003z"
        />
        <path
          fill="#6554BC"
          d="M283.182 295.68c0-.318.002-.636.006-.953.965-.417 1.93-.834 2.893-1.253l.125 2.245-.01.013c-1.016.652-2.024.849-3.014-.052z"
        />
        <path
          fill="#816ED4"
          d="M256.196 293.658c1.451-1.626 3.357-.747 5.072-.922-1.475 1.49-3.35.783-5.072.922z"
        />
        <path
          fill="#9282E4"
          d="M329.139 237.701c-.33 0-.918-.088-.951.014-1.672 4.884-6.975 7.52-7.959 12.77-.277 1.477-.08 3.455-1.994 3.333-2.027-.129-2.09-2.182-1.924-3.816.115-1.124.564-2.214.865-3.319-.805-1.394-.629-2.855-.314-4.329 1.09-2.927 1.543-6.188 4.26-8.279 1.742-1.098 3.084-2.646 4.535-4.072 3.621-.872 1.986 2.475 2.988 3.712.238.781.523 1.55.795 2.323.049.195.09.394.137.591a1.42 1.42 0 01-.438 1.072z"
        />
        <path
          fill="#7E69D8"
          d="M315.159 247.672c-2.043-3.852-5.396-3.753-8.975-2.982-.998-2.072-.273-4.271-.467-6.396 1.955-4.514 5.277-6.351 9.629-4.965 2.848.907 1.783 3.847 2.502 5.865.129.748-.066 1.465-.217 2.185-.459 1.104-.623 2.346-1.48 3.271-1.108.752-.936 1.925-.992 3.022z"
        />
        <path
          fill="#9D8CED"
          d="M335.182 252.693c-.178 1.323-4.102.622-1.781 3.339.559.653.092 1.337-.627 1.48-4.057.808-4.191 3.104-2.758 6.378.461 1.052-.742 1.665-1.836 1.801-3.602-.544-4.76-2.572-4-6.999.543-1.648-1.684-5.561 3.174-3.735.756.283.855-1.241.791-1.981-.271-3.145 1.658-3.462 4.035-3.286 1.32.682 2.522 1.482 3.002 3.003z"
        />
        <path
          fill="#B9AAF3"
          d="M337.178 251.712a13.745 13.745 0 00-.975-.053c-3.457-2.757-3.75-6.15-2.004-9.955.338-.32.676-.641 1.016-.961 4.313-.85 8.623-.909 12.932.041 0 .305-.002.608-.006.913-2.445 1.844-5.328 1.002-8.484 1.331 2.822 2.265-.504 5.32 1.494 7.659-1.031 1.476-2.6.87-3.973 1.025z"
        />
        <path
          fill="#7D83CA"
          d="M348.147 240.785l-12.932-.042c-1.098-.107-2.311.15-3.078-.984l.416-.457c.619-.243 1.191-.204 1.691.279l21.922.012c3.008.056 6.016.111 9.023.169-.006.29-.023.578-.051.865-5.665.051-11.327.105-16.991.158z"
        />
        <path
          fill="#9B8DE8"
          d="M324.18 258.692c.533 2.79 1.385 5.399 4 6.999l-.002 1.001c-3.59 2.484-4.502-1.104-5.877-2.878-.65-.838-.707-2.059-2.115-2.124.148-2.577 2.742-1.895 3.994-2.998z"
        />
        <path
          fill="#A08BE4"
          d="M334.2 241.705c-.178 3.488.678 6.77 2.004 9.955-.34.345-.682.688-1.021 1.033-1.277-.726-2.967-1.038-3.002-3.004-.072-2.049.053-4.131-.271-6.139-.374-2.29 1.1-1.772 2.29-1.845z"
        />
        <path
          fill="#8575E3"
          d="M314.184 254.694c.311-2.004-.807-4.243.986-6.003-.3 2.005.813 4.243-.986 6.003z"
        />
        <path
          fill="#727FD4"
          d="M329.139 237.701l.041-1.018c2.182-.242 3.846.061 3.078 2.924l-.121.15c-1.424-.066-2.387-.803-2.998-2.056z"
        />
        <path
          fill="#A08FF2"
          d="M316.151 244.649c.047-1.099-.092-2.257.971-3.03.59.113.68.721 1.045 1.057-.639 1.259-1.141 2.552-.99 4.006-.823-.436-.971-1.211-1.026-2.033z"
        />
        <path
          fill="#9F8CF0"
          d="M283.154 322.621c-16.796 4.421-33.737 5.578-50.886 2.303-1.291-.246-2.633-.22-3.951-.32-.196-.17-.391-.34-.589-.509-.535-.989-.538-2.003-.139-3.037a2.312 2.312 0 011.134-1.069c2.941-.594 5.78.488 8.687.533 1.365.279 2.769.096 4.134.364 6.833.66 13.663.726 20.489-.046 4.479-.175 8.983-.048 13.384-1.126 2.155-.006 4.255-.757 6.434-.514 1.389.776 1.729 1.953 1.303 3.421z"
        />
        <path
          fill="#3B1C7F"
          d="M228.206 336.691l.014-8.07c2.4.243 4.918-.375 7.168.976-.18.285-.514.357-.724.539-.333.286-.318.349-.037.243 1.456-.549 3.115.338 4.524-.618l16.053-.021c1.585 1.979 4.198.068 6.013 1.543-5.018 1.583-9.803-1.075-14.749-.51 2.481 3.358 6.583 2.418 9.713 3.918.201 2.453-1.135 3.214-3.328 2.995-5.906-.588-12.078 1.54-17.696-2.336-2.199-1.517-4.383 1.973-6.951 1.341z"
        />
        <path
          fill="#9A8AE9"
          d="M283.154 322.621c-.328-.987-.656-1.975-.986-2.961-.34-.321-.941-.382-.992-.993 3.232-2.995 3.484 1.11 5.037 2.114l-3.059 1.84z"
        />
        <path
          fill="#391B7D"
          d="M239.15 329.76c-2.626 1.439-5.469 1.459-9.139 2.02 1.819-2.836 3.831-1.756 5.374-2.183l3.765.163z"
        />
        <path
          fill="#3E53C1"
          d="M228.253 328.53l-2.07-.812a123.48 123.48 0 00-.494-.557c-.377-1.006-.326-1.94.464-2.75.734-.336 1.42-.304 2.032.274l.131-.082c-.02 1.31-.041 2.618-.063 3.927z"
        />
        <path
          fill="#BCAEF1"
          d="M341.151 250.688c-1.811-.325-3.717-1.025-2.129-3.144 2.555-3.406-.496-3.647-3.049-4.85 4.441-1.758 8.375-.671 12.168-.997l-1.943 3.996c-1.082 2.271-3.35 3.346-5.047 4.995z"
        />
        <path
          fill="#1165B0"
          d="M354.542 309.528c-2.098.914-4.188 2.233-6.346.125-2.17-3.042-.555-6.286-.502-9.443 1.441-1.997 3.117-1.563 4.277.042 1.018 1.405 2.75 2.252 3.201 4.084.514 1.82 0 3.513-.63 5.192z"
        />
        <path
          fill="#A9E3F0"
          d="M354.542 309.528c-.074-1.884-.15-3.768-.225-5.651.045-2.039.281-4.004 2.094-5.354.529-.448 1.119-.751 1.836-.728 2.258 4.759-.609 8.121-3.15 11.571a.957.957 0 00-.555.162z"
        />
        <path
          fill="#1893CE"
          d="M344.184 310.693c.424-1.771-1.205-4.368 2.016-5.015 1.709.955 1.756 2.363 1.08 3.968-1.771.952-.557 2.982-1.508 4.258-2.57-.09-.318-2.521-1.588-3.211z"
        />
        <path
          fill="#036DAF"
          d="M347.28 309.646l-1.08-3.967c-.006-.996-.012-1.991-.02-2.986.15-1.589.768-2.941 2.012-3.976.254.214.342.432.264.653-.078.224-.156.335-.24.335-.006 3.316-.012 6.632-.02 9.947l-.457.002-.459-.008z"
        />
        <path
          fill="#2394B5"
          d="M341.069 305.411l.082-2.605c2.117 1.249.529 3.274 1.018 4.864-.911-.489-.975-1.389-1.1-2.259z"
        />
        <path
          fill="#3B1C7F"
          d="M270.192 333.695c-3.911 3.687-7.381 3.686-10.011-.004 3.646-.591 7.197-2.235 11.01-.995.246.911.029 1.361-.999.999zM277.208 329.705l-3.023 1.991c-.563.545-.865 1.627-2.006.966-.615-4.883 3.207-2.22 5.029-2.957z"
        />
        <path
          fill="#4E2B8F"
          d="M272.179 332.662l2.006-.966-.006 1.034c-1.177.952-2.174 2.645-3.987.965l.999-.999c.329-.001.658-.013.988-.034z"
        />
        <path
          fill="#07B6DF"
          d="M352.28 285.633c1.416.164 2.668-.299 3.855-1.01 2.697 1.063 1.852-2.919 3.918-2.753 1.17 2.138-1.932 4.981 1.127 6.805.865.605 1.418 1.411 1.229 2.484-.029.166-1.1.411-1.213.262-2.688-3.581-6.406.225-9.754-1.428-2.34-1.156-3.508-1.742-3.234-4.254 1.357-.034 2.714-.07 4.072-.106z"
        />
        <path
          fill="#0FA7D1"
          d="M366.198 305.705c-4.891.859-6.932-1.101-5.965-6.033 1.436-.125 2.715.341 3.941 1.018l1.055 1.975c.498.957 2.23 1.523.963 3.04h.006z"
        />
        <path
          fill="#074579"
          d="M358.247 297.794c-.4.308-.803.614-1.205.922-3.277.999-5.354-.23-6.369-3.431.148-.862.934-1.129 1.504-1.599 2.332-.253 4.627-.387 6.107 1.985-.012.708-.026 1.416-.037 2.123z"
        />
        <path
          fill="#17A7D4"
          d="M352.176 293.687l-1.053.984c-1.025.963-.527 3.402-2.934 3.024l-.051-.046c-.364-3.063.952-4.414 4.038-3.962z"
        />
        <path
          fill="#7864DA"
          d="M306.18 237.69l.004 7c-.145 1.378.459 2.94-.986 3.996-.014-3.001-.025-6.003-.037-9.004.012-4.657.023-9.314.037-13.972.803.425.959 1.171.982 1.981 2.369 3.334 1.412 6.666 0 9.999z"
        />
        <path
          fill="#1269B6"
          d="M348.19 297.696c.979-1.008 1.955-2.016 2.934-3.023.803 3.061 3.635 3.15 5.92 4.043l-2.727 5.161c-.457-1.312-3.395.567-2.846-2.498.344-1.917-1.902-1.552-3.256-1.673a16.3 16.3 0 01-.023-.989l-.002-1.021z"
        />
        <path
          fill="#6458CE"
          d="M283.182 295.68l3.014.052c-.027.336-.057.671-.086 1.007-.977.322-1.955.644-2.932.964-1.022-.677-1.022-1.351.004-2.023z"
        />
        <path
          fill="#5BB9FA"
          d="M286.221 281.671l-1.988-.002-.146-1.888c-.545-.642-.676-1.393-.596-2.204.658-1.533.152-3.902 2.84-3.992.381.758.4 1.501-.092 2.223-.007 1.954-.012 3.909-.018 5.863z"
        />
        <path
          fill="#71B7D1"
          d="M286.238 275.808c-.051-.721-.102-1.441-.15-2.162-.539-.661-.49-1.307.049-1.94.012-.671.021-1.341.033-2.011l1.201.086c-.348 2.015.399 4.235-1.133 6.027z"
        />
        <path
          fill="#B19BEE"
          d="M286.172 263.689c-1.371-.101-2.02-.848-1.914-2.21.051-.665.33-1.43 1.061-1.238.402.105.6.98.891 1.51-.013.646-.024 1.292-.038 1.938z"
        />
        <path
          fill="#E758EF"
          d="M465.192 349.689c2.93-3.345 7.809-1.32 10.982-3.989l-.035 5.985-2.959.004c-2.324-3.088-5.635 1.729-8.002-1.001-.225-.226-.297-.448-.219-.67.079-.22.157-.329.233-.329z"
        />
        <path
          fill="#EB6CEC"
          d="M476.184 344.706c-.438-1.764 1.207-4.359-2.002-5.017-1.557-1.594-1.326-3.461-.836-5.37.676-1.417 1.516-2.712 2.836-3.63.324.001.65 0 .975-.004-.397 4.669 1.072 9.466-.973 14.021z"
        />
        <path
          fill="#F57BF4"
          d="M465.186 324.689l-.016-1.987c.008-1.341.018-2.681.027-4.021l.986-.99c2.748-.561 5.564.18 8.17.47 3.688.411 1.08 4.303 1.828 6.53-3.665 2.378-7.331 1.1-10.995-.002z"
        />
        <path
          fill="#F072F3"
          d="M465.186 324.689c3.666-1.107 7.33 1.002 10.996.001v4.001c-.648.943-1.334 2.314-2.479 2.141-3.76-.568-6.043 1.756-8.504 3.848-.003-3.331-.009-6.661-.013-9.991z"
        />
        <path
          fill="#F06EF1"
          d="M465.2 334.679c.883-4.055 2.871-6.097 7.389-4.652.957.307 2.383-.853 3.594-1.336v1.998c.014 1.454.029 2.909-2.002 3.002-2.629 2.307-5.354 4.19-8.982 1.996-.001-.336.001-.672.001-1.008z"
        />
        <path
          fill="#1E98DA"
          d="M366.192 305.704c.541-1.286-1.752-1.675-.963-3.04 2.213.414 2.496 1.439.963 3.04z"
        />
        <path
          fill="#92B8CC"
          d="M472.176 133.736l6.008-.097 25.965.074c.029.286.045.572.045.86-.539.681-1.236 1.213-2.09 1.231-9.787.209-19.586 1.002-29.35-.446-.658-.374-.849-.916-.578-1.622z"
        />
        <path
          fill="#D9FDFE"
          d="M472.17 134.551c10.676.008 21.35.016 32.023.022 1.133.786 1.055 1.936.934 3.1l-.992.169c-.256-.069-.512-.139-.773-.204a7.272 7.272 0 00-1.561-.452c-16.752-.138-33.5-.259-50.232.08-.428.276-.875.524-1.324.768-.754.228-1.469.271-1.965-.514l.008-2.676c7.947-1.24 15.916-.673 23.882-.293z"
        />
        <path
          fill="#85C5D7"
          d="M366.165 205.699c6.459-.003 12.917-.037 19.378.016 1.586.014 3.361-.553 4.645.995-3.018 4.035-6.813 6.722-12.027 6.951-4.729-1.555-9.991-2.307-11.996-7.962z"
        />
        <path
          fill="#70ADC8"
          d="M366.165 205.699c3.027 4.117 8.342 4.789 11.996 7.962a6983.752 6983.752 0 00-4.027 5.997c-3.258-3.435-6.447-6.923-8.979-10.952.062-1.094-.155-2.283 1.01-3.007z"
        />
        <path
          fill="#68BDE8"
          d="M368.165 225.68c2.449-.317 3.219-2.765 4.992-3.938 1.059 6.14-1.033 10.581-6.975 12.948l-.006-2.017c1.758-3.528-.781-6.115-1.973-8.998 2.45-1.561 2.432 1.751 3.962 2.005z"
        />
        <path
          fill="#6BBEEA"
          d="M499.167 198.663l-61.973.015c1.482-1.626 3.438-.95 5.188-.956 15.82-.051 31.643-.016 47.465-.042 2.824-.004 6.197 1.022 7.002-3.397.059-.323 1.477-.398 2.262-.589.018 1.655.036 3.311.056 4.969zM437.184 192.775l4.957-.009c-1.098 1.664-4.232.102-4.957 2.91v-2.901z"
        />
        <path
          fill="#6CC0E7"
          d="M422.194 206.665l1.963-1.91 4.057-.003c1.98.719 3.959.721 5.939-.001 2.049.211 4.273-.747 7.365 1.914h-19.324z"
        />
        <path
          fill="#69BFED"
          d="M434.153 204.75c-1.98 1.429-3.961 1.431-5.939 0h5.939z"
        />
        <path
          fill="#79C4EC"
          d="M475.176 163.694c.004-1.002.008-2.005.01-3.007 7.557-2.833 15.246-2.604 22.994-.995.369 2.94-.756 4.193-3.873 4.053-4.621-.209-9.262.043-13.889-.096-2.127-.064-3.889.329-5.234 2.04-.004-.665-.006-1.33-.008-1.995z"
        />
        <path
          fill="#77BEE8"
          d="M446.186 159.687c-.002-1.33-.004-2.661-.004-3.991l23.002-.003c.035 2.281-.309 3.321-3.357 3.234-6.532-.185-13.174-1.293-19.641.76z"
        />
        <path
          fill="#7BB3CF"
          d="M396.146 176.715c.018.324.035.647.051.972-1.697 1.642-2.732 3.941-4.988 5.028-2.098 1.896-4.908 3.288-4.762 6.765-3.092 2.423-6.23-.521-9.437.041-1.838.323-3.936-.149-5.922.05-1.871-.184-3.539-.941-5.148-1.856a2.396 2.396 0 01-.234-1.338c.301-.979 1.1-1.409 1.951-1.781 2.014-.593 2.834-2.77 4.699-3.567 3.105-1.64 6.064 1.554 9.146.257 1.098-1.622 2.146-3.259 2.756-5.139.313-.921.619-1.839 1.02-2.73 1.434-2.398 3.242-3.544 5.91-1.744l-.002.022c2.01 2.245 1.07 4.856.732 7.785-.086.196 1.125-.311.457-.297.09-2.607 1.328-3.457 3.771-2.468z"
        />
        <path
          fill="#76AECA"
          d="M386.182 188.689c-1.963-5.053 2.201-4.949 5.025-5.974l-.002 6.961-.029 1.01c-2.201.677-3.668-.483-4.994-1.997z"
        />
        <path
          fill="#7CB7D0"
          d="M386.182 188.689l4.994 1.997.004 1.002c-1.801 1.334.361 2.668 0 4.002-8.008 3.242-16.146 2.247-24.291.711-.604-.114-1.311-1.074-1.664-.923-6.539 2.788-3.602-2.405-4.037-4.737.166-1.31.92-2.335 1.627-3.388.6-.681 1.309-1.166 2.242-1.238.455.045.836.236 1.127.592.002.328.004.657.008.985 1.035.44 2.031.939 2.76 1.838.701.918 1.66 1.582 2.793 2.834-.846-1.083-1.52-1.622-1.867-2.412a1.31 1.31 0 01.303-1.26c4.252-1.568 8.4-.242 12.525.588 1.357.272 2.485.654 3.476-.591z"
        />
        <path
          fill="#71C5EE"
          d="M391.188 171.671c-2.24.059-4.725-.29-5.021 3.011-3.539-.401-3.166-2.638-2.385-5.071 1.957-2.574 4.182-4.14 7.389-1.92l.017 3.98z"
        />
        <path
          fill="#86C8DD"
          d="M396.146 176.715c-2.346-.264-2.938 2.369-4.961 3.102v-8.123c3.083.263 3.858 2.803 4.961 5.021z"
        />
        <path
          fill="#74C4E9"
          d="M391.17 167.691c-2.723-.706-4.742.998-6.959 2.028l-.314-.639c-.057-1.001.287-1.875.846-2.684.473-.57 1.047-.984 1.779-1.154 1.709-.059 3.328.195 4.65 1.416l.023.025c-.007.336-.017.672-.025 1.008z"
        />
        <path
          fill="#88E2F7"
          d="M392.092 158.652c8.305-4.161 9.375-9.921 2.93-15.774 2.67-2.377 5.406-2.031 8.176-.194l1.006.052c2.949 11.239.631 17.299-8.02 20.96-1.418-1.638-2.481-3.565-4.092-5.044z"
        />
        <path
          fill="#86DEF7"
          d="M392.092 158.652c3.57-.11 3.986 2.342 4.092 5.043-1.385 1.659-3.309.746-4.979 1.038a63.74 63.74 0 00-.58-.584c-.871-1.902-.861-3.717.553-5.387.297-.095.601-.132.914-.11z"
        />
        <path
          fill="#95D0EF"
          d="M391.172 166.659c-1.762.144-3.455-.087-5.033-.934-1.508-.101-.939-.803-.43-1.49 1.91-1.05 3.727-.955 5.43.455l.066.043-.033 1.926z"
        />
        <path
          fill="#0282B5"
          d="M372.268 59.655l.918 2.037c1.803 2.696 1.988 5.379-.066 8.042l-.383-.01-.383.006c-.055-2.018-.113-4.035-.17-6.053.029-1.341.057-2.681.084-4.022z"
        />
        <path
          fill="#209ED1"
          d="M373.12 69.734c.021-2.681.045-5.361.066-8.042.332-.005.664-.007.996-.007 1.656 1.687 1.365 3.82 1.369 5.891-.035 1.511-.141 3-1.369 4.114a50.892 50.892 0 01-.957-.011l-.105-1.945z"
        />
        <path
          fill="#2761D5"
          d="M190.14 360.645c-.249-2.402.443-4.66 1.067-6.928.359-.341.79-.508 1.279-.535 7.738-1.079 15.544-1.482 23.226-.118 3.75.666 2.946-2.918 4.822-3.777 2.304-.166 2.589 1.514 2.917 3.163.169 1.684.167 3.37.097 5.057-.064 1.391-.11 2.789-.913 4.012-3.473 1.938-6.836 1.977-10.799.84-5.976-1.715-12.263-1.76-18.486-.707-1.136.192-2.946 1.836-3.21-1.007z"
        />
        <path
          fill="#2664D9"
          d="M190.14 360.645c10.789-2.98 21.341 1.305 32.042 1.047 1.149 1.334 1.152 2.668-.002 4-2.678.328-1.807 2.43-1.998 4-3.324-4-8.065-3.721-12.529-3.949-4.611-.234-9.245-.068-13.868-.043-1.863.01-3.693.039-4.62-2.033.034-1.103-.129-2.267.975-3.022z"
        />
        <path
          fill="#3F7FE2"
          d="M192.164 353.664c-.32.017-.639.034-.958.053-3.898.472-7.808 1.007-11.042-2.068l.02-3.957c4.463-1.049 11.354.636 13.014 3.181.039 1.072-.137 2.066-1.034 2.791z"
        />
        <path
          fill="#4980D0"
          d="M172.168 356.602c.005-.297.004-.594-.003-.891 2.701.297 1.832 2.402 2.012 3.975l-1.117-.047c-.632-.914-.453-2.067-.892-3.037z"
        />
        <path
          fill="#9AC9FE"
          d="M172.168 356.602c1.113.773 1.062 1.889.892 3.037-.968-.043-1.936-.086-2.903-.131 1.466-1.18 1.858-1.879-.623-1.85-8.085.096-16.171.1-24.256.141.846-1.947 2.656-.789 3.969-1.234 3.961-.586 7.924-.561 11.887-.02l11.034.057z"
        />
        <path
          fill="#2761D4"
          d="M222.179 365.691l.002-4v-4c1.317.973 2.646-1.283 3.961.014-.006 2.666-.011 5.334-.018 8-2.828-.17-1.067 4.199-3.941 3.984l-.004-3.998z"
        />
        <path
          fill="#0C9BC1"
          d="M50.241 143.677c.31.011.619.018.929.022-.297 2.418.436 4.688 1 6.982-.346.01-.692.019-1.039.027-2.146-2.109-.457-4.704-.89-7.031z"
        />
        <path
          fill="#F4D5F4"
          d="M420.168 347.606c1.27.642 1.08 1.954 1.396 3.035.135.488-.047.818-.504 1.012l-2.875.071c-4.021 1.154-8.008.948-11.969-.301l-.15-2.721c.115-.256.166-.524.152-.805 4.613-1.921 9.271-1.641 13.95-.291z"
        />
        <path
          fill="#CB4FEC"
          d="M465.192 349.689c-.01.332-.014.666-.014.999l-.992.01c-.293-.085-.586-.17-.881-.254-11.459-.786-22.934-.079-34.395-.424-2.049-.062-4.877 1.046-5.727-2.306 12.393-.01 24.785-.058 37.176.016 1.755.01 4.196-1.058 4.833 1.959z"
        />
        <path
          fill="#CB4FEC"
          d="M421.061 351.653c.166-.337.332-.673.502-1.011.193.002.385-.012.574-.041.285-.172.564-.477.857-.491 13.447-.653 26.895-.727 40.338.044.289.017.559.342.836.525l.018.019c-1.311 1.516-3.09.965-4.686.969-12.812.029-25.626-.001-38.439-.014z"
        />
        <path
          fill="#DA52E0"
          d="M406.217 351.423l11.969.301c-4.062 2.822-8.027 1.728-11.969-.301z"
        />
        <path
          fill="#CB6CF2"
          d="M464.143 307.7l.027 6.001c-.066 4.518-2.727 5.874-6.738 5.406-6.42-.748-12.672 1.733-19.078.928-3.049.249-5.404-2.854-8.633-1.796-6.783-.56-13.693.706-20.375-1.403-.807-.255-1.557-.546-2.165-1.145 0-.332-.002-.665 0-.998.061-6.998.061-6.998 6.991-6.998h6.893c0 .257.002.514.004.77h-9.756c1.889 3.886 11.457 6.153 14.365 3.411 2.354-2.221 4-4.8 4.783.834.133.958 1.307 1.542 2.375 1.315.945-.2 1.283-1.011.982-1.936-1.191-3.66 1.238-1.419 2.094-1.2 7.705 1.966 15.65-.224 23.398 1.376 1.078.223 3.455-.079 3.506-1.949.063-2.319-2.127-1.572-3.436-1.588-6.627-.079-13.254-.036-19.898-1.028h24.661z"
        />
        <path
          fill="#CA68F0"
          d="M407.182 315.691c2.44.12 4.993-.515 7.129 1.398.809.724 1.83.563 2.713-.187.488-.416 1.283-1.165 1.572-1.021 3.652 1.817 7.895-.217 11.48 1.813 1.285 1.141 1.176 2.488.582 3.912-.688.989-1.674 1.523-2.805 1.834-6.607.598-13.217 1.19-19.842.112a2.66 2.66 0 01-1.252-1.103c-1.02-1.689-.791-3.269.42-4.76l.003-1.998z"
        />
        <path
          fill="#CB6CF2"
          d="M407.18 317.69v4.999c-.322.339-.639.337-.955-.008l-.076.019c-1.297-1.674-1.293-3.348 0-5.021l.061.025c.323-.008.645-.013.97-.014z"
        />
        <path
          fill="#F57CF5"
          d="M406.148 317.678v5.021l-9.963-.007c.004-1.461-.031-2.925.021-4.385.092-2.551 1.648-3.389 3.473-1.91 2.091 1.696 4.276 1.102 6.469 1.281z"
        />
        <path
          fill="#C761EE"
          d="M464.235 322.685c-.02 2.005-.039 4.01-.061 6.016-1.096 2.144-3.119 2.271-5.146 2.33-6.152.18-12.314-.076-18.463.356-1.469.104-2.648-.262-3.057-1.879-.01-4.053 4.621-4.367 5.926-7.362 2.035-2.137 4.379-1.614 6.854-.929 4.805 1.332 9.502 1.17 13.893-1.524l.054 2.992z"
        />
        <path
          fill="#C967F1"
          d="M464.18 319.693c-.941 1.989-1.65 3.661-4.732 3.242-3.504-.477-7.176 1.74-10.713-.973-1.063-.815-3.236-.799-4.557.732-3.268.291-5.811-.778-7.266-3.881 7.629.469 15.131-2.219 22.75-1.062 3.547.539 3.154-2.559 4.508-4.052l.01 5.994z"
        />
        <path
          fill="#C354EB"
          d="M464.178 333.693c.004.497.012.993.012 1.489.01 6.494.01 6.503-6.352 6.504-17.209.003-34.416-.003-51.625-.005l-.006-5.992c.783-.631.148-2.389 1.83-2.311 3.891 1.085 7.879.813 11.852.896 11.756.248 23.539-.726 35.264.64 3.18.37 5.93-1.519 9.025-1.221z"
        />
        <path
          fill="#C761EE"
          d="M407.184 333.692c-.021.815-.189 1.558-.977 1.997l-.059-1.004.008-6.005.064.024c.576-.142 1.049.022 1.416.489.843 1.6.825 3.113-.452 4.499z"
        />
        <path
          fill="#CA68F0"
          d="M407.182 328.692c-.32 0-.641.004-.961.013l.004-6.023c.318.006.637.009.955.008l.002.003c1.393 1.676 1.439 3.493.576 5.409-.19.197-.383.394-.576.59z"
        />
        <path
          fill="#C459EE"
          d="M407.184 333.692l-.002-5v-.001c6.67-1.55 13.333-.587 19.995.034 1.182.315 1.984 1.289 3.063 1.772 3.008.813 4.893-2.819 7.895-2.003.139.808.244 2.043 1.174 1.9 7.172-1.097 14.387-.482 21.574-.753 1.107-.042 2.195-.615 3.293-.942.002 1.665.004 3.329.004 4.993-3.348 3.963-7.475 2.727-11.791 2.203-4.76-.577-9.637-.194-14.463-.201-8.49-.013-16.98-.064-25.469.038-2.132.027-3.922-.307-5.273-2.04z"
        />
        <path
          fill="#C247E4"
          d="M464.168 350.679l-42.031-.077c.055-1.07-.156-2.235 1.047-2.888 1.49 1.603 3.439.937 5.189.946 10.479.061 20.957-.002 31.436.062 1.649.01 3.883-.844 4.359 1.957z"
        />
        <path
          fill="#EE66F1"
          d="M465.198 335.687c3.305.735 5.848-1.967 8.982-1.996.002 1.999.002 3.998.002 5.998-2.236 4.18-5.352.335-8.012.808-.916.162-.988-.247-.972-4.81z"
        />
        <path
          fill="#E160E2"
          d="M420.168 347.606c-4.65.097-9.301.192-13.95.291 3.937-3.011 11.04-3.159 13.95-.291z"
        />
        <path
          fill="#DF77E6"
          d="M110.179 265.694l.068-2.17c2.039.694 3.346 2.114 4.076 4.108l-4.132.047c-.538-.658-.613-1.32-.012-1.985z"
        />
        <path
          fill="#D582DD"
          d="M116.212 277.752l-1.02-.051c.663-1.202 1.553-2.068 3.04-2.051-.086 1.266-.743 1.982-2.02 2.102z"
        />
        <path
          fill="#EC67F2"
          d="M127.188 271.686l-1.006.013c-.66.587-1.324.583-1.993.014l-.015-1.018c-.054-1.938.516-3.604 2.797-2.748 2.211.831.609 2.445.217 3.739z"
        />
        <path
          fill="#F370FC"
          d="M126.174 262.689c.488-6.256 3.74 1.368 5.003-.997-1.323 2.058-3.018 2.253-5.003.997z"
        />
        <path
          fill="#DF68EA"
          d="M124.188 271.712l1.993-.015.005 2.005c-.034 1.302-.71 1.96-2.004 1.998.003-1.328.005-2.658.006-3.988z"
        />
        <path
          fill="#DE58EC"
          d="M122.179 277.691c-.032 1.301-.699 1.967-1.999 2 .079-1.253-.451-3.115 1.999-2z"
        />
        <path
          fill="#EB6AFA"
          d="M110.179 265.694l.012 1.986c-.097 1.767-1.363 2.595-2.799 2.589-1.606-.006-1.041-1.586-1.205-2.579l3.992-1.996z"
        />
        <path
          fill="#5863C2"
          d="M130.181 297.691c-2.688-.331-1.805-2.444-2.005-4.018l.032-1.944 1.895-.122.124.124c.373.329.765.663 1.241.792 1.241.336 2.909.265 3.045 1.958.169 2.114-1.737 1.997-3.106 2.394-.476.137-.861.478-1.226.816z"
        />
        <path
          fill="#6AA5DF"
          d="M403.197 142.683l-8.176.193-2.057-1.021c-2.426-1.532-5.363-2.391-6.814-5.2.459-.772 1.211-.938 2.027-.974 1.67-1.189 3.342-1.271 5.021-.018 4.103 1.245 8.425 2.175 9.999 7.02z"
        />
        <path
          fill="#82B8EE"
          d="M393.199 135.665l-5.021.018c-.002-.339-.002-.678-.002-1.018 2.012-1.471 4.025-1.448 6.039-.004l-1.016 1.004z"
        />
        <path
          fill="#75B7E7"
          d="M448.28 137.52l1.908.015c4.307-1.716 8.799-.632 13.199-.792 4.775-.173 9.566-.136 14.348.03 3.896.864 7.861.31 11.785.586 1.797.126 4.146-.511 4.658 2.327l-24.994.008c-6.566-.004-13.135-.041-19.701.008-1.953.013-1.762-.927-1.203-2.182z"
        />
        <path
          fill="#8FB3C4"
          d="M472.17 134.551l-23.883.292c.889-1.741 2.555-.938 3.898-1.186l19.99.077c.005.273.003.546-.005.817z"
        />
        <path
          fill="#71B0E7"
          d="M440.29 136.051c.021-1.495.557-2.188 1.758-2.232 1.457-.054 2.102.727 2.004 2.121-.084 1.203-.852 1.667-1.988 1.643-1.222-.027-1.696-.756-1.774-1.532z"
        />
        <path
          fill="#BCFEFE"
          d="M383.18 79.704l.029 1.049c-.732 1.209-1.436 1.04-2.119-.045-.859-3.2-.18-6.463-.393-9.688 0-2.305-.002-4.611 0-6.917.449-2.103-1.08-3.8-1.195-5.789 2.229-2.688 5.318-2.491 7.727.491-1.957-.173-3.25.705-3.959 2.506.816 2.824.215 5.713.387 8.563-.876 3.241-.272 6.554-.477 9.83z"
        />
        <path
          fill="#169ACD"
          d="M374.182 71.69l.006-4.006c1.07-.963 2.27-1.137 3.586-.581 1.111.508.617 1.888 1.398 2.575v6.914c-1.667.284-1.314-1.763-2.535-1.958-1.381 1.436.559 3.377-.799 5.121-3.048-2.29-1.017-5.482-1.656-8.065z"
        />
        <path
          fill="#1BA4D0"
          d="M379.172 69.678c-.804-.427-.97-1.174-.992-1.991-1.91-2.665-1.895-5.331 0-7.996-.158-6.955 5.267-2.854 8.017-4.049 1.27.081 1.961.741 2.031 2.025.555.699.49 1.378-.064 2.041-.313-.301-.623-.603-.936-.903-2.305-.938-4.592-2.987-6.953-.101.451 1.047.754 2.081-.27 2.995-1.655 2.516-.454 5.331-.833 7.979z"
        />
        <path
          fill="#51A3BF"
          d="M381.057 70.956c.01 3.251.021 6.502.033 9.752-1.799-3.286-.709-6.79-.768-10.207.416-.124.66.028.735.455z"
        />
        <path
          fill="#B6E8ED"
          d="M381.057 70.956c-.24-.157-.486-.309-.734-.454.008-2.273.014-4.547.02-6.819.291-.45.559-.416.811.034-.035 2.412-.066 4.825-.097 7.239z"
        />
        <path
          fill="#BFECEF"
          d="M381.152 63.716a24.2 24.2 0 00-.811-.034l-.336-1.982.27-2.995c1.534 1.454.707 3.32.877 5.011z"
        />
        <path
          fill="#5662BD"
          d="M130.181 297.691c.005-2.302 2.332-1.73 3.484-2.563-.316-2.177-3.755-.842-3.439-3.397 17.616-4.501 35.467-.668 53.491-2.311-.721 4.393-4.209 2.127-6.62 4.015 7.439 0 13.992.192 20.523-.09 2.868-.124 6.393 2.16 8.576-1.687 2.578.281 2.414 2.539 3.059 4.221.296 2.243.203 4.393-1.542 6.122-3.362 2.293-6.779.995-10.032-.121-5.537-1.901-11.054-3.599-17.023-2.793-13.438.021-26.865.014-40.292.013-2.487 0-5.001.146-7.184-1.408l-3.001-.001z"
        />
        <path
          fill="#4D6ECC"
          d="M134.288 318.72c-3.01-1.228-5.059-4.414-9.215-3.491-1.89.419-3.169-2.586-4.796-3.954-1.388-1.166-2.73-2.387-4.093-3.583l-.002-2.001.002-3.999c2.082-1.087 2.592.531 3.146 1.898.527 1.3 1.247 2.696 2.707 2.498 5.896-.8 9.963 2.302 13.805 6.049 8.393.626 16.819-.514 25.189.639 1.254.587 1.889 1.479 1.416 2.904-1.714 1.736-3.943 1.298-6.03 1.379-6.704.26-13.427-.458-20.109.414a13.57 13.57 0 00-1.311.892c-.235.12-.472.237-.709.355z"
        />
        <path
          fill="#506BC8"
          d="M134.483 313.552c-2.968-4.648-6.95-6.999-12.657-5.902-2.282.438-3.864-.412-3.658-3.157.107-1.429-.241-2.636-1.985-2.801l-.006-.003c-.595-.667-.527-1.333.005-1.997 4.103.691 8.05 1.992 12.267 2.453 2.112.231 3.81 4.25 5.694 6.557.918-.771 1.959-1.32 3.167-1.294 7.779.163 15.595-.958 23.331.635.588.332.845.841.771 1.51-1.651 1.92-3.934 1.451-6.037 1.5-6.14.143-12.285-.143-18.406.168a3.977 3.977 0 00-1.225.696c-.422.539-.842 1.086-1.261 1.635z"
        />
        <path
          fill="#5167C5"
          d="M133.182 297.692l48.995.005c.638.981.552 1.847-.409 2.575-1.502.878-3.175.807-4.818.811-12.375.034-24.75.03-37.126.003-1.972-.004-3.998.117-5.626-1.355l-1.016-2.039z"
        />
        <path
          fill="#546BB6"
          d="M161.138 309.766l.052-1.03c-2.208-1.752-4.805-.83-7.233-1.04-6.574-.566-13.259 1.146-19.759-.967.395-.855 1.16-1.03 1.991-1.082 4.536-2.094 9.364-1.127 14.079-1.346 2.593-.12 5.293.435 7.633-1.24 2.552-.91 5.119-1.002 7.697-.118.769.404 1.118 1.064 1.132 1.914-.055 1.813-3.375 1.863-2.313 4.281.163.388.261.791.329 1.199.096.601.163 1.215.67 1.656 4.205 1.191 8.725-.726 12.822 1.366 1.157 1.513 1.198 2.982-.162 4.399a1.994 1.994 0 01-1.609.031c-2.839-1.262-5.85-.539-8.78-.753-1.925-.14-4.016.337-5.51-1.447-.053-.906-.354-1.657-1.262-2.032a3.063 3.063 0 01-.61-1.653 4.238 4.238 0 01.135-1.186c.167-.362.399-.682.698-.952z"
        />
        <path
          fill="#C3CEDD"
          d="M134.197 306.729l23.955-.219c1.569-.015 3.103.013 3.038 2.226-9.016.449-18.032.491-27.046-.035l.053-1.972z"
        />
        <path
          fill="#555F9A"
          d="M134.197 299.73l47.979-.073c1.624-1.122 3.436-1.321 5.117-.433 1.838.974.615 1.732-.441 2.362-7.115 1.091-14.276.371-21.416.484-8.32.132-16.645.058-24.966.013-2.135-.011-4.371.31-6.214-1.239-.021-.371-.04-.743-.059-1.114z"
        />
        <path
          fill="#B2BDF8"
          d="M134.254 300.844l52.914-.142c.292.706.107 1.249-.552 1.633-4.687 1.5-9.538.923-14.258.665-9.752-.535-19.475.387-29.208.088-2.945-.09-5.95.13-8.711-1.267a3.127 3.127 0 01-.185-.977z"
        />
        <path
          fill="#C6CEE0"
          d="M166.18 303.831l-8.013.019c-6.675 1.355-13.35 1.36-20.024-.004-1.184-.548-2.957.636-3.685-1.252 9.571-.866 19.162-.243 28.743-.36 7.779-.095 15.561-.106 23.34.034 1.678 2.67-1.002 2.03-2.014 2.663-1.556.186-3.123.143-4.686.185-4.548-.476-9.296 1.134-13.661-1.285z"
        />
        <path
          fill="#F3FBFE"
          d="M187.168 302.669l-52.71-.076a.814.814 0 01-.019-.771l52.719-.14c.252.326.255.655.01.987z"
        />
        <path
          fill="#4F67BB"
          d="M138.143 303.845l20.024.003c-.488 2.456-2.462 1.798-4 1.811-5.993.046-11.986 0-17.979-.012l1.955-1.802z"
        />
        <path
          fill="#4E6BBB"
          d="M116.182 299.692l-.004 1.997c-3.28-1.212-1.836-3.357-1.43-5.622 2.055.955 1.169 2.473 1.434 3.625z"
        />
        <path
          fill="#4575B7"
          d="M161.134 356.545l-11.888.021c3.519-1.864 7.305-.381 10.933-.877l.955.856z"
        />
        <path
          fill="#4B72D2"
          d="M150.077 320.904l.111-1.146c1.061-1.304 2.569-1.424 4.057-1.413 6.927.05 13.862-.41 20.777.259 1.512.435 2.917 1.028 4.615 1.082 3.486.111 3.876 1.476 1.706 4.883-9.412 1.066-18.844.392-28.267.388-1.181-.001-2.279-.405-3.094-1.354-.499-.92-.518-1.821.095-2.699z"
        />
        <path
          fill="#5571A7"
          d="M150.047 322.413c1.28 1.897 3.256 1.242 4.975 1.254 9.051.062 18.103.036 27.155.041l.167.938a2.91 2.91 0 01-1.631.909c-14.21.299-28.422.062-42.634.119-1.32.005-2.661.034-3.789-.847l-.054-2.182c5.247-1.593 10.524-1.285 15.811-.232z"
        />
        <path
          fill="#F0FCFE"
          d="M182.032 326.633l-47.564.071a1.06 1.06 0 01-.045-.888c.968-.934 2.187-.598 3.308-.597 14.568.013 29.137-.083 43.706.038.782.205.981.664.595 1.376z"
        />
        <path
          fill="#AECBFE"
          d="M182.033 325.76l-47.611.057-.134-.99c15.938-.018 31.876-.035 47.813-.054.211.235.272.46.181.674-.088.209-.171.313-.249.313z"
        />
        <path
          fill="#C6DDE9"
          d="M150.047 322.413c-5.26.824-10.538.44-15.812.233-.067-1.764.972-2.289 2.512-2.218 4.442.205 8.918-.552 13.33.475l-.03 1.51z"
        />
        <path
          fill="#4A65A9"
          d="M176.181 319.693l-25.993.064-1.039-.147c-.244-.685-.05-1.206.579-1.567 8.659-1.162 17.319-1.301 25.977.051.61.398.768.932.476 1.599z"
        />
        <path
          fill="#455E9E"
          d="M149.161 318.843c.008.257.004.512-.012.767-4.949-.402-10.018 1.225-14.863-.89l-.037-.096c5.001-1.974 9.978-2.287 14.912.219z"
        />
        <path
          fill="#4974D3"
          d="M182.033 325.76c.093-.324.116-.653.068-.987l.104-.133c3.255 1.131 6.338.329 9.537-.523 6.478-1.726 6.829-1.452 9.648 4.333.489 1.467-.001 2.788-.6 4.095a6.374 6.374 0 01-.841 1.114c-1.208 1.058-2.125 2.567-4.205 2.016-5.037-1.338-10.224-1.051-15.368-1.225-.435-.17-.82-.42-1.164-.733l-1.151-.165c-2.123-1.701-4.61-.482-6.896-.864a6.533 6.533 0 00-.017-.969l.264-.979c4.561 2.275 7.843.226 10.728-3.171a2.218 2.218 0 00-.108-.936.95.95 0 00.001-.873z"
        />
        <path
          fill="#427BDE"
          d="M192.191 350.706l-12.007-3.015-1.133.105c-2.201 1.67-4.603 1.354-7.037.716-1.185-.574-1.307-1.481-.803-2.584.417-.934 1.273-1.483 1.951-2.192l-1.004-1.08c-1.049-1.459-2.612-.804-3.976-.97-1.046-1.315-1.072-2.629.011-3.939l9.975-.082c.606-.541 1.288-.577 2.014-.302 3.157 2.331 6.996 2.339 10.62 3.034 1.886.362 4.034-.05 5.105 2.183.684 3.083-.881 5.516-2.296 7.995-.439.412-.913.455-1.42.131z"
        />
        <path
          fill="#BCD5F3"
          d="M173.162 343.736c-.001.918-.16 1.764-1.052 2.269-8.083 2.166-16.297.854-24.456.85-1.688 0-3.268-.856-2.713-3.159a258.437 258.437 0 0128.221.04z"
        />
        <path
          fill="#4A7CC9"
          d="M144.941 343.695c.247 2.801 2.406 2.153 4.078 2.172 7.697.083 15.395.098 23.092.138l-.895 1.563c-.393.4-.869.606-1.428.625-4.466-.093-8.945-.615-13.385.374-1.064.278-2.147.392-3.242.436-.84.048-1.68.053-2.522.052-2.221-.211-4.672.556-6.46-1.504.128-1.311-.4-2.751.762-3.856z"
        />
        <path
          fill="#4872B1"
          d="M153.161 350.729c-6.22 2.063-12.624.413-18.919.936l.007-1.084c5.083-2.545 10.493-.784 15.739-1.202.901.055 1.769.234 2.553.711.207.21.414.425.62.639z"
        />
        <path
          fill="#9FC8FE"
          d="M151.129 350.548l-16.881.033.163-1.03c5.319-2.541 10.778-.362 16.17-.481.652.318.835.812.548 1.478z"
        />
        <path
          fill="#E8FCFE"
          d="M151.165 349.653l-16.754-.102a.895.895 0 01.032-.779c3.264-2.359 6.771-.387 10.157-.544a54.97 54.97 0 015.993.041c.705.249.896.71.572 1.384z"
        />
        <path
          fill="#C2D6EA"
          d="M151.174 348.695l-16.731.077a2.384 2.384 0 01-.22-.886c2.578-1.265 5.241-.688 7.893-.364l2.063.028c2.31.079 4.619.16 6.929.24.275.182.376.376.305.583-.074.214-.153.322-.239.322z"
        />
        <path
          fill="#4C7AC6"
          d="M142.116 347.522l-7.893.363c2.545-1.985 5.204-1.491 7.893-.363z"
        />
        <path
          fill="#417DD5"
          d="M168.193 337.747l-.011 3.939-4.017-.018c-1.036-1.302-1.069-2.604-.003-3.909l4.031-.012z"
        />
        <path
          fill="#437AE7"
          d="M164.162 337.759l.003 3.91-1.946.009c-.776-1.317-.809-2.635-.006-3.954l1.949.035z"
        />
        <path
          fill="#5074C1"
          d="M162.214 337.724l.005 3.954-1.219-.067c.096-.312.117-.628.062-.949.168-.895-.089-1.609-.89-2.094.492-.739 1.233-.874 2.042-.844z"
        />
        <path
          fill="#EAFCFE"
          d="M178.975 348.75a.97.97 0 01.054.799c-8.491.958-17.001.974-25.521.512-.564-.494-.625-1.044-.181-1.649 8.569-1.368 17.11-.618 25.648.338z"
        />
        <path
          fill="#9EC7FE"
          d="M153.289 349.562l25.74-.012c-3.625 2.337-7.639.695-11.454 1.09-2.137.221-4.307.128-6.462.177-2.293.547-4.585.587-6.875-.021l-1.077-.066.095-.202c-.252-.224-.332-.44-.237-.652.091-.209.182-.314.27-.314z"
        />
        <path
          fill="#C3D6EA"
          d="M178.975 348.75c-8.552.009-17.104.017-25.657.024-.287-.197-.386-.401-.299-.61.088-.213.178-.318.271-.318l2.949-.309c4.629-.54 9.259-.553 13.888.011l1.088.019 7.835.229a1.67 1.67 0 01-.075.954z"
        />
        <path
          fill="#4872B1"
          d="M154.238 350.795l6.875.021c-2.296 1.306-4.588 1.336-6.875-.021z"
        />
        <path
          fill="#C7E4FE"
          d="M152.1 336.455c.005-.279.02-.558.044-.836l-.021.047c8.772-.995 17.571-.248 26.355-.407.257.292.923.147.753.923-.157.716-.692.464-1.055.646l-26.076-.373z"
        />
        <path
          fill="#547BB9"
          d="M178.177 336.828c.264-.398.528-.797.793-1.194-.228-.245-.278-.455-.153-.632.113-.158.22-.238.322-.238l.074-1.047a19.3 19.3 0 01.962-.023c.999 1.327 1.213 2.653.001 3.98l-2.007-.008c.007-.28.01-.559.008-.838z"
        />
        <path
          fill="#E9FCFE"
          d="M179.139 334.763c.022.305-.034.595-.169.87l-26.846.032c1.532-1.952 3.696-1.1 5.57-1.106 7.148-.028 14.296.121 21.445.204zM160.115 340.651l-24.841-.029c8.283-1.495 16.563-1.565 24.841.029z"
        />
        <path
          fill="#10A7D8"
          d="M38.178 143.688c1.467 1.168 3.085 1.958 5.002 1.996a8.247 8.247 0 002.969 4.005l.024 1.987c-1.326 1.095-2.658 1.086-3.996.023-1.808 1.161-2.675 5.161-5.926 1.962-1.128-.942-1.14-2.136-.773-3.413.278-.845 2.094-1.521.275-2.612-.461-.895-.481-1.794-.1-2.709.559-.992 1.511-1.18 2.525-1.239z"
        />
        <path
          fill="#429BAB"
          d="M36.226 149.701l.026 3.961-.135 2.351c-1.538-.159-1.748-1.312-1.884-2.519.109-2.856-1.206-5.805.544-8.558.496-.496.989-.491 1.478.013l-.042 2.738c.564.667.564 1.339.013 2.014z"
        />
        <path
          fill="#0DA5C6"
          d="M42.179 151.7l3.996-.022.003 2.015c-2.1.873-3.557.459-3.999-1.993z"
        />
        <path
          fill="#D3FDFE"
          d="M35.012 153.776c.177.839.061 1.823 1.105 2.234.051.937.566 2.18-.806 2.451-1.185.235-1.07-.938-1.206-1.712-.635-.886-.383-1.864-.292-2.825.353-.426.752-.476 1.199-.148z"
        />
        <path
          fill="#8EEAF6"
          d="M34.31 153.905l-.205 2.846a8.36 8.36 0 01-.765-.364l-.056-4.678c1.83.037 1.422 1.119 1.026 2.196z"
        />
        <path
          fill="#0AACD2"
          d="M46.15 149.689c-3.08.215-5.012-.422-2.969-4.005l1.048-.009c2.211.586 2.639 2.026 1.921 4.014z"
        />
        <path
          fill="#92F3FD"
          d="M34.31 153.905l-1.026-2.196-1.129-1.026a4.642 4.642 0 01.053-.92c1.196-1.875-.168-4.131.897-6.025l1.039-.263c.634.199 1.059.603 1.226 1.257l-.357 9.045a1.405 1.405 0 00-.703.128z"
        />
        <path
          fill="#67E8F8"
          d="M35.369 144.731l-1.226-1.256c1.411-1.165 2.759-1.162 4.035.214-.641.419-1.283.838-1.923 1.259a2.71 2.71 0 00-.886-.217z"
        />
        <path
          fill="#3498AF"
          d="M33.104 143.737c-.343 2.002 1.136 4.275-.897 6.025l-.06-2.088c.241-1.331-.462-2.892.957-3.937z"
        />
        <path
          fill="#0DAFDD"
          d="M392.184 57.693c.68-1.472-2.783-2.269-.791-3.675 1.139-.803 2.957-.657 4.266.245.811.56 1.424 1.394 2.521 1.429 1.006.769 1.545 1.847 1.988 2.99l.014 6.007c-2.324-.022-4.4-1.523-6.945-.787-1.365.394-.855-1.362-1.057-2.212a7.26 7.26 0 00.004-3.997z"
        />
        <path
          fill="#13ABD6"
          d="M392.184 57.693c1.387.109 2.016.856 1.926 2.244-.078 1.221-.867 1.631-1.93 1.753l-5 .001.984-1.982.064-2.04c1.319.007 2.637.016 3.956.024z"
        />
        <path
          fill="#BFECEF"
          d="M383.037 70.903l.234-9.589c1.334 2.658.266 5.585.916 8.321.043 2.667.086 5.334.131 8.002-3.209-1.716-1.205-4.423-1.281-6.734z"
        />
        <path
          fill="#A6F5FD"
          d="M404.115 57.613c1.689-1.025 3.373-1.66 5.012.095l-5.012-.095zM402.154 57.667l1.932-.074 1.008 1.725c-1.531.429-2.871.522-2.94-1.651z"
        />
        <path
          fill="#09B5DD"
          d="M400.168 58.682c-1.324-.557-1.984-1.556-1.988-2.99.596-.243 1.301-.358 1.766-.754 1.117-.95 2.807-1.394 3.537-.594 1.227 1.347-1.07 2.058-1.359 3.265-.798.094-1.54.285-1.956 1.073z"
        />
        <path
          fill="#10B0D5"
          d="M410.268 61.72l1.559 2.221c1.037-2.842-.582-5.99 2.354-8.455v12.207c-2.016 1.646-2.012 3.922-2.021 6.235-.008 1.54.49 3.453-1.977 3.735.028-5.314.058-10.628.085-15.943z"
        />
        <path
          fill="#F2FEFA"
          d="M383.037 70.903c.535 2.224-.973 4.837 1.279 6.734.309.031.611.086.91.165 1.064 2.515-1.055 1.602-2.047 1.901-1.628-2.908-1.411-5.845-.142-8.8z"
        />
        <path
          fill="#0FA5D2"
          d="M378.18 59.691v7.996l-3.992-.003-.006-5.999c.379-2.579 2.701-1.261 3.998-1.994z"
        />
        <path
          fill="#77BCEE"
          d="M494.178 139.686c-3.133-2.03-6.617-.546-9.906-.993-2.033-.276-4.236.671-6.096-.851.797-1.036 1.957-1.159 3.107-1.104 7.645.364 15.348-.975 22.945.769l-.094.335c.016.616.029 1.231.045 1.846l-10.001-.002z"
        />
        <path
          fill="#2C58CB"
          d="M193.137 350.677l2.076-7.95a2.931 2.931 0 011.164-.768c2.948-2.137 6.361-1.396 9.635-1.592 3.468-.206 6.962.683 10.406-.282a5.019 5.019 0 011.458-.037c3.663 1.087 5.828 4.052 8.296 6.638l-.001 3.004c-1.454.836-.753 4.536-3.99 3.002.011-1.451.03-2.908-1.999-3-6.103.514-11.947-1.733-18.189-1.393-3.431.188-5.685 2.659-8.856 2.378z"
        />
        <path
          fill="#2B49B8"
          d="M226.184 327.718l-.012 5.977c-1.23 3.037-2.998 3.896-6.061 2.028-1.942-1.184-4.369-1.539-6.153-3.125-4.121-2.045-7.317-5.691-11.943-6.866-.297-2.004.833-3.297 2.217-4.469.743-.313 1.506-.342 2.286-.171 4.813 1.828 9.68 3.476 14.771 4.371 1.822.321 3.561.828 4.894 2.226l.001.029z"
        />
        <path
          fill="#2C4EC0"
          d="M214.183 331.689c2.015.58 3.918 1.646 5.665 2.593 2.594 1.405 4.347 1.059 6.323-.587l.005 5.999c-3.109.941-5.235-.894-7.351-2.324-.151-.956-1.006-.351-.403-.634.134-.063.143.107.277.392.626 1.317.587 2.511-.519 3.563l-1-.001c-3.751-1.411-7.337-3.003-8.267-7.523 1.167-2.601 3.087-2.51 5.27-1.478z"
        />
        <path
          fill="#274FC1"
          d="M218.181 340.691c.176-1.394-.414-2.878.648-4.494 2.156 1.817 4.873 2.371 7.347 3.497l-.003 6.992c-3.612-.735-5.092-4.311-7.992-5.995z"
        />
        <path
          fill="#2C5BCE"
          d="M222.181 352.692c2.302.291 1.695-3.284 3.99-3.002l-.028 8.015c-1.321-.1-2.65 2.34-3.962-.014v-4.999z"
        />
        <path
          fill="#A492DB"
          d="M173.225 207.706l.07-10.066c.29.029.58.054.87.073-.415 3.321.987 6.814-.94 9.993z"
        />
        <path
          fill="#E556CF"
          d="M178.179 105.701c-1.016 3.611-4.001 1.309-5.991 1.994.917-3.907 3.632-2.417 5.991-1.994z"
        />
        <path
          fill="#E6E1F7"
          d="M289.23 212.539c-2.617.766-2.648-1.973-3.984-2.941-.57-.336-1.004-.924-1.729-.914-.551 1.233-.305 2.746-1.436 3.714l.086.349c-.639.294-1.152.148-1.543-.437-1.086-2.98-1.312-5.931.319-8.814 1.47-.947 2.878-.921 4.21.274l1.814 2.062c1.803.756 1.994 2.685 2.965 4.051.672 1.122.654 2.069-.702 2.656z"
        />
        <path
          fill="#6A55A0"
          d="M285.154 203.769l-3.938.091c-.834.49-.288 1.936-1.499 2.168a2.263 2.263 0 01-1.297-.532c-2.467-2.965-6.612-.187-9.211-2.69l2.023-2.157c.313-.057.624-.05.933.021 3.926 2.125 8.122.599 12.184.902.611.039 1.221.08 1.83.12l-1.025 2.077z"
        />
        <path
          fill="#FAF6FE"
          d="M289.23 212.539c.162-.66 1.061-1.396-.197-1.909a1.786 1.786 0 01-.035-1.389c.33-1.841-.51-3.952 1.252-5.464a.932.932 0 01.908.021c.807 2.882.857 5.763-.023 8.64l-1.905.101z"
        />
        <path
          fill="#605596"
          d="M289.299 209.716c-.1.301-.188.605-.266.913-.688-1.601-1.377-3.2-2.066-4.799l2.318-2.106c.608 1.996.582 3.993.014 5.992z"
        />
        <path
          fill="#E6E1F7"
          d="M291.135 212.438l.023-8.64c1.576 2.885 1.28 5.764-.023 8.64z"
        />
        <path
          fill="#695E95"
          d="M283.521 205.799c.574 1.267 1.15 2.532 1.725 3.798l-2.105 2.035c-.508-1.986-1.139-3.979.38-5.833z"
        />
        <path
          fill="#D5CDEA"
          d="M283.521 205.799l-.381 5.833-1.059.765c.681-2.155-1.108-4.85 1.44-6.598z"
        />
        <path
          fill="#69579C"
          d="M281.223 212.449c.299.151.613.25.945.297-1.766 1.749-3.993.624-5.985.959l-.005-.033c-.241-.233-.343-.484-.305-.753.039-.276.093-.414.159-.416 1.07-.899 2.341-1.191 3.701-1.21.72.096.944.832 1.49 1.156z"
        />
        <path
          fill="#B5AAE9"
          d="M289.299 209.716l-.016-5.992a2.91 2.91 0 01.967.053c-.385 1.969.654 4.166-.951 5.939z"
        />
        <path
          fill="#E7DBF2"
          d="M242.18 201.708c3.327.681 7.003-.445 10.002 1.934.613.675.599 1.407.204 2.176-1.448 1.07-2.875.801-4.29-.063-1.157-.663-2.34-.865-2.888-.621.314-.198 1.288-.019 2.256.524.56 1.59-.082 2.363-1.666 2.542 1.973-.136 4.121-1.436 5.84.686.385 1.051.32 1.994-.636 2.728l-10.765-.044-.009-2.846c-.94-1.408-.075-2.987-.429-4.454-.02-.453.114-.861.371-1.23l2.01-1.332z"
        />
        <path
          fill="#EDDFF6"
          d="M240.169 203.039l.003.268c-.007 1.846.136 3.715-.84 5.41l-1.192 1.807c-3.298 1.143-6.612.924-9.932.109l.167-8.771c4.01-.379 7.988-.458 11.794 1.177z"
        />
        <path
          fill="#8940A4"
          d="M224.762 203.044c1.761 2.786 1.566 4.374.756 6.363-2.103-1.645-1.211-3.393-.756-6.363zM226.186 199.688c1.019.249 2.272-.611 3.027.547.108.167-.707.935-1.095 1.424-1.229-.432-2.789 2.014-3.692-.259-.483-1.215.744-1.562 1.76-1.712z"
        />
        <path
          fill="#845BA1"
          d="M228.209 210.632c3.309-.182 6.631.797 9.932-.109-3.289 1.975-6.603 1.701-9.932.109z"
        />
        <path
          fill="#8F7D9D"
          d="M239.333 208.716c.096-1.831-.773-3.812.84-5.408 1.361 1.79.71 3.603.055 5.414l-.447-.009-.448.003z"
        />
        <path
          fill="#E3D8F1"
          d="M253.228 211.882a3.373 3.373 0 00-.948-.236c-.69-.488-.58-1.162-.433-1.842.806-1.292 2.217-.896 3.332-1.192-.783.058-1.413-.203-1.996-.657-.28-.426-.333-.871-.201-1.35.892-.962 2.089-1.308 3.282-1.671 1.022-.248 2.043-.233 3.068-.008 1.98.635 4.242.742 5.447 2.859.49 1.367.547 2.67-.573 3.793l-2.069.258c-2.967.575-5.937.495-8.909.046z"
        />
        <path
          fill="#E2D7F3"
          d="M264.207 211.579l-.016-3.855c-.925-1.35-1.117-2.699-.003-4.051 1.429-1.801 2.703-.605 3.997.208 1.919 2.234 1.422 4.724.772 7.233-.573 1.182-1.598 1.492-2.806 1.448-.875.12-1.707.158-1.944-.983z"
        />
        <path
          fill="#7B53AB"
          d="M253.23 206.678c.104.244.188.495.254.753.024.569-.18 1.058-.531 1.492-.248.261-.506.512-.771.757l.097 1.966-1.278-.033.04-2.514c-.486-1.686-3.73-.182-3.336-2.885-.018-.503.132-.944.479-1.314l4.027.65c.558.18.9.553 1.019 1.128z"
        />
        <path
          fill="#7658A8"
          d="M253.228 211.882l8.909-.047c-2.963 1.373-5.932 1.294-8.909.047z"
        />
        <path
          fill="#6A4DB6"
          d="M266.151 212.562c.353-.967 1.289-.857 2.033-1.104 1.094-.539 1.883-.21 2.416.85.073.508-.052.962-.374 1.361l-4.049.011c-.01-.373-.018-.746-.026-1.118z"
        />
        <path
          fill="#634C93"
          d="M270.225 213.669l.091-1.283c2.043-1.247 4.01-1.342 5.855.388.004.3.006.599.007.898l-5.953-.003z"
        />
        <path
          fill="#8A77DC"
          d="M274.236 284.743c-4.71 2.556-9.837 2.982-15.054 2.949-.423.197-.905.276-1.057-.253-.257-.896.46-1.304 1.063-1.731 4.748-.587 8.429-3.95 13.002-4.991 1.487.933 2.704 2.003 2.046 4.026z"
        />
        <path
          fill="#826FD4"
          d="M274.236 284.743l-2.045-4.026 8.021-4.984c3.004.729 3.424 2.483 1.979 4.98-2.328 1.982-4.643 3.992-7.955 4.03z"
        />
        <path
          fill="#9584E4"
          d="M259.189 285.708c-.101.661-1.111 1.319-.007 1.984-2.87 1.951-5.962.665-9.17.906 1.423-2.926 4.681-.9 6.178-2.903l2.999.013z"
        />
        <path
          fill="#766CD5"
          d="M282.191 280.712c.303-2.043-.326-3.716-1.98-4.98l1.978-2.008 2.004-1.011c.834 1.671.635 3.351.043 5.034-.049.678-.1 1.354-.15 2.033l-1.895.932z"
        />
        <path
          fill="#A08BE5"
          d="M255.179 277.714l.981-1.013c.953.127 2.6.37 2.144 1.284-.686 1.377-2.135.777-3.125-.271z"
        />
        <path
          fill="#4344AC"
          d="M208.2 295.69l-2.003-4.03-1.03-3.939.015-1.031 6 5.002c.873 2.327 3.752 2.145 5.003 3.998-1.446 3.187-4.707.95-6.78 2.27-.98-.45-.475-1.687-1.205-2.27z"
        />
        <path
          fill="#E499A1"
          d="M266.158 83.694l7.158.061c-.333 2.487-2.626 1.991-4.121 2.718-1.053.196-2.054.075-2.972-.514l-1.932-.379c.298-.952.998-1.502 1.867-1.886z"
        />
        <path
          fill="#D685A5"
          d="M270.172 89.667c.007-.307.002-.614-.013-.92 2.227-.779 4.874.865 6.881-1.191-.009-.454.179-.792.592-.995l.506.388c-1.132 5.369-5.359 1.67-7.966 2.718z"
        />
        <path
          fill="#5C3F7C"
          d="M276.898 83.507c.83-.581 1.94-1.201 2.684-.509 1.277 1.19-.555 2.34-.459 3.593l-.984.356-.018-.452c-.973-.764-1.221-1.825-1.223-2.988z"
        />
        <path
          fill="#E2D1DF"
          d="M263.345 101.761l1.879-.873c1.477-1.375 3.083-1.52 4.812-.509 1.756 2.141.713 3.765-.976 5.269-1.945-1.236-4.985-.862-5.715-3.887z"
        />
        <path
          fill="#3F3987"
          d="M269.06 105.648l.957-4.759c.099-.184.198-.367.294-.552 1.108-.667 2.251-1.11 3.546-.524.648 1.758-.372 3.308-.616 4.954-.153.213-.204.447-.153.703l-4.028.178z"
        />
        <path
          fill="#D07390"
          d="M274.136 97.672l-.09 1.19c-2.052 1.287-4.431.515-6.602 1.053-.536.227-.957.092-1.264-.401 1.968-3.567 5.349-1.037 7.956-1.842z"
        />
        <path
          fill="#5A374D"
          d="M266.181 99.514c.306.065.616.096.929.09 1.182-.198 2.691-1.383 3.017 1.001l-.109.285c-1.599-.002-3.196-.002-4.793-.002l.036-1.138c.323-.009.63-.088.92-.236z"
        />
        <path
          fill="#3E3990"
          d="M276.898 83.507c1.275.641 1.283 1.801 1.225 2.987l-1.083 1.062c-3.568-.782-7.673 2.066-10.816-1.598l2.604-.396c2.462-.628 5.21-.146 7.381-1.903a.848.848 0 01.689-.152z"
        />
        <path
          fill="#FBA89E"
          d="M260.182 114.694c1.43 1.649 1.516 3.291-.025 4.924l.025-4.924z"
        />
        <path
          fill="#4246B5"
          d="M209.182 297.691c1.599-3.241 5.023-.094 7.002-2.002 4.24.274 6.727 4.533 11.055 4.794 1.599.097.831 1.85.904 2.856.131 1.791.053 3.597.062 5.396.924 2.214.365 4.494.307 6.75-.446.45-.953.532-1.52.249-1.63-2.146-1.071-4.661-1.192-7.056-.071-1.64-.579-2.53-2.521-2.973-3.846-.878-7.602-2.238-11.221-3.837-1.64-.725-4.015-1.356-2.876-4.177z"
        />
        <path
          fill="#816FDB"
          d="M228.042 315.679l.164-6.944c1.086-.768.861-1.96.984-3.039 3.709.354 6.925 3.361 10.946 2.035.991.576 2.412 1.226.766 2.375-.811.566-2.196.569-3.278.447-8.369-.944-8.366-.974-8.522 7.15-.429.271-.831.224-1.209-.101-.343-.671-.303-1.313.149-1.923z"
        />
        <path
          fill="#5C3F7C"
          d="M276.208 83.659c-1.9 2.8-4.754 1.901-7.378 1.903l4.486-1.808 2.892-.095z"
        />
        <path
          fill="#C1B2D8"
          d="M270.155 118.523c-1.395.429-3.065-.149-4.219 1.16l-1.664-.176c1.207-3.205 3.926-1.25 5.928-1.741.322.188.423.362.303.524-.115.156-.23.233-.348.233z"
        />
        <path
          fill="#B3A1CC"
          d="M270.155 118.523c.016-.252.03-.505.045-.758 2.004.155 4.142-.762 5.978.744l-6.023.014z"
        />
        <path
          fill="#3747A0"
          d="M264.147 128.663l.02 1.04c-2.011-.236-2.194-1.482-1.712-3.214l1.692 2.174z"
        />
        <path
          fill="#E2DBF3"
          d="M276.171 212.774l-5.855-.387-2.132-.929.001-7.578 1.025-1.075c2.438.023 4.877.116 7.313.049 2.066-.057 3.088.694 2.713 2.862-1.496 1.793-4.019.541-6.02 1.712 2.609 1.841 5.254-2.432 7.404.678-.057 1.238.391 2.536-.459 3.67l-3.99.998z"
        />
        <path
          fill="#E6D7F3"
          d="M253.23 206.678l-1.018-1.128-.03-1.908c3.745-1.704 7.485-1.794 11.218.039.639 2.796-.956 2.588-2.777 2.071-1.481-.399-2.972-1.231-4.447.033-.746 1.076-1.88.873-2.946.893z"
        />
        <path
          fill="#715F98"
          d="M260.123 204.917c1.538.768 2.799.805 3.277-1.236.262.003.524 0 .787-.009l.003 4.051-5.261-1.856c.13-.654.738-.706 1.194-.95z"
        />
        <path
          fill="#7B65D1"
          d="M306.18 237.69v-9.998c3.102-4.036 5.738-3.211 8.127.742.209.347.721.51 1.092.759 1.447-4.243 7.221-1.51 8.836-5.482.768.867.697 1.901.219 2.769-2.426 4.411-4.133 9.222-7.324 13.205-1.695-1.338-.426-3.442-1.516-5.4-2.727 2.263-7.315-1.141-9.434 3.405z"
        />
        <path
          fill="#AB9AF5"
          d="M317.129 239.684c2.367-5.325 4.736-10.649 7.104-15.974l2.891-2.951c1.082.652.99 1.9 1.461 2.864.129.434.148.87.053 1.313-.623 1.926-1.697 3.58-3.061 5.059-1.207 1.531-2.281 3.161-3.498 4.687-2.818 1.924-2.975 5.15-3.912 7.994l-1.045-1.056.007-1.936z"
        />
        <path
          fill="#71A7EE"
          d="M328.026 223.716c-1.059-.756-.807-1.91-.9-2.958l1.041-1.036c2.986.628.137 2.779 1.031 3.954l-.322.399c-.364.072-.647-.048-.85-.359z"
        />
        <path
          fill="#71A7EE"
          d="M330.172 223.688l.01 3.013c1.748 2.897 2.451 5.705-.695 8.186-1.184-.783-1.236-2.016-1.287-3.247-.25-2.712-.557-5.432.963-7.93l.033-.033c.326.006.652.01.976.011z"
        />
        <path
          fill="#DD7178"
          d="M286.184 125.653c.992 1.416-1.145 1.092-1.102 1.98-2.697.331-5.234-.218-7.601-1.495-.622-.335-.998-.949.089-1.259.287-.082.64.07.963.115.906-.302 1.848-.271 2.788-.288 1.663.099 3.439-.372 4.863.947z"
        />
        <path
          fill="#87657E"
          d="M279.86 125.597l-1.335-.607c-.155-.397-.318-.8-.481-1.202l4.177-.127 5.02.13-1.037.979c-2.018 1.013-4.325-.188-6.344.827z"
        />
        <path
          fill="#2E3D9D"
          d="M271.513 135.571c-1.908-.341-4.806 1.617-5.205-2.237 1.991.152 3.623 1.137 5.205 2.237z"
        />
        <path
          fill="#DDBBD4"
          d="M279.86 125.597c1.937-1.63 4.214-.669 6.343-.829.004.296-.002.591-.02.885l-6.323-.056z"
        />
        <path
          fill="#963C59"
          d="M270.126 100.605c-.72-1.196-1.977-.771-3.017-1.001 2.162-1.654 4.597-.768 6.938-.742.032.337-.03.654-.189.951-1.1.946-2.401.937-3.732.792z"
        />
        <path
          fill="#5EB2EE"
          d="M329.237 234.71c1.896-2.483.521-5.353.945-8.01 2.656-1.314 4.168.822 6 1.992.057 3.755-.807 7.346-1.939 10.889l-1.984.027c-.199-1.846-1.793-2.223-3.078-2.926l.023.012c-.582-.67-.608-1.332.033-1.984z"
        />
        <path
          fill="#62B6EE"
          d="M348.194 220.686c2.098 3.51.48 7.353.988 11.006-2.123-3.508-.494-7.353-.988-11.006z"
        />
        <path
          fill="#72CFF2"
          d="M358.225 190.665c-.008.312-.016.622-.021.934-6.973 4.201-13.16 3.426-18.648-2.337-1.59-2.016-1.77-4.589-2.652-6.885-.717-1.867-.324-3.989 1.652-4.582 1.674-.501 2.428 1.385 2.795 2.839.477 1.886 1.795 3.118 3.045 4.426 2.803 3.688 6.188 4.398 10.188 1.975 2.668-.248 4 .845 3.641 3.63z"
        />
        <path
          fill="#7DB4CF"
          d="M358.225 190.665c-.801-1.729-1.66-3.377-4.037-2.948-1.008.176-1.277-.325-1.121-1.22 3.748-2.674 4.666-6.895 5.949-10.918.473-.202.936-.173 1.391.055 1.727 2.932.471 6.811 3.018 9.485.178.471.221.953.121 1.447-1.24.916-.779 3.675-3.379 3.123l-1.942.976z"
        />
        <path
          fill="#8BE3FC"
          d="M340.18 188.7c5.104 6.589 11.467 5.35 18.023 2.899 1.121.729.088 1.399-.059 2.095-2.996.287-5.891 1.446-8.967 1.031-6.188-.342-10.469-3.429-13-9.033l1.006-.002c1.435.57 2.136 1.871 2.997 3.01z"
        />
        <path
          fill="#96D0E7"
          d="M360.167 189.689l3-3.008c.314.223.424.449.326.682-.1.234-.199.352-.303.352.002 1.451-.756 2.398-2.002 3.025l-1.021-1.051z"
        />
        <path
          fill="#58ADE6"
          d="M357.165 217.714c.055 5.959 1.143 11.673 4.037 16.957-.193.661-.279 2.127-1.205.567-3.237-5.438-5.383-11.12-2.832-17.524z"
        />
        <path
          fill="#69BAE6"
          d="M336.182 162.69l-.189 1.898-.811.015v-13.905l40.002-.021.012.011c.801 1.011.982 2.125.563 3.339-.998 2.322-3.023 2.956-5.27 3.015-4.621.121-9.186.308-13.764-1.168-5.379-1.733-11.232-.041-16.727-1.755-1.758-.549-2.158 1.043-2.291 2.446-.201 2.12.086 4.357-1.525 6.125z"
        />
        <path
          fill="#6FBAD1"
          d="M368.165 225.68l-3.961-2.005-2.051-8.968.041-1.02 5.971 11.993z"
        />
        <path
          fill="#6DBAEA"
          d="M336.182 162.69c.002-2.649.047-5.299-.004-7.947-.057-2.849 1.49-3.773 3.752-2.54 3.287 1.793 6.727 1.627 10.162 1.447 6.732-.352 12.992 3.22 19.842 2.135 2.014-.318 3.895-.321 5.209-2.1 2.281 2.204 3.812 4.811 4.289 7.986-.273.4-.621.724-1.035.975-7.354-.094-14.842 1.146-21.869-2.31-1.137-.559-2.596.707-3.906-.299.182.942.875.514 1.314.584 1.057.17 2.656-1.103 3.094.351.553 1.84-1.219 2.39-2.672 2.852-3.717-.291-7.451 1.578-11.146-.115-1.932-3.182-4.665-.837-7.03-1.019z"
        />
        <path
          fill="#71C2EB"
          d="M340.18 188.7c-1.355-.646-2.313-1.692-2.996-3.01-2.457-4.187-1.709-8.614-.984-13.041a476.9 476.9 0 01.971-1.878c1.293-2.072 3.02-3.717 5.021-5.09l-.02.015c7.84-4.05 14.277-3.291 20.371 2.39 1.35 2.212 2.781 4.399 2.574 7.169a3.625 3.625 0 01-.563 1.332c-1.297.838-2.119-.016-2.766-.925-.656-.924-1.096-.819-1.613.039l-1.17.105c-.418.183-.816.159-1.199-.096-1.164-1.218-2.164-2.627-3.816-3.284-6.797-2.473-11.445 1.249-10.436 8.342.209 1.46.988 2.795.908 4.313-.102.208-.207.415-.311.622-3.879-.815-3.748-4.376-4.783-7.681-3.854 4.31.195 7.344.812 10.678z"
        />
        <path
          fill="#88D7FB"
          d="M362.182 168.691c-6.127-4.621-12.666-6.497-20.01-2.995l1.039-1.988c3.928-.988 7.92-1.22 11.949-.996.75.6 1.74.123 2.533.552 1.645.791 3.371 1.458 4.623 2.884.412.618.518 1.284.305 1.997l-.439.546z"
        />
        <path
          fill="#89D9FD"
          d="M342.192 165.681c-1.279 2.086-3.02 3.716-5.021 5.089.494-2.859 2.204-4.52 5.021-5.089z"
        />
        <path
          fill="#73BBE4"
          d="M376.155 150.642l2.012-.067 3.906-.873c.883.355.434 1.288.809 1.863l1.123 3.223c-.885 2.276-1.436 4.841-4.512 5.228-2.751-2.529-4.154-5.542-3.343-9.347l.005-.027z"
        />
        <path
          fill="#75A0C5"
          d="M380.145 159.714c1.369-1.577 1.93-3.789 3.859-4.928a.876.876 0 01.279.669c-.049 3.188 3.99 2.547 4.711 5.025.436 2.537-.492 3.898-3.203 3.722-2.607.258-4.43-.935-5.729-3.095-.3-.482-.273-.946.083-1.393z"
        />
        <path
          fill="#71BBE0"
          d="M385.189 163.72c3.113.29 3.055-1.866 3.063-3.97.371-.831 1.369-.36 1.879-.902.35-.029.697-.059 1.047-.087l-.039 5.929-5.963-.008-.326-.486.339-.476z"
        />
        <path
          fill="#7B9CBC"
          d="M390.131 158.848l-1.881.901c-2.129-.685-5.92.166-3.967-4.294 1.854 1.296 3.453 3.031 5.848 3.393z"
        />
        <path
          fill="#88DCFA"
          d="M382.881 151.565l-.807-1.863.107-4.014 1.873-.012-1.173 5.889z"
        />
        <path
          fill="#88D3F8"
          d="M380.145 159.714c.018.32.035.641.049.961.262.209.373.441.338.697-.037.268-.092.401-.164.401-.418.196-.811.154-1.18-.125-1.691-2.48-3.486-4.908-4.044-7.964l.053-2.997c.318-.003.637-.009.955-.02.532 3.369.925 6.798 3.993 9.047z"
        />
        <path
          fill="#5087D3"
          d="M284.236 277.748l-.043-5.034c.43-.755 1.141-.971 1.943-1.008-.016.646-.031 1.294-.049 1.94l-1.851 4.102z"
        />
        <path
          fill="#8676DD"
          d="M256.192 300.708c4.025 2.097 8.335.576 12.498.948 2.638.235 4.817.657 4.49 4.04-7.973.342-15.476-1.778-22.944-4.988h5.956z"
        />
        <path
          fill="#7C6AD5"
          d="M276.142 320.639c-4.644.158-9.184 1.622-13.88 1.092-7.043.725-14.085.764-21.127-.02-1.317-.013-2.635-.024-3.953-.036-.579-1.134-.842-2.107 1.018-1.998l3.994.038c6.982.836 13.967.763 20.953.043l9.978-.113c1.205-.273 2.699-1.427 3.017.994z"
        />
        <path
          fill="#7C6CD5"
          d="M238.2 319.677c-.807.428-.999 1.169-1.018 1.998l-8.83-.879c-1.065-.996-1.036-2.037-.126-3.113.292.006.585.013.876.021 2.652 2.411 6.433-.379 9.098 1.973zM263.146 319.758c-6.988 1.492-13.972 1.554-20.953-.044l20.953.044z"
        />
        <path
          fill="#8772D7"
          d="M276.142 320.639c-.733-1.159-1.938-.886-3.018-.994 2.498-1.854 5.379-.555 8.051-.979l.992.993-6.025.98z"
        />
        <path
          fill="#8071CF"
          d="M325.114 229.616l2.982-4.997c1.156 2.17.301 4.509.57 6.754-.102 1.119.299 2.315-.506 3.328-1.863-.747.199-3.438-1.99-4.021-.914.201-1.365-.054-1.056-1.064z"
        />
        <path
          fill="#8877D6"
          d="M325.114 229.616c.354.354.705.709 1.057 1.063-.982 1.723-2.268 3.136-4.09 4.002.451-2.024 1.144-3.903 3.033-5.065z"
        />
        <path
          fill="#6680D1"
          d="M328.161 234.701l.035-3.007c.314-.458.625-.455.932.01l.109 3.007c-.01.661-.021 1.323-.033 1.984-.834-.41-1-1.17-1.043-1.994z"
        />
        <path
          fill="#4556C2"
          d="M227.175 307.7l.014 7.99c1.215 1.848-.24 4.109.925 5.966l.072 3.03-2.002.004a2.944 2.944 0 01-.855-1.155c-.369-1.146-.411-2.363-.755-3.513-3.719-2.671-8.385-2.871-12.385-4.809-3.477-1.685-6.446-3.59-5.391-8.209.865-1.188 2.149-1.592 3.463-1.396 5.622.835 11.392.468 16.914 2.092z"
        />
        <path
          fill="#7C6CD5"
          d="M241.135 321.711l21.126.02c-7.043 1.526-14.086 1.549-21.126-.02z"
        />
        <path
          fill="#3E53C1"
          d="M228.113 321.656c-1.709-1.771-.623-3.977-.925-5.966.285 0 .57-.004.854-.011l.183 2.004.126 3.112c-.075.288-.155.576-.238.861z"
        />
        <path
          fill="#3B56C6"
          d="M226.181 323.693l.002.997-.003 2.999c-6.854-1.381-13.947-1.959-20.009-5.984-.376-1.871.849-2.381 2.293-2.71 6.006 1.179 12.241 1.512 17.717 4.698z"
        />
        <path
          fill="#EFFEFE"
          d="M450.182 136.688c-.285-1.558.943-.976 1.537-.977 16.424-.03 32.85-.022 49.273-.018 1.156 0 2.352-.102 3.172.988-2.902 1.001-5.898.448-8.846.463-13.422.069-26.844.048-40.266.009-1.622-.003-3.319.428-4.87-.465z"
        />
        <path
          fill="#E7F7FB"
          d="M450.182 136.688l53.982-.006c.01.275.031.551.064.824-8.686.111-17.369.224-26.053.336l-27.988-.307a79.874 79.874 0 01-.005-.847z"
        />
        <path
          fill="#71C4ED"
          d="M366.184 186.707l-1.012-.016c-1.439-1.842-.447-3.894-.27-5.76.404-4.226.105-8.226-2.02-11.973 1.533-2.557 4.098-2.64 6.537-2.346 2.268.272 4.576.291 6.814.827 1.922 2.937-.465 5.267-1.094 7.847-.578 1.33-1.33 2.565-2.117 3.778-1.605 2.217-3.021 4.58-4.875 6.617-.814.032-1.549.221-1.963 1.026z"
        />
        <path
          fill="#72A1C4"
          d="M372.178 178.691l1.932-3.021c1.168-.928 2.432-1.147 3.809-.527 2.029 1.78 1.304 5.355 4.25 6.548-.305.921.828 3.287-1.889 1.732-2.484-1.421-5.22-1.987-8.097-1.721-.79-1.003-.647-2.007-.005-3.011z"
        />
        <path
          fill="#6BA4C8"
          d="M382.168 181.69c-5.275.627-3.761-3.258-3.98-5.992.896-1.655 1.72-3.408 4.093-3.136.215.263.43.559.418.876-.125 3.002-.133 3.002 2.475 3.257-.225 2.133-1.68 3.525-3.006 4.995z"
        />
        <path
          fill="#74C4E9"
          d="M385.174 176.695c-2.031-.272-2.748 2.088-4.637 2.332-.85-2.503 1.814-4.07 1.605-6.334-.924-2.087-.182-3.045 2.035-3.006l.033.032c-.035 1.925-.348 3.959 1.955 4.963-.329.671-.661 1.342-.991 2.013z"
        />
        <path
          fill="#6FB1CE"
          d="M372.178 178.691l.004 3.011c-1.236 1.437-1.643 3.714-4.031 3.98.818-2.632 2.361-4.848 4.027-6.991z"
        />
        <path
          fill="#7AABC3"
          d="M368.182 189.693c-.949-.384-1.625-1.037-1.99-2.001 1.736-1.291 2.711.459 3.988 1l.006.999c-.668.641-1.336.556-2.004.002z"
        />
        <path
          fill="#8BDBFB"
          d="M363.18 168.692c3.729 5.66 3.787 11.728 1.992 17.999-.66.341-1.32.682-1.982 1.022l-.023-1.032c.006-.33.008-.659.004-.989-.701-1.691.451-3.132.623-4.706-.164-1.801 1.057-3.49.412-5.328.385-2.63-1.883-4.489-2.023-6.967l.002-.004c.333-.346.665-.344.995.005z"
        />
        <path
          fill="#7BB3CF"
          d="M368.182 189.693l2.004-.002c2.133 1.104 3.219 2.895 4.035 6.111-2.769-2.238-4.66-3.909-6.039-6.109z"
        />
        <path
          fill="#6E99C0"
          d="M384.178 169.687c-1.311.574-1.979 1.582-2.033 3.006-1.725.468-1.816 3.086-3.957 3.005-1.359-.009-2.717-.019-4.076-.027.717-2.656 1.436-5.311 2.152-7.966-.082-1.849.463-3.372 2.215-4.268 2.019 1.544 4.687 1.758 6.736 3.255l-1.037 2.995z"
        />
        <path
          fill="#78A6C8"
          d="M385.215 166.692c-2.725-.049-5.799.72-6.968-2.975-.691-.663-.625-1.336-.027-2.017.324-.001.646-.019.968-.052.326.014.652.021.979.021 1.596 1.139 3.436 1.876 5.016 3.041l-.006-.028.963 1.043c-.31.322-.617.645-.925.967z"
        />
        <path
          fill="#2C5BCE"
          d="M193.137 350.677c2.669-4.593 6.725-3.605 10.983-3.142 3.558.387 7.309-2.995 10.781 1.361 1.033 1.295.623-2.118 2.502-2.587 1.545.135.212 3.711 2.779 3.382.242 4.334-.504 5.369-5.747 4.469-6.546-1.124-13.713-1.817-20.439.693-1.047.392-1.433-.463-1.832-1.189l.027-2.96c.315-.014.63-.023.946-.027z"
        />
        <path
          fill="#FAF3FB"
          d="M438.133 328.495c-2.814.708-4.521 4.188-8.012 3.199-1.697-3.327-1.957-6.661-.053-10.008l.008-3.992c.244-1.091.617-1.841 1.971-1.146 1.592.816 3.242 1.515 4.865 2.266l7.266 3.881c-.322 3.698-4.654 3.217-6.045 5.8z"
        />
        <path
          fill="#C761EE"
          d="M428.18 329.69c-7.008-.122-14.031.023-20.999-.999v-5.999l20.969.001c1.505 2.326 1.474 4.658.03 6.997z"
        />
        <path
          fill="#BE68DF"
          d="M428.18 329.69l-.029-6.997c.41-.773 1.115-.982 1.918-1.007l.053 10.008c-1.293-.042-1.911-.739-1.942-2.004z"
        />
        <path
          fill="#5565C1"
          d="M187.168 302.669l-.01-.987a1.88 1.88 0 00.01-.979c-1.315-2.013-3.362-.536-4.993-1.045l.002-1.961c7.096-1.156 13.296 2.355 19.828 3.996 1.898.476 3.454.1 5.169-.001.321 3.353-.871 5.904-3.941 7.468-3.852-.118-7.192-2.368-11.116-2.523-2.2-.087-4.188-.343-6.217.771-1.249.685-2.998 1.646-3.913-.21-.913-1.853 1.142-2.417 2.187-3.353 1.002-.384 2.42.295 2.994-1.176z"
        />
        <path
          fill="#424DB9"
          d="M203.18 308.687c1.999-1.95 2.633-4.68 3.995-6.995 1.208-1.853 1.014-3.944 1.024-6.002.793.438.963 1.184.983 2.001.519 2.868 3.146 3.342 5.159 3.799 3.627.822 6.77 3.172 10.665 3.102 1.939-.035 2.3 1.47 2.168 3.108-5.043 1.646-9.966-.352-14.945-.567-1.766-.077-3.51-1.057-5.05.561-.988 1.725-1.031 4.53-4.246 3.707-.561-.964-.574-1.877.247-2.714z"
        />
        <path
          fill="#F2FCFE"
          d="M162.175 315.59c3.932.062 7.865.078 11.795.212 1.292.044 3.23-.651 3.051 1.891-10.766 1.12-21.561.262-32.34.427-3.416.053-6.926.749-10.279-.609.305-2.771 2.494-1.655 3.869-1.685 7.966-.17 15.936-.175 23.904-.236z"
        />
        <path
          fill="#F3FCFE"
          d="M160.973 311.845l-.06 1.713-26.43-.006-.073-1.709c1.127-1.289 2.668-1.125 4.135-1.133 6.097-.032 12.195-.032 18.292 0 1.468.008 3.007-.149 4.136 1.135z"
        />
        <path
          fill="#94AEF1"
          d="M134.401 317.51l42.62.183a.588.588 0 01.51-.191c.013.929-.394 1.413-1.371 1.295l-26.999.047-14.912-.218c.052-.373.102-.745.152-1.116z"
        />
        <path
          fill="#44599B"
          d="M161.138 309.766l.009 1.022c-8.974.642-17.947.628-26.92.003 1.915-2.016 4.379-.994 6.571-1.036 6.777-.13 13.559-.011 20.34.011z"
        />
        <path
          fill="#A0B5F8"
          d="M134.226 310.792l26.92-.004-.174 1.058-26.562-.002-.184-1.052z"
        />
        <path
          fill="#4C6FCD"
          d="M176.161 318.796l1.369-1.294c1.042-1.071.526-2.425.666-3.659.447-.614 1.05-.699 1.731-.516 1.019 1.756 2.979 1.044 4.434 1.674.6.281 1.202 1.133 1.638.998 6.912-2.146 12.803 2.887 19.417 2.688.762 1.47-.177 2.266-1.198 3.029.064 1.728-1.511 2.584-2.105 3.962.011 1.11-.22 2.145-.959 3.017-.62-.191-1.762-.339-1.782-.579-.516-6.206-4.622-3.005-7.418-2.747-1.207.11-2.469.522-3.699 1.119-2.312 1.119-4.805 1.272-6.048-1.848a24.272 24.272 0 01-.03-.934c-.247-1.651.586-4.44-2.905-2.354-1.392.832-2.849.371-3.09-1.659.006-.299-.001-.598-.021-.897z"
        />
        <path
          fill="#516AC7"
          d="M164.209 309.725c-1.681-.193-2.307-1.217-1.803-2.722.644-1.923 2.428-1.099 3.77-1.317 3.185-1.477 6.614-.705 9.783-.431 2.632.228 4.276 2.474 1.58 5.22-4.499.662-9.008 1.591-13.33-.75z"
        />
        <path
          fill="#E4EDFE"
          d="M180.129 313.842l-1.935.001c-3.937-.066-7.875-.094-11.811-.222-1.304-.042-3.212.671-3.1-1.85 6.941-1.885 14-1.184 21.038-.957.58.268.995.699 1.248 1.285.147 1.027-.278 1.755-1.175 2.234-1.486.418-2.934.47-4.265-.491z"
        />
        <path
          fill="#5466BE"
          d="M178.17 309.655c.275-2.606-2.296-4.559-3.351-3.689-3.311 2.727-5.815-.484-8.643-.279l.004-1.855 14.003.002c1.38 1.84 1.341 3.771.365 5.761-.774.663-1.568.683-2.378.06z"
        />
        <path
          fill="#9FB3F2"
          d="M185.015 311.788l-21.73-.016.93-1.247c6.841-.487 13.691-.398 20.543-.342.608.451.693.986.257 1.605z"
        />
        <path
          fill="#4F60A2"
          d="M185.153 310.786l-20.939-.26a6.924 6.924 0 01-.005-.802c4.654-.022 9.308-.046 13.961-.069l2.015.021c1.976-1.061 3.962-2.172 4.968 1.11z"
        />
        <path
          fill="#5168C5"
          d="M185.153 310.786c-1.326-1.847-3.297-.806-4.968-1.11l-.001-5.844 3.99.013-1.935 3.946c7.739-5.08 14.339-2.082 20.941.896l.023 2.998c-.153.17-.305.341-.451.519-1.807 2.781-5.372 2.176-7.191 1.814-3.424-.681-7.102.688-10.271-1.307a14.84 14.84 0 00-.275-.924l.138-1.001z"
        />
        <path
          fill="#2E53C5"
          d="M209.178 333.693l8.003 6.997c-1.149 1.333-2.38 1.367-4.22 1.267-5.586-.308-11.269-1.074-16.793.703-2.005-4.245 2.252-6.574 3.047-9.963.316-.003.631-.008.947-.016 3.786-3.808 4.529-3.725 9.016 1.012z"
        />
        <path
          fill="#4677D8"
          d="M199.215 332.697c-.08 3.607-2.684 6.442-3.047 9.963l-.956.067c-4.5-.768-8.818-2.464-13.597-1.765-2.433.356-.948-2.159-1.44-3.289l-.001-3.98c4.871-.967 9.799-.609 14.443.688 2.508.701 3.395-.237 4.598-1.684z"
        />
        <path
          fill="#304DBD"
          d="M209.178 333.693c-.461-.204-8.63-1.121-9.017-1.012l.991-3.986c-.686-1.326-.647-2.422.96-3.017 5.541-1.045 7.908 4.285 12.07 6.011-2.072-.344-3.718.382-5.004 2.004z"
        />
        <path
          fill="#4D77BF"
          d="M170.127 347.548l-13.889-.01c4.632-1.33 9.261-1.36 13.889.01z"
        />
        <path
          fill="#8CABD9"
          d="M153.29 347.846c-.043.311-.034.62.028.929-.083.26-.094.522-.029.787-.05.32-.062.643-.033.966-.708.007-1.417.015-2.126.021a6.1 6.1 0 00.036-.896c.096-.318.1-.638.009-.958a3.354 3.354 0 00-.066-.905l2.181.056z"
        />
        <path
          fill="#12A8CB"
          d="M36.226 149.701l-.013-2.014c1.149.254 2.62-.576 3.447 1-.813 1.587-2.287.756-3.434 1.014z"
        />
        <path
          fill="#3E53C1"
          d="M204.217 321.716l.978-3.025c-.954-2.256-2.018-4.479-2.032-7.008l.04.002 3.977-3.992c1.171 7.459 8.25 6.455 12.861 8.997 2 1.103 5.21-.269 6.139 3.006-4.109 2.08-8.006-.249-11.99-.616-2.072-.19-4.184-1.433-6.008.61-.959.383-1.627 1.057-2.011 2.015l-1.954.011z"
        />
        <path
          fill="#D5CDEA"
          d="M280.162 211.776l-.014-4.174c-.563-.587-.572-1.215-.143-1.877.307-.685.202-1.637 1.211-1.866l.006 8.59c-.352-.225-.707-.449-1.06-.673z"
        />
        <path
          fill="#6A50B1"
          d="M280.005 205.725l.143 1.877c-1.828-.382-2.859.664-4.146 1.802-1.016.896-2.871.652-4.215-.057-1.036-.546-.816-1.763-.588-2.661.552-2.161 2.324-1.238 3.67-1.229 1.455.011 2.911.167 4.367.26.256-.009.514-.007.769.008z"
        />
        <path
          fill="#7A5C98"
          d="M248.118 205.634c-.233 2.175 2.664 1.706 2.925 3.464l-7.834-.435c.913-2.053 4.718.422 3.909-2.944.299-.419.633-.447 1-.085z"
        />
        <path
          fill="#6E558E"
          d="M248.118 205.634l-1 .085h-3.232c1.412-1.333 2.846-1.209 4.299-.819-.01.246-.033.49-.067.734z"
        />
        <path
          fill="#8242A5"
          d="M236.214 204.771c1.281.885.871 1.918.262 2.969-1.356.679-2.765.47-4.174.251-1.385-4.342 2.46-2.327 3.912-3.22z"
        />
        <path
          fill="#6B4588"
          d="M236.214 204.771c-.883 1.605-4.039.04-4.031 2.889-.284.406-.579.394-.882.022-.861-5.187 2.299-3.59 4.913-2.911z"
        />
        <path
          fill="#77658E"
          d="M231.301 207.682c.294-.002.588-.009.882-.021 1.43.026 2.861.054 4.292.079-1.74 1.413-3.467 1.619-5.174-.058z"
        />
        <path
          fill="#8674B0"
          d="M252.183 209.68l.044-1.07c1.505-.931 3.307.087 4.828-.737.958-.089 2.377-.364 2.544.667.234 1.447-1.259.97-2.096 1.014-1.771.09-3.546.089-5.32.126z"
        />
        <path
          fill="#65488E"
          d="M257.055 207.873c-1.441 1.349-3.215.523-4.829.738l1.258-1.18 3.571.442z"
        />
        <path
          fill="#695688"
          d="M260.123 204.917l-1.193.949-2.754-.081c.934-2.023 2.552-.94 3.947-.868z"
        />
        <path
          fill="#5993D9"
          d="M329.127 231.704a57.92 57.92 0 00-.932-.01l-.1-7.074a2.769 2.769 0 00-.068-.903l1.137-.007-.037 7.994z"
        />
        <path
          fill="#76CBEF"
          d="M353.19 187.139l.998.577c-3.373 3.565-7.051 2.828-10.035-2.014l.176-.145c3.144-.538 6.029.376 8.861 1.582z"
        />
        <path
          fill="#F9FCFB"
          d="M353.19 187.139c-3.277 1.286-6.006-.508-8.863-1.58-2.441-3.461-3.406-7.209-1.377-11.113 2.326-4.479 7.008-5.406 12.213-2.708.176 1.966 1.664 2.914 3.051 3.94.262.065.525.107.793.127.802 5.186-.919 9.074-5.817 11.334z"
        />
        <path
          fill="#70C9EF"
          d="M365.129 181.669c-.652 1.341-1.307 2.682-1.959 4.022-4.531-2.272-2.543-6.498-2.994-9.992-.018-.896-.369-2.367.008-2.586 1.475-.856 1.775.488 2.109 1.565.299.969.982 1.601 1.889 2.011 1.16 1.5-.183 3.476.947 4.98z"
        />
        <path
          fill="#6DC0EC"
          d="M378.219 161.701l.027 2.017c-.254 1.532-.773 2.932-1.982 3.987-1.811.389-3.207 1.831-5.568.29-2.098-1.368-5.014.044-7.516.697-.332-.003-.664-.005-.996-.005l-.018-1.954c-1.01-2.087-2.848-2.808-4.988-3.033-.822-.022-1.568-.202-2.018-.988.391-.293 1.098-.563 1.121-.882.127-1.776-.928-.604-1.461-.469-2.773.702-4.572.319-3.947-3.039 8.958 3.178 18.169 3.154 27.346 3.379z"
        />
        <path
          fill="#F0FCFC"
          d="M358.213 175.678c-2.947.181-5.146-.218-3.051-3.94 1.698.786 2.911 1.949 3.051 3.94z"
        />
        <path
          fill="#79C6E4"
          d="M365.129 181.669c-1.598-1.416-.709-3.305-.947-4.979l.023-1.032c1.747 1.783.7 3.995.924 6.011z"
        />
        <path
          fill="#6DBAEA"
          d="M357.178 163.7c2.902-1.028 4.943-.643 4.988 3.032l-4.988-3.032z"
        />
        <path
          fill="#99C0E0"
          d="M385.182 164.71c-2.09-.324-3.951-1.026-5.016-3.041.004-.331.014-.663.027-.994l4.996 3.045c.008.33.004.66-.007.99z"
        />
        <path
          fill="#4159C8"
          d="M208.182 319.69c-.11-2.724-.291-4.159 3.628-2.577 4.417 1.784 9.549 1.799 14.37 2.583l.001 3.997a104.98 104.98 0 01-17.999-4.003z"
        />
        <path
          fill="#4F6CC9"
          d="M203.163 311.683c2.267 1.875 2.422 4.362 2.032 7.008-3.864 2.551-7.228-.457-10.751-1.122-2.271-.428-4.166-1.88-6.635-.073-1.369 1.001-3.101.2-3.629-1.807-.584-.624-.593-1.25-.006-1.878l1.117-1.1c.881.295 1.86 1.284 2.659.135 1.832-2.636 3.445-4.426 4.922.238.099.313 1.49.652 1.746.411 2.511-2.363 5.877-.441 8.545-1.812z"
        />
        <path
          fill="#546BB6"
          d="M184.173 313.811l.006 1.878c-1.25-.835-4.066 1.764-4.05-1.847l4.044-.031z"
        />
        <path
          className="desaparecera2"
          fill="#6395EC"
          d="M63.485 341.649c-3.375 1.906-6.771 1.938-10.19.119a19.077 19.077 0 01-.157-1.014c-.469-1.23-.965-2.459-.414-3.797.555-.881 1.396-1.15 2.376-1.107 2.033 1.005 4.077 1.79 6.157.061.94-.213 1.811-.078 2.603.494.867 1.1.915 2.35.696 3.652a3.636 3.636 0 01-1.071 1.592z"
        />
        <path
          className="desaparecera2"
          fill="#8E7BFB"
          d="M62.174 329.182c.541.755 1.081 1.512 1.621 2.268a2.9 2.9 0 01.329 2.051 2.65 2.65 0 01-1.463 1.479c-3.211.725-6.399 1.08-9.452-.62-.726-1.04-.657-2.02.228-2.935 1.006-.611-.446-2.315 1.179-2.65 2.591-1.206 5.147-1.747 7.558.407z"
        />
        <path
          className="desaparecera2"
          fill="#7686DC"
          d="M53.437 331.424l-.053 2.615c.698.867.694 1.717-.057 2.55l-.188 4.165c-3.02-3.211-3.819-6.349.298-9.33z"
        />
        <path
          className="desaparecera2"
          fill="#7A8BD1"
          d="M63.502 334.025l.146-1.429c2.434.336 3.794 1.325 2.426 3.979-.153.361-.18.731-.082 1.11-.956.8.036 3.229-2.362 2.819l-.104-3.919c-.751-.846-.752-1.7-.024-2.56z"
        />
        <path
          className="desaparecera2"
          fill="#7A86FC"
          d="M63.502 334.025l.023 2.561-2.527.011c-1.715 1.342-3.43 1.342-5.145-.002l-2.526-.005.056-2.55 10.119-.015z"
        />
        <path
        className="desaparecera2"
          fill="#6A8CFE"
          d="M55.854 336.594l5.145.002c-.158 1.761-1.115 2.559-2.883 2.447-1.557-.097-2.089-1.096-2.262-2.449z"
        />
        <path
        className="desaparecera3"
          fill="#8161B1"
          d="M504.784 267.837c2.381-4.264 6.01-5.313 9.631-2.309 2.574 2.136 4.988 5.481.738 8.763-7.375 4.15-9.707.188-10.369-6.454z"
        />
        <path
        className="desaparecera3"
          fill="#64527F"
          d="M504.784 267.837c1.721 4.943 5.041 7.318 10.375 6.453-.955 4.33-4.051 4.599-7.219 3.206-4.338-1.907-4.783-5.558-3.156-9.659z"
        />
        <path
        className="desaparecera4"
          fill="#8161B1"
          d="M80.097 47.229c2.38-4.264 6.009-5.313 9.631-2.309 2.573 2.136 4.988 5.481.738 8.763-7.376 4.15-9.707.188-10.369-6.454z"
        />
        <path
        className="desaparecera4"
          fill="#64527F"
          d="M80.097 47.229c1.721 4.943 5.041 7.318 10.374 6.453-.955 4.33-4.05 4.599-7.219 3.206-4.336-1.908-4.782-5.558-3.155-9.659z"
        />
        <path
        className="desaparecera"
          fill="#553AD3"
          d="M159.034 19.071c3.293-2.468 6.59-4.932 11.109-4.011.402.498.81.996 1.213 1.494.882 2.782-.224 4.371-2.976 4.978-3.945-.83-4.722 6.256-9.342 3.737-.856-2.065-1.165-4.131-.004-6.198z"
        />
        <path
        className="desaparecera2"
          fill="#C51E8B"
          d="M268.627 18.695c1.144 4.179-.482 6.97-4.677 7.39-4.044.406-6.396-1.863-6.398-6.135 3.576-1.453 7.45-.248 11.075-1.255z"
        />
        <path
        className="desaparecera2"

          fill="#D52883"
          d="M268.627 18.695c-3.254 4.275-7.244 2.049-11.075 1.255-.523-1.984.558-3.053 2.176-3.816 2.318-.876 4.649-.657 6.985-.075 1.285.409 1.958 1.261 1.914 2.636z"
        />
        <path
        className="desaparecera2"

          fill="#CC3589"
          d="M266.713 16.059l-6.985.075c2.307-1.966 4.633-2.239 6.985-.075z"
        />
      </g>
    </Svg>
  )
}

export default SvgComponent
